//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.7.1.0 (NJsonSchema v11.6.1.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

import axios, { AxiosError } from 'axios';
import type { AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

export class ServiceBase {
    constructor() {
    }
}

export class ESAFEndPointsClient extends ServiceBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getAllESAFRoles( cancelToken?: CancelToken): Promise<APIResponseOfListOfESAFRoleDTO> {
        let url_ = this.baseUrl + "/api/esaf/getAllESAFRoles";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllESAFRoles(_response);
        });
    }

    protected processGetAllESAFRoles(response: AxiosResponse): Promise<APIResponseOfListOfESAFRoleDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = APIResponseOfListOfESAFRoleDTO.fromJS(resultData200);
            return Promise.resolve<APIResponseOfListOfESAFRoleDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<APIResponseOfListOfESAFRoleDTO>(null as any);
    }

    getFacilitiesByMarket(market: string, cancelToken?: CancelToken): Promise<APIResponseOfListOfESAFFacilityDTO> {
        let url_ = this.baseUrl + "/api/esaf/getFacilitiesByMarket/{market}";
        if (market === undefined || market === null)
            throw new globalThis.Error("The parameter 'market' must be defined.");
        url_ = url_.replace("{market}", encodeURIComponent("" + market));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFacilitiesByMarket(_response);
        });
    }

    protected processGetFacilitiesByMarket(response: AxiosResponse): Promise<APIResponseOfListOfESAFFacilityDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = APIResponseOfListOfESAFFacilityDTO.fromJS(resultData200);
            return Promise.resolve<APIResponseOfListOfESAFFacilityDTO>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<APIResponseOfListOfESAFFacilityDTO>(null as any);
    }

    getFacilitiesByMarketQuery(market: string, cancelToken?: CancelToken): Promise<APIResponseOfListOfESAFFacilityDTO> {
        let url_ = this.baseUrl + "/api/esaf/getFacilitiesByMarket?";
        if (market === undefined || market === null)
            throw new globalThis.Error("The parameter 'market' must be defined and cannot be null.");
        else
            url_ += "market=" + encodeURIComponent("" + market) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFacilitiesByMarketQuery(_response);
        });
    }

    protected processGetFacilitiesByMarketQuery(response: AxiosResponse): Promise<APIResponseOfListOfESAFFacilityDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = APIResponseOfListOfESAFFacilityDTO.fromJS(resultData200);
            return Promise.resolve<APIResponseOfListOfESAFFacilityDTO>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<APIResponseOfListOfESAFFacilityDTO>(null as any);
    }

    getFacilitiesByDivision(division: string, cancelToken?: CancelToken): Promise<APIResponseOfListOfESAFFacilityDTO> {
        let url_ = this.baseUrl + "/api/esaf/getFacilitiesByDivision/{division}";
        if (division === undefined || division === null)
            throw new globalThis.Error("The parameter 'division' must be defined.");
        url_ = url_.replace("{division}", encodeURIComponent("" + division));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFacilitiesByDivision(_response);
        });
    }

    protected processGetFacilitiesByDivision(response: AxiosResponse): Promise<APIResponseOfListOfESAFFacilityDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = APIResponseOfListOfESAFFacilityDTO.fromJS(resultData200);
            return Promise.resolve<APIResponseOfListOfESAFFacilityDTO>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<APIResponseOfListOfESAFFacilityDTO>(null as any);
    }

    getFacilitiesByDivisionQuery(division: string, cancelToken?: CancelToken): Promise<APIResponseOfListOfESAFFacilityDTO> {
        let url_ = this.baseUrl + "/api/esaf/getFacilitiesByDivision?";
        if (division === undefined || division === null)
            throw new globalThis.Error("The parameter 'division' must be defined and cannot be null.");
        else
            url_ += "division=" + encodeURIComponent("" + division) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFacilitiesByDivisionQuery(_response);
        });
    }

    protected processGetFacilitiesByDivisionQuery(response: AxiosResponse): Promise<APIResponseOfListOfESAFFacilityDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = APIResponseOfListOfESAFFacilityDTO.fromJS(resultData200);
            return Promise.resolve<APIResponseOfListOfESAFFacilityDTO>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<APIResponseOfListOfESAFFacilityDTO>(null as any);
    }

    addEsafUser(eSAFUserDTO: ESAFUserDTO, cancelToken?: CancelToken): Promise<APIResponseOfString> {
        let url_ = this.baseUrl + "/api/esaf/createuser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(eSAFUserDTO);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddEsafUser(_response);
        });
    }

    protected processAddEsafUser(response: AxiosResponse): Promise<APIResponseOfString> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = APIResponseOfString.fromJS(resultData200);
            return Promise.resolve<APIResponseOfString>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<APIResponseOfString>(null as any);
    }

    updateEsafUser(eSAFUserDTO: ESAFUserDTO, cancelToken?: CancelToken): Promise<APIResponseOfString> {
        let url_ = this.baseUrl + "/api/esaf/updateuser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(eSAFUserDTO);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateEsafUser(_response);
        });
    }

    protected processUpdateEsafUser(response: AxiosResponse): Promise<APIResponseOfString> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = APIResponseOfString.fromJS(resultData200);
            return Promise.resolve<APIResponseOfString>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<APIResponseOfString>(null as any);
    }

    getAppUser(userid: string, cancelToken?: CancelToken): Promise<APIResponseOfESAFUserDTO> {
        let url_ = this.baseUrl + "/api/esaf/getAppUser/{userid}";
        if (userid === undefined || userid === null)
            throw new globalThis.Error("The parameter 'userid' must be defined.");
        url_ = url_.replace("{userid}", encodeURIComponent("" + userid));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAppUser(_response);
        });
    }

    protected processGetAppUser(response: AxiosResponse): Promise<APIResponseOfESAFUserDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = APIResponseOfESAFUserDTO.fromJS(resultData200);
            return Promise.resolve<APIResponseOfESAFUserDTO>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<APIResponseOfESAFUserDTO>(null as any);
    }

    deleteUser(eSAFUserDTO: ESAFUserDTO, cancelToken?: CancelToken): Promise<APIResponseOfString> {
        let url_ = this.baseUrl + "/api/esaf/deleteuser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(eSAFUserDTO);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteUser(_response);
        });
    }

    protected processDeleteUser(response: AxiosResponse): Promise<APIResponseOfString> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = APIResponseOfString.fromJS(resultData200);
            return Promise.resolve<APIResponseOfString>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<APIResponseOfString>(null as any);
    }
}

export class HealthEndPointsClient extends ServiceBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    healthCheck( cancelToken?: CancelToken): Promise<APIResponseOfEmpty> {
        let url_ = this.baseUrl + "/api/healthcheck";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processHealthCheck(_response);
        });
    }

    protected processHealthCheck(response: AxiosResponse): Promise<APIResponseOfEmpty> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = APIResponseOfEmpty.fromJS(resultData200);
            return Promise.resolve<APIResponseOfEmpty>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<APIResponseOfEmpty>(null as any);
    }
}

export class AccountEndPointsClient extends ServiceBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getAccountDetail(accountNumber: string, cancelToken?: CancelToken): Promise<APIResponseOfAppAccountDTO> {
        let url_ = this.baseUrl + "/api/account/getAccountDetail?";
        if (accountNumber === undefined || accountNumber === null)
            throw new globalThis.Error("The parameter 'accountNumber' must be defined and cannot be null.");
        else
            url_ += "accountNumber=" + encodeURIComponent("" + accountNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAccountDetail(_response);
        });
    }

    protected processGetAccountDetail(response: AxiosResponse): Promise<APIResponseOfAppAccountDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = APIResponseOfAppAccountDTO.fromJS(resultData200);
            return Promise.resolve<APIResponseOfAppAccountDTO>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<APIResponseOfAppAccountDTO>(null as any);
    }

    createAccount(appAccountCreateDTO: AppAccountCreateDTO, cancelToken?: CancelToken): Promise<APIResponseOfEmpty> {
        let url_ = this.baseUrl + "/api/account/createAccount";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(appAccountCreateDTO);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateAccount(_response);
        });
    }

    protected processCreateAccount(response: AxiosResponse): Promise<APIResponseOfEmpty> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = APIResponseOfEmpty.fromJS(resultData201);
            return Promise.resolve<APIResponseOfEmpty>(result201);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<APIResponseOfEmpty>(null as any);
    }

    getMessageCategory( cancelToken?: CancelToken): Promise<APIResponseOfListOfMessageCategoryDTO> {
        let url_ = this.baseUrl + "/api/account/getMessageCategory";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMessageCategory(_response);
        });
    }

    protected processGetMessageCategory(response: AxiosResponse): Promise<APIResponseOfListOfMessageCategoryDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = APIResponseOfListOfMessageCategoryDTO.fromJS(resultData200);
            return Promise.resolve<APIResponseOfListOfMessageCategoryDTO>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<APIResponseOfListOfMessageCategoryDTO>(null as any);
    }

    getInteractionStatus( cancelToken?: CancelToken): Promise<APIResponseOfListOfInteractionStatus> {
        let url_ = this.baseUrl + "/api/account/getInteractionStatus";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetInteractionStatus(_response);
        });
    }

    protected processGetInteractionStatus(response: AxiosResponse): Promise<APIResponseOfListOfInteractionStatus> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = APIResponseOfListOfInteractionStatus.fromJS(resultData200);
            return Promise.resolve<APIResponseOfListOfInteractionStatus>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<APIResponseOfListOfInteractionStatus>(null as any);
    }

    getInteractionType( cancelToken?: CancelToken): Promise<APIResponseOfListOfInteractionTypeDTO> {
        let url_ = this.baseUrl + "/api/account/getInteractionType";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetInteractionType(_response);
        });
    }

    protected processGetInteractionType(response: AxiosResponse): Promise<APIResponseOfListOfInteractionTypeDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = APIResponseOfListOfInteractionTypeDTO.fromJS(resultData200);
            return Promise.resolve<APIResponseOfListOfInteractionTypeDTO>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<APIResponseOfListOfInteractionTypeDTO>(null as any);
    }

    getInteractionData(interactionDetailRequest: InteractionDetailRequest, cancelToken?: CancelToken): Promise<APIResponseOfListOfInteractionDetailsResponse> {
        let url_ = this.baseUrl + "/api/account/getInteractionData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(interactionDetailRequest);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetInteractionData(_response);
        });
    }

    protected processGetInteractionData(response: AxiosResponse): Promise<APIResponseOfListOfInteractionDetailsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = APIResponseOfListOfInteractionDetailsResponse.fromJS(resultData200);
            return Promise.resolve<APIResponseOfListOfInteractionDetailsResponse>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<APIResponseOfListOfInteractionDetailsResponse>(null as any);
    }

    getInteractionCount(interactionCountRequest: InteractionCountRequest, cancelToken?: CancelToken): Promise<APIResponseOfInteractionCount> {
        let url_ = this.baseUrl + "/api/account/getInteractionCount";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(interactionCountRequest);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetInteractionCount(_response);
        });
    }

    protected processGetInteractionCount(response: AxiosResponse): Promise<APIResponseOfInteractionCount> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = APIResponseOfInteractionCount.fromJS(resultData200);
            return Promise.resolve<APIResponseOfInteractionCount>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<APIResponseOfInteractionCount>(null as any);
    }

    searchAccount(accountNumber: string, idToken: string | null | undefined, cancelToken?: CancelToken): Promise<APIResponseOfListOfSearchAccountDTO> {
        let url_ = this.baseUrl + "/api/account/searchAccount?";
        if (accountNumber === undefined || accountNumber === null)
            throw new globalThis.Error("The parameter 'accountNumber' must be defined and cannot be null.");
        else
            url_ += "accountNumber=" + encodeURIComponent("" + accountNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Authorization": idToken !== undefined && idToken !== null ? "" + idToken : "",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchAccount(_response);
        });
    }

    protected processSearchAccount(response: AxiosResponse): Promise<APIResponseOfListOfSearchAccountDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = APIResponseOfListOfSearchAccountDTO.fromJS(resultData200);
            return Promise.resolve<APIResponseOfListOfSearchAccountDTO>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<APIResponseOfListOfSearchAccountDTO>(null as any);
    }

    advancedSearch(idToken: string | null | undefined, req: any, cancelToken?: CancelToken): Promise<APIResponseOfSearchAccountResponse> {
        let url_ = this.baseUrl + "/api/account/AdvancedSearchAccount";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(req);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Authorization": idToken !== undefined && idToken !== null ? "" + idToken : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAdvancedSearch(_response);
        });
    }

    protected processAdvancedSearch(response: AxiosResponse): Promise<APIResponseOfSearchAccountResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = APIResponseOfSearchAccountResponse.fromJS(resultData200);
            return Promise.resolve<APIResponseOfSearchAccountResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<APIResponseOfSearchAccountResponse>(null as any);
    }

    getAccountSummary(idToken: string | null | undefined, accountSummaryRequest: AccountSummaryRequest, cancelToken?: CancelToken): Promise<APIResponseOfAccountSummaryResponseDTO> {
        let url_ = this.baseUrl + "/api/account/getAccountSummary";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(accountSummaryRequest);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Authorization": idToken !== undefined && idToken !== null ? "" + idToken : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAccountSummary(_response);
        });
    }

    protected processGetAccountSummary(response: AxiosResponse): Promise<APIResponseOfAccountSummaryResponseDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = APIResponseOfAccountSummaryResponseDTO.fromJS(resultData200);
            return Promise.resolve<APIResponseOfAccountSummaryResponseDTO>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<APIResponseOfAccountSummaryResponseDTO>(null as any);
    }

    updateWorkQueueStatus(idToken: string | null | undefined, req: WorkQueueUpdateRequest, cancelToken?: CancelToken): Promise<APIResponseOfUpdateResponseDTO> {
        let url_ = this.baseUrl + "/api/account/updateWorkQueueStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(req);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Authorization": idToken !== undefined && idToken !== null ? "" + idToken : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateWorkQueueStatus(_response);
        });
    }

    protected processUpdateWorkQueueStatus(response: AxiosResponse): Promise<APIResponseOfUpdateResponseDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = APIResponseOfUpdateResponseDTO.fromJS(resultData200);
            return Promise.resolve<APIResponseOfUpdateResponseDTO>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<APIResponseOfUpdateResponseDTO>(null as any);
    }

    getWorkQueueStatus( cancelToken?: CancelToken): Promise<APIResponseOfListOfWorkQueueStatusDTO> {
        let url_ = this.baseUrl + "/api/account/getWorkQueueStatus";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetWorkQueueStatus(_response);
        });
    }

    protected processGetWorkQueueStatus(response: AxiosResponse): Promise<APIResponseOfListOfWorkQueueStatusDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = APIResponseOfListOfWorkQueueStatusDTO.fromJS(resultData200);
            return Promise.resolve<APIResponseOfListOfWorkQueueStatusDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<APIResponseOfListOfWorkQueueStatusDTO>(null as any);
    }

    getAllAccountWorkQueueStatus(accountWorkQueueStatusRequest: AccountWorkQueueStatusRequest, cancelToken?: CancelToken): Promise<APIResponseOfListOfAccountStatusDTO> {
        let url_ = this.baseUrl + "/api/account/getAllAccountWorkQueueStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(accountWorkQueueStatusRequest);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllAccountWorkQueueStatus(_response);
        });
    }

    protected processGetAllAccountWorkQueueStatus(response: AxiosResponse): Promise<APIResponseOfListOfAccountStatusDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = APIResponseOfListOfAccountStatusDTO.fromJS(resultData200);
            return Promise.resolve<APIResponseOfListOfAccountStatusDTO>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<APIResponseOfListOfAccountStatusDTO>(null as any);
    }

    getAppointmentsType(accountSummaryRequest: AccountSummaryRequest, cancelToken?: CancelToken): Promise<APIResponseOfListOfAppointmentType> {
        let url_ = this.baseUrl + "/api/account/getAppointmentsType";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(accountSummaryRequest);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAppointmentsType(_response);
        });
    }

    protected processGetAppointmentsType(response: AxiosResponse): Promise<APIResponseOfListOfAppointmentType> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = APIResponseOfListOfAppointmentType.fromJS(resultData200);
            return Promise.resolve<APIResponseOfListOfAppointmentType>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<APIResponseOfListOfAppointmentType>(null as any);
    }

    getAppointmentsData(appointmentDetailsRequest: AppointmentDetailsRequest, cancelToken?: CancelToken): Promise<APIResponseOfListOfAppointmentDetailsResponse> {
        let url_ = this.baseUrl + "/api/account/getAppointmentsData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(appointmentDetailsRequest);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAppointmentsData(_response);
        });
    }

    protected processGetAppointmentsData(response: AxiosResponse): Promise<APIResponseOfListOfAppointmentDetailsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = APIResponseOfListOfAppointmentDetailsResponse.fromJS(resultData200);
            return Promise.resolve<APIResponseOfListOfAppointmentDetailsResponse>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<APIResponseOfListOfAppointmentDetailsResponse>(null as any);
    }

    getAppointmentsCount(appointmentDetailsRequest: AppointmentDetailsRequest, cancelToken?: CancelToken): Promise<APIResponseOfAppointmentsCount> {
        let url_ = this.baseUrl + "/api/account/getAppointmentsCount";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(appointmentDetailsRequest);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAppointmentsCount(_response);
        });
    }

    protected processGetAppointmentsCount(response: AxiosResponse): Promise<APIResponseOfAppointmentsCount> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = APIResponseOfAppointmentsCount.fromJS(resultData200);
            return Promise.resolve<APIResponseOfAppointmentsCount>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<APIResponseOfAppointmentsCount>(null as any);
    }

    isAccountUnsubscribed(accountEmailAddress: string, cancelToken?: CancelToken): Promise<APIResponseOfBoolean> {
        let url_ = this.baseUrl + "/api/account/isAccountUnsubscribed?";
        if (accountEmailAddress === undefined || accountEmailAddress === null)
            throw new globalThis.Error("The parameter 'accountEmailAddress' must be defined and cannot be null.");
        else
            url_ += "accountEmailAddress=" + encodeURIComponent("" + accountEmailAddress) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processIsAccountUnsubscribed(_response);
        });
    }

    protected processIsAccountUnsubscribed(response: AxiosResponse): Promise<APIResponseOfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = APIResponseOfBoolean.fromJS(resultData200);
            return Promise.resolve<APIResponseOfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<APIResponseOfBoolean>(null as any);
    }

    sendAppointmentEmail(idToken: string, appointmentEmailRequest: AppointmentEmailRequest, cancelToken?: CancelToken): Promise<APIResponseOfEmpty> {
        let url_ = this.baseUrl + "/api/account/sendAppointmentEmail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(appointmentEmailRequest);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Authorization": idToken !== undefined && idToken !== null ? "" + idToken : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSendAppointmentEmail(_response);
        });
    }

    protected processSendAppointmentEmail(response: AxiosResponse): Promise<APIResponseOfEmpty> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = APIResponseOfEmpty.fromJS(resultData200);
            return Promise.resolve<APIResponseOfEmpty>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = APIResponseOfEmpty.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = APIResponseOfEmpty.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = APIResponseOfEmpty.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<APIResponseOfEmpty>(null as any);
    }

    updateAllowInteractionFlag(idToken: string | null | undefined, req: UpdateAllowInteractionRequest, cancelToken?: CancelToken): Promise<APIResponseOfUpdateResponseDTO> {
        let url_ = this.baseUrl + "/api/account/updateAllowInteractionFlag";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(req);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Authorization": idToken !== undefined && idToken !== null ? "" + idToken : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateAllowInteractionFlag(_response);
        });
    }

    protected processUpdateAllowInteractionFlag(response: AxiosResponse): Promise<APIResponseOfUpdateResponseDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = APIResponseOfUpdateResponseDTO.fromJS(resultData200);
            return Promise.resolve<APIResponseOfUpdateResponseDTO>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<APIResponseOfUpdateResponseDTO>(null as any);
    }

    getCommunicationStatus(accountId: number, cancelToken?: CancelToken): Promise<APIResponseOfBoolean> {
        let url_ = this.baseUrl + "/api/account/getCommunicationStatus?";
        if (accountId === undefined || accountId === null)
            throw new globalThis.Error("The parameter 'accountId' must be defined and cannot be null.");
        else
            url_ += "accountId=" + encodeURIComponent("" + accountId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCommunicationStatus(_response);
        });
    }

    protected processGetCommunicationStatus(response: AxiosResponse): Promise<APIResponseOfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = APIResponseOfBoolean.fromJS(resultData200);
            return Promise.resolve<APIResponseOfBoolean>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<APIResponseOfBoolean>(null as any);
    }

    getStates( cancelToken?: CancelToken): Promise<APIResponseOfListOfStatesDTO> {
        let url_ = this.baseUrl + "/api/account/getStates";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetStates(_response);
        });
    }

    protected processGetStates(response: AxiosResponse): Promise<APIResponseOfListOfStatesDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = APIResponseOfListOfStatesDTO.fromJS(resultData200);
            return Promise.resolve<APIResponseOfListOfStatesDTO>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<APIResponseOfListOfStatesDTO>(null as any);
    }

    updatePatientContact(idToken: string | null | undefined, contactUpdateRequest: ContactUpdateRequest, cancelToken?: CancelToken): Promise<APIResponseOfUpdateResponseDTO> {
        let url_ = this.baseUrl + "/api/account/updatePatientContact";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(contactUpdateRequest);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Authorization": idToken !== undefined && idToken !== null ? "" + idToken : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdatePatientContact(_response);
        });
    }

    protected processUpdatePatientContact(response: AxiosResponse): Promise<APIResponseOfUpdateResponseDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = APIResponseOfUpdateResponseDTO.fromJS(resultData200);
            return Promise.resolve<APIResponseOfUpdateResponseDTO>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<APIResponseOfUpdateResponseDTO>(null as any);
    }

    getWorkQueueCount(workQueueRequest: WorkQueueRequest, cancelToken?: CancelToken): Promise<APIResponseOfWorkQueueCount> {
        let url_ = this.baseUrl + "/api/account/getWorkQueueCount";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(workQueueRequest);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetWorkQueueCount(_response);
        });
    }

    protected processGetWorkQueueCount(response: AxiosResponse): Promise<APIResponseOfWorkQueueCount> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = APIResponseOfWorkQueueCount.fromJS(resultData200);
            return Promise.resolve<APIResponseOfWorkQueueCount>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<APIResponseOfWorkQueueCount>(null as any);
    }

    addManualInteraction(idToken: string | null | undefined, req: ManualInteractionRequest, cancelToken?: CancelToken): Promise<APIResponseOfUpdateResponseDTO> {
        let url_ = this.baseUrl + "/api/account/addManualInteraction";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(req);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Authorization": idToken !== undefined && idToken !== null ? "" + idToken : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddManualInteraction(_response);
        });
    }

    protected processAddManualInteraction(response: AxiosResponse): Promise<APIResponseOfUpdateResponseDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = APIResponseOfUpdateResponseDTO.fromJS(resultData200);
            return Promise.resolve<APIResponseOfUpdateResponseDTO>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<APIResponseOfUpdateResponseDTO>(null as any);
    }

    getAccountLock(accountSummaryRequest: AccountSummaryRequest, cancelToken?: CancelToken): Promise<APIResponseOfListOfAppAccountLock> {
        let url_ = this.baseUrl + "/api/account/getAccountLock";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(accountSummaryRequest);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAccountLock(_response);
        });
    }

    protected processGetAccountLock(response: AxiosResponse): Promise<APIResponseOfListOfAppAccountLock> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = APIResponseOfListOfAppAccountLock.fromJS(resultData200);
            return Promise.resolve<APIResponseOfListOfAppAccountLock>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<APIResponseOfListOfAppAccountLock>(null as any);
    }

    addAppAccountLock(idToken: string | null | undefined, accountSummaryRequest: AccountSummaryRequest, cancelToken?: CancelToken): Promise<APIResponseOfUpdateResponseDTO> {
        let url_ = this.baseUrl + "/api/account/addAppAccountLock";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(accountSummaryRequest);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Authorization": idToken !== undefined && idToken !== null ? "" + idToken : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddAppAccountLock(_response);
        });
    }

    protected processAddAppAccountLock(response: AxiosResponse): Promise<APIResponseOfUpdateResponseDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = APIResponseOfUpdateResponseDTO.fromJS(resultData200);
            return Promise.resolve<APIResponseOfUpdateResponseDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<APIResponseOfUpdateResponseDTO>(null as any);
    }

    updateAppAccountLock(accountSummaryRequest: AccountSummaryRequest, cancelToken?: CancelToken): Promise<APIResponseOfUpdateResponseDTO> {
        let url_ = this.baseUrl + "/api/account/updateAppAccountLock";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(accountSummaryRequest);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateAppAccountLock(_response);
        });
    }

    protected processUpdateAppAccountLock(response: AxiosResponse): Promise<APIResponseOfUpdateResponseDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = APIResponseOfUpdateResponseDTO.fromJS(resultData200);
            return Promise.resolve<APIResponseOfUpdateResponseDTO>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<APIResponseOfUpdateResponseDTO>(null as any);
    }
}

export class FacilityEndPointsClient extends ServiceBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getUserFacilities(idToken: string | null | undefined, cancelToken?: CancelToken): Promise<APIResponseOfListOfRoot> {
        let url_ = this.baseUrl + "/api/facility/getUserFacilities";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Authorization": idToken !== undefined && idToken !== null ? "" + idToken : "",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUserFacilities(_response);
        });
    }

    protected processGetUserFacilities(response: AxiosResponse): Promise<APIResponseOfListOfRoot> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = APIResponseOfListOfRoot.fromJS(resultData200);
            return Promise.resolve<APIResponseOfListOfRoot>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<APIResponseOfListOfRoot>(null as any);
    }

    getFacilities(seviceCenterIds: string, cancelToken?: CancelToken): Promise<APIResponseOfListOfRoot> {
        let url_ = this.baseUrl + "/api/facility/getFacilities?";
        if (seviceCenterIds === undefined || seviceCenterIds === null)
            throw new globalThis.Error("The parameter 'seviceCenterIds' must be defined and cannot be null.");
        else
            url_ += "seviceCenterIds=" + encodeURIComponent("" + seviceCenterIds) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFacilities(_response);
        });
    }

    protected processGetFacilities(response: AxiosResponse): Promise<APIResponseOfListOfRoot> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = APIResponseOfListOfRoot.fromJS(resultData200);
            return Promise.resolve<APIResponseOfListOfRoot>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<APIResponseOfListOfRoot>(null as any);
    }

    getFacilityResourceFilters(idToken: string | null | undefined, cancelToken?: CancelToken): Promise<APIResponseOfFacilityResourceFiltersDTO> {
        let url_ = this.baseUrl + "/api/facility/getFacilityResourceFilters";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Authorization": idToken !== undefined && idToken !== null ? "" + idToken : "",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFacilityResourceFilters(_response);
        });
    }

    protected processGetFacilityResourceFilters(response: AxiosResponse): Promise<APIResponseOfFacilityResourceFiltersDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = APIResponseOfFacilityResourceFiltersDTO.fromJS(resultData200);
            return Promise.resolve<APIResponseOfFacilityResourceFiltersDTO>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<APIResponseOfFacilityResourceFiltersDTO>(null as any);
    }

    checkIfFacilityResourceExists(facilityResourceRequest: FacilityResourceRequest, cancelToken?: CancelToken): Promise<APIResponseOfUpdateResponseDTO> {
        let url_ = this.baseUrl + "/api/facility/checkIfFacilityResourceExists";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(facilityResourceRequest);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCheckIfFacilityResourceExists(_response);
        });
    }

    protected processCheckIfFacilityResourceExists(response: AxiosResponse): Promise<APIResponseOfUpdateResponseDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = APIResponseOfUpdateResponseDTO.fromJS(resultData200);
            return Promise.resolve<APIResponseOfUpdateResponseDTO>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<APIResponseOfUpdateResponseDTO>(null as any);
    }

    getFacilityResourceListView(idToken: string | null | undefined, facilityResourceListViewRequest: FacilityResourceListViewRequest, cancelToken?: CancelToken): Promise<APIResponseOfListOfFacilityResourceListViewDetailDTO> {
        let url_ = this.baseUrl + "/api/facility/getFacilityResourceListView";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(facilityResourceListViewRequest);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Authorization": idToken !== undefined && idToken !== null ? "" + idToken : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFacilityResourceListView(_response);
        });
    }

    protected processGetFacilityResourceListView(response: AxiosResponse): Promise<APIResponseOfListOfFacilityResourceListViewDetailDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = APIResponseOfListOfFacilityResourceListViewDetailDTO.fromJS(resultData200);
            return Promise.resolve<APIResponseOfListOfFacilityResourceListViewDetailDTO>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<APIResponseOfListOfFacilityResourceListViewDetailDTO>(null as any);
    }

    addOrUpdateFacilityResource(idToken: string | null | undefined, addOrUpdateFacilityResourceRequest: AddOrUpdateFacilityResourceRequest, cancelToken?: CancelToken): Promise<APIResponseOfAddOrUpdateFacilityResourceResponseDTO> {
        let url_ = this.baseUrl + "/api/facility/addOrUpdateFacilityResource";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(addOrUpdateFacilityResourceRequest);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Authorization": idToken !== undefined && idToken !== null ? "" + idToken : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddOrUpdateFacilityResource(_response);
        });
    }

    protected processAddOrUpdateFacilityResource(response: AxiosResponse): Promise<APIResponseOfAddOrUpdateFacilityResourceResponseDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = APIResponseOfAddOrUpdateFacilityResourceResponseDTO.fromJS(resultData200);
            return Promise.resolve<APIResponseOfAddOrUpdateFacilityResourceResponseDTO>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<APIResponseOfAddOrUpdateFacilityResourceResponseDTO>(null as any);
    }

    bulkUpdateFacilityResource(idToken: string | null | undefined, bulkUpdateFacilityResourceRequest: BulkUpdateFacilityResourceRequest, cancelToken?: CancelToken): Promise<APIResponseOfAddOrUpdateFacilityResourceResponseDTO> {
        let url_ = this.baseUrl + "/api/facility/bulkUpdateFacilityResource";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(bulkUpdateFacilityResourceRequest);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Authorization": idToken !== undefined && idToken !== null ? "" + idToken : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBulkUpdateFacilityResource(_response);
        });
    }

    protected processBulkUpdateFacilityResource(response: AxiosResponse): Promise<APIResponseOfAddOrUpdateFacilityResourceResponseDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = APIResponseOfAddOrUpdateFacilityResourceResponseDTO.fromJS(resultData200);
            return Promise.resolve<APIResponseOfAddOrUpdateFacilityResourceResponseDTO>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<APIResponseOfAddOrUpdateFacilityResourceResponseDTO>(null as any);
    }

    getFacilityAppointmentExclusionFilters(idToken: string | null | undefined, req: FacilityAppointmentExclusionFilterRequest, cancelToken?: CancelToken): Promise<APIResponseOfFacilityAppointmentExclusionFiltersDTO> {
        let url_ = this.baseUrl + "/api/facility/getFacilityAppointmentExclusionFilters";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(req);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Authorization": idToken !== undefined && idToken !== null ? "" + idToken : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFacilityAppointmentExclusionFilters(_response);
        });
    }

    protected processGetFacilityAppointmentExclusionFilters(response: AxiosResponse): Promise<APIResponseOfFacilityAppointmentExclusionFiltersDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = APIResponseOfFacilityAppointmentExclusionFiltersDTO.fromJS(resultData200);
            return Promise.resolve<APIResponseOfFacilityAppointmentExclusionFiltersDTO>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<APIResponseOfFacilityAppointmentExclusionFiltersDTO>(null as any);
    }

    getFacilityAppointmentExclusionListView(idToken: string | null | undefined, facilityAppointmentExclusionListViewRequest: FacilityAppointmentExclusionListViewRequest, cancelToken?: CancelToken): Promise<APIResponseOfListOfFacilityAppointmentExclusionListViewDTO> {
        let url_ = this.baseUrl + "/api/facility/getFacilityAppointmentExclusionListView";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(facilityAppointmentExclusionListViewRequest);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Authorization": idToken !== undefined && idToken !== null ? "" + idToken : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFacilityAppointmentExclusionListView(_response);
        });
    }

    protected processGetFacilityAppointmentExclusionListView(response: AxiosResponse): Promise<APIResponseOfListOfFacilityAppointmentExclusionListViewDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = APIResponseOfListOfFacilityAppointmentExclusionListViewDTO.fromJS(resultData200);
            return Promise.resolve<APIResponseOfListOfFacilityAppointmentExclusionListViewDTO>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<APIResponseOfListOfFacilityAppointmentExclusionListViewDTO>(null as any);
    }

    addOrUpdateFacilityAppointmentExclusion(idToken: string | null | undefined, addOrUpdateFacilityAppointmentExclusionRequest: AddOrUpdateFacilityAppointmentExclusionRequest, cancelToken?: CancelToken): Promise<APIResponseOfResultData> {
        let url_ = this.baseUrl + "/api/facility/addOrUpdateFacilityAppointmentExclusion";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(addOrUpdateFacilityAppointmentExclusionRequest);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Authorization": idToken !== undefined && idToken !== null ? "" + idToken : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddOrUpdateFacilityAppointmentExclusion(_response);
        });
    }

    protected processAddOrUpdateFacilityAppointmentExclusion(response: AxiosResponse): Promise<APIResponseOfResultData> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = APIResponseOfResultData.fromJS(resultData200);
            return Promise.resolve<APIResponseOfResultData>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<APIResponseOfResultData>(null as any);
    }

    addOrUpdateOutageCampaign(idToken: string | null | undefined, addOrUpdateOutageCampaignRequest: AddOrUpdateOutageCampaignRequest, cancelToken?: CancelToken): Promise<APIResponseOfUpdateResponse> {
        let url_ = this.baseUrl + "/api/facility/AddOrUpdateOutageCampaign";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(addOrUpdateOutageCampaignRequest);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Authorization": idToken !== undefined && idToken !== null ? "" + idToken : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddOrUpdateOutageCampaign(_response);
        });
    }

    protected processAddOrUpdateOutageCampaign(response: AxiosResponse): Promise<APIResponseOfUpdateResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = APIResponseOfUpdateResponse.fromJS(resultData200);
            return Promise.resolve<APIResponseOfUpdateResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<APIResponseOfUpdateResponse>(null as any);
    }

    getOutageCampaignDetails(idToken: string | null | undefined, getOutageCampaignDetailsRequest: GetOutageCampaignDetailsRequest, cancelToken?: CancelToken): Promise<APIResponseOfAddOrUpdateOutageCampaignRequest> {
        let url_ = this.baseUrl + "/api/facility/GetOutageCampaignDetails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(getOutageCampaignDetailsRequest);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Authorization": idToken !== undefined && idToken !== null ? "" + idToken : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOutageCampaignDetails(_response);
        });
    }

    protected processGetOutageCampaignDetails(response: AxiosResponse): Promise<APIResponseOfAddOrUpdateOutageCampaignRequest> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = APIResponseOfAddOrUpdateOutageCampaignRequest.fromJS(resultData200);
            return Promise.resolve<APIResponseOfAddOrUpdateOutageCampaignRequest>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<APIResponseOfAddOrUpdateOutageCampaignRequest>(null as any);
    }

    getOutageCommunicationTypes(idToken: string | null | undefined, cancelToken?: CancelToken): Promise<APIResponseOfOutageCommunicationTypeResponse> {
        let url_ = this.baseUrl + "/api/facility/GetOutageCommunicationTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Authorization": idToken !== undefined && idToken !== null ? "" + idToken : "",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOutageCommunicationTypes(_response);
        });
    }

    protected processGetOutageCommunicationTypes(response: AxiosResponse): Promise<APIResponseOfOutageCommunicationTypeResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = APIResponseOfOutageCommunicationTypeResponse.fromJS(resultData200);
            return Promise.resolve<APIResponseOfOutageCommunicationTypeResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<APIResponseOfOutageCommunicationTypeResponse>(null as any);
    }

    getOutageCampaignListView(idToken: string | null | undefined, req: OutageCampaignListViewRequest, cancelToken?: CancelToken): Promise<APIResponseOfListOfOutageCampaignResponse> {
        let url_ = this.baseUrl + "/api/facility/GetOutageCampaignListView";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(req);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Authorization": idToken !== undefined && idToken !== null ? "" + idToken : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOutageCampaignListView(_response);
        });
    }

    protected processGetOutageCampaignListView(response: AxiosResponse): Promise<APIResponseOfListOfOutageCampaignResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = APIResponseOfListOfOutageCampaignResponse.fromJS(resultData200);
            return Promise.resolve<APIResponseOfListOfOutageCampaignResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<APIResponseOfListOfOutageCampaignResponse>(null as any);
    }

    processOutageContacts(idToken: string | null | undefined, cCaaSOutagecampaignRequest: CCaaSOutagecampaignRequest, cancelToken?: CancelToken): Promise<APIResponseOfString> {
        let url_ = this.baseUrl + "/api/facility/ProcessOutageContacts";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(cCaaSOutagecampaignRequest);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Authorization": idToken !== undefined && idToken !== null ? "" + idToken : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processProcessOutageContacts(_response);
        });
    }

    protected processProcessOutageContacts(response: AxiosResponse): Promise<APIResponseOfString> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = APIResponseOfString.fromJS(resultData200);
            return Promise.resolve<APIResponseOfString>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<APIResponseOfString>(null as any);
    }

    validateCampaignName(req: ValidateCampaignNameRequest, cancelToken?: CancelToken): Promise<APIResponseOfValidateCampaignNameResponse> {
        let url_ = this.baseUrl + "/api/facility/ValidateCampainName";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(req);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processValidateCampaignName(_response);
        });
    }

    protected processValidateCampaignName(response: AxiosResponse): Promise<APIResponseOfValidateCampaignNameResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = APIResponseOfValidateCampaignNameResponse.fromJS(resultData200);
            return Promise.resolve<APIResponseOfValidateCampaignNameResponse>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<APIResponseOfValidateCampaignNameResponse>(null as any);
    }

    getFacilityOutageCampaignFilters(idToken: string | null | undefined, req: FacilityOutageCampaignFilterRequest, cancelToken?: CancelToken): Promise<APIResponseOfFacilityOutageCampaignFiltersDTO> {
        let url_ = this.baseUrl + "/api/facility/getFacilityOutageCampaignFilters";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(req);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Authorization": idToken !== undefined && idToken !== null ? "" + idToken : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFacilityOutageCampaignFilters(_response);
        });
    }

    protected processGetFacilityOutageCampaignFilters(response: AxiosResponse): Promise<APIResponseOfFacilityOutageCampaignFiltersDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = APIResponseOfFacilityOutageCampaignFiltersDTO.fromJS(resultData200);
            return Promise.resolve<APIResponseOfFacilityOutageCampaignFiltersDTO>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<APIResponseOfFacilityOutageCampaignFiltersDTO>(null as any);
    }

    getAllUserFacilities(idToken: string | null | undefined, cancelToken?: CancelToken): Promise<APIResponseOfListOfGetAllUserFacilityResponse> {
        let url_ = this.baseUrl + "/api/facility/GetAllUserFacilities";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Authorization": idToken !== undefined && idToken !== null ? "" + idToken : "",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllUserFacilities(_response);
        });
    }

    protected processGetAllUserFacilities(response: AxiosResponse): Promise<APIResponseOfListOfGetAllUserFacilityResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = APIResponseOfListOfGetAllUserFacilityResponse.fromJS(resultData200);
            return Promise.resolve<APIResponseOfListOfGetAllUserFacilityResponse>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<APIResponseOfListOfGetAllUserFacilityResponse>(null as any);
    }

    getOutageCampaignAccounts(idToken: string | null | undefined, req: OutageCampaignAccountRequest, cancelToken?: CancelToken): Promise<APIResponseOfListOfOutageCampaignAccountsResponse> {
        let url_ = this.baseUrl + "/api/facility/GetOutageCampaignAccounts";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(req);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Authorization": idToken !== undefined && idToken !== null ? "" + idToken : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOutageCampaignAccounts(_response);
        });
    }

    protected processGetOutageCampaignAccounts(response: AxiosResponse): Promise<APIResponseOfListOfOutageCampaignAccountsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = APIResponseOfListOfOutageCampaignAccountsResponse.fromJS(resultData200);
            return Promise.resolve<APIResponseOfListOfOutageCampaignAccountsResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<APIResponseOfListOfOutageCampaignAccountsResponse>(null as any);
    }
}

export class AuthEndPointsClient extends ServiceBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getUserInfo(idToken: string | null | undefined, cancelToken?: CancelToken): Promise<APIResponseOfUserInfo> {
        let url_ = this.baseUrl + "/api/auth/getUserInfo";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Authorization": idToken !== undefined && idToken !== null ? "" + idToken : "",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUserInfo(_response);
        });
    }

    protected processGetUserInfo(response: AxiosResponse): Promise<APIResponseOfUserInfo> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = APIResponseOfUserInfo.fromJS(resultData200);
            return Promise.resolve<APIResponseOfUserInfo>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<APIResponseOfUserInfo>(null as any);
    }
}

export class AuthorizationEndPointsClient extends ServiceBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getAuthorizationSummary(idToken: string | null | undefined, authorizationSummaryRequest: AuthorizationSummaryRequest, cancelToken?: CancelToken): Promise<APIResponseOfListOfAuthorizationSummaryResponse> {
        let url_ = this.baseUrl + "/api/authorization/getAuthorizationSummary";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(authorizationSummaryRequest);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Authorization": idToken !== undefined && idToken !== null ? "" + idToken : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAuthorizationSummary(_response);
        });
    }

    protected processGetAuthorizationSummary(response: AxiosResponse): Promise<APIResponseOfListOfAuthorizationSummaryResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = APIResponseOfListOfAuthorizationSummaryResponse.fromJS(resultData200);
            return Promise.resolve<APIResponseOfListOfAuthorizationSummaryResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<APIResponseOfListOfAuthorizationSummaryResponse>(null as any);
    }

    getAuthorizationListView(idToken: string | null | undefined, authorizationListViewRequest: AuthorizationListViewRequest, cancelToken?: CancelToken): Promise<APIResponseOfListOfAuthorizationListViewResponseDTO> {
        let url_ = this.baseUrl + "/api/authorization/getAuthorizationListView";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(authorizationListViewRequest);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Authorization": idToken !== undefined && idToken !== null ? "" + idToken : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAuthorizationListView(_response);
        });
    }

    protected processGetAuthorizationListView(response: AxiosResponse): Promise<APIResponseOfListOfAuthorizationListViewResponseDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = APIResponseOfListOfAuthorizationListViewResponseDTO.fromJS(resultData200);
            return Promise.resolve<APIResponseOfListOfAuthorizationListViewResponseDTO>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<APIResponseOfListOfAuthorizationListViewResponseDTO>(null as any);
    }

    getInsuranceData(insuranceDetailRequest: InsuranceDetailRequest, cancelToken?: CancelToken): Promise<APIResponseOfInsuranceData> {
        let url_ = this.baseUrl + "/api/authorization/getInsuranceData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(insuranceDetailRequest);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetInsuranceData(_response);
        });
    }

    protected processGetInsuranceData(response: AxiosResponse): Promise<APIResponseOfInsuranceData> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = APIResponseOfInsuranceData.fromJS(resultData200);
            return Promise.resolve<APIResponseOfInsuranceData>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<APIResponseOfInsuranceData>(null as any);
    }

    updateAuthStatus(idToken: string | null | undefined, authStatusUpdateRequest: AuthStatusUpdateRequest, cancelToken?: CancelToken): Promise<APIResponseOfUpdateResponseDTO> {
        let url_ = this.baseUrl + "/api/authorization/updateAuthStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(authStatusUpdateRequest);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Authorization": idToken !== undefined && idToken !== null ? "" + idToken : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateAuthStatus(_response);
        });
    }

    protected processUpdateAuthStatus(response: AxiosResponse): Promise<APIResponseOfUpdateResponseDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = APIResponseOfUpdateResponseDTO.fromJS(resultData200);
            return Promise.resolve<APIResponseOfUpdateResponseDTO>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<APIResponseOfUpdateResponseDTO>(null as any);
    }

    getAuthorziationStatus( cancelToken?: CancelToken): Promise<APIResponseOfListOfDropDownItem> {
        let url_ = this.baseUrl + "/api/authorization/getAuthorizationStatus";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAuthorziationStatus(_response);
        });
    }

    protected processGetAuthorziationStatus(response: AxiosResponse): Promise<APIResponseOfListOfDropDownItem> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = APIResponseOfListOfDropDownItem.fromJS(resultData200);
            return Promise.resolve<APIResponseOfListOfDropDownItem>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<APIResponseOfListOfDropDownItem>(null as any);
    }

    getInsuranceCount(insuranceDetailRequest: InsuranceDetailRequest, cancelToken?: CancelToken): Promise<APIResponseOfInsuranceCount> {
        let url_ = this.baseUrl + "/api/authorization/getInsuranceCount";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(insuranceDetailRequest);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetInsuranceCount(_response);
        });
    }

    protected processGetInsuranceCount(response: AxiosResponse): Promise<APIResponseOfInsuranceCount> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = APIResponseOfInsuranceCount.fromJS(resultData200);
            return Promise.resolve<APIResponseOfInsuranceCount>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<APIResponseOfInsuranceCount>(null as any);
    }

    getAttendingPhysician( cancelToken?: CancelToken): Promise<APIResponseOfListOfDropDownItem> {
        let url_ = this.baseUrl + "/api/authorization/getAttendingPhysician";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAttendingPhysician(_response);
        });
    }

    protected processGetAttendingPhysician(response: AxiosResponse): Promise<APIResponseOfListOfDropDownItem> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = APIResponseOfListOfDropDownItem.fromJS(resultData200);
            return Promise.resolve<APIResponseOfListOfDropDownItem>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<APIResponseOfListOfDropDownItem>(null as any);
    }

    getMajorPayor( cancelToken?: CancelToken): Promise<APIResponseOfListOfDropDownItem> {
        let url_ = this.baseUrl + "/api/authorization/getMajorPayor";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMajorPayor(_response);
        });
    }

    protected processGetMajorPayor(response: AxiosResponse): Promise<APIResponseOfListOfDropDownItem> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = APIResponseOfListOfDropDownItem.fromJS(resultData200);
            return Promise.resolve<APIResponseOfListOfDropDownItem>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<APIResponseOfListOfDropDownItem>(null as any);
    }

    getFinancialClass( cancelToken?: CancelToken): Promise<APIResponseOfListOfDropDownItem> {
        let url_ = this.baseUrl + "/api/authorization/getFinancialClass";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFinancialClass(_response);
        });
    }

    protected processGetFinancialClass(response: AxiosResponse): Promise<APIResponseOfListOfDropDownItem> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = APIResponseOfListOfDropDownItem.fromJS(resultData200);
            return Promise.resolve<APIResponseOfListOfDropDownItem>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<APIResponseOfListOfDropDownItem>(null as any);
    }

    getAccountType( cancelToken?: CancelToken): Promise<APIResponseOfListOfDropDownItem> {
        let url_ = this.baseUrl + "/api/authorization/getAccountType";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAccountType(_response);
        });
    }

    protected processGetAccountType(response: AxiosResponse): Promise<APIResponseOfListOfDropDownItem> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = APIResponseOfListOfDropDownItem.fromJS(resultData200);
            return Promise.resolve<APIResponseOfListOfDropDownItem>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<APIResponseOfListOfDropDownItem>(null as any);
    }

    getLocation( cancelToken?: CancelToken): Promise<APIResponseOfListOfDropDownItem> {
        let url_ = this.baseUrl + "/api/authorization/getLocation";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetLocation(_response);
        });
    }

    protected processGetLocation(response: AxiosResponse): Promise<APIResponseOfListOfDropDownItem> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = APIResponseOfListOfDropDownItem.fromJS(resultData200);
            return Promise.resolve<APIResponseOfListOfDropDownItem>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<APIResponseOfListOfDropDownItem>(null as any);
    }

    getScheduledBy( cancelToken?: CancelToken): Promise<APIResponseOfListOfDropDownItem> {
        let url_ = this.baseUrl + "/api/authorization/getScheduledBy";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetScheduledBy(_response);
        });
    }

    protected processGetScheduledBy(response: AxiosResponse): Promise<APIResponseOfListOfDropDownItem> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = APIResponseOfListOfDropDownItem.fromJS(resultData200);
            return Promise.resolve<APIResponseOfListOfDropDownItem>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<APIResponseOfListOfDropDownItem>(null as any);
    }

    getAuthResp( cancelToken?: CancelToken): Promise<APIResponseOfListOfDropDownItem> {
        let url_ = this.baseUrl + "/api/authorization/getAuthResp";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAuthResp(_response);
        });
    }

    protected processGetAuthResp(response: AxiosResponse): Promise<APIResponseOfListOfDropDownItem> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = APIResponseOfListOfDropDownItem.fromJS(resultData200);
            return Promise.resolve<APIResponseOfListOfDropDownItem>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<APIResponseOfListOfDropDownItem>(null as any);
    }

    getAllInsuranceCPTs( cancelToken?: CancelToken): Promise<APIResponseOfListOfCPTDTO> {
        let url_ = this.baseUrl + "/api/authorization/allCPTs";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllInsuranceCPTs(_response);
        });
    }

    protected processGetAllInsuranceCPTs(response: AxiosResponse): Promise<APIResponseOfListOfCPTDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = APIResponseOfListOfCPTDTO.fromJS(resultData200);
            return Promise.resolve<APIResponseOfListOfCPTDTO>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<APIResponseOfListOfCPTDTO>(null as any);
    }

    getInsuranceCPTs(insuranceCPTRequest: InsuranceCPTRequest, cancelToken?: CancelToken): Promise<APIResponseOfListOfAuthInsuranceCPTDTO> {
        let url_ = this.baseUrl + "/api/authorization/insurance/CPTs";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(insuranceCPTRequest);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetInsuranceCPTs(_response);
        });
    }

    protected processGetInsuranceCPTs(response: AxiosResponse): Promise<APIResponseOfListOfAuthInsuranceCPTDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = APIResponseOfListOfAuthInsuranceCPTDTO.fromJS(resultData200);
            return Promise.resolve<APIResponseOfListOfAuthInsuranceCPTDTO>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<APIResponseOfListOfAuthInsuranceCPTDTO>(null as any);
    }

    saveInsuranceCpts(idToken: string | null | undefined, insuranceCPTSaveRequest: InsuranceCPTSaveRequest, cancelToken?: CancelToken): Promise<APIResponseOfUpdateResponseDTO> {
        let url_ = this.baseUrl + "/api/authorization/insurance/saveCPTs";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(insuranceCPTSaveRequest);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Authorization": idToken !== undefined && idToken !== null ? "" + idToken : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveInsuranceCpts(_response);
        });
    }

    protected processSaveInsuranceCpts(response: AxiosResponse): Promise<APIResponseOfUpdateResponseDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = APIResponseOfUpdateResponseDTO.fromJS(resultData200);
            return Promise.resolve<APIResponseOfUpdateResponseDTO>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<APIResponseOfUpdateResponseDTO>(null as any);
    }

    setPrimaryCPTs(idToken: string | null | undefined, insuranceCPTPrimarySetRequest: InsuranceCPTPrimarySetRequest, cancelToken?: CancelToken): Promise<APIResponseOfUpdateResponseDTO> {
        let url_ = this.baseUrl + "/api/authorization/insurance/setPrimaryCPTs";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(insuranceCPTPrimarySetRequest);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Authorization": idToken !== undefined && idToken !== null ? "" + idToken : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetPrimaryCPTs(_response);
        });
    }

    protected processSetPrimaryCPTs(response: AxiosResponse): Promise<APIResponseOfUpdateResponseDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = APIResponseOfUpdateResponseDTO.fromJS(resultData200);
            return Promise.resolve<APIResponseOfUpdateResponseDTO>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<APIResponseOfUpdateResponseDTO>(null as any);
    }

    getCompletedReasons( cancelToken?: CancelToken): Promise<APIResponseOfListOfDropDownItem> {
        let url_ = this.baseUrl + "/api/authorization/insurance/getReasons";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCompletedReasons(_response);
        });
    }

    protected processGetCompletedReasons(response: AxiosResponse): Promise<APIResponseOfListOfDropDownItem> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = APIResponseOfListOfDropDownItem.fromJS(resultData200);
            return Promise.resolve<APIResponseOfListOfDropDownItem>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<APIResponseOfListOfDropDownItem>(null as any);
    }

    setMarkAsComplete(idToken: string | null | undefined, insuranceMarkAsCompleteRequest: InsuranceMarkAsCompleteRequest, cancelToken?: CancelToken): Promise<APIResponseOfUpdateResponseDTO> {
        let url_ = this.baseUrl + "/api/authorization/insurance/markAsComplete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(insuranceMarkAsCompleteRequest);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Authorization": idToken !== undefined && idToken !== null ? "" + idToken : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetMarkAsComplete(_response);
        });
    }

    protected processSetMarkAsComplete(response: AxiosResponse): Promise<APIResponseOfUpdateResponseDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = APIResponseOfUpdateResponseDTO.fromJS(resultData200);
            return Promise.resolve<APIResponseOfUpdateResponseDTO>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<APIResponseOfUpdateResponseDTO>(null as any);
    }

    cptSummary(insuranceCPTRequest: InsuranceCPTRequest, cancelToken?: CancelToken): Promise<APIResponseOfAuthInsuranceCPTResponse> {
        let url_ = this.baseUrl + "/api/authorization/insurance/CPTSummary";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(insuranceCPTRequest);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCptSummary(_response);
        });
    }

    protected processCptSummary(response: AxiosResponse): Promise<APIResponseOfAuthInsuranceCPTResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = APIResponseOfAuthInsuranceCPTResponse.fromJS(resultData200);
            return Promise.resolve<APIResponseOfAuthInsuranceCPTResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<APIResponseOfAuthInsuranceCPTResponse>(null as any);
    }

    addAuthorization(idToken: string | null | undefined, insuranceAddAuthorizationRequest: InsuranceAddAuthorizationRequest, cancelToken?: CancelToken): Promise<APIResponseOfUpdateResponseDTO> {
        let url_ = this.baseUrl + "/api/authorization/insurance/addAuthorization";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(insuranceAddAuthorizationRequest);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Authorization": idToken !== undefined && idToken !== null ? "" + idToken : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddAuthorization(_response);
        });
    }

    protected processAddAuthorization(response: AxiosResponse): Promise<APIResponseOfUpdateResponseDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = APIResponseOfUpdateResponseDTO.fromJS(resultData200);
            return Promise.resolve<APIResponseOfUpdateResponseDTO>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<APIResponseOfUpdateResponseDTO>(null as any);
    }

    getAuthType( cancelToken?: CancelToken): Promise<APIResponseOfListOfDropDownItem> {
        let url_ = this.baseUrl + "/api/authorization/insurance/getAuthType";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAuthType(_response);
        });
    }

    protected processGetAuthType(response: AxiosResponse): Promise<APIResponseOfListOfDropDownItem> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = APIResponseOfListOfDropDownItem.fromJS(resultData200);
            return Promise.resolve<APIResponseOfListOfDropDownItem>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<APIResponseOfListOfDropDownItem>(null as any);
    }

    getResult( cancelToken?: CancelToken): Promise<APIResponseOfListOfInsuranceAuthResultResponse> {
        let url_ = this.baseUrl + "/api/authorization/insurance/getResult";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetResult(_response);
        });
    }

    protected processGetResult(response: AxiosResponse): Promise<APIResponseOfListOfInsuranceAuthResultResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = APIResponseOfListOfInsuranceAuthResultResponse.fromJS(resultData200);
            return Promise.resolve<APIResponseOfListOfInsuranceAuthResultResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<APIResponseOfListOfInsuranceAuthResultResponse>(null as any);
    }

    getAuthStatus( cancelToken?: CancelToken): Promise<APIResponseOfListOfInsuranceAuthStatusDTO> {
        let url_ = this.baseUrl + "/api/authorization/insurance/getAuthStatus";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAuthStatus(_response);
        });
    }

    protected processGetAuthStatus(response: AxiosResponse): Promise<APIResponseOfListOfInsuranceAuthStatusDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = APIResponseOfListOfInsuranceAuthStatusDTO.fromJS(resultData200);
            return Promise.resolve<APIResponseOfListOfInsuranceAuthStatusDTO>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<APIResponseOfListOfInsuranceAuthStatusDTO>(null as any);
    }

    getAccountAuthorziation(inusranceGetAccountAuthorizationRequest: InusranceGetAccountAuthorizationRequest, cancelToken?: CancelToken): Promise<APIResponseOfInsuranceGetAccountAuthorizationDTO> {
        let url_ = this.baseUrl + "/api/authorization/insurance/getAccountAuthorization";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(inusranceGetAccountAuthorizationRequest);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAccountAuthorziation(_response);
        });
    }

    protected processGetAccountAuthorziation(response: AxiosResponse): Promise<APIResponseOfInsuranceGetAccountAuthorizationDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = APIResponseOfInsuranceGetAccountAuthorizationDTO.fromJS(resultData200);
            return Promise.resolve<APIResponseOfInsuranceGetAccountAuthorizationDTO>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<APIResponseOfInsuranceGetAccountAuthorizationDTO>(null as any);
    }

    getEscalationReason( cancelToken?: CancelToken): Promise<APIResponseOfListOfDropDownItem> {
        let url_ = this.baseUrl + "/api/authorization/insurance/getEscalationReason";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetEscalationReason(_response);
        });
    }

    protected processGetEscalationReason(response: AxiosResponse): Promise<APIResponseOfListOfDropDownItem> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = APIResponseOfListOfDropDownItem.fromJS(resultData200);
            return Promise.resolve<APIResponseOfListOfDropDownItem>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<APIResponseOfListOfDropDownItem>(null as any);
    }

    escalateAccountInsurance(idToken: string | null | undefined, insuranceEscalateAccountRequest: InsuranceEscalateAccountRequest, cancelToken?: CancelToken): Promise<APIResponseOfUpdateResponseDTO> {
        let url_ = this.baseUrl + "/api/authorization/insurance/escalateAccount";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(insuranceEscalateAccountRequest);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Authorization": idToken !== undefined && idToken !== null ? "" + idToken : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processEscalateAccountInsurance(_response);
        });
    }

    protected processEscalateAccountInsurance(response: AxiosResponse): Promise<APIResponseOfUpdateResponseDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = APIResponseOfUpdateResponseDTO.fromJS(resultData200);
            return Promise.resolve<APIResponseOfUpdateResponseDTO>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<APIResponseOfUpdateResponseDTO>(null as any);
    }

    getAuthPhoneType( cancelToken?: CancelToken): Promise<APIResponseOfListOfDropDownItem> {
        let url_ = this.baseUrl + "/api/authorization/insurance/getAuthPhoneType";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAuthPhoneType(_response);
        });
    }

    protected processGetAuthPhoneType(response: AxiosResponse): Promise<APIResponseOfListOfDropDownItem> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = APIResponseOfListOfDropDownItem.fromJS(resultData200);
            return Promise.resolve<APIResponseOfListOfDropDownItem>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<APIResponseOfListOfDropDownItem>(null as any);
    }

    getAuthMatrix( cancelToken?: CancelToken): Promise<APIResponseOfListOfInsuranceAuthMatrixResponse> {
        let url_ = this.baseUrl + "/api/authorization/insurance/getAuthMatrix";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAuthMatrix(_response);
        });
    }

    protected processGetAuthMatrix(response: AxiosResponse): Promise<APIResponseOfListOfInsuranceAuthMatrixResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = APIResponseOfListOfInsuranceAuthMatrixResponse.fromJS(resultData200);
            return Promise.resolve<APIResponseOfListOfInsuranceAuthMatrixResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<APIResponseOfListOfInsuranceAuthMatrixResponse>(null as any);
    }

    getAuthMethod( cancelToken?: CancelToken): Promise<APIResponseOfListOfDropDownItem> {
        let url_ = this.baseUrl + "/api/authorization/insurance/getAuthMethod";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAuthMethod(_response);
        });
    }

    protected processGetAuthMethod(response: AxiosResponse): Promise<APIResponseOfListOfDropDownItem> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = APIResponseOfListOfDropDownItem.fromJS(resultData200);
            return Promise.resolve<APIResponseOfListOfDropDownItem>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<APIResponseOfListOfDropDownItem>(null as any);
    }

    updateAuthInitiatedDate(idToken: string | null | undefined, req: UpdateAuthInitiatedRequest, cancelToken?: CancelToken): Promise<APIResponseOfUpdateResponseDTO> {
        let url_ = this.baseUrl + "/api/authorization/insurance/updateAuthInitiatedDate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(req);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Authorization": idToken !== undefined && idToken !== null ? "" + idToken : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateAuthInitiatedDate(_response);
        });
    }

    protected processUpdateAuthInitiatedDate(response: AxiosResponse): Promise<APIResponseOfUpdateResponseDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = APIResponseOfUpdateResponseDTO.fromJS(resultData200);
            return Promise.resolve<APIResponseOfUpdateResponseDTO>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<APIResponseOfUpdateResponseDTO>(null as any);
    }
}

export class PatientInstructionsEndpointsClient extends ServiceBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getPatientInstructions(patientInstructionsDTO: PatientInstructionsDTO, cancelToken?: CancelToken): Promise<APIResponseOfPatientInstructionsResponse> {
        let url_ = this.baseUrl + "/api/patientinstructions/getPatientInstructions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(patientInstructionsDTO);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPatientInstructions(_response);
        });
    }

    protected processGetPatientInstructions(response: AxiosResponse): Promise<APIResponseOfPatientInstructionsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = APIResponseOfPatientInstructionsResponse.fromJS(resultData200);
            return Promise.resolve<APIResponseOfPatientInstructionsResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<APIResponseOfPatientInstructionsResponse>(null as any);
    }
}

export class NoteEndPointsClient extends ServiceBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    addNote(req: AppAccountNoteAddRequest, cancelToken?: CancelToken): Promise<APIResponseOfUpdateResponseDTO> {
        let url_ = this.baseUrl + "/api/note/addNote";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(req);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddNote(_response);
        });
    }

    protected processAddNote(response: AxiosResponse): Promise<APIResponseOfUpdateResponseDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = APIResponseOfUpdateResponseDTO.fromJS(resultData200);
            return Promise.resolve<APIResponseOfUpdateResponseDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<APIResponseOfUpdateResponseDTO>(null as any);
    }

    getNoteTypes( cancelToken?: CancelToken): Promise<APIResponseOfListOfNoteTypeDTO> {
        let url_ = this.baseUrl + "/api/note/getNoteTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetNoteTypes(_response);
        });
    }

    protected processGetNoteTypes(response: AxiosResponse): Promise<APIResponseOfListOfNoteTypeDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = APIResponseOfListOfNoteTypeDTO.fromJS(resultData200);
            return Promise.resolve<APIResponseOfListOfNoteTypeDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<APIResponseOfListOfNoteTypeDTO>(null as any);
    }

    getNoteActions( cancelToken?: CancelToken): Promise<APIResponseOfListOfNoteActionDTO> {
        let url_ = this.baseUrl + "/api/note/getNoteActions";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetNoteActions(_response);
        });
    }

    protected processGetNoteActions(response: AxiosResponse): Promise<APIResponseOfListOfNoteActionDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = APIResponseOfListOfNoteActionDTO.fromJS(resultData200);
            return Promise.resolve<APIResponseOfListOfNoteActionDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<APIResponseOfListOfNoteActionDTO>(null as any);
    }

    getNoteDetailsData(noteDetailsRequest: NoteDetailsRequest, cancelToken?: CancelToken): Promise<APIResponseOfListOfNoteDetailsResponse> {
        let url_ = this.baseUrl + "/api/note/getNoteDetailsData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(noteDetailsRequest);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetNoteDetailsData(_response);
        });
    }

    protected processGetNoteDetailsData(response: AxiosResponse): Promise<APIResponseOfListOfNoteDetailsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = APIResponseOfListOfNoteDetailsResponse.fromJS(resultData200);
            return Promise.resolve<APIResponseOfListOfNoteDetailsResponse>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<APIResponseOfListOfNoteDetailsResponse>(null as any);
    }

    getNoteDetailsCount(noteDetailsRequest: NoteDetailsRequest, cancelToken?: CancelToken): Promise<APIResponseOfNoteDetailsCount> {
        let url_ = this.baseUrl + "/api/note/getNoteDetailsCount";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(noteDetailsRequest);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetNoteDetailsCount(_response);
        });
    }

    protected processGetNoteDetailsCount(response: AxiosResponse): Promise<APIResponseOfNoteDetailsCount> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = APIResponseOfNoteDetailsCount.fromJS(resultData200);
            return Promise.resolve<APIResponseOfNoteDetailsCount>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<APIResponseOfNoteDetailsCount>(null as any);
    }

    getAllNoteActionsWithNoteType(req: NoteTypeRequest, cancelToken?: CancelToken): Promise<APIResponseOfListOfNoteActionDTO> {
        let url_ = this.baseUrl + "/api/note/getAllNoteActionsWithNoteType";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(req);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllNoteActionsWithNoteType(_response);
        });
    }

    protected processGetAllNoteActionsWithNoteType(response: AxiosResponse): Promise<APIResponseOfListOfNoteActionDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = APIResponseOfListOfNoteActionDTO.fromJS(resultData200);
            return Promise.resolve<APIResponseOfListOfNoteActionDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<APIResponseOfListOfNoteActionDTO>(null as any);
    }
}

export class UserEndPointsClient extends ServiceBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getAppUsers(searchText: string, cancelToken?: CancelToken): Promise<APIResponseOfListOfUserSearchDTO> {
        let url_ = this.baseUrl + "/api/user/getAppUsers?";
        if (searchText === undefined || searchText === null)
            throw new globalThis.Error("The parameter 'searchText' must be defined and cannot be null.");
        else
            url_ += "searchText=" + encodeURIComponent("" + searchText) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAppUsers(_response);
        });
    }

    protected processGetAppUsers(response: AxiosResponse): Promise<APIResponseOfListOfUserSearchDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = APIResponseOfListOfUserSearchDTO.fromJS(resultData200);
            return Promise.resolve<APIResponseOfListOfUserSearchDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<APIResponseOfListOfUserSearchDTO>(null as any);
    }

    getUserPermissions(hca34Id: string, cancelToken?: CancelToken): Promise<APIResponseOfListOfUserPermissionDTO> {
        let url_ = this.baseUrl + "/api/user/getUserPermissions?";
        if (hca34Id === undefined || hca34Id === null)
            throw new globalThis.Error("The parameter 'hca34Id' must be defined and cannot be null.");
        else
            url_ += "hca34Id=" + encodeURIComponent("" + hca34Id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUserPermissions(_response);
        });
    }

    protected processGetUserPermissions(response: AxiosResponse): Promise<APIResponseOfListOfUserPermissionDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = APIResponseOfListOfUserPermissionDTO.fromJS(resultData200);
            return Promise.resolve<APIResponseOfListOfUserPermissionDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<APIResponseOfListOfUserPermissionDTO>(null as any);
    }

    getUserRoles( cancelToken?: CancelToken): Promise<APIResponseOfListOfDropDownItem> {
        let url_ = this.baseUrl + "/api/user/getUserRoles";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUserRoles(_response);
        });
    }

    protected processGetUserRoles(response: AxiosResponse): Promise<APIResponseOfListOfDropDownItem> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = APIResponseOfListOfDropDownItem.fromJS(resultData200);
            return Promise.resolve<APIResponseOfListOfDropDownItem>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<APIResponseOfListOfDropDownItem>(null as any);
    }

    getUserNames( cancelToken?: CancelToken): Promise<APIResponseOfListOfDropDownItem> {
        let url_ = this.baseUrl + "/api/user/getUserNames";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUserNames(_response);
        });
    }

    protected processGetUserNames(response: AxiosResponse): Promise<APIResponseOfListOfDropDownItem> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = APIResponseOfListOfDropDownItem.fromJS(resultData200);
            return Promise.resolve<APIResponseOfListOfDropDownItem>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<APIResponseOfListOfDropDownItem>(null as any);
    }

    getUserInformation(req: UserInformationListRequest, cancelToken?: CancelToken): Promise<APIResponseOfListOfUserInformationDTO> {
        let url_ = this.baseUrl + "/api/user/getUserInformation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(req);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUserInformation(_response);
        });
    }

    protected processGetUserInformation(response: AxiosResponse): Promise<APIResponseOfListOfUserInformationDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = APIResponseOfListOfUserInformationDTO.fromJS(resultData200);
            return Promise.resolve<APIResponseOfListOfUserInformationDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<APIResponseOfListOfUserInformationDTO>(null as any);
    }

    getWorkFlows( cancelToken?: CancelToken): Promise<APIResponseOfListOfDropDownItem> {
        let url_ = this.baseUrl + "/api/user/getWorkFlows";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetWorkFlows(_response);
        });
    }

    protected processGetWorkFlows(response: AxiosResponse): Promise<APIResponseOfListOfDropDownItem> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = APIResponseOfListOfDropDownItem.fromJS(resultData200);
            return Promise.resolve<APIResponseOfListOfDropDownItem>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<APIResponseOfListOfDropDownItem>(null as any);
    }

    getAssignUsers(workFlowId: number, cancelToken?: CancelToken): Promise<APIResponseOfListOfAssignUserDTO> {
        let url_ = this.baseUrl + "/api/user/getAssignUsers?";
        if (workFlowId === undefined || workFlowId === null)
            throw new globalThis.Error("The parameter 'workFlowId' must be defined and cannot be null.");
        else
            url_ += "workFlowId=" + encodeURIComponent("" + workFlowId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAssignUsers(_response);
        });
    }

    protected processGetAssignUsers(response: AxiosResponse): Promise<APIResponseOfListOfAssignUserDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = APIResponseOfListOfAssignUserDTO.fromJS(resultData200);
            return Promise.resolve<APIResponseOfListOfAssignUserDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<APIResponseOfListOfAssignUserDTO>(null as any);
    }

    getCommonConfiguration( cancelToken?: CancelToken): Promise<APIResponseOfCommonConfiguration> {
        let url_ = this.baseUrl + "/api/user/getCommonConfiguration";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCommonConfiguration(_response);
        });
    }

    protected processGetCommonConfiguration(response: AxiosResponse): Promise<APIResponseOfCommonConfiguration> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = APIResponseOfCommonConfiguration.fromJS(resultData200);
            return Promise.resolve<APIResponseOfCommonConfiguration>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<APIResponseOfCommonConfiguration>(null as any);
    }
}

export class CCaaSAccountEndPointsClient extends ServiceBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    searchAccount(req: any, cancelToken?: CancelToken): Promise<APIResponseOfCCaaSsearchAccountResponse> {
        let url_ = this.baseUrl + "/api/CCaaS/SearchAccount";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(req);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchAccount(_response);
        });
    }

    protected processSearchAccount(response: AxiosResponse): Promise<APIResponseOfCCaaSsearchAccountResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = APIResponseOfCCaaSsearchAccountResponse.fromJS(resultData200);
            return Promise.resolve<APIResponseOfCCaaSsearchAccountResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<APIResponseOfCCaaSsearchAccountResponse>(null as any);
    }

    searchAppointment(req: any, cancelToken?: CancelToken): Promise<APIResponseOfCCaaSsearchAppointmentResponse> {
        let url_ = this.baseUrl + "/api/CCaaS/SearchAppointment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(req);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchAppointment(_response);
        });
    }

    protected processSearchAppointment(response: AxiosResponse): Promise<APIResponseOfCCaaSsearchAppointmentResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = APIResponseOfCCaaSsearchAppointmentResponse.fromJS(resultData200);
            return Promise.resolve<APIResponseOfCCaaSsearchAppointmentResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<APIResponseOfCCaaSsearchAppointmentResponse>(null as any);
    }

    searchAccountDemographics(req: CCaaSSearchAccountDemographicsRequest, cancelToken?: CancelToken): Promise<APIResponseOfCCaaSSearchAccountDemographicsResponse> {
        let url_ = this.baseUrl + "/api/CCaaS/SearchAccountDemographics";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(req);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchAccountDemographics(_response);
        });
    }

    protected processSearchAccountDemographics(response: AxiosResponse): Promise<APIResponseOfCCaaSSearchAccountDemographicsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = APIResponseOfCCaaSSearchAccountDemographicsResponse.fromJS(resultData200);
            return Promise.resolve<APIResponseOfCCaaSSearchAccountDemographicsResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<APIResponseOfCCaaSSearchAccountDemographicsResponse>(null as any);
    }
}

export class WorkFlowEndPointsClient extends ServiceBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getAllServiceCenter( cancelToken?: CancelToken): Promise<APIResponseOfListOfRefServiceCenterDTO> {
        let url_ = this.baseUrl + "/api/workflow/getAllServiceCenter";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllServiceCenter(_response);
        });
    }

    protected processGetAllServiceCenter(response: AxiosResponse): Promise<APIResponseOfListOfRefServiceCenterDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = APIResponseOfListOfRefServiceCenterDTO.fromJS(resultData200);
            return Promise.resolve<APIResponseOfListOfRefServiceCenterDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<APIResponseOfListOfRefServiceCenterDTO>(null as any);
    }

    getWorkFlowDataDetails(workFlowId: number, cancelToken?: CancelToken): Promise<APIResponseOfWorkFlowDataResponse> {
        let url_ = this.baseUrl + "/api/workflow/getWorkFlowDataDetails?";
        if (workFlowId === undefined || workFlowId === null)
            throw new globalThis.Error("The parameter 'workFlowId' must be defined and cannot be null.");
        else
            url_ += "workFlowId=" + encodeURIComponent("" + workFlowId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetWorkFlowDataDetails(_response);
        });
    }

    protected processGetWorkFlowDataDetails(response: AxiosResponse): Promise<APIResponseOfWorkFlowDataResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = APIResponseOfWorkFlowDataResponse.fromJS(resultData200);
            return Promise.resolve<APIResponseOfWorkFlowDataResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<APIResponseOfWorkFlowDataResponse>(null as any);
    }

    getWorkFlowProcesses( cancelToken?: CancelToken): Promise<APIResponseOfListOfRefWorkflowProcessDTO> {
        let url_ = this.baseUrl + "/api/workflow/getWorkFlowProcesses";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetWorkFlowProcesses(_response);
        });
    }

    protected processGetWorkFlowProcesses(response: AxiosResponse): Promise<APIResponseOfListOfRefWorkflowProcessDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = APIResponseOfListOfRefWorkflowProcessDTO.fromJS(resultData200);
            return Promise.resolve<APIResponseOfListOfRefWorkflowProcessDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<APIResponseOfListOfRefWorkflowProcessDTO>(null as any);
    }

    getAllWorkFlows(workFlowDetailsRequest: WorkFlowDetailsRequest, cancelToken?: CancelToken): Promise<APIResponseOfListOfWorkFlowSummaryDTO> {
        let url_ = this.baseUrl + "/api/workflow/getWorkflowSummaryDetails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(workFlowDetailsRequest);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllWorkFlows(_response);
        });
    }

    protected processGetAllWorkFlows(response: AxiosResponse): Promise<APIResponseOfListOfWorkFlowSummaryDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = APIResponseOfListOfWorkFlowSummaryDTO.fromJS(resultData200);
            return Promise.resolve<APIResponseOfListOfWorkFlowSummaryDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<APIResponseOfListOfWorkFlowSummaryDTO>(null as any);
    }

    saveWorkflowData(workFlowDataRequest: WorkFlowDataRequest, cancelToken?: CancelToken): Promise<APIResponseOfUpdateResponseDTO> {
        let url_ = this.baseUrl + "/api/workflow/saveWorkflowData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(workFlowDataRequest);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveWorkflowData(_response);
        });
    }

    protected processSaveWorkflowData(response: AxiosResponse): Promise<APIResponseOfUpdateResponseDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = APIResponseOfUpdateResponseDTO.fromJS(resultData200);
            return Promise.resolve<APIResponseOfUpdateResponseDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<APIResponseOfUpdateResponseDTO>(null as any);
    }

    saveAssignedUsers(assignedUserRequest: AssignedUserRequest, cancelToken?: CancelToken): Promise<APIResponseOfUpdateResponseDTO> {
        let url_ = this.baseUrl + "/api/workflow/saveAssignedUsers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(assignedUserRequest);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveAssignedUsers(_response);
        });
    }

    protected processSaveAssignedUsers(response: AxiosResponse): Promise<APIResponseOfUpdateResponseDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = APIResponseOfUpdateResponseDTO.fromJS(resultData200);
            return Promise.resolve<APIResponseOfUpdateResponseDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<APIResponseOfUpdateResponseDTO>(null as any);
    }
}

export class AlertEndPointsClient extends ServiceBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getAlertList(idToken: string | null | undefined, alertListRequest: AlertListRequest, cancelToken?: CancelToken): Promise<APIResponseOfListOfAlertListDTO> {
        let url_ = this.baseUrl + "/api/alert/getAlertList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(alertListRequest);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Authorization": idToken !== undefined && idToken !== null ? "" + idToken : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAlertList(_response);
        });
    }

    protected processGetAlertList(response: AxiosResponse): Promise<APIResponseOfListOfAlertListDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = APIResponseOfListOfAlertListDTO.fromJS(resultData200);
            return Promise.resolve<APIResponseOfListOfAlertListDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<APIResponseOfListOfAlertListDTO>(null as any);
    }

    getAlertById(id: number, cancelToken?: CancelToken): Promise<APIResponseOfAlertDetailDTO> {
        let url_ = this.baseUrl + "/api/alert/getById/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAlertById(_response);
        });
    }

    protected processGetAlertById(response: AxiosResponse): Promise<APIResponseOfAlertDetailDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = APIResponseOfAlertDetailDTO.fromJS(resultData200);
            return Promise.resolve<APIResponseOfAlertDetailDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<APIResponseOfAlertDetailDTO>(null as any);
    }

    getActiveAccountAlert(id: number, cancelToken?: CancelToken): Promise<APIResponseOfAlertDetailDTO> {
        let url_ = this.baseUrl + "/api/alert/getActiveAccountAlert/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetActiveAccountAlert(_response);
        });
    }

    protected processGetActiveAccountAlert(response: AxiosResponse): Promise<APIResponseOfAlertDetailDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = APIResponseOfAlertDetailDTO.fromJS(resultData200);
            return Promise.resolve<APIResponseOfAlertDetailDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<APIResponseOfAlertDetailDTO>(null as any);
    }

    getActiveSystemAlerts(idToken: string | null | undefined, req: ActiveSystemAlertRequest, cancelToken?: CancelToken): Promise<APIResponseOfListOfAlertListDTO> {
        let url_ = this.baseUrl + "/api/alert/getActiveSystemAlerts";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(req);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Authorization": idToken !== undefined && idToken !== null ? "" + idToken : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetActiveSystemAlerts(_response);
        });
    }

    protected processGetActiveSystemAlerts(response: AxiosResponse): Promise<APIResponseOfListOfAlertListDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = APIResponseOfListOfAlertListDTO.fromJS(resultData200);
            return Promise.resolve<APIResponseOfListOfAlertListDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<APIResponseOfListOfAlertListDTO>(null as any);
    }

    createAlert(idToken: string | null | undefined, createAlertRequest: CreateAlertRequest, cancelToken?: CancelToken): Promise<APIResponseOfUpdateResponseDTO> {
        let url_ = this.baseUrl + "/api/alert/createAlert";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(createAlertRequest);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Authorization": idToken !== undefined && idToken !== null ? "" + idToken : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateAlert(_response);
        });
    }

    protected processCreateAlert(response: AxiosResponse): Promise<APIResponseOfUpdateResponseDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = APIResponseOfUpdateResponseDTO.fromJS(resultData200);
            return Promise.resolve<APIResponseOfUpdateResponseDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<APIResponseOfUpdateResponseDTO>(null as any);
    }

    updateAlert(idToken: string | null | undefined, updateAlertRequest: UpdateAlertRequest, cancelToken?: CancelToken): Promise<APIResponseOfUpdateResponseDTO> {
        let url_ = this.baseUrl + "/api/alert/updateAlert";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updateAlertRequest);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Authorization": idToken !== undefined && idToken !== null ? "" + idToken : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateAlert(_response);
        });
    }

    protected processUpdateAlert(response: AxiosResponse): Promise<APIResponseOfUpdateResponseDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = APIResponseOfUpdateResponseDTO.fromJS(resultData200);
            return Promise.resolve<APIResponseOfUpdateResponseDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<APIResponseOfUpdateResponseDTO>(null as any);
    }

    deactivateAlert(id: number, idToken: string | null | undefined, cancelToken?: CancelToken): Promise<APIResponseOfUpdateResponseDTO> {
        let url_ = this.baseUrl + "/api/alert/deactivateAlert/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Authorization": idToken !== undefined && idToken !== null ? "" + idToken : "",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeactivateAlert(_response);
        });
    }

    protected processDeactivateAlert(response: AxiosResponse): Promise<APIResponseOfUpdateResponseDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = APIResponseOfUpdateResponseDTO.fromJS(resultData200);
            return Promise.resolve<APIResponseOfUpdateResponseDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<APIResponseOfUpdateResponseDTO>(null as any);
    }

    getAllCannedText( cancelToken?: CancelToken): Promise<APIResponseOfListOfRefAppAlerts> {
        let url_ = this.baseUrl + "/api/alert/CannedText";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllCannedText(_response);
        });
    }

    protected processGetAllCannedText(response: AxiosResponse): Promise<APIResponseOfListOfRefAppAlerts> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = APIResponseOfListOfRefAppAlerts.fromJS(resultData200);
            return Promise.resolve<APIResponseOfListOfRefAppAlerts>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<APIResponseOfListOfRefAppAlerts>(null as any);
    }
}

export class PreRegEndpointsClient extends ServiceBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getPreRegSummary(idToken: string | null | undefined, preRegSummaryRequest: PreRegSummaryRequest, cancelToken?: CancelToken): Promise<APIResponseOfListOfPreRegSummaryResponse> {
        let url_ = this.baseUrl + "/api/prereg/getPreRegSummary";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(preRegSummaryRequest);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Authorization": idToken !== undefined && idToken !== null ? "" + idToken : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPreRegSummary(_response);
        });
    }

    protected processGetPreRegSummary(response: AxiosResponse): Promise<APIResponseOfListOfPreRegSummaryResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = APIResponseOfListOfPreRegSummaryResponse.fromJS(resultData200);
            return Promise.resolve<APIResponseOfListOfPreRegSummaryResponse>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<APIResponseOfListOfPreRegSummaryResponse>(null as any);
    }
}

export class CernerEndPointsClient extends ServiceBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getCernerAgentFilters(idToken: string | null | undefined, cancelToken?: CancelToken): Promise<APIResponseOfCernerAgentFiltersDTO> {
        let url_ = this.baseUrl + "/api/cerner/getCernerAgentFilters";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Authorization": idToken !== undefined && idToken !== null ? "" + idToken : "",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCernerAgentFilters(_response);
        });
    }

    protected processGetCernerAgentFilters(response: AxiosResponse): Promise<APIResponseOfCernerAgentFiltersDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = APIResponseOfCernerAgentFiltersDTO.fromJS(resultData200);
            return Promise.resolve<APIResponseOfCernerAgentFiltersDTO>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<APIResponseOfCernerAgentFiltersDTO>(null as any);
    }

    getCernerUserInformation(req: CernerAgentInformationListRequest, cancelToken?: CancelToken): Promise<APIResponseOfListOfCernerAgentInformationDTO> {
        let url_ = this.baseUrl + "/api/cerner/getCernerUserInformation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(req);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCernerUserInformation(_response);
        });
    }

    protected processGetCernerUserInformation(response: AxiosResponse): Promise<APIResponseOfListOfCernerAgentInformationDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = APIResponseOfListOfCernerAgentInformationDTO.fromJS(resultData200);
            return Promise.resolve<APIResponseOfListOfCernerAgentInformationDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<APIResponseOfListOfCernerAgentInformationDTO>(null as any);
    }

    createCernerUser(idToken: string | null | undefined, cernerAddUserDTO: CernerAddUserDTO, cancelToken?: CancelToken): Promise<APIResponseOfString> {
        let url_ = this.baseUrl + "/api/cerner/createCernerUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(cernerAddUserDTO);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Authorization": idToken !== undefined && idToken !== null ? "" + idToken : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateCernerUser(_response);
        });
    }

    protected processCreateCernerUser(response: AxiosResponse): Promise<APIResponseOfString> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = APIResponseOfString.fromJS(resultData200);
            return Promise.resolve<APIResponseOfString>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<APIResponseOfString>(null as any);
    }

    updateCernerUser(idToken: string | null | undefined, cernerUpdateUserDTO: CernerUpdateUserDTO, cancelToken?: CancelToken): Promise<APIResponseOfString> {
        let url_ = this.baseUrl + "/api/cerner/updateCernerUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(cernerUpdateUserDTO);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Authorization": idToken !== undefined && idToken !== null ? "" + idToken : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateCernerUser(_response);
        });
    }

    protected processUpdateCernerUser(response: AxiosResponse): Promise<APIResponseOfString> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = APIResponseOfString.fromJS(resultData200);
            return Promise.resolve<APIResponseOfString>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<APIResponseOfString>(null as any);
    }
}

export class WorkQueueEndPointsClient extends ServiceBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    workQueueSummary(idToken: string | null | undefined, workQueueSummaryRequest: WorkQueueSummaryRequest, cancelToken?: CancelToken): Promise<APIResponseOfListOfWorkQueueSummaryResponse> {
        let url_ = this.baseUrl + "/api/workqueue/getWorkQueueSummary";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(workQueueSummaryRequest);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Authorization": idToken !== undefined && idToken !== null ? "" + idToken : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processWorkQueueSummary(_response);
        });
    }

    protected processWorkQueueSummary(response: AxiosResponse): Promise<APIResponseOfListOfWorkQueueSummaryResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = APIResponseOfListOfWorkQueueSummaryResponse.fromJS(resultData200);
            return Promise.resolve<APIResponseOfListOfWorkQueueSummaryResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<APIResponseOfListOfWorkQueueSummaryResponse>(null as any);
    }

    workQueueDetail(workQueueDetailRequest: WorkQueueDetailRequest, cancelToken?: CancelToken): Promise<APIResponseOfListOfWorkQueueDetail> {
        let url_ = this.baseUrl + "/api/workqueue/getWorkQueueDetail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(workQueueDetailRequest);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processWorkQueueDetail(_response);
        });
    }

    protected processWorkQueueDetail(response: AxiosResponse): Promise<APIResponseOfListOfWorkQueueDetail> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = APIResponseOfListOfWorkQueueDetail.fromJS(resultData200);
            return Promise.resolve<APIResponseOfListOfWorkQueueDetail>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<APIResponseOfListOfWorkQueueDetail>(null as any);
    }

    getWorkQueueStatusCountDetails(workQueueStatusCountDetailsRequest: WorkQueueStatusCountDetailsRequest, cancelToken?: CancelToken): Promise<APIResponseOfListOfWorkQueueStatusCountDetailsResponse> {
        let url_ = this.baseUrl + "/api/workqueue/getWorkQueueStatusCountDetails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(workQueueStatusCountDetailsRequest);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetWorkQueueStatusCountDetails(_response);
        });
    }

    protected processGetWorkQueueStatusCountDetails(response: AxiosResponse): Promise<APIResponseOfListOfWorkQueueStatusCountDetailsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = APIResponseOfListOfWorkQueueStatusCountDetailsResponse.fromJS(resultData200);
            return Promise.resolve<APIResponseOfListOfWorkQueueStatusCountDetailsResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<APIResponseOfListOfWorkQueueStatusCountDetailsResponse>(null as any);
    }

    getTEFWorkQueueSummary(idToken: string | null | undefined, tEFQueueSummaryRequest: TEFQueueSummaryRequest, cancelToken?: CancelToken): Promise<APIResponseOfListOfTEFQueueSummaryResponse> {
        let url_ = this.baseUrl + "/api/workqueue/TEF/getWorkQueueSummary";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(tEFQueueSummaryRequest);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Authorization": idToken !== undefined && idToken !== null ? "" + idToken : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTEFWorkQueueSummary(_response);
        });
    }

    protected processGetTEFWorkQueueSummary(response: AxiosResponse): Promise<APIResponseOfListOfTEFQueueSummaryResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = APIResponseOfListOfTEFQueueSummaryResponse.fromJS(resultData200);
            return Promise.resolve<APIResponseOfListOfTEFQueueSummaryResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<APIResponseOfListOfTEFQueueSummaryResponse>(null as any);
    }

    getTEFWorkQueueListView(idToken: string | null | undefined, tEFQueueListViewRequest: TEFQueueListViewRequest, cancelToken?: CancelToken): Promise<APIResponseOfListOfTEFQueueListViewDetailDTO> {
        let url_ = this.baseUrl + "/api/workqueue/TEF/getWorkQueueListView";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(tEFQueueListViewRequest);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Authorization": idToken !== undefined && idToken !== null ? "" + idToken : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTEFWorkQueueListView(_response);
        });
    }

    protected processGetTEFWorkQueueListView(response: AxiosResponse): Promise<APIResponseOfListOfTEFQueueListViewDetailDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = APIResponseOfListOfTEFQueueListViewDetailDTO.fromJS(resultData200);
            return Promise.resolve<APIResponseOfListOfTEFQueueListViewDetailDTO>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<APIResponseOfListOfTEFQueueListViewDetailDTO>(null as any);
    }

    getGenesysInteractionOutcome( cancelToken?: CancelToken): Promise<APIResponseOfListOfDropDownItem> {
        let url_ = this.baseUrl + "/api/workqueue/TEF/GetGenesysInteractionOutcome";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetGenesysInteractionOutcome(_response);
        });
    }

    protected processGetGenesysInteractionOutcome(response: AxiosResponse): Promise<APIResponseOfListOfDropDownItem> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = APIResponseOfListOfDropDownItem.fromJS(resultData200);
            return Promise.resolve<APIResponseOfListOfDropDownItem>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<APIResponseOfListOfDropDownItem>(null as any);
    }

    getInteractionOutcome( cancelToken?: CancelToken): Promise<APIResponseOfListOfDropDownItem> {
        let url_ = this.baseUrl + "/api/workqueue/TEF/GetManualInteractionOutcome";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetInteractionOutcome(_response);
        });
    }

    protected processGetInteractionOutcome(response: AxiosResponse): Promise<APIResponseOfListOfDropDownItem> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = APIResponseOfListOfDropDownItem.fromJS(resultData200);
            return Promise.resolve<APIResponseOfListOfDropDownItem>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<APIResponseOfListOfDropDownItem>(null as any);
    }

    getPreRegFilters(idToken: string | null | undefined, cancelToken?: CancelToken): Promise<APIResponseOfPreRegFiltersDTO> {
        let url_ = this.baseUrl + "/api/workqueue/PreReg/getPreRegFilters";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Authorization": idToken !== undefined && idToken !== null ? "" + idToken : "",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPreRegFilters(_response);
        });
    }

    protected processGetPreRegFilters(response: AxiosResponse): Promise<APIResponseOfPreRegFiltersDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = APIResponseOfPreRegFiltersDTO.fromJS(resultData200);
            return Promise.resolve<APIResponseOfPreRegFiltersDTO>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<APIResponseOfPreRegFiltersDTO>(null as any);
    }

    getPuAutomationFilters(idToken: string | null | undefined, cancelToken?: CancelToken): Promise<APIResponseOfPuAutomationFiltersDTO> {
        let url_ = this.baseUrl + "/api/workqueue/PreReg/getPuAutomationFilters";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Authorization": idToken !== undefined && idToken !== null ? "" + idToken : "",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPuAutomationFilters(_response);
        });
    }

    protected processGetPuAutomationFilters(response: AxiosResponse): Promise<APIResponseOfPuAutomationFiltersDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = APIResponseOfPuAutomationFiltersDTO.fromJS(resultData200);
            return Promise.resolve<APIResponseOfPuAutomationFiltersDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<APIResponseOfPuAutomationFiltersDTO>(null as any);
    }

    getPreRegWorkQueueListView(idToken: string | null | undefined, preRegQueueListViewRequest: PreRegQueueListViewRequest, cancelToken?: CancelToken): Promise<APIResponseOfListOfPreRegQueueListViewDetailDTO> {
        let url_ = this.baseUrl + "/api/workqueue/PreReg/getWorkQueueListView";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(preRegQueueListViewRequest);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Authorization": idToken !== undefined && idToken !== null ? "" + idToken : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPreRegWorkQueueListView(_response);
        });
    }

    protected processGetPreRegWorkQueueListView(response: AxiosResponse): Promise<APIResponseOfListOfPreRegQueueListViewDetailDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = APIResponseOfListOfPreRegQueueListViewDetailDTO.fromJS(resultData200);
            return Promise.resolve<APIResponseOfListOfPreRegQueueListViewDetailDTO>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<APIResponseOfListOfPreRegQueueListViewDetailDTO>(null as any);
    }

    getPreRegListView(idToken: string | null | undefined, preRegListViewRequest: PreRegListViewRequest, cancelToken?: CancelToken): Promise<APIResponseOfPreRegListViewResponseDTO> {
        let url_ = this.baseUrl + "/api/workqueue/PreReg/getPreregListView";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(preRegListViewRequest);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Authorization": idToken !== undefined && idToken !== null ? "" + idToken : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPreRegListView(_response);
        });
    }

    protected processGetPreRegListView(response: AxiosResponse): Promise<APIResponseOfPreRegListViewResponseDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = APIResponseOfPreRegListViewResponseDTO.fromJS(resultData200);
            return Promise.resolve<APIResponseOfPreRegListViewResponseDTO>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<APIResponseOfPreRegListViewResponseDTO>(null as any);
    }

    getEMRSystems( cancelToken?: CancelToken): Promise<APIResponseOfListOfDropDownItem> {
        let url_ = this.baseUrl + "/api/workqueue/TEF/GetEMRSystems";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetEMRSystems(_response);
        });
    }

    protected processGetEMRSystems(response: AxiosResponse): Promise<APIResponseOfListOfDropDownItem> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = APIResponseOfListOfDropDownItem.fromJS(resultData200);
            return Promise.resolve<APIResponseOfListOfDropDownItem>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<APIResponseOfListOfDropDownItem>(null as any);
    }

    getAuthQueueListView(idToken: string | null | undefined, eptacAuthQueueListViewRequest: EptacAuthQueueListViewRequest, cancelToken?: CancelToken): Promise<APIResponseOfListOfEptacAuthQueueListViewDetailDTO> {
        let url_ = this.baseUrl + "/api/workqueue/Eptac/GetAuthQueueListView";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(eptacAuthQueueListViewRequest);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Authorization": idToken !== undefined && idToken !== null ? "" + idToken : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAuthQueueListView(_response);
        });
    }

    protected processGetAuthQueueListView(response: AxiosResponse): Promise<APIResponseOfListOfEptacAuthQueueListViewDetailDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = APIResponseOfListOfEptacAuthQueueListViewDetailDTO.fromJS(resultData200);
            return Promise.resolve<APIResponseOfListOfEptacAuthQueueListViewDetailDTO>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<APIResponseOfListOfEptacAuthQueueListViewDetailDTO>(null as any);
    }

    getFollowupWQAgeFilters( cancelToken?: CancelToken): Promise<APIResponseOfListOfSpecialDropDown> {
        let url_ = this.baseUrl + "/api/workqueue/TEF/GetFollowupWQAgeFilters";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFollowupWQAgeFilters(_response);
        });
    }

    protected processGetFollowupWQAgeFilters(response: AxiosResponse): Promise<APIResponseOfListOfSpecialDropDown> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = APIResponseOfListOfSpecialDropDown.fromJS(resultData200);
            return Promise.resolve<APIResponseOfListOfSpecialDropDown>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<APIResponseOfListOfSpecialDropDown>(null as any);
    }

    getExhaustedWorkqueueFilters(idToken: string | null | undefined, cancelToken?: CancelToken): Promise<APIResponseOfExhaustedworkqueueFiltersDTO> {
        let url_ = this.baseUrl + "/api/workqueue/Exhausted/GetExhaustedWorkqueueFilters";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Authorization": idToken !== undefined && idToken !== null ? "" + idToken : "",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetExhaustedWorkqueueFilters(_response);
        });
    }

    protected processGetExhaustedWorkqueueFilters(response: AxiosResponse): Promise<APIResponseOfExhaustedworkqueueFiltersDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = APIResponseOfExhaustedworkqueueFiltersDTO.fromJS(resultData200);
            return Promise.resolve<APIResponseOfExhaustedworkqueueFiltersDTO>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<APIResponseOfExhaustedworkqueueFiltersDTO>(null as any);
    }

    getExhaustedWorkQueueListView(idToken: string | null | undefined, exhaustedQueueListViewRequest: ExhaustedQueueListViewRequest, cancelToken?: CancelToken): Promise<APIResponseOfListOfExhaustedQueueListViewDetailDTO> {
        let url_ = this.baseUrl + "/api/workqueue/Exhausted/getExhaustedWorkQueueListView";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(exhaustedQueueListViewRequest);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Authorization": idToken !== undefined && idToken !== null ? "" + idToken : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetExhaustedWorkQueueListView(_response);
        });
    }

    protected processGetExhaustedWorkQueueListView(response: AxiosResponse): Promise<APIResponseOfListOfExhaustedQueueListViewDetailDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = APIResponseOfListOfExhaustedQueueListViewDetailDTO.fromJS(resultData200);
            return Promise.resolve<APIResponseOfListOfExhaustedQueueListViewDetailDTO>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<APIResponseOfListOfExhaustedQueueListViewDetailDTO>(null as any);
    }

    getExhaustedWorkQueueSummary(idToken: string | null | undefined, exhaustedQueueSummaryRequest: ExhaustedQueueSummaryRequest, cancelToken?: CancelToken): Promise<APIResponseOfListOfExhaustedQueueSummaryResponse> {
        let url_ = this.baseUrl + "/api/workqueue/Exhausted/getExhaustedWorkQueueSummary";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(exhaustedQueueSummaryRequest);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Authorization": idToken !== undefined && idToken !== null ? "" + idToken : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetExhaustedWorkQueueSummary(_response);
        });
    }

    protected processGetExhaustedWorkQueueSummary(response: AxiosResponse): Promise<APIResponseOfListOfExhaustedQueueSummaryResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = APIResponseOfListOfExhaustedQueueSummaryResponse.fromJS(resultData200);
            return Promise.resolve<APIResponseOfListOfExhaustedQueueSummaryResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<APIResponseOfListOfExhaustedQueueSummaryResponse>(null as any);
    }
}

export class APIResponseOfListOfESAFRoleDTO implements IAPIResponseOfListOfESAFRoleDTO {
    statusCode?: HttpStatusCode;
    isSuccess?: boolean;
    errorMessages?: string[];
    result?: ESAFRoleDTO[] | undefined;

    constructor(data?: IAPIResponseOfListOfESAFRoleDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusCode = _data["statusCode"];
            this.isSuccess = _data["isSuccess"];
            if (Array.isArray(_data["errorMessages"])) {
                this.errorMessages = [] as any;
                for (let item of _data["errorMessages"])
                    this.errorMessages!.push(item);
            }
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result!.push(ESAFRoleDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): APIResponseOfListOfESAFRoleDTO {
        data = typeof data === 'object' ? data : {};
        let result = new APIResponseOfListOfESAFRoleDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["isSuccess"] = this.isSuccess;
        if (Array.isArray(this.errorMessages)) {
            data["errorMessages"] = [];
            for (let item of this.errorMessages)
                data["errorMessages"].push(item);
        }
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IAPIResponseOfListOfESAFRoleDTO {
    statusCode?: HttpStatusCode;
    isSuccess?: boolean;
    errorMessages?: string[];
    result?: ESAFRoleDTO[] | undefined;
}

export enum HttpStatusCode {
    Continue = 100,
    SwitchingProtocols = 101,
    Processing = 102,
    EarlyHints = 103,
    OK = 200,
    Created = 201,
    Accepted = 202,
    NonAuthoritativeInformation = 203,
    NoContent = 204,
    ResetContent = 205,
    PartialContent = 206,
    MultiStatus = 207,
    AlreadyReported = 208,
    IMUsed = 226,
    MultipleChoices = 300,
    Ambiguous = 300,
    MovedPermanently = 301,
    Moved = 301,
    Found = 302,
    Redirect = 302,
    SeeOther = 303,
    RedirectMethod = 303,
    NotModified = 304,
    UseProxy = 305,
    Unused = 306,
    TemporaryRedirect = 307,
    RedirectKeepVerb = 307,
    PermanentRedirect = 308,
    BadRequest = 400,
    Unauthorized = 401,
    PaymentRequired = 402,
    Forbidden = 403,
    NotFound = 404,
    MethodNotAllowed = 405,
    NotAcceptable = 406,
    ProxyAuthenticationRequired = 407,
    RequestTimeout = 408,
    Conflict = 409,
    Gone = 410,
    LengthRequired = 411,
    PreconditionFailed = 412,
    RequestEntityTooLarge = 413,
    RequestUriTooLong = 414,
    UnsupportedMediaType = 415,
    RequestedRangeNotSatisfiable = 416,
    ExpectationFailed = 417,
    MisdirectedRequest = 421,
    UnprocessableEntity = 422,
    UnprocessableContent = 422,
    Locked = 423,
    FailedDependency = 424,
    UpgradeRequired = 426,
    PreconditionRequired = 428,
    TooManyRequests = 429,
    RequestHeaderFieldsTooLarge = 431,
    UnavailableForLegalReasons = 451,
    InternalServerError = 500,
    NotImplemented = 501,
    BadGateway = 502,
    ServiceUnavailable = 503,
    GatewayTimeout = 504,
    HttpVersionNotSupported = 505,
    VariantAlsoNegotiates = 506,
    InsufficientStorage = 507,
    LoopDetected = 508,
    NotExtended = 510,
    NetworkAuthenticationRequired = 511,
}

export class ESAFRoleDTO implements IESAFRoleDTO {
    roleId?: number;
    roleName?: string;
    roleDesc?: string;

    constructor(data?: IESAFRoleDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.roleId = _data["roleId"];
            this.roleName = _data["roleName"];
            this.roleDesc = _data["roleDesc"];
        }
    }

    static fromJS(data: any): ESAFRoleDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ESAFRoleDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["roleId"] = this.roleId;
        data["roleName"] = this.roleName;
        data["roleDesc"] = this.roleDesc;
        return data;
    }
}

export interface IESAFRoleDTO {
    roleId?: number;
    roleName?: string;
    roleDesc?: string;
}

export class APIResponseOfListOfESAFFacilityDTO implements IAPIResponseOfListOfESAFFacilityDTO {
    statusCode?: HttpStatusCode;
    isSuccess?: boolean;
    errorMessages?: string[];
    result?: ESAFFacilityDTO[] | undefined;

    constructor(data?: IAPIResponseOfListOfESAFFacilityDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusCode = _data["statusCode"];
            this.isSuccess = _data["isSuccess"];
            if (Array.isArray(_data["errorMessages"])) {
                this.errorMessages = [] as any;
                for (let item of _data["errorMessages"])
                    this.errorMessages!.push(item);
            }
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result!.push(ESAFFacilityDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): APIResponseOfListOfESAFFacilityDTO {
        data = typeof data === 'object' ? data : {};
        let result = new APIResponseOfListOfESAFFacilityDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["isSuccess"] = this.isSuccess;
        if (Array.isArray(this.errorMessages)) {
            data["errorMessages"] = [];
            for (let item of this.errorMessages)
                data["errorMessages"].push(item);
        }
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IAPIResponseOfListOfESAFFacilityDTO {
    statusCode?: HttpStatusCode;
    isSuccess?: boolean;
    errorMessages?: string[];
    result?: ESAFFacilityDTO[] | undefined;
}

export class ESAFFacilityDTO implements IESAFFacilityDTO {
    facilityId?: number;
    facilityCOID?: number | undefined;
    facilityName?: string;
    unitNo?: number | undefined;

    constructor(data?: IESAFFacilityDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.facilityId = _data["facilityId"];
            this.facilityCOID = _data["facilityCOID"];
            this.facilityName = _data["facilityName"];
            this.unitNo = _data["unitNo"];
        }
    }

    static fromJS(data: any): ESAFFacilityDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ESAFFacilityDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["facilityId"] = this.facilityId;
        data["facilityCOID"] = this.facilityCOID;
        data["facilityName"] = this.facilityName;
        data["unitNo"] = this.unitNo;
        return data;
    }
}

export interface IESAFFacilityDTO {
    facilityId?: number;
    facilityCOID?: number | undefined;
    facilityName?: string;
    unitNo?: number | undefined;
}

export class APIResponseOfString implements IAPIResponseOfString {
    statusCode?: HttpStatusCode;
    isSuccess?: boolean;
    errorMessages?: string[];
    result?: string | undefined;

    constructor(data?: IAPIResponseOfString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusCode = _data["statusCode"];
            this.isSuccess = _data["isSuccess"];
            if (Array.isArray(_data["errorMessages"])) {
                this.errorMessages = [] as any;
                for (let item of _data["errorMessages"])
                    this.errorMessages!.push(item);
            }
            this.result = _data["result"];
        }
    }

    static fromJS(data: any): APIResponseOfString {
        data = typeof data === 'object' ? data : {};
        let result = new APIResponseOfString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["isSuccess"] = this.isSuccess;
        if (Array.isArray(this.errorMessages)) {
            data["errorMessages"] = [];
            for (let item of this.errorMessages)
                data["errorMessages"].push(item);
        }
        data["result"] = this.result;
        return data;
    }
}

export interface IAPIResponseOfString {
    statusCode?: HttpStatusCode;
    isSuccess?: boolean;
    errorMessages?: string[];
    result?: string | undefined;
}

export class ESAFUserDTO implements IESAFUserDTO {
    userId?: string;
    domain?: string;
    applicationId?: string;
    firstName?: string;
    lastName?: string;
    displayName?: string;
    attributes?: UserAttribute[];

    constructor(data?: IESAFUserDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.domain = _data["domain"];
            this.applicationId = _data["applicationId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.displayName = _data["displayName"];
            if (Array.isArray(_data["attributes"])) {
                this.attributes = [] as any;
                for (let item of _data["attributes"])
                    this.attributes!.push(UserAttribute.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ESAFUserDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ESAFUserDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["domain"] = this.domain;
        data["applicationId"] = this.applicationId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["displayName"] = this.displayName;
        if (Array.isArray(this.attributes)) {
            data["attributes"] = [];
            for (let item of this.attributes)
                data["attributes"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IESAFUserDTO {
    userId?: string;
    domain?: string;
    applicationId?: string;
    firstName?: string;
    lastName?: string;
    displayName?: string;
    attributes?: UserAttribute[];
}

export class UserAttribute implements IUserAttribute {
    attributeId?: string;
    attributeValues?: string[];

    constructor(data?: IUserAttribute) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.attributeId = _data["attributeId"];
            if (Array.isArray(_data["attributeValues"])) {
                this.attributeValues = [] as any;
                for (let item of _data["attributeValues"])
                    this.attributeValues!.push(item);
            }
        }
    }

    static fromJS(data: any): UserAttribute {
        data = typeof data === 'object' ? data : {};
        let result = new UserAttribute();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["attributeId"] = this.attributeId;
        if (Array.isArray(this.attributeValues)) {
            data["attributeValues"] = [];
            for (let item of this.attributeValues)
                data["attributeValues"].push(item);
        }
        return data;
    }
}

export interface IUserAttribute {
    attributeId?: string;
    attributeValues?: string[];
}

export class APIResponseOfESAFUserDTO implements IAPIResponseOfESAFUserDTO {
    statusCode?: HttpStatusCode;
    isSuccess?: boolean;
    errorMessages?: string[];
    result?: ESAFUserDTO | undefined;

    constructor(data?: IAPIResponseOfESAFUserDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusCode = _data["statusCode"];
            this.isSuccess = _data["isSuccess"];
            if (Array.isArray(_data["errorMessages"])) {
                this.errorMessages = [] as any;
                for (let item of _data["errorMessages"])
                    this.errorMessages!.push(item);
            }
            this.result = _data["result"] ? ESAFUserDTO.fromJS(_data["result"]) : undefined as any;
        }
    }

    static fromJS(data: any): APIResponseOfESAFUserDTO {
        data = typeof data === 'object' ? data : {};
        let result = new APIResponseOfESAFUserDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["isSuccess"] = this.isSuccess;
        if (Array.isArray(this.errorMessages)) {
            data["errorMessages"] = [];
            for (let item of this.errorMessages)
                data["errorMessages"].push(item);
        }
        data["result"] = this.result ? this.result.toJSON() : undefined as any;
        return data;
    }
}

export interface IAPIResponseOfESAFUserDTO {
    statusCode?: HttpStatusCode;
    isSuccess?: boolean;
    errorMessages?: string[];
    result?: ESAFUserDTO | undefined;
}

export class APIResponseOfEmpty implements IAPIResponseOfEmpty {
    statusCode?: HttpStatusCode;
    isSuccess?: boolean;
    errorMessages?: string[];
    result?: Empty;

    constructor(data?: IAPIResponseOfEmpty) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusCode = _data["statusCode"];
            this.isSuccess = _data["isSuccess"];
            if (Array.isArray(_data["errorMessages"])) {
                this.errorMessages = [] as any;
                for (let item of _data["errorMessages"])
                    this.errorMessages!.push(item);
            }
            this.result = _data["result"] ? Empty.fromJS(_data["result"]) : undefined as any;
        }
    }

    static fromJS(data: any): APIResponseOfEmpty {
        data = typeof data === 'object' ? data : {};
        let result = new APIResponseOfEmpty();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["isSuccess"] = this.isSuccess;
        if (Array.isArray(this.errorMessages)) {
            data["errorMessages"] = [];
            for (let item of this.errorMessages)
                data["errorMessages"].push(item);
        }
        data["result"] = this.result ? this.result.toJSON() : undefined as any;
        return data;
    }
}

export interface IAPIResponseOfEmpty {
    statusCode?: HttpStatusCode;
    isSuccess?: boolean;
    errorMessages?: string[];
    result?: Empty;
}

export class Empty implements IEmpty {

    constructor(data?: IEmpty) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): Empty {
        data = typeof data === 'object' ? data : {};
        let result = new Empty();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IEmpty {
}

export class APIResponseOfAppAccountDTO implements IAPIResponseOfAppAccountDTO {
    statusCode?: HttpStatusCode;
    isSuccess?: boolean;
    errorMessages?: string[];
    result?: AppAccountDTO | undefined;

    constructor(data?: IAPIResponseOfAppAccountDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusCode = _data["statusCode"];
            this.isSuccess = _data["isSuccess"];
            if (Array.isArray(_data["errorMessages"])) {
                this.errorMessages = [] as any;
                for (let item of _data["errorMessages"])
                    this.errorMessages!.push(item);
            }
            this.result = _data["result"] ? AppAccountDTO.fromJS(_data["result"]) : undefined as any;
        }
    }

    static fromJS(data: any): APIResponseOfAppAccountDTO {
        data = typeof data === 'object' ? data : {};
        let result = new APIResponseOfAppAccountDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["isSuccess"] = this.isSuccess;
        if (Array.isArray(this.errorMessages)) {
            data["errorMessages"] = [];
            for (let item of this.errorMessages)
                data["errorMessages"].push(item);
        }
        data["result"] = this.result ? this.result.toJSON() : undefined as any;
        return data;
    }
}

export interface IAPIResponseOfAppAccountDTO {
    statusCode?: HttpStatusCode;
    isSuccess?: boolean;
    errorMessages?: string[];
    result?: AppAccountDTO | undefined;
}

export class AppAccountDTO implements IAppAccountDTO {
    appAccountId?: number;
    firstName?: string;
    lastName?: string;
    gender?: string;
    birthDate?: Date | undefined;
    birthDateString?: string;
    unitNumber?: string;
    accountNumber?: string;
    appFacilityId?: number;
    createdBy?: string;
    createdDateUtc?: Date;
    modifiedBy?: string | undefined;
    modifiedDateUtc?: Date | undefined;
    appAccountTransactionId?: string | undefined;
    preferredLanguage?: string | undefined;
    onbaseVerified?: boolean;

    constructor(data?: IAppAccountDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.appAccountId = _data["appAccountId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.gender = _data["gender"];
            this.birthDate = _data["birthDate"] ? new Date(_data["birthDate"].toString()) : undefined as any;
            this.birthDateString = _data["birthDateString"];
            this.unitNumber = _data["unitNumber"];
            this.accountNumber = _data["accountNumber"];
            this.appFacilityId = _data["appFacilityId"];
            this.createdBy = _data["createdBy"];
            this.createdDateUtc = _data["createdDateUtc"] ? new Date(_data["createdDateUtc"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            this.modifiedDateUtc = _data["modifiedDateUtc"] ? new Date(_data["modifiedDateUtc"].toString()) : undefined as any;
            this.appAccountTransactionId = _data["appAccountTransactionId"];
            this.preferredLanguage = _data["preferredLanguage"];
            this.onbaseVerified = _data["onbaseVerified"];
        }
    }

    static fromJS(data: any): AppAccountDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AppAccountDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["appAccountId"] = this.appAccountId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["gender"] = this.gender;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : undefined as any;
        data["birthDateString"] = this.birthDateString;
        data["unitNumber"] = this.unitNumber;
        data["accountNumber"] = this.accountNumber;
        data["appFacilityId"] = this.appFacilityId;
        data["createdBy"] = this.createdBy;
        data["createdDateUtc"] = this.createdDateUtc ? this.createdDateUtc.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        data["modifiedDateUtc"] = this.modifiedDateUtc ? this.modifiedDateUtc.toISOString() : undefined as any;
        data["appAccountTransactionId"] = this.appAccountTransactionId;
        data["preferredLanguage"] = this.preferredLanguage;
        data["onbaseVerified"] = this.onbaseVerified;
        return data;
    }
}

export interface IAppAccountDTO {
    appAccountId?: number;
    firstName?: string;
    lastName?: string;
    gender?: string;
    birthDate?: Date | undefined;
    birthDateString?: string;
    unitNumber?: string;
    accountNumber?: string;
    appFacilityId?: number;
    createdBy?: string;
    createdDateUtc?: Date;
    modifiedBy?: string | undefined;
    modifiedDateUtc?: Date | undefined;
    appAccountTransactionId?: string | undefined;
    preferredLanguage?: string | undefined;
    onbaseVerified?: boolean;
}

export class AppAccountCreateDTO implements IAppAccountCreateDTO {
    appAccountId?: number;
    firstName?: string;
    lastName?: string;
    gender?: string;
    birthDate?: Date | undefined;
    unitNumber?: string;
    accountNumber?: string;
    appFacilityId?: number;
    createdBy?: string;
    createdDateUtc?: Date;
    modifiedBy?: string | undefined;
    modifiedDateUtc?: Date | undefined;
    appAccountTransactionId?: string | undefined;
    preferredLanguage?: string | undefined;
    onbaseVerified?: boolean;

    constructor(data?: IAppAccountCreateDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.appAccountId = _data["appAccountId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.gender = _data["gender"];
            this.birthDate = _data["birthDate"] ? new Date(_data["birthDate"].toString()) : undefined as any;
            this.unitNumber = _data["unitNumber"];
            this.accountNumber = _data["accountNumber"];
            this.appFacilityId = _data["appFacilityId"];
            this.createdBy = _data["createdBy"];
            this.createdDateUtc = _data["createdDateUtc"] ? new Date(_data["createdDateUtc"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            this.modifiedDateUtc = _data["modifiedDateUtc"] ? new Date(_data["modifiedDateUtc"].toString()) : undefined as any;
            this.appAccountTransactionId = _data["appAccountTransactionId"];
            this.preferredLanguage = _data["preferredLanguage"];
            this.onbaseVerified = _data["onbaseVerified"];
        }
    }

    static fromJS(data: any): AppAccountCreateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AppAccountCreateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["appAccountId"] = this.appAccountId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["gender"] = this.gender;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : undefined as any;
        data["unitNumber"] = this.unitNumber;
        data["accountNumber"] = this.accountNumber;
        data["appFacilityId"] = this.appFacilityId;
        data["createdBy"] = this.createdBy;
        data["createdDateUtc"] = this.createdDateUtc ? this.createdDateUtc.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        data["modifiedDateUtc"] = this.modifiedDateUtc ? this.modifiedDateUtc.toISOString() : undefined as any;
        data["appAccountTransactionId"] = this.appAccountTransactionId;
        data["preferredLanguage"] = this.preferredLanguage;
        data["onbaseVerified"] = this.onbaseVerified;
        return data;
    }
}

export interface IAppAccountCreateDTO {
    appAccountId?: number;
    firstName?: string;
    lastName?: string;
    gender?: string;
    birthDate?: Date | undefined;
    unitNumber?: string;
    accountNumber?: string;
    appFacilityId?: number;
    createdBy?: string;
    createdDateUtc?: Date;
    modifiedBy?: string | undefined;
    modifiedDateUtc?: Date | undefined;
    appAccountTransactionId?: string | undefined;
    preferredLanguage?: string | undefined;
    onbaseVerified?: boolean;
}

export class APIResponseOfListOfMessageCategoryDTO implements IAPIResponseOfListOfMessageCategoryDTO {
    statusCode?: HttpStatusCode;
    isSuccess?: boolean;
    errorMessages?: string[];
    result?: MessageCategoryDTO[] | undefined;

    constructor(data?: IAPIResponseOfListOfMessageCategoryDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusCode = _data["statusCode"];
            this.isSuccess = _data["isSuccess"];
            if (Array.isArray(_data["errorMessages"])) {
                this.errorMessages = [] as any;
                for (let item of _data["errorMessages"])
                    this.errorMessages!.push(item);
            }
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result!.push(MessageCategoryDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): APIResponseOfListOfMessageCategoryDTO {
        data = typeof data === 'object' ? data : {};
        let result = new APIResponseOfListOfMessageCategoryDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["isSuccess"] = this.isSuccess;
        if (Array.isArray(this.errorMessages)) {
            data["errorMessages"] = [];
            for (let item of this.errorMessages)
                data["errorMessages"].push(item);
        }
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IAPIResponseOfListOfMessageCategoryDTO {
    statusCode?: HttpStatusCode;
    isSuccess?: boolean;
    errorMessages?: string[];
    result?: MessageCategoryDTO[] | undefined;
}

export class MessageCategoryDTO implements IMessageCategoryDTO {
    refWorkflowStepId?: number;
    name?: string;
    active?: boolean;

    constructor(data?: IMessageCategoryDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.refWorkflowStepId = _data["refWorkflowStepId"];
            this.name = _data["name"];
            this.active = _data["active"];
        }
    }

    static fromJS(data: any): MessageCategoryDTO {
        data = typeof data === 'object' ? data : {};
        let result = new MessageCategoryDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["refWorkflowStepId"] = this.refWorkflowStepId;
        data["name"] = this.name;
        data["active"] = this.active;
        return data;
    }
}

export interface IMessageCategoryDTO {
    refWorkflowStepId?: number;
    name?: string;
    active?: boolean;
}

export class APIResponseOfListOfInteractionStatus implements IAPIResponseOfListOfInteractionStatus {
    statusCode?: HttpStatusCode;
    isSuccess?: boolean;
    errorMessages?: string[];
    result?: InteractionStatus[] | undefined;

    constructor(data?: IAPIResponseOfListOfInteractionStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusCode = _data["statusCode"];
            this.isSuccess = _data["isSuccess"];
            if (Array.isArray(_data["errorMessages"])) {
                this.errorMessages = [] as any;
                for (let item of _data["errorMessages"])
                    this.errorMessages!.push(item);
            }
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result!.push(InteractionStatus.fromJS(item));
            }
        }
    }

    static fromJS(data: any): APIResponseOfListOfInteractionStatus {
        data = typeof data === 'object' ? data : {};
        let result = new APIResponseOfListOfInteractionStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["isSuccess"] = this.isSuccess;
        if (Array.isArray(this.errorMessages)) {
            data["errorMessages"] = [];
            for (let item of this.errorMessages)
                data["errorMessages"].push(item);
        }
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IAPIResponseOfListOfInteractionStatus {
    statusCode?: HttpStatusCode;
    isSuccess?: boolean;
    errorMessages?: string[];
    result?: InteractionStatus[] | undefined;
}

export class InteractionStatus implements IInteractionStatus {
    interactionStatusId?: number;
    name?: string;
    active?: boolean;

    constructor(data?: IInteractionStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.interactionStatusId = _data["interactionStatusId"];
            this.name = _data["name"];
            this.active = _data["active"];
        }
    }

    static fromJS(data: any): InteractionStatus {
        data = typeof data === 'object' ? data : {};
        let result = new InteractionStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["interactionStatusId"] = this.interactionStatusId;
        data["name"] = this.name;
        data["active"] = this.active;
        return data;
    }
}

export interface IInteractionStatus {
    interactionStatusId?: number;
    name?: string;
    active?: boolean;
}

export class APIResponseOfListOfInteractionTypeDTO implements IAPIResponseOfListOfInteractionTypeDTO {
    statusCode?: HttpStatusCode;
    isSuccess?: boolean;
    errorMessages?: string[];
    result?: InteractionTypeDTO[] | undefined;

    constructor(data?: IAPIResponseOfListOfInteractionTypeDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusCode = _data["statusCode"];
            this.isSuccess = _data["isSuccess"];
            if (Array.isArray(_data["errorMessages"])) {
                this.errorMessages = [] as any;
                for (let item of _data["errorMessages"])
                    this.errorMessages!.push(item);
            }
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result!.push(InteractionTypeDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): APIResponseOfListOfInteractionTypeDTO {
        data = typeof data === 'object' ? data : {};
        let result = new APIResponseOfListOfInteractionTypeDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["isSuccess"] = this.isSuccess;
        if (Array.isArray(this.errorMessages)) {
            data["errorMessages"] = [];
            for (let item of this.errorMessages)
                data["errorMessages"].push(item);
        }
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IAPIResponseOfListOfInteractionTypeDTO {
    statusCode?: HttpStatusCode;
    isSuccess?: boolean;
    errorMessages?: string[];
    result?: InteractionTypeDTO[] | undefined;
}

export class InteractionTypeDTO implements IInteractionTypeDTO {
    refInteractionTypeId?: number;
    name?: string;
    active?: boolean;

    constructor(data?: IInteractionTypeDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.refInteractionTypeId = _data["refInteractionTypeId"];
            this.name = _data["name"];
            this.active = _data["active"];
        }
    }

    static fromJS(data: any): InteractionTypeDTO {
        data = typeof data === 'object' ? data : {};
        let result = new InteractionTypeDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["refInteractionTypeId"] = this.refInteractionTypeId;
        data["name"] = this.name;
        data["active"] = this.active;
        return data;
    }
}

export interface IInteractionTypeDTO {
    refInteractionTypeId?: number;
    name?: string;
    active?: boolean;
}

export class APIResponseOfListOfInteractionDetailsResponse implements IAPIResponseOfListOfInteractionDetailsResponse {
    statusCode?: HttpStatusCode;
    isSuccess?: boolean;
    errorMessages?: string[];
    result?: InteractionDetailsResponse[] | undefined;

    constructor(data?: IAPIResponseOfListOfInteractionDetailsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusCode = _data["statusCode"];
            this.isSuccess = _data["isSuccess"];
            if (Array.isArray(_data["errorMessages"])) {
                this.errorMessages = [] as any;
                for (let item of _data["errorMessages"])
                    this.errorMessages!.push(item);
            }
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result!.push(InteractionDetailsResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): APIResponseOfListOfInteractionDetailsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new APIResponseOfListOfInteractionDetailsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["isSuccess"] = this.isSuccess;
        if (Array.isArray(this.errorMessages)) {
            data["errorMessages"] = [];
            for (let item of this.errorMessages)
                data["errorMessages"].push(item);
        }
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IAPIResponseOfListOfInteractionDetailsResponse {
    statusCode?: HttpStatusCode;
    isSuccess?: boolean;
    errorMessages?: string[];
    result?: InteractionDetailsResponse[] | undefined;
}

export class InteractionDetailsResponse implements IInteractionDetailsResponse {
    campaign?: string;
    messageCategory?: string;
    accountEmail?: string;
    accountPhone?: string;
    interactionType?: string;
    interactionStatus?: string;
    communicationDate?: Date;
    contactInfo?: string;
    rowsCount?: number | undefined;
    error_Message?: string | undefined;
    error_MessageShort?: string | undefined;
    agent?: string;
    puAutomationOutcome?: string | undefined;
    puErrorMessage?: string | undefined;
    puErrorMessage_Detail?: string | undefined;

    constructor(data?: IInteractionDetailsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.campaign = _data["campaign"];
            this.messageCategory = _data["messageCategory"];
            this.accountEmail = _data["accountEmail"];
            this.accountPhone = _data["accountPhone"];
            this.interactionType = _data["interactionType"];
            this.interactionStatus = _data["interactionStatus"];
            this.communicationDate = _data["communicationDate"] ? new Date(_data["communicationDate"].toString()) : undefined as any;
            this.contactInfo = _data["contactInfo"];
            this.rowsCount = _data["rowsCount"];
            this.error_Message = _data["error_Message"];
            this.error_MessageShort = _data["error_MessageShort"];
            this.agent = _data["agent"];
            this.puAutomationOutcome = _data["puAutomationOutcome"];
            this.puErrorMessage = _data["puErrorMessage"];
            this.puErrorMessage_Detail = _data["puErrorMessage_Detail"];
        }
    }

    static fromJS(data: any): InteractionDetailsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new InteractionDetailsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["campaign"] = this.campaign;
        data["messageCategory"] = this.messageCategory;
        data["accountEmail"] = this.accountEmail;
        data["accountPhone"] = this.accountPhone;
        data["interactionType"] = this.interactionType;
        data["interactionStatus"] = this.interactionStatus;
        data["communicationDate"] = this.communicationDate ? this.communicationDate.toISOString() : undefined as any;
        data["contactInfo"] = this.contactInfo;
        data["rowsCount"] = this.rowsCount;
        data["error_Message"] = this.error_Message;
        data["error_MessageShort"] = this.error_MessageShort;
        data["agent"] = this.agent;
        data["puAutomationOutcome"] = this.puAutomationOutcome;
        data["puErrorMessage"] = this.puErrorMessage;
        data["puErrorMessage_Detail"] = this.puErrorMessage_Detail;
        return data;
    }
}

export interface IInteractionDetailsResponse {
    campaign?: string;
    messageCategory?: string;
    accountEmail?: string;
    accountPhone?: string;
    interactionType?: string;
    interactionStatus?: string;
    communicationDate?: Date;
    contactInfo?: string;
    rowsCount?: number | undefined;
    error_Message?: string | undefined;
    error_MessageShort?: string | undefined;
    agent?: string;
    puAutomationOutcome?: string | undefined;
    puErrorMessage?: string | undefined;
    puErrorMessage_Detail?: string | undefined;
}

export class InteractionDetailRequest implements IInteractionDetailRequest {
    accountNumber?: string;
    coid?: number | undefined;
    fromCommunicationDate?: Date | undefined;
    toCommunicationDate?: Date | undefined;
    messageCategory?: string;
    interactionType?: string;
    interactionStatus?: string;
    sortColumn?: string;
    sortDir?: string;
    page?: number;
    pageSize?: number;

    constructor(data?: IInteractionDetailRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountNumber = _data["accountNumber"];
            this.coid = _data["coid"];
            this.fromCommunicationDate = _data["fromCommunicationDate"] ? new Date(_data["fromCommunicationDate"].toString()) : undefined as any;
            this.toCommunicationDate = _data["toCommunicationDate"] ? new Date(_data["toCommunicationDate"].toString()) : undefined as any;
            this.messageCategory = _data["messageCategory"];
            this.interactionType = _data["interactionType"];
            this.interactionStatus = _data["interactionStatus"];
            this.sortColumn = _data["sortColumn"];
            this.sortDir = _data["sortDir"];
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
        }
    }

    static fromJS(data: any): InteractionDetailRequest {
        data = typeof data === 'object' ? data : {};
        let result = new InteractionDetailRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountNumber"] = this.accountNumber;
        data["coid"] = this.coid;
        data["fromCommunicationDate"] = this.fromCommunicationDate ? this.fromCommunicationDate.toISOString() : undefined as any;
        data["toCommunicationDate"] = this.toCommunicationDate ? this.toCommunicationDate.toISOString() : undefined as any;
        data["messageCategory"] = this.messageCategory;
        data["interactionType"] = this.interactionType;
        data["interactionStatus"] = this.interactionStatus;
        data["sortColumn"] = this.sortColumn;
        data["sortDir"] = this.sortDir;
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        return data;
    }
}

export interface IInteractionDetailRequest {
    accountNumber?: string;
    coid?: number | undefined;
    fromCommunicationDate?: Date | undefined;
    toCommunicationDate?: Date | undefined;
    messageCategory?: string;
    interactionType?: string;
    interactionStatus?: string;
    sortColumn?: string;
    sortDir?: string;
    page?: number;
    pageSize?: number;
}

export class APIResponseOfInteractionCount implements IAPIResponseOfInteractionCount {
    statusCode?: HttpStatusCode;
    isSuccess?: boolean;
    errorMessages?: string[];
    result?: InteractionCount | undefined;

    constructor(data?: IAPIResponseOfInteractionCount) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusCode = _data["statusCode"];
            this.isSuccess = _data["isSuccess"];
            if (Array.isArray(_data["errorMessages"])) {
                this.errorMessages = [] as any;
                for (let item of _data["errorMessages"])
                    this.errorMessages!.push(item);
            }
            this.result = _data["result"] ? InteractionCount.fromJS(_data["result"]) : undefined as any;
        }
    }

    static fromJS(data: any): APIResponseOfInteractionCount {
        data = typeof data === 'object' ? data : {};
        let result = new APIResponseOfInteractionCount();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["isSuccess"] = this.isSuccess;
        if (Array.isArray(this.errorMessages)) {
            data["errorMessages"] = [];
            for (let item of this.errorMessages)
                data["errorMessages"].push(item);
        }
        data["result"] = this.result ? this.result.toJSON() : undefined as any;
        return data;
    }
}

export interface IAPIResponseOfInteractionCount {
    statusCode?: HttpStatusCode;
    isSuccess?: boolean;
    errorMessages?: string[];
    result?: InteractionCount | undefined;
}

export class InteractionCount implements IInteractionCount {
    totalCount?: number;

    constructor(data?: IInteractionCount) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): InteractionCount {
        data = typeof data === 'object' ? data : {};
        let result = new InteractionCount();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IInteractionCount {
    totalCount?: number;
}

export class InteractionCountRequest implements IInteractionCountRequest {
    accountNumber?: string | undefined;
    coid?: number | undefined;

    constructor(data?: IInteractionCountRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountNumber = _data["accountNumber"];
            this.coid = _data["coid"];
        }
    }

    static fromJS(data: any): InteractionCountRequest {
        data = typeof data === 'object' ? data : {};
        let result = new InteractionCountRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountNumber"] = this.accountNumber;
        data["coid"] = this.coid;
        return data;
    }
}

export interface IInteractionCountRequest {
    accountNumber?: string | undefined;
    coid?: number | undefined;
}

export class APIResponseOfListOfSearchAccountDTO implements IAPIResponseOfListOfSearchAccountDTO {
    statusCode?: HttpStatusCode;
    isSuccess?: boolean;
    errorMessages?: string[];
    result?: SearchAccountDTO[] | undefined;

    constructor(data?: IAPIResponseOfListOfSearchAccountDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusCode = _data["statusCode"];
            this.isSuccess = _data["isSuccess"];
            if (Array.isArray(_data["errorMessages"])) {
                this.errorMessages = [] as any;
                for (let item of _data["errorMessages"])
                    this.errorMessages!.push(item);
            }
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result!.push(SearchAccountDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): APIResponseOfListOfSearchAccountDTO {
        data = typeof data === 'object' ? data : {};
        let result = new APIResponseOfListOfSearchAccountDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["isSuccess"] = this.isSuccess;
        if (Array.isArray(this.errorMessages)) {
            data["errorMessages"] = [];
            for (let item of this.errorMessages)
                data["errorMessages"].push(item);
        }
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IAPIResponseOfListOfSearchAccountDTO {
    statusCode?: HttpStatusCode;
    isSuccess?: boolean;
    errorMessages?: string[];
    result?: SearchAccountDTO[] | undefined;
}

export class SearchAccountDTO implements ISearchAccountDTO {
    name?: string;
    appFacilityId?: number;
    marketName?: string;
    coid?: number;
    unitNumber?: string;
    accountNumber?: string;
    mnemonic?: string;

    constructor(data?: ISearchAccountDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.appFacilityId = _data["appFacilityId"];
            this.marketName = _data["marketName"];
            this.coid = _data["coid"];
            this.unitNumber = _data["unitNumber"];
            this.accountNumber = _data["accountNumber"];
            this.mnemonic = _data["mnemonic"];
        }
    }

    static fromJS(data: any): SearchAccountDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SearchAccountDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["appFacilityId"] = this.appFacilityId;
        data["marketName"] = this.marketName;
        data["coid"] = this.coid;
        data["unitNumber"] = this.unitNumber;
        data["accountNumber"] = this.accountNumber;
        data["mnemonic"] = this.mnemonic;
        return data;
    }
}

export interface ISearchAccountDTO {
    name?: string;
    appFacilityId?: number;
    marketName?: string;
    coid?: number;
    unitNumber?: string;
    accountNumber?: string;
    mnemonic?: string;
}

export class APIResponseOfSearchAccountResponse implements IAPIResponseOfSearchAccountResponse {
    statusCode?: HttpStatusCode;
    isSuccess?: boolean;
    errorMessages?: string[];
    result?: SearchAccountResponse | undefined;

    constructor(data?: IAPIResponseOfSearchAccountResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusCode = _data["statusCode"];
            this.isSuccess = _data["isSuccess"];
            if (Array.isArray(_data["errorMessages"])) {
                this.errorMessages = [] as any;
                for (let item of _data["errorMessages"])
                    this.errorMessages!.push(item);
            }
            this.result = _data["result"] ? SearchAccountResponse.fromJS(_data["result"]) : undefined as any;
        }
    }

    static fromJS(data: any): APIResponseOfSearchAccountResponse {
        data = typeof data === 'object' ? data : {};
        let result = new APIResponseOfSearchAccountResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["isSuccess"] = this.isSuccess;
        if (Array.isArray(this.errorMessages)) {
            data["errorMessages"] = [];
            for (let item of this.errorMessages)
                data["errorMessages"].push(item);
        }
        data["result"] = this.result ? this.result.toJSON() : undefined as any;
        return data;
    }
}

export interface IAPIResponseOfSearchAccountResponse {
    statusCode?: HttpStatusCode;
    isSuccess?: boolean;
    errorMessages?: string[];
    result?: SearchAccountResponse | undefined;
}

export class SearchAccountResponse implements ISearchAccountResponse {
    userDemographics?: AccountSearchDTO[] | undefined;
    total?: number | undefined;

    constructor(data?: ISearchAccountResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["userDemographics"])) {
                this.userDemographics = [] as any;
                for (let item of _data["userDemographics"])
                    this.userDemographics!.push(AccountSearchDTO.fromJS(item));
            }
            this.total = _data["total"];
        }
    }

    static fromJS(data: any): SearchAccountResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SearchAccountResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.userDemographics)) {
            data["userDemographics"] = [];
            for (let item of this.userDemographics)
                data["userDemographics"].push(item ? item.toJSON() : undefined as any);
        }
        data["total"] = this.total;
        return data;
    }
}

export interface ISearchAccountResponse {
    userDemographics?: AccountSearchDTO[] | undefined;
    total?: number | undefined;
}

export class AccountSearchDTO implements IAccountSearchDTO {
    accountnumber?: string;
    firstname?: string | undefined;
    lastname?: string | undefined;
    birthDate?: string | undefined;
    medicalRecordNumber?: string | undefined;
    coid?: number | undefined;
    primaryHomePhone?: string | undefined;
    secondaryHomePhone?: string | undefined;
    primaryCellPhone?: string | undefined;
    secondaryCellPhone?: string | undefined;
    mnemonic?: string | undefined;
    totalInteractions?: number;

    constructor(data?: IAccountSearchDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountnumber = _data["accountnumber"];
            this.firstname = _data["firstname"];
            this.lastname = _data["lastname"];
            this.birthDate = _data["birthDate"];
            this.medicalRecordNumber = _data["medicalRecordNumber"];
            this.coid = _data["coid"];
            this.primaryHomePhone = _data["primaryHomePhone"];
            this.secondaryHomePhone = _data["secondaryHomePhone"];
            this.primaryCellPhone = _data["primaryCellPhone"];
            this.secondaryCellPhone = _data["secondaryCellPhone"];
            this.mnemonic = _data["mnemonic"];
            this.totalInteractions = _data["totalInteractions"];
        }
    }

    static fromJS(data: any): AccountSearchDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AccountSearchDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountnumber"] = this.accountnumber;
        data["firstname"] = this.firstname;
        data["lastname"] = this.lastname;
        data["birthDate"] = this.birthDate;
        data["medicalRecordNumber"] = this.medicalRecordNumber;
        data["coid"] = this.coid;
        data["primaryHomePhone"] = this.primaryHomePhone;
        data["secondaryHomePhone"] = this.secondaryHomePhone;
        data["primaryCellPhone"] = this.primaryCellPhone;
        data["secondaryCellPhone"] = this.secondaryCellPhone;
        data["mnemonic"] = this.mnemonic;
        data["totalInteractions"] = this.totalInteractions;
        return data;
    }
}

export interface IAccountSearchDTO {
    accountnumber?: string;
    firstname?: string | undefined;
    lastname?: string | undefined;
    birthDate?: string | undefined;
    medicalRecordNumber?: string | undefined;
    coid?: number | undefined;
    primaryHomePhone?: string | undefined;
    secondaryHomePhone?: string | undefined;
    primaryCellPhone?: string | undefined;
    secondaryCellPhone?: string | undefined;
    mnemonic?: string | undefined;
    totalInteractions?: number;
}

export class APIResponseOfAccountSummaryResponseDTO implements IAPIResponseOfAccountSummaryResponseDTO {
    statusCode?: HttpStatusCode;
    isSuccess?: boolean;
    errorMessages?: string[];
    result?: AccountSummaryResponseDTO | undefined;

    constructor(data?: IAPIResponseOfAccountSummaryResponseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusCode = _data["statusCode"];
            this.isSuccess = _data["isSuccess"];
            if (Array.isArray(_data["errorMessages"])) {
                this.errorMessages = [] as any;
                for (let item of _data["errorMessages"])
                    this.errorMessages!.push(item);
            }
            this.result = _data["result"] ? AccountSummaryResponseDTO.fromJS(_data["result"]) : undefined as any;
        }
    }

    static fromJS(data: any): APIResponseOfAccountSummaryResponseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new APIResponseOfAccountSummaryResponseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["isSuccess"] = this.isSuccess;
        if (Array.isArray(this.errorMessages)) {
            data["errorMessages"] = [];
            for (let item of this.errorMessages)
                data["errorMessages"].push(item);
        }
        data["result"] = this.result ? this.result.toJSON() : undefined as any;
        return data;
    }
}

export interface IAPIResponseOfAccountSummaryResponseDTO {
    statusCode?: HttpStatusCode;
    isSuccess?: boolean;
    errorMessages?: string[];
    result?: AccountSummaryResponseDTO | undefined;
}

export class AccountSummaryResponseDTO implements IAccountSummaryResponseDTO {
    accountSummary?: AccountSummaryDTO;
    accountDemographics?: AccountDemographicsDTO;
    accountStatus?: CancelRescheduleAccountStatusDTO[];
    errorDetails?: AccountSummaryErrorMessageDTO;

    constructor(data?: IAccountSummaryResponseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountSummary = _data["accountSummary"] ? AccountSummaryDTO.fromJS(_data["accountSummary"]) : undefined as any;
            this.accountDemographics = _data["accountDemographics"] ? AccountDemographicsDTO.fromJS(_data["accountDemographics"]) : undefined as any;
            if (Array.isArray(_data["accountStatus"])) {
                this.accountStatus = [] as any;
                for (let item of _data["accountStatus"])
                    this.accountStatus!.push(CancelRescheduleAccountStatusDTO.fromJS(item));
            }
            this.errorDetails = _data["errorDetails"] ? AccountSummaryErrorMessageDTO.fromJS(_data["errorDetails"]) : undefined as any;
        }
    }

    static fromJS(data: any): AccountSummaryResponseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AccountSummaryResponseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountSummary"] = this.accountSummary ? this.accountSummary.toJSON() : undefined as any;
        data["accountDemographics"] = this.accountDemographics ? this.accountDemographics.toJSON() : undefined as any;
        if (Array.isArray(this.accountStatus)) {
            data["accountStatus"] = [];
            for (let item of this.accountStatus)
                data["accountStatus"].push(item ? item.toJSON() : undefined as any);
        }
        data["errorDetails"] = this.errorDetails ? this.errorDetails.toJSON() : undefined as any;
        return data;
    }
}

export interface IAccountSummaryResponseDTO {
    accountSummary?: AccountSummaryDTO;
    accountDemographics?: AccountDemographicsDTO;
    accountStatus?: CancelRescheduleAccountStatusDTO[];
    errorDetails?: AccountSummaryErrorMessageDTO;
}

export class AccountSummaryDTO implements IAccountSummaryDTO {
    name?: string | undefined;
    dob?: Date | undefined;
    accountNumber?: string | undefined;
    facilityName?: string | undefined;
    coid?: number | undefined;
    unit?: number | undefined;
    onBaseVerified?: string | undefined;
    communicationStatus?: string | undefined;
    createdBy?: string | undefined;
    createdDate?: Date | undefined;
    workflowStep?: string | undefined;
    appAccountId?: number;
    allowInteraction?: string | undefined;
    schedulingPhoneNumber?: string | undefined;
    facilityPhoneNumber?: string | undefined;
    mrn?: string | undefined;
    ssn?: string | undefined;
    dateofService?: Date | undefined;
    bookDate?: Date | undefined;
    diagnosis?: string | undefined;
    familyName?: string | undefined;
    npi?: string | undefined;
    phone?: string | undefined;
    mnemonic?: string | undefined;
    taxID?: string | undefined;
    exceptionStatus?: string | undefined;
    authStatus?: string | undefined;
    practice?: string | undefined;
    cpt?: string | undefined;
    sscCoid?: number | undefined;
    onbaseUrl?: string | undefined;
    scheduledBy?: string | undefined;
    whoToObtainAuth?: string | undefined;
    anyPendingAppointment?: number | undefined;
    emrSystem?: string | undefined;

    constructor(data?: IAccountSummaryDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.dob = _data["dob"] ? new Date(_data["dob"].toString()) : undefined as any;
            this.accountNumber = _data["accountNumber"];
            this.facilityName = _data["facilityName"];
            this.coid = _data["coid"];
            this.unit = _data["unit"];
            this.onBaseVerified = _data["onBaseVerified"];
            this.communicationStatus = _data["communicationStatus"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined as any;
            this.workflowStep = _data["workflowStep"];
            this.appAccountId = _data["appAccountId"];
            this.allowInteraction = _data["allowInteraction"];
            this.schedulingPhoneNumber = _data["schedulingPhoneNumber"];
            this.facilityPhoneNumber = _data["facilityPhoneNumber"];
            this.mrn = _data["mrn"];
            this.ssn = _data["ssn"];
            this.dateofService = _data["dateofService"] ? new Date(_data["dateofService"].toString()) : undefined as any;
            this.bookDate = _data["bookDate"] ? new Date(_data["bookDate"].toString()) : undefined as any;
            this.diagnosis = _data["diagnosis"];
            this.familyName = _data["familyName"];
            this.npi = _data["npi"];
            this.phone = _data["phone"];
            this.mnemonic = _data["mnemonic"];
            this.taxID = _data["taxID"];
            this.exceptionStatus = _data["exceptionStatus"];
            this.authStatus = _data["authStatus"];
            this.practice = _data["practice"];
            this.cpt = _data["cpt"];
            this.sscCoid = _data["sscCoid"];
            this.onbaseUrl = _data["onbaseUrl"];
            this.scheduledBy = _data["scheduledBy"];
            this.whoToObtainAuth = _data["whoToObtainAuth"];
            this.anyPendingAppointment = _data["anyPendingAppointment"];
            this.emrSystem = _data["emrSystem"];
        }
    }

    static fromJS(data: any): AccountSummaryDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AccountSummaryDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["dob"] = this.dob ? this.dob.toISOString() : undefined as any;
        data["accountNumber"] = this.accountNumber;
        data["facilityName"] = this.facilityName;
        data["coid"] = this.coid;
        data["unit"] = this.unit;
        data["onBaseVerified"] = this.onBaseVerified;
        data["communicationStatus"] = this.communicationStatus;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined as any;
        data["workflowStep"] = this.workflowStep;
        data["appAccountId"] = this.appAccountId;
        data["allowInteraction"] = this.allowInteraction;
        data["schedulingPhoneNumber"] = this.schedulingPhoneNumber;
        data["facilityPhoneNumber"] = this.facilityPhoneNumber;
        data["mrn"] = this.mrn;
        data["ssn"] = this.ssn;
        data["dateofService"] = this.dateofService ? this.dateofService.toISOString() : undefined as any;
        data["bookDate"] = this.bookDate ? this.bookDate.toISOString() : undefined as any;
        data["diagnosis"] = this.diagnosis;
        data["familyName"] = this.familyName;
        data["npi"] = this.npi;
        data["phone"] = this.phone;
        data["mnemonic"] = this.mnemonic;
        data["taxID"] = this.taxID;
        data["exceptionStatus"] = this.exceptionStatus;
        data["authStatus"] = this.authStatus;
        data["practice"] = this.practice;
        data["cpt"] = this.cpt;
        data["sscCoid"] = this.sscCoid;
        data["onbaseUrl"] = this.onbaseUrl;
        data["scheduledBy"] = this.scheduledBy;
        data["whoToObtainAuth"] = this.whoToObtainAuth;
        data["anyPendingAppointment"] = this.anyPendingAppointment;
        data["emrSystem"] = this.emrSystem;
        return data;
    }
}

export interface IAccountSummaryDTO {
    name?: string | undefined;
    dob?: Date | undefined;
    accountNumber?: string | undefined;
    facilityName?: string | undefined;
    coid?: number | undefined;
    unit?: number | undefined;
    onBaseVerified?: string | undefined;
    communicationStatus?: string | undefined;
    createdBy?: string | undefined;
    createdDate?: Date | undefined;
    workflowStep?: string | undefined;
    appAccountId?: number;
    allowInteraction?: string | undefined;
    schedulingPhoneNumber?: string | undefined;
    facilityPhoneNumber?: string | undefined;
    mrn?: string | undefined;
    ssn?: string | undefined;
    dateofService?: Date | undefined;
    bookDate?: Date | undefined;
    diagnosis?: string | undefined;
    familyName?: string | undefined;
    npi?: string | undefined;
    phone?: string | undefined;
    mnemonic?: string | undefined;
    taxID?: string | undefined;
    exceptionStatus?: string | undefined;
    authStatus?: string | undefined;
    practice?: string | undefined;
    cpt?: string | undefined;
    sscCoid?: number | undefined;
    onbaseUrl?: string | undefined;
    scheduledBy?: string | undefined;
    whoToObtainAuth?: string | undefined;
    anyPendingAppointment?: number | undefined;
    emrSystem?: string | undefined;
}

export class AccountDemographicsDTO implements IAccountDemographicsDTO {
    addressLineOne?: string | undefined;
    addressLineTwo?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    country?: string | undefined;
    postalCode?: string | undefined;
    cellPhone?: string | undefined;
    homePhone?: string | undefined;
    primaryEmail?: string | undefined;
    alternateEmail?: string | undefined;
    language?: string | undefined;

    constructor(data?: IAccountDemographicsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.addressLineOne = _data["addressLineOne"];
            this.addressLineTwo = _data["addressLineTwo"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.country = _data["country"];
            this.postalCode = _data["postalCode"];
            this.cellPhone = _data["cellPhone"];
            this.homePhone = _data["homePhone"];
            this.primaryEmail = _data["primaryEmail"];
            this.alternateEmail = _data["alternateEmail"];
            this.language = _data["language"];
        }
    }

    static fromJS(data: any): AccountDemographicsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AccountDemographicsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["addressLineOne"] = this.addressLineOne;
        data["addressLineTwo"] = this.addressLineTwo;
        data["city"] = this.city;
        data["state"] = this.state;
        data["country"] = this.country;
        data["postalCode"] = this.postalCode;
        data["cellPhone"] = this.cellPhone;
        data["homePhone"] = this.homePhone;
        data["primaryEmail"] = this.primaryEmail;
        data["alternateEmail"] = this.alternateEmail;
        data["language"] = this.language;
        return data;
    }
}

export interface IAccountDemographicsDTO {
    addressLineOne?: string | undefined;
    addressLineTwo?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    country?: string | undefined;
    postalCode?: string | undefined;
    cellPhone?: string | undefined;
    homePhone?: string | undefined;
    primaryEmail?: string | undefined;
    alternateEmail?: string | undefined;
    language?: string | undefined;
}

export class AccountStatusDTO implements IAccountStatusDTO {
    workQueueId?: number;
    workFlowStepId?: number | undefined;
    workQueueName?: string | undefined;
    status?: string | undefined;
    assignedTo?: string | undefined;
    assignedUserFirstName?: string | undefined;
    assignedUserLastName?: string | undefined;
    refWorkQueueProcMappingId?: number | undefined;
    isFollowup?: boolean;
    statusList?: StatusLookup[] | undefined;

    constructor(data?: IAccountStatusDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.workQueueId = _data["workQueueId"];
            this.workFlowStepId = _data["workFlowStepId"];
            this.workQueueName = _data["workQueueName"];
            this.status = _data["status"];
            this.assignedTo = _data["assignedTo"];
            this.assignedUserFirstName = _data["assignedUserFirstName"];
            this.assignedUserLastName = _data["assignedUserLastName"];
            this.refWorkQueueProcMappingId = _data["refWorkQueueProcMappingId"];
            this.isFollowup = _data["isFollowup"];
            if (Array.isArray(_data["statusList"])) {
                this.statusList = [] as any;
                for (let item of _data["statusList"])
                    this.statusList!.push(StatusLookup.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AccountStatusDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AccountStatusDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workQueueId"] = this.workQueueId;
        data["workFlowStepId"] = this.workFlowStepId;
        data["workQueueName"] = this.workQueueName;
        data["status"] = this.status;
        data["assignedTo"] = this.assignedTo;
        data["assignedUserFirstName"] = this.assignedUserFirstName;
        data["assignedUserLastName"] = this.assignedUserLastName;
        data["refWorkQueueProcMappingId"] = this.refWorkQueueProcMappingId;
        data["isFollowup"] = this.isFollowup;
        if (Array.isArray(this.statusList)) {
            data["statusList"] = [];
            for (let item of this.statusList)
                data["statusList"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IAccountStatusDTO {
    workQueueId?: number;
    workFlowStepId?: number | undefined;
    workQueueName?: string | undefined;
    status?: string | undefined;
    assignedTo?: string | undefined;
    assignedUserFirstName?: string | undefined;
    assignedUserLastName?: string | undefined;
    refWorkQueueProcMappingId?: number | undefined;
    isFollowup?: boolean;
    statusList?: StatusLookup[] | undefined;
}

export class CancelRescheduleAccountStatusDTO extends AccountStatusDTO implements ICancelRescheduleAccountStatusDTO {
    isAuthReschedule?: boolean;

    constructor(data?: ICancelRescheduleAccountStatusDTO) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.isAuthReschedule = _data["isAuthReschedule"];
        }
    }

    static override fromJS(data: any): CancelRescheduleAccountStatusDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CancelRescheduleAccountStatusDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isAuthReschedule"] = this.isAuthReschedule;
        super.toJSON(data);
        return data;
    }
}

export interface ICancelRescheduleAccountStatusDTO extends IAccountStatusDTO {
    isAuthReschedule?: boolean;
}

export class StatusLookup implements IStatusLookup {
    id?: number;
    name?: string;

    constructor(data?: IStatusLookup) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): StatusLookup {
        data = typeof data === 'object' ? data : {};
        let result = new StatusLookup();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IStatusLookup {
    id?: number;
    name?: string;
}

export class AccountSummaryErrorMessageDTO implements IAccountSummaryErrorMessageDTO {
    errorMessage?: string | undefined;
    isUserHaveAccessToFacility?: boolean;

    constructor(data?: IAccountSummaryErrorMessageDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isUserHaveAccessToFacility = _data["isUserHaveAccessToFacility"];
        }
    }

    static fromJS(data: any): AccountSummaryErrorMessageDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AccountSummaryErrorMessageDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isUserHaveAccessToFacility"] = this.isUserHaveAccessToFacility;
        return data;
    }
}

export interface IAccountSummaryErrorMessageDTO {
    errorMessage?: string | undefined;
    isUserHaveAccessToFacility?: boolean;
}

export class AccountSummaryRequest implements IAccountSummaryRequest {
    accountNumber?: string;
    coid?: number | undefined;
    accountGUID?: string;

    constructor(data?: IAccountSummaryRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountNumber = _data["accountNumber"];
            this.coid = _data["coid"];
            this.accountGUID = _data["accountGUID"];
        }
    }

    static fromJS(data: any): AccountSummaryRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AccountSummaryRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountNumber"] = this.accountNumber;
        data["coid"] = this.coid;
        data["accountGUID"] = this.accountGUID;
        return data;
    }
}

export interface IAccountSummaryRequest {
    accountNumber?: string;
    coid?: number | undefined;
    accountGUID?: string;
}

export class APIResponseOfUpdateResponseDTO implements IAPIResponseOfUpdateResponseDTO {
    statusCode?: HttpStatusCode;
    isSuccess?: boolean;
    errorMessages?: string[];
    result?: UpdateResponseDTO | undefined;

    constructor(data?: IAPIResponseOfUpdateResponseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusCode = _data["statusCode"];
            this.isSuccess = _data["isSuccess"];
            if (Array.isArray(_data["errorMessages"])) {
                this.errorMessages = [] as any;
                for (let item of _data["errorMessages"])
                    this.errorMessages!.push(item);
            }
            this.result = _data["result"] ? UpdateResponseDTO.fromJS(_data["result"]) : undefined as any;
        }
    }

    static fromJS(data: any): APIResponseOfUpdateResponseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new APIResponseOfUpdateResponseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["isSuccess"] = this.isSuccess;
        if (Array.isArray(this.errorMessages)) {
            data["errorMessages"] = [];
            for (let item of this.errorMessages)
                data["errorMessages"].push(item);
        }
        data["result"] = this.result ? this.result.toJSON() : undefined as any;
        return data;
    }
}

export interface IAPIResponseOfUpdateResponseDTO {
    statusCode?: HttpStatusCode;
    isSuccess?: boolean;
    errorMessages?: string[];
    result?: UpdateResponseDTO | undefined;
}

export class UpdateResponseDTO implements IUpdateResponseDTO {
    responseText?: string;
    isSuccess?: boolean;

    constructor(data?: IUpdateResponseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseText = _data["responseText"];
            this.isSuccess = _data["isSuccess"];
        }
    }

    static fromJS(data: any): UpdateResponseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateResponseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseText"] = this.responseText;
        data["isSuccess"] = this.isSuccess;
        return data;
    }
}

export interface IUpdateResponseDTO {
    responseText?: string;
    isSuccess?: boolean;
}

export class WorkQueueUpdateRequest implements IWorkQueueUpdateRequest {
    queueName?: string;
    id?: number;
    status?: string;

    constructor(data?: IWorkQueueUpdateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.queueName = _data["queueName"];
            this.id = _data["id"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): WorkQueueUpdateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new WorkQueueUpdateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["queueName"] = this.queueName;
        data["id"] = this.id;
        data["status"] = this.status;
        return data;
    }
}

export interface IWorkQueueUpdateRequest {
    queueName?: string;
    id?: number;
    status?: string;
}

export class APIResponseOfListOfWorkQueueStatusDTO implements IAPIResponseOfListOfWorkQueueStatusDTO {
    statusCode?: HttpStatusCode;
    isSuccess?: boolean;
    errorMessages?: string[];
    result?: WorkQueueStatusDTO[] | undefined;

    constructor(data?: IAPIResponseOfListOfWorkQueueStatusDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusCode = _data["statusCode"];
            this.isSuccess = _data["isSuccess"];
            if (Array.isArray(_data["errorMessages"])) {
                this.errorMessages = [] as any;
                for (let item of _data["errorMessages"])
                    this.errorMessages!.push(item);
            }
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result!.push(WorkQueueStatusDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): APIResponseOfListOfWorkQueueStatusDTO {
        data = typeof data === 'object' ? data : {};
        let result = new APIResponseOfListOfWorkQueueStatusDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["isSuccess"] = this.isSuccess;
        if (Array.isArray(this.errorMessages)) {
            data["errorMessages"] = [];
            for (let item of this.errorMessages)
                data["errorMessages"].push(item);
        }
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IAPIResponseOfListOfWorkQueueStatusDTO {
    statusCode?: HttpStatusCode;
    isSuccess?: boolean;
    errorMessages?: string[];
    result?: WorkQueueStatusDTO[] | undefined;
}

export class WorkQueueStatusDTO implements IWorkQueueStatusDTO {
    id?: number;
    name?: string;

    constructor(data?: IWorkQueueStatusDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): WorkQueueStatusDTO {
        data = typeof data === 'object' ? data : {};
        let result = new WorkQueueStatusDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IWorkQueueStatusDTO {
    id?: number;
    name?: string;
}

export class APIResponseOfListOfAccountStatusDTO implements IAPIResponseOfListOfAccountStatusDTO {
    statusCode?: HttpStatusCode;
    isSuccess?: boolean;
    errorMessages?: string[];
    result?: AccountStatusDTO[] | undefined;

    constructor(data?: IAPIResponseOfListOfAccountStatusDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusCode = _data["statusCode"];
            this.isSuccess = _data["isSuccess"];
            if (Array.isArray(_data["errorMessages"])) {
                this.errorMessages = [] as any;
                for (let item of _data["errorMessages"])
                    this.errorMessages!.push(item);
            }
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result!.push(AccountStatusDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): APIResponseOfListOfAccountStatusDTO {
        data = typeof data === 'object' ? data : {};
        let result = new APIResponseOfListOfAccountStatusDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["isSuccess"] = this.isSuccess;
        if (Array.isArray(this.errorMessages)) {
            data["errorMessages"] = [];
            for (let item of this.errorMessages)
                data["errorMessages"].push(item);
        }
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IAPIResponseOfListOfAccountStatusDTO {
    statusCode?: HttpStatusCode;
    isSuccess?: boolean;
    errorMessages?: string[];
    result?: AccountStatusDTO[] | undefined;
}

export class AccountWorkQueueStatusRequest implements IAccountWorkQueueStatusRequest {
    accountNumber?: string;
    coid?: number | undefined;

    constructor(data?: IAccountWorkQueueStatusRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountNumber = _data["accountNumber"];
            this.coid = _data["coid"];
        }
    }

    static fromJS(data: any): AccountWorkQueueStatusRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AccountWorkQueueStatusRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountNumber"] = this.accountNumber;
        data["coid"] = this.coid;
        return data;
    }
}

export interface IAccountWorkQueueStatusRequest {
    accountNumber?: string;
    coid?: number | undefined;
}

export class APIResponseOfListOfAppointmentType implements IAPIResponseOfListOfAppointmentType {
    statusCode?: HttpStatusCode;
    isSuccess?: boolean;
    errorMessages?: string[];
    result?: AppointmentType[] | undefined;

    constructor(data?: IAPIResponseOfListOfAppointmentType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusCode = _data["statusCode"];
            this.isSuccess = _data["isSuccess"];
            if (Array.isArray(_data["errorMessages"])) {
                this.errorMessages = [] as any;
                for (let item of _data["errorMessages"])
                    this.errorMessages!.push(item);
            }
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result!.push(AppointmentType.fromJS(item));
            }
        }
    }

    static fromJS(data: any): APIResponseOfListOfAppointmentType {
        data = typeof data === 'object' ? data : {};
        let result = new APIResponseOfListOfAppointmentType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["isSuccess"] = this.isSuccess;
        if (Array.isArray(this.errorMessages)) {
            data["errorMessages"] = [];
            for (let item of this.errorMessages)
                data["errorMessages"].push(item);
        }
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IAPIResponseOfListOfAppointmentType {
    statusCode?: HttpStatusCode;
    isSuccess?: boolean;
    errorMessages?: string[];
    result?: AppointmentType[] | undefined;
}

export class AppointmentType implements IAppointmentType {
    apptType?: string;

    constructor(data?: IAppointmentType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.apptType = _data["apptType"];
        }
    }

    static fromJS(data: any): AppointmentType {
        data = typeof data === 'object' ? data : {};
        let result = new AppointmentType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["apptType"] = this.apptType;
        return data;
    }
}

export interface IAppointmentType {
    apptType?: string;
}

export class APIResponseOfListOfAppointmentDetailsResponse implements IAPIResponseOfListOfAppointmentDetailsResponse {
    statusCode?: HttpStatusCode;
    isSuccess?: boolean;
    errorMessages?: string[];
    result?: AppointmentDetailsResponse[] | undefined;

    constructor(data?: IAPIResponseOfListOfAppointmentDetailsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusCode = _data["statusCode"];
            this.isSuccess = _data["isSuccess"];
            if (Array.isArray(_data["errorMessages"])) {
                this.errorMessages = [] as any;
                for (let item of _data["errorMessages"])
                    this.errorMessages!.push(item);
            }
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result!.push(AppointmentDetailsResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): APIResponseOfListOfAppointmentDetailsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new APIResponseOfListOfAppointmentDetailsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["isSuccess"] = this.isSuccess;
        if (Array.isArray(this.errorMessages)) {
            data["errorMessages"] = [];
            for (let item of this.errorMessages)
                data["errorMessages"].push(item);
        }
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IAPIResponseOfListOfAppointmentDetailsResponse {
    statusCode?: HttpStatusCode;
    isSuccess?: boolean;
    errorMessages?: string[];
    result?: AppointmentDetailsResponse[] | undefined;
}

export class AppointmentDetailsResponse implements IAppointmentDetailsResponse {
    apptType?: string | undefined;
    apptURN?: string | undefined;
    apptAge?: string | undefined;
    isActive?: string | undefined;
    isMissAppliedAppType?: string | undefined;
    facilityMnenomic?: string | undefined;
    market?: string | undefined;
    division?: string | undefined;
    scheduleStatus?: string | undefined;
    scheduledDate?: string | undefined;
    scheduledBy?: string | undefined;
    doctorName?: string | undefined;
    doctorType?: string | undefined;
    orderSource?: string | undefined;
    doctorPhone?: string | undefined;
    createdDate?: string | undefined;
    createdSource?: string | undefined;
    lastModifiedSource?: string | undefined;
    lastModifiedDate?: string | undefined;
    apptTypeDesc?: string | undefined;
    bookedDateUtc?: string | undefined;
    apptLocation?: string | undefined;
    emrSystem?: string | undefined;
    mnemonic?: string | undefined;
    apptLocationName?: string | undefined;
    apptResource?: string | undefined;

    constructor(data?: IAppointmentDetailsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.apptType = _data["apptType"];
            this.apptURN = _data["apptURN"];
            this.apptAge = _data["apptAge"];
            this.isActive = _data["isActive"];
            this.isMissAppliedAppType = _data["isMissAppliedAppType"];
            this.facilityMnenomic = _data["facilityMnenomic"];
            this.market = _data["market"];
            this.division = _data["division"];
            this.scheduleStatus = _data["scheduleStatus"];
            this.scheduledDate = _data["scheduledDate"];
            this.scheduledBy = _data["scheduledBy"];
            this.doctorName = _data["doctorName"];
            this.doctorType = _data["doctorType"];
            this.orderSource = _data["orderSource"];
            this.doctorPhone = _data["doctorPhone"];
            this.createdDate = _data["createdDate"];
            this.createdSource = _data["createdSource"];
            this.lastModifiedSource = _data["lastModifiedSource"];
            this.lastModifiedDate = _data["lastModifiedDate"];
            this.apptTypeDesc = _data["apptTypeDesc"];
            this.bookedDateUtc = _data["bookedDateUtc"];
            this.apptLocation = _data["apptLocation"];
            this.emrSystem = _data["emrSystem"];
            this.mnemonic = _data["mnemonic"];
            this.apptLocationName = _data["apptLocationName"];
            this.apptResource = _data["apptResource"];
        }
    }

    static fromJS(data: any): AppointmentDetailsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AppointmentDetailsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["apptType"] = this.apptType;
        data["apptURN"] = this.apptURN;
        data["apptAge"] = this.apptAge;
        data["isActive"] = this.isActive;
        data["isMissAppliedAppType"] = this.isMissAppliedAppType;
        data["facilityMnenomic"] = this.facilityMnenomic;
        data["market"] = this.market;
        data["division"] = this.division;
        data["scheduleStatus"] = this.scheduleStatus;
        data["scheduledDate"] = this.scheduledDate;
        data["scheduledBy"] = this.scheduledBy;
        data["doctorName"] = this.doctorName;
        data["doctorType"] = this.doctorType;
        data["orderSource"] = this.orderSource;
        data["doctorPhone"] = this.doctorPhone;
        data["createdDate"] = this.createdDate;
        data["createdSource"] = this.createdSource;
        data["lastModifiedSource"] = this.lastModifiedSource;
        data["lastModifiedDate"] = this.lastModifiedDate;
        data["apptTypeDesc"] = this.apptTypeDesc;
        data["bookedDateUtc"] = this.bookedDateUtc;
        data["apptLocation"] = this.apptLocation;
        data["emrSystem"] = this.emrSystem;
        data["mnemonic"] = this.mnemonic;
        data["apptLocationName"] = this.apptLocationName;
        data["apptResource"] = this.apptResource;
        return data;
    }
}

export interface IAppointmentDetailsResponse {
    apptType?: string | undefined;
    apptURN?: string | undefined;
    apptAge?: string | undefined;
    isActive?: string | undefined;
    isMissAppliedAppType?: string | undefined;
    facilityMnenomic?: string | undefined;
    market?: string | undefined;
    division?: string | undefined;
    scheduleStatus?: string | undefined;
    scheduledDate?: string | undefined;
    scheduledBy?: string | undefined;
    doctorName?: string | undefined;
    doctorType?: string | undefined;
    orderSource?: string | undefined;
    doctorPhone?: string | undefined;
    createdDate?: string | undefined;
    createdSource?: string | undefined;
    lastModifiedSource?: string | undefined;
    lastModifiedDate?: string | undefined;
    apptTypeDesc?: string | undefined;
    bookedDateUtc?: string | undefined;
    apptLocation?: string | undefined;
    emrSystem?: string | undefined;
    mnemonic?: string | undefined;
    apptLocationName?: string | undefined;
    apptResource?: string | undefined;
}

export class AppointmentDetailsRequest implements IAppointmentDetailsRequest {
    accountNumber?: string | undefined;
    coid?: number | undefined;
    apptType?: string;

    constructor(data?: IAppointmentDetailsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountNumber = _data["accountNumber"];
            this.coid = _data["coid"];
            this.apptType = _data["apptType"];
        }
    }

    static fromJS(data: any): AppointmentDetailsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AppointmentDetailsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountNumber"] = this.accountNumber;
        data["coid"] = this.coid;
        data["apptType"] = this.apptType;
        return data;
    }
}

export interface IAppointmentDetailsRequest {
    accountNumber?: string | undefined;
    coid?: number | undefined;
    apptType?: string;
}

export class APIResponseOfAppointmentsCount implements IAPIResponseOfAppointmentsCount {
    statusCode?: HttpStatusCode;
    isSuccess?: boolean;
    errorMessages?: string[];
    result?: AppointmentsCount | undefined;

    constructor(data?: IAPIResponseOfAppointmentsCount) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusCode = _data["statusCode"];
            this.isSuccess = _data["isSuccess"];
            if (Array.isArray(_data["errorMessages"])) {
                this.errorMessages = [] as any;
                for (let item of _data["errorMessages"])
                    this.errorMessages!.push(item);
            }
            this.result = _data["result"] ? AppointmentsCount.fromJS(_data["result"]) : undefined as any;
        }
    }

    static fromJS(data: any): APIResponseOfAppointmentsCount {
        data = typeof data === 'object' ? data : {};
        let result = new APIResponseOfAppointmentsCount();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["isSuccess"] = this.isSuccess;
        if (Array.isArray(this.errorMessages)) {
            data["errorMessages"] = [];
            for (let item of this.errorMessages)
                data["errorMessages"].push(item);
        }
        data["result"] = this.result ? this.result.toJSON() : undefined as any;
        return data;
    }
}

export interface IAPIResponseOfAppointmentsCount {
    statusCode?: HttpStatusCode;
    isSuccess?: boolean;
    errorMessages?: string[];
    result?: AppointmentsCount | undefined;
}

export class AppointmentsCount implements IAppointmentsCount {
    appointmentCount?: number;

    constructor(data?: IAppointmentsCount) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.appointmentCount = _data["appointmentCount"];
        }
    }

    static fromJS(data: any): AppointmentsCount {
        data = typeof data === 'object' ? data : {};
        let result = new AppointmentsCount();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["appointmentCount"] = this.appointmentCount;
        return data;
    }
}

export interface IAppointmentsCount {
    appointmentCount?: number;
}

export class APIResponseOfBoolean implements IAPIResponseOfBoolean {
    statusCode?: HttpStatusCode;
    isSuccess?: boolean;
    errorMessages?: string[];
    result?: boolean;

    constructor(data?: IAPIResponseOfBoolean) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusCode = _data["statusCode"];
            this.isSuccess = _data["isSuccess"];
            if (Array.isArray(_data["errorMessages"])) {
                this.errorMessages = [] as any;
                for (let item of _data["errorMessages"])
                    this.errorMessages!.push(item);
            }
            this.result = _data["result"];
        }
    }

    static fromJS(data: any): APIResponseOfBoolean {
        data = typeof data === 'object' ? data : {};
        let result = new APIResponseOfBoolean();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["isSuccess"] = this.isSuccess;
        if (Array.isArray(this.errorMessages)) {
            data["errorMessages"] = [];
            for (let item of this.errorMessages)
                data["errorMessages"].push(item);
        }
        data["result"] = this.result;
        return data;
    }
}

export interface IAPIResponseOfBoolean {
    statusCode?: HttpStatusCode;
    isSuccess?: boolean;
    errorMessages?: string[];
    result?: boolean;
}

export class AppointmentEmailRequest implements IAppointmentEmailRequest {
    recipientEmail!: string;
    conversationId!: string | undefined;
    accountNumber!: string;
    coid!: number;
    appointments!: AppointmentData[];

    constructor(data?: IAppointmentEmailRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.appointments = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.recipientEmail = _data["recipientEmail"];
            this.conversationId = _data["conversationId"];
            this.accountNumber = _data["accountNumber"];
            this.coid = _data["coid"];
            if (Array.isArray(_data["appointments"])) {
                this.appointments = [] as any;
                for (let item of _data["appointments"])
                    this.appointments!.push(AppointmentData.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AppointmentEmailRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AppointmentEmailRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["recipientEmail"] = this.recipientEmail;
        data["conversationId"] = this.conversationId;
        data["accountNumber"] = this.accountNumber;
        data["coid"] = this.coid;
        if (Array.isArray(this.appointments)) {
            data["appointments"] = [];
            for (let item of this.appointments)
                data["appointments"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IAppointmentEmailRequest {
    recipientEmail: string;
    conversationId: string | undefined;
    accountNumber: string;
    coid: number;
    appointments: AppointmentData[];
}

export class AppointmentData implements IAppointmentData {
    urn!: string;
    location!: string | undefined;
    mnemonic!: string | undefined;
    type!: string | undefined;

    constructor(data?: IAppointmentData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.urn = _data["urn"];
            this.location = _data["location"];
            this.mnemonic = _data["mnemonic"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): AppointmentData {
        data = typeof data === 'object' ? data : {};
        let result = new AppointmentData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["urn"] = this.urn;
        data["location"] = this.location;
        data["mnemonic"] = this.mnemonic;
        data["type"] = this.type;
        return data;
    }
}

export interface IAppointmentData {
    urn: string;
    location: string | undefined;
    mnemonic: string | undefined;
    type: string | undefined;
}

export class UpdateAllowInteractionRequest implements IUpdateAllowInteractionRequest {
    appAccountId?: number;
    allowInteraction?: boolean;

    constructor(data?: IUpdateAllowInteractionRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.appAccountId = _data["appAccountId"];
            this.allowInteraction = _data["allowInteraction"];
        }
    }

    static fromJS(data: any): UpdateAllowInteractionRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateAllowInteractionRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["appAccountId"] = this.appAccountId;
        data["allowInteraction"] = this.allowInteraction;
        return data;
    }
}

export interface IUpdateAllowInteractionRequest {
    appAccountId?: number;
    allowInteraction?: boolean;
}

export class APIResponseOfListOfStatesDTO implements IAPIResponseOfListOfStatesDTO {
    statusCode?: HttpStatusCode;
    isSuccess?: boolean;
    errorMessages?: string[];
    result?: StatesDTO[] | undefined;

    constructor(data?: IAPIResponseOfListOfStatesDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusCode = _data["statusCode"];
            this.isSuccess = _data["isSuccess"];
            if (Array.isArray(_data["errorMessages"])) {
                this.errorMessages = [] as any;
                for (let item of _data["errorMessages"])
                    this.errorMessages!.push(item);
            }
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result!.push(StatesDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): APIResponseOfListOfStatesDTO {
        data = typeof data === 'object' ? data : {};
        let result = new APIResponseOfListOfStatesDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["isSuccess"] = this.isSuccess;
        if (Array.isArray(this.errorMessages)) {
            data["errorMessages"] = [];
            for (let item of this.errorMessages)
                data["errorMessages"].push(item);
        }
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IAPIResponseOfListOfStatesDTO {
    statusCode?: HttpStatusCode;
    isSuccess?: boolean;
    errorMessages?: string[];
    result?: StatesDTO[] | undefined;
}

export class StatesDTO implements IStatesDTO {
    stateCode?: string;
    stateDesc?: string;
    active?: boolean;

    constructor(data?: IStatesDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.stateCode = _data["stateCode"];
            this.stateDesc = _data["stateDesc"];
            this.active = _data["active"];
        }
    }

    static fromJS(data: any): StatesDTO {
        data = typeof data === 'object' ? data : {};
        let result = new StatesDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["stateCode"] = this.stateCode;
        data["stateDesc"] = this.stateDesc;
        data["active"] = this.active;
        return data;
    }
}

export interface IStatesDTO {
    stateCode?: string;
    stateDesc?: string;
    active?: boolean;
}

export class ContactUpdateRequest implements IContactUpdateRequest {
    accountNumber?: string | undefined;
    facilityCoid?: string | undefined;
    addresslineOne?: string | undefined;
    addressLineTwo?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    postalcode?: string | undefined;
    homephone?: string | undefined;
    cellphone?: string | undefined;
    email?: string | undefined;

    constructor(data?: IContactUpdateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountNumber = _data["accountNumber"];
            this.facilityCoid = _data["facilityCoid"];
            this.addresslineOne = _data["addresslineOne"];
            this.addressLineTwo = _data["addressLineTwo"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.postalcode = _data["postalcode"];
            this.homephone = _data["homephone"];
            this.cellphone = _data["cellphone"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): ContactUpdateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ContactUpdateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountNumber"] = this.accountNumber;
        data["facilityCoid"] = this.facilityCoid;
        data["addresslineOne"] = this.addresslineOne;
        data["addressLineTwo"] = this.addressLineTwo;
        data["city"] = this.city;
        data["state"] = this.state;
        data["postalcode"] = this.postalcode;
        data["homephone"] = this.homephone;
        data["cellphone"] = this.cellphone;
        data["email"] = this.email;
        return data;
    }
}

export interface IContactUpdateRequest {
    accountNumber?: string | undefined;
    facilityCoid?: string | undefined;
    addresslineOne?: string | undefined;
    addressLineTwo?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    postalcode?: string | undefined;
    homephone?: string | undefined;
    cellphone?: string | undefined;
    email?: string | undefined;
}

export class APIResponseOfWorkQueueCount implements IAPIResponseOfWorkQueueCount {
    statusCode?: HttpStatusCode;
    isSuccess?: boolean;
    errorMessages?: string[];
    result?: WorkQueueCount | undefined;

    constructor(data?: IAPIResponseOfWorkQueueCount) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusCode = _data["statusCode"];
            this.isSuccess = _data["isSuccess"];
            if (Array.isArray(_data["errorMessages"])) {
                this.errorMessages = [] as any;
                for (let item of _data["errorMessages"])
                    this.errorMessages!.push(item);
            }
            this.result = _data["result"] ? WorkQueueCount.fromJS(_data["result"]) : undefined as any;
        }
    }

    static fromJS(data: any): APIResponseOfWorkQueueCount {
        data = typeof data === 'object' ? data : {};
        let result = new APIResponseOfWorkQueueCount();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["isSuccess"] = this.isSuccess;
        if (Array.isArray(this.errorMessages)) {
            data["errorMessages"] = [];
            for (let item of this.errorMessages)
                data["errorMessages"].push(item);
        }
        data["result"] = this.result ? this.result.toJSON() : undefined as any;
        return data;
    }
}

export interface IAPIResponseOfWorkQueueCount {
    statusCode?: HttpStatusCode;
    isSuccess?: boolean;
    errorMessages?: string[];
    result?: WorkQueueCount | undefined;
}

export class WorkQueueCount implements IWorkQueueCount {
    totalCount?: number;

    constructor(data?: IWorkQueueCount) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): WorkQueueCount {
        data = typeof data === 'object' ? data : {};
        let result = new WorkQueueCount();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IWorkQueueCount {
    totalCount?: number;
}

export class WorkQueueRequest implements IWorkQueueRequest {
    accountNumber?: string | undefined;
    coid?: number | undefined;

    constructor(data?: IWorkQueueRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountNumber = _data["accountNumber"];
            this.coid = _data["coid"];
        }
    }

    static fromJS(data: any): WorkQueueRequest {
        data = typeof data === 'object' ? data : {};
        let result = new WorkQueueRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountNumber"] = this.accountNumber;
        data["coid"] = this.coid;
        return data;
    }
}

export interface IWorkQueueRequest {
    accountNumber?: string | undefined;
    coid?: number | undefined;
}

export class ManualInteractionRequest implements IManualInteractionRequest {
    campaign?: string;
    interactionType?: string;
    contactType?: string;
    outcome?: string;
    accountNumber?: string;
    coid?: number;
    userId?: string;

    constructor(data?: IManualInteractionRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.campaign = _data["campaign"];
            this.interactionType = _data["interactionType"];
            this.contactType = _data["contactType"];
            this.outcome = _data["outcome"];
            this.accountNumber = _data["accountNumber"];
            this.coid = _data["coid"];
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): ManualInteractionRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ManualInteractionRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["campaign"] = this.campaign;
        data["interactionType"] = this.interactionType;
        data["contactType"] = this.contactType;
        data["outcome"] = this.outcome;
        data["accountNumber"] = this.accountNumber;
        data["coid"] = this.coid;
        data["userId"] = this.userId;
        return data;
    }
}

export interface IManualInteractionRequest {
    campaign?: string;
    interactionType?: string;
    contactType?: string;
    outcome?: string;
    accountNumber?: string;
    coid?: number;
    userId?: string;
}

export class APIResponseOfListOfAppAccountLock implements IAPIResponseOfListOfAppAccountLock {
    statusCode?: HttpStatusCode;
    isSuccess?: boolean;
    errorMessages?: string[];
    result?: AppAccountLock[] | undefined;

    constructor(data?: IAPIResponseOfListOfAppAccountLock) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusCode = _data["statusCode"];
            this.isSuccess = _data["isSuccess"];
            if (Array.isArray(_data["errorMessages"])) {
                this.errorMessages = [] as any;
                for (let item of _data["errorMessages"])
                    this.errorMessages!.push(item);
            }
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result!.push(AppAccountLock.fromJS(item));
            }
        }
    }

    static fromJS(data: any): APIResponseOfListOfAppAccountLock {
        data = typeof data === 'object' ? data : {};
        let result = new APIResponseOfListOfAppAccountLock();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["isSuccess"] = this.isSuccess;
        if (Array.isArray(this.errorMessages)) {
            data["errorMessages"] = [];
            for (let item of this.errorMessages)
                data["errorMessages"].push(item);
        }
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IAPIResponseOfListOfAppAccountLock {
    statusCode?: HttpStatusCode;
    isSuccess?: boolean;
    errorMessages?: string[];
    result?: AppAccountLock[] | undefined;
}

export class AppAccountLock implements IAppAccountLock {
    appAccountId?: number;
    displayName?: string;
    hcA34ID?: string;
    lockTimeUtc?: Date;
    unlockTimeUtc?: Date | undefined;

    constructor(data?: IAppAccountLock) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.appAccountId = _data["appAccountId"];
            this.displayName = _data["displayName"];
            this.hcA34ID = _data["hcA34ID"];
            this.lockTimeUtc = _data["lockTimeUtc"] ? new Date(_data["lockTimeUtc"].toString()) : undefined as any;
            this.unlockTimeUtc = _data["unlockTimeUtc"] ? new Date(_data["unlockTimeUtc"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): AppAccountLock {
        data = typeof data === 'object' ? data : {};
        let result = new AppAccountLock();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["appAccountId"] = this.appAccountId;
        data["displayName"] = this.displayName;
        data["hcA34ID"] = this.hcA34ID;
        data["lockTimeUtc"] = this.lockTimeUtc ? this.lockTimeUtc.toISOString() : undefined as any;
        data["unlockTimeUtc"] = this.unlockTimeUtc ? this.unlockTimeUtc.toISOString() : undefined as any;
        return data;
    }
}

export interface IAppAccountLock {
    appAccountId?: number;
    displayName?: string;
    hcA34ID?: string;
    lockTimeUtc?: Date;
    unlockTimeUtc?: Date | undefined;
}

export class APIResponseOfListOfRoot implements IAPIResponseOfListOfRoot {
    statusCode?: HttpStatusCode;
    isSuccess?: boolean;
    errorMessages?: string[];
    result?: Root[] | undefined;

    constructor(data?: IAPIResponseOfListOfRoot) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusCode = _data["statusCode"];
            this.isSuccess = _data["isSuccess"];
            if (Array.isArray(_data["errorMessages"])) {
                this.errorMessages = [] as any;
                for (let item of _data["errorMessages"])
                    this.errorMessages!.push(item);
            }
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result!.push(Root.fromJS(item));
            }
        }
    }

    static fromJS(data: any): APIResponseOfListOfRoot {
        data = typeof data === 'object' ? data : {};
        let result = new APIResponseOfListOfRoot();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["isSuccess"] = this.isSuccess;
        if (Array.isArray(this.errorMessages)) {
            data["errorMessages"] = [];
            for (let item of this.errorMessages)
                data["errorMessages"].push(item);
        }
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IAPIResponseOfListOfRoot {
    statusCode?: HttpStatusCode;
    isSuccess?: boolean;
    errorMessages?: string[];
    result?: Root[] | undefined;
}

export class Root implements IRoot {
    value?: string;
    label?: string;
    children?: Child[];

    constructor(data?: IRoot) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.label = _data["label"];
            if (Array.isArray(_data["children"])) {
                this.children = [] as any;
                for (let item of _data["children"])
                    this.children!.push(Child.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Root {
        data = typeof data === 'object' ? data : {};
        let result = new Root();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["label"] = this.label;
        if (Array.isArray(this.children)) {
            data["children"] = [];
            for (let item of this.children)
                data["children"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IRoot {
    value?: string;
    label?: string;
    children?: Child[];
}

export class Child implements IChild {
    value?: string;
    label?: string;
    isAuthEnabled?: boolean | undefined;

    constructor(data?: IChild) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.label = _data["label"];
            this.isAuthEnabled = _data["isAuthEnabled"];
        }
    }

    static fromJS(data: any): Child {
        data = typeof data === 'object' ? data : {};
        let result = new Child();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["label"] = this.label;
        data["isAuthEnabled"] = this.isAuthEnabled;
        return data;
    }
}

export interface IChild {
    value?: string;
    label?: string;
    isAuthEnabled?: boolean | undefined;
}

export class APIResponseOfFacilityResourceFiltersDTO implements IAPIResponseOfFacilityResourceFiltersDTO {
    statusCode?: HttpStatusCode;
    isSuccess?: boolean;
    errorMessages?: string[];
    result?: FacilityResourceFiltersDTO | undefined;

    constructor(data?: IAPIResponseOfFacilityResourceFiltersDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusCode = _data["statusCode"];
            this.isSuccess = _data["isSuccess"];
            if (Array.isArray(_data["errorMessages"])) {
                this.errorMessages = [] as any;
                for (let item of _data["errorMessages"])
                    this.errorMessages!.push(item);
            }
            this.result = _data["result"] ? FacilityResourceFiltersDTO.fromJS(_data["result"]) : undefined as any;
        }
    }

    static fromJS(data: any): APIResponseOfFacilityResourceFiltersDTO {
        data = typeof data === 'object' ? data : {};
        let result = new APIResponseOfFacilityResourceFiltersDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["isSuccess"] = this.isSuccess;
        if (Array.isArray(this.errorMessages)) {
            data["errorMessages"] = [];
            for (let item of this.errorMessages)
                data["errorMessages"].push(item);
        }
        data["result"] = this.result ? this.result.toJSON() : undefined as any;
        return data;
    }
}

export interface IAPIResponseOfFacilityResourceFiltersDTO {
    statusCode?: HttpStatusCode;
    isSuccess?: boolean;
    errorMessages?: string[];
    result?: FacilityResourceFiltersDTO | undefined;
}

export class FacilityResourceFiltersDTO implements IFacilityResourceFiltersDTO {
    facilities?: DropDownItem[];
    mnemonics?: DropDownItem[];
    siteLocations?: DropDownItem[];

    constructor(data?: IFacilityResourceFiltersDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["facilities"])) {
                this.facilities = [] as any;
                for (let item of _data["facilities"])
                    this.facilities!.push(DropDownItem.fromJS(item));
            }
            if (Array.isArray(_data["mnemonics"])) {
                this.mnemonics = [] as any;
                for (let item of _data["mnemonics"])
                    this.mnemonics!.push(DropDownItem.fromJS(item));
            }
            if (Array.isArray(_data["siteLocations"])) {
                this.siteLocations = [] as any;
                for (let item of _data["siteLocations"])
                    this.siteLocations!.push(DropDownItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FacilityResourceFiltersDTO {
        data = typeof data === 'object' ? data : {};
        let result = new FacilityResourceFiltersDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.facilities)) {
            data["facilities"] = [];
            for (let item of this.facilities)
                data["facilities"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.mnemonics)) {
            data["mnemonics"] = [];
            for (let item of this.mnemonics)
                data["mnemonics"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.siteLocations)) {
            data["siteLocations"] = [];
            for (let item of this.siteLocations)
                data["siteLocations"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IFacilityResourceFiltersDTO {
    facilities?: DropDownItem[];
    mnemonics?: DropDownItem[];
    siteLocations?: DropDownItem[];
}

export class DropDownItem implements IDropDownItem {
    label?: string;
    value?: string;

    constructor(data?: IDropDownItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.label = _data["label"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): DropDownItem {
        data = typeof data === 'object' ? data : {};
        let result = new DropDownItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["label"] = this.label;
        data["value"] = this.value;
        return data;
    }
}

export interface IDropDownItem {
    label?: string;
    value?: string;
}

export class FacilityResourceRequest implements IFacilityResourceRequest {
    facilityId?: number;
    resourceMnemonic?: string | undefined;

    constructor(data?: IFacilityResourceRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.facilityId = _data["facilityId"];
            this.resourceMnemonic = _data["resourceMnemonic"];
        }
    }

    static fromJS(data: any): FacilityResourceRequest {
        data = typeof data === 'object' ? data : {};
        let result = new FacilityResourceRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["facilityId"] = this.facilityId;
        data["resourceMnemonic"] = this.resourceMnemonic;
        return data;
    }
}

export interface IFacilityResourceRequest {
    facilityId?: number;
    resourceMnemonic?: string | undefined;
}

export class APIResponseOfListOfFacilityResourceListViewDetailDTO implements IAPIResponseOfListOfFacilityResourceListViewDetailDTO {
    statusCode?: HttpStatusCode;
    isSuccess?: boolean;
    errorMessages?: string[];
    result?: FacilityResourceListViewDetailDTO[] | undefined;

    constructor(data?: IAPIResponseOfListOfFacilityResourceListViewDetailDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusCode = _data["statusCode"];
            this.isSuccess = _data["isSuccess"];
            if (Array.isArray(_data["errorMessages"])) {
                this.errorMessages = [] as any;
                for (let item of _data["errorMessages"])
                    this.errorMessages!.push(item);
            }
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result!.push(FacilityResourceListViewDetailDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): APIResponseOfListOfFacilityResourceListViewDetailDTO {
        data = typeof data === 'object' ? data : {};
        let result = new APIResponseOfListOfFacilityResourceListViewDetailDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["isSuccess"] = this.isSuccess;
        if (Array.isArray(this.errorMessages)) {
            data["errorMessages"] = [];
            for (let item of this.errorMessages)
                data["errorMessages"].push(item);
        }
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IAPIResponseOfListOfFacilityResourceListViewDetailDTO {
    statusCode?: HttpStatusCode;
    isSuccess?: boolean;
    errorMessages?: string[];
    result?: FacilityResourceListViewDetailDTO[] | undefined;
}

export class FacilityResourceListViewDetailDTO implements IFacilityResourceListViewDetailDTO {
    facilityName?: string | undefined;
    coid?: number | undefined;
    resourceMnemonic?: string | undefined;
    resourceName?: string | undefined;
    siteLocation?: string | undefined;
    siteAddress?: string | undefined;
    status?: boolean;
    lastModifiedBy?: string | undefined;
    lastModifiedDate?: Date | undefined;
    totalRows?: number;

    constructor(data?: IFacilityResourceListViewDetailDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.facilityName = _data["facilityName"];
            this.coid = _data["coid"];
            this.resourceMnemonic = _data["resourceMnemonic"];
            this.resourceName = _data["resourceName"];
            this.siteLocation = _data["siteLocation"];
            this.siteAddress = _data["siteAddress"];
            this.status = _data["status"];
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined as any;
            this.totalRows = _data["totalRows"];
        }
    }

    static fromJS(data: any): FacilityResourceListViewDetailDTO {
        data = typeof data === 'object' ? data : {};
        let result = new FacilityResourceListViewDetailDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["facilityName"] = this.facilityName;
        data["coid"] = this.coid;
        data["resourceMnemonic"] = this.resourceMnemonic;
        data["resourceName"] = this.resourceName;
        data["siteLocation"] = this.siteLocation;
        data["siteAddress"] = this.siteAddress;
        data["status"] = this.status;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined as any;
        data["totalRows"] = this.totalRows;
        return data;
    }
}

export interface IFacilityResourceListViewDetailDTO {
    facilityName?: string | undefined;
    coid?: number | undefined;
    resourceMnemonic?: string | undefined;
    resourceName?: string | undefined;
    siteLocation?: string | undefined;
    siteAddress?: string | undefined;
    status?: boolean;
    lastModifiedBy?: string | undefined;
    lastModifiedDate?: Date | undefined;
    totalRows?: number;
}

export class FacilityResourceListViewRequest implements IFacilityResourceListViewRequest {
    resourceMnemonics?: string | undefined;
    facilityIds?: string;
    siteLocations?: string | undefined;
    status?: string | undefined;
    facilityIdList?: string[];
    sortColumn?: string | undefined;
    sortDir?: string | undefined;
    page?: number;
    pageSize?: number;

    constructor(data?: IFacilityResourceListViewRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resourceMnemonics = _data["resourceMnemonics"];
            this.facilityIds = _data["facilityIds"];
            this.siteLocations = _data["siteLocations"];
            this.status = _data["status"];
            if (Array.isArray(_data["facilityIdList"])) {
                this.facilityIdList = [] as any;
                for (let item of _data["facilityIdList"])
                    this.facilityIdList!.push(item);
            }
            this.sortColumn = _data["sortColumn"];
            this.sortDir = _data["sortDir"];
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
        }
    }

    static fromJS(data: any): FacilityResourceListViewRequest {
        data = typeof data === 'object' ? data : {};
        let result = new FacilityResourceListViewRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resourceMnemonics"] = this.resourceMnemonics;
        data["facilityIds"] = this.facilityIds;
        data["siteLocations"] = this.siteLocations;
        data["status"] = this.status;
        if (Array.isArray(this.facilityIdList)) {
            data["facilityIdList"] = [];
            for (let item of this.facilityIdList)
                data["facilityIdList"].push(item);
        }
        data["sortColumn"] = this.sortColumn;
        data["sortDir"] = this.sortDir;
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        return data;
    }
}

export interface IFacilityResourceListViewRequest {
    resourceMnemonics?: string | undefined;
    facilityIds?: string;
    siteLocations?: string | undefined;
    status?: string | undefined;
    facilityIdList?: string[];
    sortColumn?: string | undefined;
    sortDir?: string | undefined;
    page?: number;
    pageSize?: number;
}

export class APIResponseOfAddOrUpdateFacilityResourceResponseDTO implements IAPIResponseOfAddOrUpdateFacilityResourceResponseDTO {
    statusCode?: HttpStatusCode;
    isSuccess?: boolean;
    errorMessages?: string[];
    result?: AddOrUpdateFacilityResourceResponseDTO | undefined;

    constructor(data?: IAPIResponseOfAddOrUpdateFacilityResourceResponseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusCode = _data["statusCode"];
            this.isSuccess = _data["isSuccess"];
            if (Array.isArray(_data["errorMessages"])) {
                this.errorMessages = [] as any;
                for (let item of _data["errorMessages"])
                    this.errorMessages!.push(item);
            }
            this.result = _data["result"] ? AddOrUpdateFacilityResourceResponseDTO.fromJS(_data["result"]) : undefined as any;
        }
    }

    static fromJS(data: any): APIResponseOfAddOrUpdateFacilityResourceResponseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new APIResponseOfAddOrUpdateFacilityResourceResponseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["isSuccess"] = this.isSuccess;
        if (Array.isArray(this.errorMessages)) {
            data["errorMessages"] = [];
            for (let item of this.errorMessages)
                data["errorMessages"].push(item);
        }
        data["result"] = this.result ? this.result.toJSON() : undefined as any;
        return data;
    }
}

export interface IAPIResponseOfAddOrUpdateFacilityResourceResponseDTO {
    statusCode?: HttpStatusCode;
    isSuccess?: boolean;
    errorMessages?: string[];
    result?: AddOrUpdateFacilityResourceResponseDTO | undefined;
}

export class AddOrUpdateFacilityResourceResponseDTO implements IAddOrUpdateFacilityResourceResponseDTO {
    responseMessage?: string | undefined;
    status?: number;

    constructor(data?: IAddOrUpdateFacilityResourceResponseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseMessage = _data["responseMessage"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): AddOrUpdateFacilityResourceResponseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AddOrUpdateFacilityResourceResponseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseMessage"] = this.responseMessage;
        data["status"] = this.status;
        return data;
    }
}

export interface IAddOrUpdateFacilityResourceResponseDTO {
    responseMessage?: string | undefined;
    status?: number;
}

export class AddOrUpdateFacilityResourceRequest implements IAddOrUpdateFacilityResourceRequest {
    facilityId?: number;
    resourceMnemonic?: string | undefined;
    resourceName?: string | undefined;
    siteLocation?: string | undefined;
    siteAddress?: string | undefined;
    status?: boolean;
    isEditMode?: boolean;

    constructor(data?: IAddOrUpdateFacilityResourceRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.facilityId = _data["facilityId"];
            this.resourceMnemonic = _data["resourceMnemonic"];
            this.resourceName = _data["resourceName"];
            this.siteLocation = _data["siteLocation"];
            this.siteAddress = _data["siteAddress"];
            this.status = _data["status"];
            this.isEditMode = _data["isEditMode"];
        }
    }

    static fromJS(data: any): AddOrUpdateFacilityResourceRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AddOrUpdateFacilityResourceRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["facilityId"] = this.facilityId;
        data["resourceMnemonic"] = this.resourceMnemonic;
        data["resourceName"] = this.resourceName;
        data["siteLocation"] = this.siteLocation;
        data["siteAddress"] = this.siteAddress;
        data["status"] = this.status;
        data["isEditMode"] = this.isEditMode;
        return data;
    }
}

export interface IAddOrUpdateFacilityResourceRequest {
    facilityId?: number;
    resourceMnemonic?: string | undefined;
    resourceName?: string | undefined;
    siteLocation?: string | undefined;
    siteAddress?: string | undefined;
    status?: boolean;
    isEditMode?: boolean;
}

export class BulkUpdateFacilityResourceRequest implements IBulkUpdateFacilityResourceRequest {
    coid_Mnemonic?: string[] | undefined;
    siteLocation?: string | undefined;
    siteAddress?: string | undefined;
    isUpdateSiteLocation?: boolean;
    isUpdateSiteAddress?: boolean;
    status?: boolean;

    constructor(data?: IBulkUpdateFacilityResourceRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["coid_Mnemonic"])) {
                this.coid_Mnemonic = [] as any;
                for (let item of _data["coid_Mnemonic"])
                    this.coid_Mnemonic!.push(item);
            }
            this.siteLocation = _data["siteLocation"];
            this.siteAddress = _data["siteAddress"];
            this.isUpdateSiteLocation = _data["isUpdateSiteLocation"];
            this.isUpdateSiteAddress = _data["isUpdateSiteAddress"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): BulkUpdateFacilityResourceRequest {
        data = typeof data === 'object' ? data : {};
        let result = new BulkUpdateFacilityResourceRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.coid_Mnemonic)) {
            data["coid_Mnemonic"] = [];
            for (let item of this.coid_Mnemonic)
                data["coid_Mnemonic"].push(item);
        }
        data["siteLocation"] = this.siteLocation;
        data["siteAddress"] = this.siteAddress;
        data["isUpdateSiteLocation"] = this.isUpdateSiteLocation;
        data["isUpdateSiteAddress"] = this.isUpdateSiteAddress;
        data["status"] = this.status;
        return data;
    }
}

export interface IBulkUpdateFacilityResourceRequest {
    coid_Mnemonic?: string[] | undefined;
    siteLocation?: string | undefined;
    siteAddress?: string | undefined;
    isUpdateSiteLocation?: boolean;
    isUpdateSiteAddress?: boolean;
    status?: boolean;
}

export class APIResponseOfFacilityAppointmentExclusionFiltersDTO implements IAPIResponseOfFacilityAppointmentExclusionFiltersDTO {
    statusCode?: HttpStatusCode;
    isSuccess?: boolean;
    errorMessages?: string[];
    result?: FacilityAppointmentExclusionFiltersDTO | undefined;

    constructor(data?: IAPIResponseOfFacilityAppointmentExclusionFiltersDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusCode = _data["statusCode"];
            this.isSuccess = _data["isSuccess"];
            if (Array.isArray(_data["errorMessages"])) {
                this.errorMessages = [] as any;
                for (let item of _data["errorMessages"])
                    this.errorMessages!.push(item);
            }
            this.result = _data["result"] ? FacilityAppointmentExclusionFiltersDTO.fromJS(_data["result"]) : undefined as any;
        }
    }

    static fromJS(data: any): APIResponseOfFacilityAppointmentExclusionFiltersDTO {
        data = typeof data === 'object' ? data : {};
        let result = new APIResponseOfFacilityAppointmentExclusionFiltersDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["isSuccess"] = this.isSuccess;
        if (Array.isArray(this.errorMessages)) {
            data["errorMessages"] = [];
            for (let item of this.errorMessages)
                data["errorMessages"].push(item);
        }
        data["result"] = this.result ? this.result.toJSON() : undefined as any;
        return data;
    }
}

export interface IAPIResponseOfFacilityAppointmentExclusionFiltersDTO {
    statusCode?: HttpStatusCode;
    isSuccess?: boolean;
    errorMessages?: string[];
    result?: FacilityAppointmentExclusionFiltersDTO | undefined;
}

export class FacilityAppointmentExclusionFiltersDTO implements IFacilityAppointmentExclusionFiltersDTO {
    facilities?: DropDownItem[];
    appointmentTypes?: DropDownItem[];
    appointmentLocations?: DropDownItem[];
    workflowSteps?: DropDownItem[];
    allFacilities?: DropDownItem[];

    constructor(data?: IFacilityAppointmentExclusionFiltersDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["facilities"])) {
                this.facilities = [] as any;
                for (let item of _data["facilities"])
                    this.facilities!.push(DropDownItem.fromJS(item));
            }
            if (Array.isArray(_data["appointmentTypes"])) {
                this.appointmentTypes = [] as any;
                for (let item of _data["appointmentTypes"])
                    this.appointmentTypes!.push(DropDownItem.fromJS(item));
            }
            if (Array.isArray(_data["appointmentLocations"])) {
                this.appointmentLocations = [] as any;
                for (let item of _data["appointmentLocations"])
                    this.appointmentLocations!.push(DropDownItem.fromJS(item));
            }
            if (Array.isArray(_data["workflowSteps"])) {
                this.workflowSteps = [] as any;
                for (let item of _data["workflowSteps"])
                    this.workflowSteps!.push(DropDownItem.fromJS(item));
            }
            if (Array.isArray(_data["allFacilities"])) {
                this.allFacilities = [] as any;
                for (let item of _data["allFacilities"])
                    this.allFacilities!.push(DropDownItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FacilityAppointmentExclusionFiltersDTO {
        data = typeof data === 'object' ? data : {};
        let result = new FacilityAppointmentExclusionFiltersDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.facilities)) {
            data["facilities"] = [];
            for (let item of this.facilities)
                data["facilities"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.appointmentTypes)) {
            data["appointmentTypes"] = [];
            for (let item of this.appointmentTypes)
                data["appointmentTypes"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.appointmentLocations)) {
            data["appointmentLocations"] = [];
            for (let item of this.appointmentLocations)
                data["appointmentLocations"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.workflowSteps)) {
            data["workflowSteps"] = [];
            for (let item of this.workflowSteps)
                data["workflowSteps"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.allFacilities)) {
            data["allFacilities"] = [];
            for (let item of this.allFacilities)
                data["allFacilities"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IFacilityAppointmentExclusionFiltersDTO {
    facilities?: DropDownItem[];
    appointmentTypes?: DropDownItem[];
    appointmentLocations?: DropDownItem[];
    workflowSteps?: DropDownItem[];
    allFacilities?: DropDownItem[];
}

export class FacilityAppointmentExclusionFilterRequest implements IFacilityAppointmentExclusionFilterRequest {
    facilityId?: number | undefined;
    exclusionType?: string | undefined;

    constructor(data?: IFacilityAppointmentExclusionFilterRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.facilityId = _data["facilityId"];
            this.exclusionType = _data["exclusionType"];
        }
    }

    static fromJS(data: any): FacilityAppointmentExclusionFilterRequest {
        data = typeof data === 'object' ? data : {};
        let result = new FacilityAppointmentExclusionFilterRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["facilityId"] = this.facilityId;
        data["exclusionType"] = this.exclusionType;
        return data;
    }
}

export interface IFacilityAppointmentExclusionFilterRequest {
    facilityId?: number | undefined;
    exclusionType?: string | undefined;
}

export class APIResponseOfListOfFacilityAppointmentExclusionListViewDTO implements IAPIResponseOfListOfFacilityAppointmentExclusionListViewDTO {
    statusCode?: HttpStatusCode;
    isSuccess?: boolean;
    errorMessages?: string[];
    result?: FacilityAppointmentExclusionListViewDTO[] | undefined;

    constructor(data?: IAPIResponseOfListOfFacilityAppointmentExclusionListViewDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusCode = _data["statusCode"];
            this.isSuccess = _data["isSuccess"];
            if (Array.isArray(_data["errorMessages"])) {
                this.errorMessages = [] as any;
                for (let item of _data["errorMessages"])
                    this.errorMessages!.push(item);
            }
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result!.push(FacilityAppointmentExclusionListViewDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): APIResponseOfListOfFacilityAppointmentExclusionListViewDTO {
        data = typeof data === 'object' ? data : {};
        let result = new APIResponseOfListOfFacilityAppointmentExclusionListViewDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["isSuccess"] = this.isSuccess;
        if (Array.isArray(this.errorMessages)) {
            data["errorMessages"] = [];
            for (let item of this.errorMessages)
                data["errorMessages"].push(item);
        }
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IAPIResponseOfListOfFacilityAppointmentExclusionListViewDTO {
    statusCode?: HttpStatusCode;
    isSuccess?: boolean;
    errorMessages?: string[];
    result?: FacilityAppointmentExclusionListViewDTO[] | undefined;
}

export class FacilityAppointmentExclusionListViewDTO implements IFacilityAppointmentExclusionListViewDTO {
    appFacilityId?: number | undefined;
    facilityName?: string | undefined;
    coid?: number | undefined;
    appointmentType?: string | undefined;
    appointmentLocation?: string | undefined;
    workflowStep?: string | undefined;
    status?: boolean;
    lastModifiedBy?: string | undefined;
    lastModifiedDate?: Date | undefined;
    totalRows?: number;

    constructor(data?: IFacilityAppointmentExclusionListViewDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.appFacilityId = _data["appFacilityId"];
            this.facilityName = _data["facilityName"];
            this.coid = _data["coid"];
            this.appointmentType = _data["appointmentType"];
            this.appointmentLocation = _data["appointmentLocation"];
            this.workflowStep = _data["workflowStep"];
            this.status = _data["status"];
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined as any;
            this.totalRows = _data["totalRows"];
        }
    }

    static fromJS(data: any): FacilityAppointmentExclusionListViewDTO {
        data = typeof data === 'object' ? data : {};
        let result = new FacilityAppointmentExclusionListViewDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["appFacilityId"] = this.appFacilityId;
        data["facilityName"] = this.facilityName;
        data["coid"] = this.coid;
        data["appointmentType"] = this.appointmentType;
        data["appointmentLocation"] = this.appointmentLocation;
        data["workflowStep"] = this.workflowStep;
        data["status"] = this.status;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined as any;
        data["totalRows"] = this.totalRows;
        return data;
    }
}

export interface IFacilityAppointmentExclusionListViewDTO {
    appFacilityId?: number | undefined;
    facilityName?: string | undefined;
    coid?: number | undefined;
    appointmentType?: string | undefined;
    appointmentLocation?: string | undefined;
    workflowStep?: string | undefined;
    status?: boolean;
    lastModifiedBy?: string | undefined;
    lastModifiedDate?: Date | undefined;
    totalRows?: number;
}

export class FacilityAppointmentExclusionListViewRequest implements IFacilityAppointmentExclusionListViewRequest {
    exclusionType?: string | undefined;
    facilityIds?: string | undefined;
    facilityIdList?: string[] | undefined;
    appointmentTypes?: string | undefined;
    appointmentLocations?: string | undefined;
    workflowSteps?: string | undefined;
    status?: string | undefined;
    sortColumn?: string | undefined;
    sortDir?: string | undefined;
    page?: number;
    pageSize?: number;

    constructor(data?: IFacilityAppointmentExclusionListViewRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.exclusionType = _data["exclusionType"];
            this.facilityIds = _data["facilityIds"];
            if (Array.isArray(_data["facilityIdList"])) {
                this.facilityIdList = [] as any;
                for (let item of _data["facilityIdList"])
                    this.facilityIdList!.push(item);
            }
            this.appointmentTypes = _data["appointmentTypes"];
            this.appointmentLocations = _data["appointmentLocations"];
            this.workflowSteps = _data["workflowSteps"];
            this.status = _data["status"];
            this.sortColumn = _data["sortColumn"];
            this.sortDir = _data["sortDir"];
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
        }
    }

    static fromJS(data: any): FacilityAppointmentExclusionListViewRequest {
        data = typeof data === 'object' ? data : {};
        let result = new FacilityAppointmentExclusionListViewRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["exclusionType"] = this.exclusionType;
        data["facilityIds"] = this.facilityIds;
        if (Array.isArray(this.facilityIdList)) {
            data["facilityIdList"] = [];
            for (let item of this.facilityIdList)
                data["facilityIdList"].push(item);
        }
        data["appointmentTypes"] = this.appointmentTypes;
        data["appointmentLocations"] = this.appointmentLocations;
        data["workflowSteps"] = this.workflowSteps;
        data["status"] = this.status;
        data["sortColumn"] = this.sortColumn;
        data["sortDir"] = this.sortDir;
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        return data;
    }
}

export interface IFacilityAppointmentExclusionListViewRequest {
    exclusionType?: string | undefined;
    facilityIds?: string | undefined;
    facilityIdList?: string[] | undefined;
    appointmentTypes?: string | undefined;
    appointmentLocations?: string | undefined;
    workflowSteps?: string | undefined;
    status?: string | undefined;
    sortColumn?: string | undefined;
    sortDir?: string | undefined;
    page?: number;
    pageSize?: number;
}

export class APIResponseOfResultData implements IAPIResponseOfResultData {
    statusCode?: HttpStatusCode;
    isSuccess?: boolean;
    errorMessages?: string[];
    result?: ResultData | undefined;

    constructor(data?: IAPIResponseOfResultData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusCode = _data["statusCode"];
            this.isSuccess = _data["isSuccess"];
            if (Array.isArray(_data["errorMessages"])) {
                this.errorMessages = [] as any;
                for (let item of _data["errorMessages"])
                    this.errorMessages!.push(item);
            }
            this.result = _data["result"] ? ResultData.fromJS(_data["result"]) : undefined as any;
        }
    }

    static fromJS(data: any): APIResponseOfResultData {
        data = typeof data === 'object' ? data : {};
        let result = new APIResponseOfResultData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["isSuccess"] = this.isSuccess;
        if (Array.isArray(this.errorMessages)) {
            data["errorMessages"] = [];
            for (let item of this.errorMessages)
                data["errorMessages"].push(item);
        }
        data["result"] = this.result ? this.result.toJSON() : undefined as any;
        return data;
    }
}

export interface IAPIResponseOfResultData {
    statusCode?: HttpStatusCode;
    isSuccess?: boolean;
    errorMessages?: string[];
    result?: ResultData | undefined;
}

export class ResultData implements IResultData {
    returnValue?: number;
    message?: string;

    constructor(data?: IResultData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.returnValue = _data["returnValue"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): ResultData {
        data = typeof data === 'object' ? data : {};
        let result = new ResultData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["returnValue"] = this.returnValue;
        data["message"] = this.message;
        return data;
    }
}

export interface IResultData {
    returnValue?: number;
    message?: string;
}

export class AddOrUpdateFacilityAppointmentExclusionRequest implements IAddOrUpdateFacilityAppointmentExclusionRequest {
    appfacilityId?: number;
    exclusionType?: string;
    appointmentTypes?: string | undefined;
    appointmentLocations?: string | undefined;
    workflowsteps?: string | undefined;
    status?: boolean;

    constructor(data?: IAddOrUpdateFacilityAppointmentExclusionRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.appfacilityId = _data["appfacilityId"];
            this.exclusionType = _data["exclusionType"];
            this.appointmentTypes = _data["appointmentTypes"];
            this.appointmentLocations = _data["appointmentLocations"];
            this.workflowsteps = _data["workflowsteps"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): AddOrUpdateFacilityAppointmentExclusionRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AddOrUpdateFacilityAppointmentExclusionRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["appfacilityId"] = this.appfacilityId;
        data["exclusionType"] = this.exclusionType;
        data["appointmentTypes"] = this.appointmentTypes;
        data["appointmentLocations"] = this.appointmentLocations;
        data["workflowsteps"] = this.workflowsteps;
        data["status"] = this.status;
        return data;
    }
}

export interface IAddOrUpdateFacilityAppointmentExclusionRequest {
    appfacilityId?: number;
    exclusionType?: string;
    appointmentTypes?: string | undefined;
    appointmentLocations?: string | undefined;
    workflowsteps?: string | undefined;
    status?: boolean;
}

export class APIResponseOfUpdateResponse implements IAPIResponseOfUpdateResponse {
    statusCode?: HttpStatusCode;
    isSuccess?: boolean;
    errorMessages?: string[];
    result?: UpdateResponse | undefined;

    constructor(data?: IAPIResponseOfUpdateResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusCode = _data["statusCode"];
            this.isSuccess = _data["isSuccess"];
            if (Array.isArray(_data["errorMessages"])) {
                this.errorMessages = [] as any;
                for (let item of _data["errorMessages"])
                    this.errorMessages!.push(item);
            }
            this.result = _data["result"] ? UpdateResponse.fromJS(_data["result"]) : undefined as any;
        }
    }

    static fromJS(data: any): APIResponseOfUpdateResponse {
        data = typeof data === 'object' ? data : {};
        let result = new APIResponseOfUpdateResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["isSuccess"] = this.isSuccess;
        if (Array.isArray(this.errorMessages)) {
            data["errorMessages"] = [];
            for (let item of this.errorMessages)
                data["errorMessages"].push(item);
        }
        data["result"] = this.result ? this.result.toJSON() : undefined as any;
        return data;
    }
}

export interface IAPIResponseOfUpdateResponse {
    statusCode?: HttpStatusCode;
    isSuccess?: boolean;
    errorMessages?: string[];
    result?: UpdateResponse | undefined;
}

export class UpdateResponse implements IUpdateResponse {
    responseText?: number;

    constructor(data?: IUpdateResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseText = _data["responseText"];
        }
    }

    static fromJS(data: any): UpdateResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseText"] = this.responseText;
        return data;
    }
}

export interface IUpdateResponse {
    responseText?: number;
}

export class AddOrUpdateOutageCampaignRequest implements IAddOrUpdateOutageCampaignRequest {
    campaignName?: string;
    workflowstepId?: number;
    commType?: string;
    startDate?: Date;
    endDate?: Date;
    campaignType?: string | undefined;
    outages?: Outage[];

    constructor(data?: IAddOrUpdateOutageCampaignRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.campaignName = _data["campaignName"];
            this.workflowstepId = _data["workflowstepId"];
            this.commType = _data["commType"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : undefined as any;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : undefined as any;
            this.campaignType = _data["campaignType"];
            if (Array.isArray(_data["outages"])) {
                this.outages = [] as any;
                for (let item of _data["outages"])
                    this.outages!.push(Outage.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AddOrUpdateOutageCampaignRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AddOrUpdateOutageCampaignRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["campaignName"] = this.campaignName;
        data["workflowstepId"] = this.workflowstepId;
        data["commType"] = this.commType;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : undefined as any;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : undefined as any;
        data["campaignType"] = this.campaignType;
        if (Array.isArray(this.outages)) {
            data["outages"] = [];
            for (let item of this.outages)
                data["outages"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IAddOrUpdateOutageCampaignRequest {
    campaignName?: string;
    workflowstepId?: number;
    commType?: string;
    startDate?: Date;
    endDate?: Date;
    campaignType?: string | undefined;
    outages?: Outage[];
}

export class Outage implements IOutage {
    appFacilityId?: number;
    appointmentType?: string | undefined;
    appointmentLocation?: string | undefined;
    appointmentResource?: string | undefined;
    accountLocation?: string | undefined;
    campaignClosureId?: number | undefined;
    active?: boolean;

    constructor(data?: IOutage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.appFacilityId = _data["appFacilityId"];
            this.appointmentType = _data["appointmentType"];
            this.appointmentLocation = _data["appointmentLocation"];
            this.appointmentResource = _data["appointmentResource"];
            this.accountLocation = _data["accountLocation"];
            this.campaignClosureId = _data["campaignClosureId"];
            this.active = _data["active"];
        }
    }

    static fromJS(data: any): Outage {
        data = typeof data === 'object' ? data : {};
        let result = new Outage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["appFacilityId"] = this.appFacilityId;
        data["appointmentType"] = this.appointmentType;
        data["appointmentLocation"] = this.appointmentLocation;
        data["appointmentResource"] = this.appointmentResource;
        data["accountLocation"] = this.accountLocation;
        data["campaignClosureId"] = this.campaignClosureId;
        data["active"] = this.active;
        return data;
    }
}

export interface IOutage {
    appFacilityId?: number;
    appointmentType?: string | undefined;
    appointmentLocation?: string | undefined;
    appointmentResource?: string | undefined;
    accountLocation?: string | undefined;
    campaignClosureId?: number | undefined;
    active?: boolean;
}

export class APIResponseOfAddOrUpdateOutageCampaignRequest implements IAPIResponseOfAddOrUpdateOutageCampaignRequest {
    statusCode?: HttpStatusCode;
    isSuccess?: boolean;
    errorMessages?: string[];
    result?: AddOrUpdateOutageCampaignRequest | undefined;

    constructor(data?: IAPIResponseOfAddOrUpdateOutageCampaignRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusCode = _data["statusCode"];
            this.isSuccess = _data["isSuccess"];
            if (Array.isArray(_data["errorMessages"])) {
                this.errorMessages = [] as any;
                for (let item of _data["errorMessages"])
                    this.errorMessages!.push(item);
            }
            this.result = _data["result"] ? AddOrUpdateOutageCampaignRequest.fromJS(_data["result"]) : undefined as any;
        }
    }

    static fromJS(data: any): APIResponseOfAddOrUpdateOutageCampaignRequest {
        data = typeof data === 'object' ? data : {};
        let result = new APIResponseOfAddOrUpdateOutageCampaignRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["isSuccess"] = this.isSuccess;
        if (Array.isArray(this.errorMessages)) {
            data["errorMessages"] = [];
            for (let item of this.errorMessages)
                data["errorMessages"].push(item);
        }
        data["result"] = this.result ? this.result.toJSON() : undefined as any;
        return data;
    }
}

export interface IAPIResponseOfAddOrUpdateOutageCampaignRequest {
    statusCode?: HttpStatusCode;
    isSuccess?: boolean;
    errorMessages?: string[];
    result?: AddOrUpdateOutageCampaignRequest | undefined;
}

export class GetOutageCampaignDetailsRequest implements IGetOutageCampaignDetailsRequest {
    campaignName?: string;
    facilityIds?: string;
    facilityIdList?: string[];

    constructor(data?: IGetOutageCampaignDetailsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.campaignName = _data["campaignName"];
            this.facilityIds = _data["facilityIds"];
            if (Array.isArray(_data["facilityIdList"])) {
                this.facilityIdList = [] as any;
                for (let item of _data["facilityIdList"])
                    this.facilityIdList!.push(item);
            }
        }
    }

    static fromJS(data: any): GetOutageCampaignDetailsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetOutageCampaignDetailsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["campaignName"] = this.campaignName;
        data["facilityIds"] = this.facilityIds;
        if (Array.isArray(this.facilityIdList)) {
            data["facilityIdList"] = [];
            for (let item of this.facilityIdList)
                data["facilityIdList"].push(item);
        }
        return data;
    }
}

export interface IGetOutageCampaignDetailsRequest {
    campaignName?: string;
    facilityIds?: string;
    facilityIdList?: string[];
}

export class APIResponseOfOutageCommunicationTypeResponse implements IAPIResponseOfOutageCommunicationTypeResponse {
    statusCode?: HttpStatusCode;
    isSuccess?: boolean;
    errorMessages?: string[];
    result?: OutageCommunicationTypeResponse | undefined;

    constructor(data?: IAPIResponseOfOutageCommunicationTypeResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusCode = _data["statusCode"];
            this.isSuccess = _data["isSuccess"];
            if (Array.isArray(_data["errorMessages"])) {
                this.errorMessages = [] as any;
                for (let item of _data["errorMessages"])
                    this.errorMessages!.push(item);
            }
            this.result = _data["result"] ? OutageCommunicationTypeResponse.fromJS(_data["result"]) : undefined as any;
        }
    }

    static fromJS(data: any): APIResponseOfOutageCommunicationTypeResponse {
        data = typeof data === 'object' ? data : {};
        let result = new APIResponseOfOutageCommunicationTypeResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["isSuccess"] = this.isSuccess;
        if (Array.isArray(this.errorMessages)) {
            data["errorMessages"] = [];
            for (let item of this.errorMessages)
                data["errorMessages"].push(item);
        }
        data["result"] = this.result ? this.result.toJSON() : undefined as any;
        return data;
    }
}

export interface IAPIResponseOfOutageCommunicationTypeResponse {
    statusCode?: HttpStatusCode;
    isSuccess?: boolean;
    errorMessages?: string[];
    result?: OutageCommunicationTypeResponse | undefined;
}

export class OutageCommunicationTypeResponse implements IOutageCommunicationTypeResponse {
    communicationTypes?: DropDownItem[];

    constructor(data?: IOutageCommunicationTypeResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["communicationTypes"])) {
                this.communicationTypes = [] as any;
                for (let item of _data["communicationTypes"])
                    this.communicationTypes!.push(DropDownItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): OutageCommunicationTypeResponse {
        data = typeof data === 'object' ? data : {};
        let result = new OutageCommunicationTypeResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.communicationTypes)) {
            data["communicationTypes"] = [];
            for (let item of this.communicationTypes)
                data["communicationTypes"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IOutageCommunicationTypeResponse {
    communicationTypes?: DropDownItem[];
}

export class APIResponseOfListOfOutageCampaignResponse implements IAPIResponseOfListOfOutageCampaignResponse {
    statusCode?: HttpStatusCode;
    isSuccess?: boolean;
    errorMessages?: string[];
    result?: OutageCampaignResponse[] | undefined;

    constructor(data?: IAPIResponseOfListOfOutageCampaignResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusCode = _data["statusCode"];
            this.isSuccess = _data["isSuccess"];
            if (Array.isArray(_data["errorMessages"])) {
                this.errorMessages = [] as any;
                for (let item of _data["errorMessages"])
                    this.errorMessages!.push(item);
            }
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result!.push(OutageCampaignResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): APIResponseOfListOfOutageCampaignResponse {
        data = typeof data === 'object' ? data : {};
        let result = new APIResponseOfListOfOutageCampaignResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["isSuccess"] = this.isSuccess;
        if (Array.isArray(this.errorMessages)) {
            data["errorMessages"] = [];
            for (let item of this.errorMessages)
                data["errorMessages"].push(item);
        }
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IAPIResponseOfListOfOutageCampaignResponse {
    statusCode?: HttpStatusCode;
    isSuccess?: boolean;
    errorMessages?: string[];
    result?: OutageCampaignResponse[] | undefined;
}

export class OutageCampaignResponse implements IOutageCampaignResponse {
    campaigns?: OutageCampaignList[] | undefined;

    constructor(data?: IOutageCampaignResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["campaigns"])) {
                this.campaigns = [] as any;
                for (let item of _data["campaigns"])
                    this.campaigns!.push(OutageCampaignList.fromJS(item));
            }
        }
    }

    static fromJS(data: any): OutageCampaignResponse {
        data = typeof data === 'object' ? data : {};
        let result = new OutageCampaignResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.campaigns)) {
            data["campaigns"] = [];
            for (let item of this.campaigns)
                data["campaigns"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IOutageCampaignResponse {
    campaigns?: OutageCampaignList[] | undefined;
}

export class OutageCampaignListBase implements IOutageCampaignListBase {
    type?: string | undefined;
    name?: string | undefined;

    constructor(data?: IOutageCampaignListBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): OutageCampaignListBase {
        data = typeof data === 'object' ? data : {};
        let result = new OutageCampaignListBase();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["name"] = this.name;
        return data;
    }
}

export interface IOutageCampaignListBase {
    type?: string | undefined;
    name?: string | undefined;
}

export class OutageCampaignList extends OutageCampaignListBase implements IOutageCampaignList {
    outages?: OutageCampaignFacility[] | undefined;
    rowsCount?: number | undefined;
    communicationType?: string | undefined;
    contactListType?: string | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    lastModified?: Date | undefined;
    modifiedBy?: string | undefined;
    qualifiedCount?: number | undefined;
    publishedCount?: number | undefined;
    havePending?: boolean | undefined;

    constructor(data?: IOutageCampaignList) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["outages"])) {
                this.outages = [] as any;
                for (let item of _data["outages"])
                    this.outages!.push(OutageCampaignFacility.fromJS(item));
            }
            this.rowsCount = _data["rowsCount"];
            this.communicationType = _data["communicationType"];
            this.contactListType = _data["contactListType"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : undefined as any;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : undefined as any;
            this.lastModified = _data["lastModified"] ? new Date(_data["lastModified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            this.qualifiedCount = _data["qualifiedCount"];
            this.publishedCount = _data["publishedCount"];
            this.havePending = _data["havePending"];
        }
    }

    static override fromJS(data: any): OutageCampaignList {
        data = typeof data === 'object' ? data : {};
        let result = new OutageCampaignList();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.outages)) {
            data["outages"] = [];
            for (let item of this.outages)
                data["outages"].push(item ? item.toJSON() : undefined as any);
        }
        data["rowsCount"] = this.rowsCount;
        data["communicationType"] = this.communicationType;
        data["contactListType"] = this.contactListType;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : undefined as any;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : undefined as any;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        data["qualifiedCount"] = this.qualifiedCount;
        data["publishedCount"] = this.publishedCount;
        data["havePending"] = this.havePending;
        super.toJSON(data);
        return data;
    }
}

export interface IOutageCampaignList extends IOutageCampaignListBase {
    outages?: OutageCampaignFacility[] | undefined;
    rowsCount?: number | undefined;
    communicationType?: string | undefined;
    contactListType?: string | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    lastModified?: Date | undefined;
    modifiedBy?: string | undefined;
    qualifiedCount?: number | undefined;
    publishedCount?: number | undefined;
    havePending?: boolean | undefined;
}

export class OutageCampaignFacility extends OutageCampaignListBase implements IOutageCampaignFacility {
    apptType?: string | undefined;
    apptLocation?: string | undefined;
    apptResource?: string | undefined;
    acctLocation?: string | undefined;
    appFacilityId?: number;
    coid?: number;
    campaignName?: string | undefined;

    constructor(data?: IOutageCampaignFacility) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.apptType = _data["apptType"];
            this.apptLocation = _data["apptLocation"];
            this.apptResource = _data["apptResource"];
            this.acctLocation = _data["acctLocation"];
            this.appFacilityId = _data["appFacilityId"];
            this.coid = _data["coid"];
            this.campaignName = _data["campaignName"];
        }
    }

    static override fromJS(data: any): OutageCampaignFacility {
        data = typeof data === 'object' ? data : {};
        let result = new OutageCampaignFacility();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["apptType"] = this.apptType;
        data["apptLocation"] = this.apptLocation;
        data["apptResource"] = this.apptResource;
        data["acctLocation"] = this.acctLocation;
        data["appFacilityId"] = this.appFacilityId;
        data["coid"] = this.coid;
        data["campaignName"] = this.campaignName;
        super.toJSON(data);
        return data;
    }
}

export interface IOutageCampaignFacility extends IOutageCampaignListBase {
    apptType?: string | undefined;
    apptLocation?: string | undefined;
    apptResource?: string | undefined;
    acctLocation?: string | undefined;
    appFacilityId?: number;
    coid?: number;
    campaignName?: string | undefined;
}

export class OutageCampaignListViewRequest implements IOutageCampaignListViewRequest {
    pageCount?: number;
    pageNumber?: number;

    constructor(data?: IOutageCampaignListViewRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageCount = _data["pageCount"];
            this.pageNumber = _data["pageNumber"];
        }
    }

    static fromJS(data: any): OutageCampaignListViewRequest {
        data = typeof data === 'object' ? data : {};
        let result = new OutageCampaignListViewRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageCount"] = this.pageCount;
        data["pageNumber"] = this.pageNumber;
        return data;
    }
}

export interface IOutageCampaignListViewRequest {
    pageCount?: number;
    pageNumber?: number;
}

export class CCaaSOutagecampaignRequest implements ICCaaSOutagecampaignRequest {
    campaignType?: string;
    workFlowName?: string | undefined;
    communicationType?: string | undefined;
    ccaasContactlistName?: string | undefined;
    cCaasContactlistId?: string | undefined;
    campaignName?: string;

    constructor(data?: ICCaaSOutagecampaignRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.campaignType = _data["campaignType"];
            this.workFlowName = _data["workFlowName"];
            this.communicationType = _data["communicationType"];
            this.ccaasContactlistName = _data["ccaasContactlistName"];
            this.cCaasContactlistId = _data["cCaasContactlistId"];
            this.campaignName = _data["campaignName"];
        }
    }

    static fromJS(data: any): CCaaSOutagecampaignRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CCaaSOutagecampaignRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["campaignType"] = this.campaignType;
        data["workFlowName"] = this.workFlowName;
        data["communicationType"] = this.communicationType;
        data["ccaasContactlistName"] = this.ccaasContactlistName;
        data["cCaasContactlistId"] = this.cCaasContactlistId;
        data["campaignName"] = this.campaignName;
        return data;
    }
}

export interface ICCaaSOutagecampaignRequest {
    campaignType?: string;
    workFlowName?: string | undefined;
    communicationType?: string | undefined;
    ccaasContactlistName?: string | undefined;
    cCaasContactlistId?: string | undefined;
    campaignName?: string;
}

export class APIResponseOfValidateCampaignNameResponse implements IAPIResponseOfValidateCampaignNameResponse {
    statusCode?: HttpStatusCode;
    isSuccess?: boolean;
    errorMessages?: string[];
    result?: ValidateCampaignNameResponse | undefined;

    constructor(data?: IAPIResponseOfValidateCampaignNameResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusCode = _data["statusCode"];
            this.isSuccess = _data["isSuccess"];
            if (Array.isArray(_data["errorMessages"])) {
                this.errorMessages = [] as any;
                for (let item of _data["errorMessages"])
                    this.errorMessages!.push(item);
            }
            this.result = _data["result"] ? ValidateCampaignNameResponse.fromJS(_data["result"]) : undefined as any;
        }
    }

    static fromJS(data: any): APIResponseOfValidateCampaignNameResponse {
        data = typeof data === 'object' ? data : {};
        let result = new APIResponseOfValidateCampaignNameResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["isSuccess"] = this.isSuccess;
        if (Array.isArray(this.errorMessages)) {
            data["errorMessages"] = [];
            for (let item of this.errorMessages)
                data["errorMessages"].push(item);
        }
        data["result"] = this.result ? this.result.toJSON() : undefined as any;
        return data;
    }
}

export interface IAPIResponseOfValidateCampaignNameResponse {
    statusCode?: HttpStatusCode;
    isSuccess?: boolean;
    errorMessages?: string[];
    result?: ValidateCampaignNameResponse | undefined;
}

export class ValidateCampaignNameResponse implements IValidateCampaignNameResponse {
    isGoodCampaignName?: boolean;

    constructor(data?: IValidateCampaignNameResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isGoodCampaignName = _data["isGoodCampaignName"];
        }
    }

    static fromJS(data: any): ValidateCampaignNameResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ValidateCampaignNameResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isGoodCampaignName"] = this.isGoodCampaignName;
        return data;
    }
}

export interface IValidateCampaignNameResponse {
    isGoodCampaignName?: boolean;
}

export class ValidateCampaignNameRequest implements IValidateCampaignNameRequest {
    campaignName?: string | undefined;

    constructor(data?: IValidateCampaignNameRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.campaignName = _data["campaignName"];
        }
    }

    static fromJS(data: any): ValidateCampaignNameRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ValidateCampaignNameRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["campaignName"] = this.campaignName;
        return data;
    }
}

export interface IValidateCampaignNameRequest {
    campaignName?: string | undefined;
}

export class APIResponseOfFacilityOutageCampaignFiltersDTO implements IAPIResponseOfFacilityOutageCampaignFiltersDTO {
    statusCode?: HttpStatusCode;
    isSuccess?: boolean;
    errorMessages?: string[];
    result?: FacilityOutageCampaignFiltersDTO | undefined;

    constructor(data?: IAPIResponseOfFacilityOutageCampaignFiltersDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusCode = _data["statusCode"];
            this.isSuccess = _data["isSuccess"];
            if (Array.isArray(_data["errorMessages"])) {
                this.errorMessages = [] as any;
                for (let item of _data["errorMessages"])
                    this.errorMessages!.push(item);
            }
            this.result = _data["result"] ? FacilityOutageCampaignFiltersDTO.fromJS(_data["result"]) : undefined as any;
        }
    }

    static fromJS(data: any): APIResponseOfFacilityOutageCampaignFiltersDTO {
        data = typeof data === 'object' ? data : {};
        let result = new APIResponseOfFacilityOutageCampaignFiltersDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["isSuccess"] = this.isSuccess;
        if (Array.isArray(this.errorMessages)) {
            data["errorMessages"] = [];
            for (let item of this.errorMessages)
                data["errorMessages"].push(item);
        }
        data["result"] = this.result ? this.result.toJSON() : undefined as any;
        return data;
    }
}

export interface IAPIResponseOfFacilityOutageCampaignFiltersDTO {
    statusCode?: HttpStatusCode;
    isSuccess?: boolean;
    errorMessages?: string[];
    result?: FacilityOutageCampaignFiltersDTO | undefined;
}

export class FacilityOutageCampaignFiltersDTO implements IFacilityOutageCampaignFiltersDTO {
    appointmentTypes?: DropDownItem[];
    appointmentLocations?: DropDownItem[];
    appointmentResources?: DropDownItem[];
    accountLocations?: DropDownItem[];

    constructor(data?: IFacilityOutageCampaignFiltersDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["appointmentTypes"])) {
                this.appointmentTypes = [] as any;
                for (let item of _data["appointmentTypes"])
                    this.appointmentTypes!.push(DropDownItem.fromJS(item));
            }
            if (Array.isArray(_data["appointmentLocations"])) {
                this.appointmentLocations = [] as any;
                for (let item of _data["appointmentLocations"])
                    this.appointmentLocations!.push(DropDownItem.fromJS(item));
            }
            if (Array.isArray(_data["appointmentResources"])) {
                this.appointmentResources = [] as any;
                for (let item of _data["appointmentResources"])
                    this.appointmentResources!.push(DropDownItem.fromJS(item));
            }
            if (Array.isArray(_data["accountLocations"])) {
                this.accountLocations = [] as any;
                for (let item of _data["accountLocations"])
                    this.accountLocations!.push(DropDownItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FacilityOutageCampaignFiltersDTO {
        data = typeof data === 'object' ? data : {};
        let result = new FacilityOutageCampaignFiltersDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.appointmentTypes)) {
            data["appointmentTypes"] = [];
            for (let item of this.appointmentTypes)
                data["appointmentTypes"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.appointmentLocations)) {
            data["appointmentLocations"] = [];
            for (let item of this.appointmentLocations)
                data["appointmentLocations"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.appointmentResources)) {
            data["appointmentResources"] = [];
            for (let item of this.appointmentResources)
                data["appointmentResources"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.accountLocations)) {
            data["accountLocations"] = [];
            for (let item of this.accountLocations)
                data["accountLocations"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IFacilityOutageCampaignFiltersDTO {
    appointmentTypes?: DropDownItem[];
    appointmentLocations?: DropDownItem[];
    appointmentResources?: DropDownItem[];
    accountLocations?: DropDownItem[];
}

export class FacilityOutageCampaignFilterRequest implements IFacilityOutageCampaignFilterRequest {
    facilityId?: number;

    constructor(data?: IFacilityOutageCampaignFilterRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.facilityId = _data["facilityId"];
        }
    }

    static fromJS(data: any): FacilityOutageCampaignFilterRequest {
        data = typeof data === 'object' ? data : {};
        let result = new FacilityOutageCampaignFilterRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["facilityId"] = this.facilityId;
        return data;
    }
}

export interface IFacilityOutageCampaignFilterRequest {
    facilityId?: number;
}

export class APIResponseOfListOfGetAllUserFacilityResponse implements IAPIResponseOfListOfGetAllUserFacilityResponse {
    statusCode?: HttpStatusCode;
    isSuccess?: boolean;
    errorMessages?: string[];
    result?: GetAllUserFacilityResponse[] | undefined;

    constructor(data?: IAPIResponseOfListOfGetAllUserFacilityResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusCode = _data["statusCode"];
            this.isSuccess = _data["isSuccess"];
            if (Array.isArray(_data["errorMessages"])) {
                this.errorMessages = [] as any;
                for (let item of _data["errorMessages"])
                    this.errorMessages!.push(item);
            }
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result!.push(GetAllUserFacilityResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): APIResponseOfListOfGetAllUserFacilityResponse {
        data = typeof data === 'object' ? data : {};
        let result = new APIResponseOfListOfGetAllUserFacilityResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["isSuccess"] = this.isSuccess;
        if (Array.isArray(this.errorMessages)) {
            data["errorMessages"] = [];
            for (let item of this.errorMessages)
                data["errorMessages"].push(item);
        }
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IAPIResponseOfListOfGetAllUserFacilityResponse {
    statusCode?: HttpStatusCode;
    isSuccess?: boolean;
    errorMessages?: string[];
    result?: GetAllUserFacilityResponse[] | undefined;
}

export class GetAllUserFacilityResponse implements IGetAllUserFacilityResponse {
    appFacilityId?: number;
    facility?: string;

    constructor(data?: IGetAllUserFacilityResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.appFacilityId = _data["appFacilityId"];
            this.facility = _data["facility"];
        }
    }

    static fromJS(data: any): GetAllUserFacilityResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllUserFacilityResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["appFacilityId"] = this.appFacilityId;
        data["facility"] = this.facility;
        return data;
    }
}

export interface IGetAllUserFacilityResponse {
    appFacilityId?: number;
    facility?: string;
}

export class APIResponseOfListOfOutageCampaignAccountsResponse implements IAPIResponseOfListOfOutageCampaignAccountsResponse {
    statusCode?: HttpStatusCode;
    isSuccess?: boolean;
    errorMessages?: string[];
    result?: OutageCampaignAccountsResponse[] | undefined;

    constructor(data?: IAPIResponseOfListOfOutageCampaignAccountsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusCode = _data["statusCode"];
            this.isSuccess = _data["isSuccess"];
            if (Array.isArray(_data["errorMessages"])) {
                this.errorMessages = [] as any;
                for (let item of _data["errorMessages"])
                    this.errorMessages!.push(item);
            }
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result!.push(OutageCampaignAccountsResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): APIResponseOfListOfOutageCampaignAccountsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new APIResponseOfListOfOutageCampaignAccountsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["isSuccess"] = this.isSuccess;
        if (Array.isArray(this.errorMessages)) {
            data["errorMessages"] = [];
            for (let item of this.errorMessages)
                data["errorMessages"].push(item);
        }
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IAPIResponseOfListOfOutageCampaignAccountsResponse {
    statusCode?: HttpStatusCode;
    isSuccess?: boolean;
    errorMessages?: string[];
    result?: OutageCampaignAccountsResponse[] | undefined;
}

export class OutageCampaignAccountsResponse implements IOutageCampaignAccountsResponse {
    coid?: number | undefined;
    facilityName?: string | undefined;
    accountNumber?: string | undefined;
    accountLocationCode?: string | undefined;
    apptURN?: string | undefined;
    apptType?: string | undefined;
    apptTypeDescription?: string | undefined;
    scheduledDate?: Date | undefined;
    apptLocation?: string | undefined;
    apptLocationName?: string | undefined;
    apptResource?: string | undefined;
    apptResourceName?: string | undefined;
    interactionCreatedDate?: Date | undefined;

    constructor(data?: IOutageCampaignAccountsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.coid = _data["coid"];
            this.facilityName = _data["facilityName"];
            this.accountNumber = _data["accountNumber"];
            this.accountLocationCode = _data["accountLocationCode"];
            this.apptURN = _data["apptURN"];
            this.apptType = _data["apptType"];
            this.apptTypeDescription = _data["apptTypeDescription"];
            this.scheduledDate = _data["scheduledDate"] ? new Date(_data["scheduledDate"].toString()) : undefined as any;
            this.apptLocation = _data["apptLocation"];
            this.apptLocationName = _data["apptLocationName"];
            this.apptResource = _data["apptResource"];
            this.apptResourceName = _data["apptResourceName"];
            this.interactionCreatedDate = _data["interactionCreatedDate"] ? new Date(_data["interactionCreatedDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): OutageCampaignAccountsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new OutageCampaignAccountsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["coid"] = this.coid;
        data["facilityName"] = this.facilityName;
        data["accountNumber"] = this.accountNumber;
        data["accountLocationCode"] = this.accountLocationCode;
        data["apptURN"] = this.apptURN;
        data["apptType"] = this.apptType;
        data["apptTypeDescription"] = this.apptTypeDescription;
        data["scheduledDate"] = this.scheduledDate ? this.scheduledDate.toISOString() : undefined as any;
        data["apptLocation"] = this.apptLocation;
        data["apptLocationName"] = this.apptLocationName;
        data["apptResource"] = this.apptResource;
        data["apptResourceName"] = this.apptResourceName;
        data["interactionCreatedDate"] = this.interactionCreatedDate ? this.interactionCreatedDate.toISOString() : undefined as any;
        return data;
    }
}

export interface IOutageCampaignAccountsResponse {
    coid?: number | undefined;
    facilityName?: string | undefined;
    accountNumber?: string | undefined;
    accountLocationCode?: string | undefined;
    apptURN?: string | undefined;
    apptType?: string | undefined;
    apptTypeDescription?: string | undefined;
    scheduledDate?: Date | undefined;
    apptLocation?: string | undefined;
    apptLocationName?: string | undefined;
    apptResource?: string | undefined;
    apptResourceName?: string | undefined;
    interactionCreatedDate?: Date | undefined;
}

export class OutageCampaignAccountRequest implements IOutageCampaignAccountRequest {
    campaignName?: string | undefined;
    reportType?: string | undefined;

    constructor(data?: IOutageCampaignAccountRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.campaignName = _data["campaignName"];
            this.reportType = _data["reportType"];
        }
    }

    static fromJS(data: any): OutageCampaignAccountRequest {
        data = typeof data === 'object' ? data : {};
        let result = new OutageCampaignAccountRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["campaignName"] = this.campaignName;
        data["reportType"] = this.reportType;
        return data;
    }
}

export interface IOutageCampaignAccountRequest {
    campaignName?: string | undefined;
    reportType?: string | undefined;
}

export class APIResponseOfUserInfo implements IAPIResponseOfUserInfo {
    statusCode?: HttpStatusCode;
    isSuccess?: boolean;
    errorMessages?: string[];
    result?: UserInfo | undefined;

    constructor(data?: IAPIResponseOfUserInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusCode = _data["statusCode"];
            this.isSuccess = _data["isSuccess"];
            if (Array.isArray(_data["errorMessages"])) {
                this.errorMessages = [] as any;
                for (let item of _data["errorMessages"])
                    this.errorMessages!.push(item);
            }
            this.result = _data["result"] ? UserInfo.fromJS(_data["result"]) : undefined as any;
        }
    }

    static fromJS(data: any): APIResponseOfUserInfo {
        data = typeof data === 'object' ? data : {};
        let result = new APIResponseOfUserInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["isSuccess"] = this.isSuccess;
        if (Array.isArray(this.errorMessages)) {
            data["errorMessages"] = [];
            for (let item of this.errorMessages)
                data["errorMessages"].push(item);
        }
        data["result"] = this.result ? this.result.toJSON() : undefined as any;
        return data;
    }
}

export interface IAPIResponseOfUserInfo {
    statusCode?: HttpStatusCode;
    isSuccess?: boolean;
    errorMessages?: string[];
    result?: UserInfo | undefined;
}

export class UserInfo implements IUserInfo {
    userId?: string;
    firstName?: string;
    lastName?: string;
    displayName?: string;
    userPermissions?: UserPermissionDTO[];
    tecToolAuthorizeToken?: string | undefined;

    constructor(data?: IUserInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.displayName = _data["displayName"];
            if (Array.isArray(_data["userPermissions"])) {
                this.userPermissions = [] as any;
                for (let item of _data["userPermissions"])
                    this.userPermissions!.push(UserPermissionDTO.fromJS(item));
            }
            this.tecToolAuthorizeToken = _data["tecToolAuthorizeToken"];
        }
    }

    static fromJS(data: any): UserInfo {
        data = typeof data === 'object' ? data : {};
        let result = new UserInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["displayName"] = this.displayName;
        if (Array.isArray(this.userPermissions)) {
            data["userPermissions"] = [];
            for (let item of this.userPermissions)
                data["userPermissions"].push(item ? item.toJSON() : undefined as any);
        }
        data["tecToolAuthorizeToken"] = this.tecToolAuthorizeToken;
        return data;
    }
}

export interface IUserInfo {
    userId?: string;
    firstName?: string;
    lastName?: string;
    displayName?: string;
    userPermissions?: UserPermissionDTO[];
    tecToolAuthorizeToken?: string | undefined;
}

export class UserPermissionDTO implements IUserPermissionDTO {
    appUserId?: number;
    feature?: Feature;
    component?: Component;
    permission?: PermissionType;
    followUpWQFilterIds?: FollowUpWQFilter[];

    constructor(data?: IUserPermissionDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.appUserId = _data["appUserId"];
            this.feature = _data["feature"];
            this.component = _data["component"];
            this.permission = _data["permission"];
            if (Array.isArray(_data["followUpWQFilterIds"])) {
                this.followUpWQFilterIds = [] as any;
                for (let item of _data["followUpWQFilterIds"])
                    this.followUpWQFilterIds!.push(item);
            }
        }
    }

    static fromJS(data: any): UserPermissionDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UserPermissionDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["appUserId"] = this.appUserId;
        data["feature"] = this.feature;
        data["component"] = this.component;
        data["permission"] = this.permission;
        if (Array.isArray(this.followUpWQFilterIds)) {
            data["followUpWQFilterIds"] = [];
            for (let item of this.followUpWQFilterIds)
                data["followUpWQFilterIds"].push(item);
        }
        return data;
    }
}

export interface IUserPermissionDTO {
    appUserId?: number;
    feature?: Feature;
    component?: Component;
    permission?: PermissionType;
    followUpWQFilterIds?: FollowUpWQFilter[];
}

export enum Feature {
    Framework = 1,
    WorkQueues = 2,
    BlockitUserMgmt = 3,
    AccountDetails = 4,
    Maintenance = 5,
    Reporting = 6,
    PreRegistration = 7,
    AuthReSchedule = 8,
}

export enum Component {
    Toolbar = 1,
    TitleBarSearch = 2,
    TitleBarMenu = 3,
    LandingPageIcons = 4,
    ExternalLinks = 5,
    SummaryView = 6,
    ListView = 7,
    BlockItSummaryView = 8,
    BlockItListView = 9,
    UserDetails = 10,
    AccountSummaryPanel = 11,
    NotesTab = 12,
    ApptsTab = 13,
    InteractionsTab = 14,
    PtInfoTab = 15,
    InsuranceTab = 16,
    SchedulingTab = 17,
    AuthorizationTab = 18,
    UsersandGroups = 19,
    CheckMyAccess = 20,
    WorkFlows = 21,
    AlertNotifications = 22,
    TBD = 23,
    AccountStatusTab = 24,
    SystemAlerts = 25,
    FacilityResource = 26,
    PreregSummaryView = 27,
    PreregListView = 28,
    PreregWorkQueue = 29,
    CancelRescheduleAuthListview = 30,
    AppointmentExclusions = 31,
    OutageCampaign = 32,
    Agent34IDMaintenance = 33,
}

export enum PermissionType {
    View = 1,
    Edit = 2,
}

export enum FollowUpWQFilter {
    Undefined = 0,
    Days45 = 1,
    Days90 = 2,
    Days180 = 3,
    Year1 = 4,
    Custom = 5,
}

export class APIResponseOfListOfAuthorizationSummaryResponse implements IAPIResponseOfListOfAuthorizationSummaryResponse {
    statusCode?: HttpStatusCode;
    isSuccess?: boolean;
    errorMessages?: string[];
    result?: AuthorizationSummaryResponse[] | undefined;

    constructor(data?: IAPIResponseOfListOfAuthorizationSummaryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusCode = _data["statusCode"];
            this.isSuccess = _data["isSuccess"];
            if (Array.isArray(_data["errorMessages"])) {
                this.errorMessages = [] as any;
                for (let item of _data["errorMessages"])
                    this.errorMessages!.push(item);
            }
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result!.push(AuthorizationSummaryResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): APIResponseOfListOfAuthorizationSummaryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new APIResponseOfListOfAuthorizationSummaryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["isSuccess"] = this.isSuccess;
        if (Array.isArray(this.errorMessages)) {
            data["errorMessages"] = [];
            for (let item of this.errorMessages)
                data["errorMessages"].push(item);
        }
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IAPIResponseOfListOfAuthorizationSummaryResponse {
    statusCode?: HttpStatusCode;
    isSuccess?: boolean;
    errorMessages?: string[];
    result?: AuthorizationSummaryResponse[] | undefined;
}

export class AuthorizationSummaryResponse implements IAuthorizationSummaryResponse {
    sscs?: SSC[] | undefined;

    constructor(data?: IAuthorizationSummaryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["sscs"])) {
                this.sscs = [] as any;
                for (let item of _data["sscs"])
                    this.sscs!.push(SSC.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AuthorizationSummaryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AuthorizationSummaryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.sscs)) {
            data["sscs"] = [];
            for (let item of this.sscs)
                data["sscs"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IAuthorizationSummaryResponse {
    sscs?: SSC[] | undefined;
}

export class AuthorizationSummaryBase implements IAuthorizationSummaryBase {
    type?: string | undefined;
    name?: string | undefined;
    sscId?: number | undefined;
    divisionId?: number | undefined;
    facilityId?: number | undefined;
    sameDay?: number | undefined;
    t1?: number | undefined;
    t2?: number | undefined;
    t3?: number | undefined;
    t4?: number | undefined;
    t5?: number | undefined;
    t6?: number | undefined;
    t7?: number | undefined;
    t8?: number | undefined;
    t9To14?: number | undefined;
    totalSchedAccts14?: number | undefined;
    totalAcctsWorkedToday?: number | undefined;
    pastDue?: number | undefined;

    constructor(data?: IAuthorizationSummaryBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.name = _data["name"];
            this.sscId = _data["sscId"];
            this.divisionId = _data["divisionId"];
            this.facilityId = _data["facilityId"];
            this.sameDay = _data["sameDay"];
            this.t1 = _data["t1"];
            this.t2 = _data["t2"];
            this.t3 = _data["t3"];
            this.t4 = _data["t4"];
            this.t5 = _data["t5"];
            this.t6 = _data["t6"];
            this.t7 = _data["t7"];
            this.t8 = _data["t8"];
            this.t9To14 = _data["t9To14"];
            this.totalSchedAccts14 = _data["totalSchedAccts14"];
            this.totalAcctsWorkedToday = _data["totalAcctsWorkedToday"];
            this.pastDue = _data["pastDue"];
        }
    }

    static fromJS(data: any): AuthorizationSummaryBase {
        data = typeof data === 'object' ? data : {};
        let result = new AuthorizationSummaryBase();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["name"] = this.name;
        data["sscId"] = this.sscId;
        data["divisionId"] = this.divisionId;
        data["facilityId"] = this.facilityId;
        data["sameDay"] = this.sameDay;
        data["t1"] = this.t1;
        data["t2"] = this.t2;
        data["t3"] = this.t3;
        data["t4"] = this.t4;
        data["t5"] = this.t5;
        data["t6"] = this.t6;
        data["t7"] = this.t7;
        data["t8"] = this.t8;
        data["t9To14"] = this.t9To14;
        data["totalSchedAccts14"] = this.totalSchedAccts14;
        data["totalAcctsWorkedToday"] = this.totalAcctsWorkedToday;
        data["pastDue"] = this.pastDue;
        return data;
    }
}

export interface IAuthorizationSummaryBase {
    type?: string | undefined;
    name?: string | undefined;
    sscId?: number | undefined;
    divisionId?: number | undefined;
    facilityId?: number | undefined;
    sameDay?: number | undefined;
    t1?: number | undefined;
    t2?: number | undefined;
    t3?: number | undefined;
    t4?: number | undefined;
    t5?: number | undefined;
    t6?: number | undefined;
    t7?: number | undefined;
    t8?: number | undefined;
    t9To14?: number | undefined;
    totalSchedAccts14?: number | undefined;
    totalAcctsWorkedToday?: number | undefined;
    pastDue?: number | undefined;
}

export class SSC extends AuthorizationSummaryBase implements ISSC {
    divisions?: Division[] | undefined;

    constructor(data?: ISSC) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["divisions"])) {
                this.divisions = [] as any;
                for (let item of _data["divisions"])
                    this.divisions!.push(Division.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): SSC {
        data = typeof data === 'object' ? data : {};
        let result = new SSC();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.divisions)) {
            data["divisions"] = [];
            for (let item of this.divisions)
                data["divisions"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface ISSC extends IAuthorizationSummaryBase {
    divisions?: Division[] | undefined;
}

export class Division extends AuthorizationSummaryBase implements IDivision {
    facilities?: Facility[] | undefined;

    constructor(data?: IDivision) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["facilities"])) {
                this.facilities = [] as any;
                for (let item of _data["facilities"])
                    this.facilities!.push(Facility.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): Division {
        data = typeof data === 'object' ? data : {};
        let result = new Division();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.facilities)) {
            data["facilities"] = [];
            for (let item of this.facilities)
                data["facilities"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IDivision extends IAuthorizationSummaryBase {
    facilities?: Facility[] | undefined;
}

export class Facility extends AuthorizationSummaryBase implements IFacility {

    constructor(data?: IFacility) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): Facility {
        data = typeof data === 'object' ? data : {};
        let result = new Facility();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IFacility extends IAuthorizationSummaryBase {
}

export class AuthorizationSummaryRequest implements IAuthorizationSummaryRequest {
    facilityIds?: string | undefined;
    facilityIdList?: string[] | undefined;
    authStatuses?: string | undefined;

    constructor(data?: IAuthorizationSummaryRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.facilityIds = _data["facilityIds"];
            if (Array.isArray(_data["facilityIdList"])) {
                this.facilityIdList = [] as any;
                for (let item of _data["facilityIdList"])
                    this.facilityIdList!.push(item);
            }
            this.authStatuses = _data["authStatuses"];
        }
    }

    static fromJS(data: any): AuthorizationSummaryRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AuthorizationSummaryRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["facilityIds"] = this.facilityIds;
        if (Array.isArray(this.facilityIdList)) {
            data["facilityIdList"] = [];
            for (let item of this.facilityIdList)
                data["facilityIdList"].push(item);
        }
        data["authStatuses"] = this.authStatuses;
        return data;
    }
}

export interface IAuthorizationSummaryRequest {
    facilityIds?: string | undefined;
    facilityIdList?: string[] | undefined;
    authStatuses?: string | undefined;
}

export class APIResponseOfListOfAuthorizationListViewResponseDTO implements IAPIResponseOfListOfAuthorizationListViewResponseDTO {
    statusCode?: HttpStatusCode;
    isSuccess?: boolean;
    errorMessages?: string[];
    result?: AuthorizationListViewResponseDTO[] | undefined;

    constructor(data?: IAPIResponseOfListOfAuthorizationListViewResponseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusCode = _data["statusCode"];
            this.isSuccess = _data["isSuccess"];
            if (Array.isArray(_data["errorMessages"])) {
                this.errorMessages = [] as any;
                for (let item of _data["errorMessages"])
                    this.errorMessages!.push(item);
            }
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result!.push(AuthorizationListViewResponseDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): APIResponseOfListOfAuthorizationListViewResponseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new APIResponseOfListOfAuthorizationListViewResponseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["isSuccess"] = this.isSuccess;
        if (Array.isArray(this.errorMessages)) {
            data["errorMessages"] = [];
            for (let item of this.errorMessages)
                data["errorMessages"].push(item);
        }
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IAPIResponseOfListOfAuthorizationListViewResponseDTO {
    statusCode?: HttpStatusCode;
    isSuccess?: boolean;
    errorMessages?: string[];
    result?: AuthorizationListViewResponseDTO[] | undefined;
}

export class AuthorizationListViewResponseDTO implements IAuthorizationListViewResponseDTO {
    accountNumber?: string | undefined;
    patientName?: string | undefined;
    coid?: number;
    escalated?: string | undefined;
    authReq?: string | undefined;
    finClass?: number | undefined;
    iplan?: number | undefined;
    iPlanDescription?: string | undefined;
    mnemonic?: string | undefined;
    insuranceOrder?: number | undefined;
    attendingPhysician?: string | undefined;
    payorName?: string | undefined;
    appointmentDescription?: string | undefined;
    accountType?: string | undefined;
    authStatus?: string | undefined;
    dateBooked?: Date | undefined;
    dateOfService?: Date | undefined;
    totRowCount?: number | undefined;
    authInitiatedDate?: Date | undefined;
    scheduledBy?: string | undefined;
    authResp?: string | undefined;

    constructor(data?: IAuthorizationListViewResponseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountNumber = _data["accountNumber"];
            this.patientName = _data["patientName"];
            this.coid = _data["coid"];
            this.escalated = _data["escalated"];
            this.authReq = _data["authReq"];
            this.finClass = _data["finClass"];
            this.iplan = _data["iplan"];
            this.iPlanDescription = _data["iPlanDescription"];
            this.mnemonic = _data["mnemonic"];
            this.insuranceOrder = _data["insuranceOrder"];
            this.attendingPhysician = _data["attendingPhysician"];
            this.payorName = _data["payorName"];
            this.appointmentDescription = _data["appointmentDescription"];
            this.accountType = _data["accountType"];
            this.authStatus = _data["authStatus"];
            this.dateBooked = _data["dateBooked"] ? new Date(_data["dateBooked"].toString()) : undefined as any;
            this.dateOfService = _data["dateOfService"] ? new Date(_data["dateOfService"].toString()) : undefined as any;
            this.totRowCount = _data["totRowCount"];
            this.authInitiatedDate = _data["authInitiatedDate"] ? new Date(_data["authInitiatedDate"].toString()) : undefined as any;
            this.scheduledBy = _data["scheduledBy"];
            this.authResp = _data["authResp"];
        }
    }

    static fromJS(data: any): AuthorizationListViewResponseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AuthorizationListViewResponseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountNumber"] = this.accountNumber;
        data["patientName"] = this.patientName;
        data["coid"] = this.coid;
        data["escalated"] = this.escalated;
        data["authReq"] = this.authReq;
        data["finClass"] = this.finClass;
        data["iplan"] = this.iplan;
        data["iPlanDescription"] = this.iPlanDescription;
        data["mnemonic"] = this.mnemonic;
        data["insuranceOrder"] = this.insuranceOrder;
        data["attendingPhysician"] = this.attendingPhysician;
        data["payorName"] = this.payorName;
        data["appointmentDescription"] = this.appointmentDescription;
        data["accountType"] = this.accountType;
        data["authStatus"] = this.authStatus;
        data["dateBooked"] = this.dateBooked ? this.dateBooked.toISOString() : undefined as any;
        data["dateOfService"] = this.dateOfService ? this.dateOfService.toISOString() : undefined as any;
        data["totRowCount"] = this.totRowCount;
        data["authInitiatedDate"] = this.authInitiatedDate ? this.authInitiatedDate.toISOString() : undefined as any;
        data["scheduledBy"] = this.scheduledBy;
        data["authResp"] = this.authResp;
        return data;
    }
}

export interface IAuthorizationListViewResponseDTO {
    accountNumber?: string | undefined;
    patientName?: string | undefined;
    coid?: number;
    escalated?: string | undefined;
    authReq?: string | undefined;
    finClass?: number | undefined;
    iplan?: number | undefined;
    iPlanDescription?: string | undefined;
    mnemonic?: string | undefined;
    insuranceOrder?: number | undefined;
    attendingPhysician?: string | undefined;
    payorName?: string | undefined;
    appointmentDescription?: string | undefined;
    accountType?: string | undefined;
    authStatus?: string | undefined;
    dateBooked?: Date | undefined;
    dateOfService?: Date | undefined;
    totRowCount?: number | undefined;
    authInitiatedDate?: Date | undefined;
    scheduledBy?: string | undefined;
    authResp?: string | undefined;
}

export class AuthorizationListViewRequest implements IAuthorizationListViewRequest {
    category?: string;
    categoryId?: number;
    columnName?: string;
    facilityIds?: string | undefined;
    facilityIdList?: string[] | undefined;
    authStatuses?: string | undefined;
    sortColumn?: string;
    sortDir?: string;
    page?: number;
    pageSize?: number;
    dateofServiceFrom?: Date | undefined;
    dateofServiceTo?: Date | undefined;
    attendingPhysician?: string | undefined;
    authResp?: string | undefined;
    payor?: string | undefined;
    financialClass?: string | undefined;
    previousDenial?: string | undefined;
    location?: string | undefined;
    accountType?: string | undefined;
    escalated?: string | undefined;
    scheduledBy?: string | undefined;

    constructor(data?: IAuthorizationListViewRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.category = _data["category"];
            this.categoryId = _data["categoryId"];
            this.columnName = _data["columnName"];
            this.facilityIds = _data["facilityIds"];
            if (Array.isArray(_data["facilityIdList"])) {
                this.facilityIdList = [] as any;
                for (let item of _data["facilityIdList"])
                    this.facilityIdList!.push(item);
            }
            this.authStatuses = _data["authStatuses"];
            this.sortColumn = _data["sortColumn"];
            this.sortDir = _data["sortDir"];
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
            this.dateofServiceFrom = _data["dateofServiceFrom"] ? new Date(_data["dateofServiceFrom"].toString()) : undefined as any;
            this.dateofServiceTo = _data["dateofServiceTo"] ? new Date(_data["dateofServiceTo"].toString()) : undefined as any;
            this.attendingPhysician = _data["attendingPhysician"];
            this.authResp = _data["authResp"];
            this.payor = _data["payor"];
            this.financialClass = _data["financialClass"];
            this.previousDenial = _data["previousDenial"];
            this.location = _data["location"];
            this.accountType = _data["accountType"];
            this.escalated = _data["escalated"];
            this.scheduledBy = _data["scheduledBy"];
        }
    }

    static fromJS(data: any): AuthorizationListViewRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AuthorizationListViewRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["category"] = this.category;
        data["categoryId"] = this.categoryId;
        data["columnName"] = this.columnName;
        data["facilityIds"] = this.facilityIds;
        if (Array.isArray(this.facilityIdList)) {
            data["facilityIdList"] = [];
            for (let item of this.facilityIdList)
                data["facilityIdList"].push(item);
        }
        data["authStatuses"] = this.authStatuses;
        data["sortColumn"] = this.sortColumn;
        data["sortDir"] = this.sortDir;
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        data["dateofServiceFrom"] = this.dateofServiceFrom ? this.dateofServiceFrom.toISOString() : undefined as any;
        data["dateofServiceTo"] = this.dateofServiceTo ? this.dateofServiceTo.toISOString() : undefined as any;
        data["attendingPhysician"] = this.attendingPhysician;
        data["authResp"] = this.authResp;
        data["payor"] = this.payor;
        data["financialClass"] = this.financialClass;
        data["previousDenial"] = this.previousDenial;
        data["location"] = this.location;
        data["accountType"] = this.accountType;
        data["escalated"] = this.escalated;
        data["scheduledBy"] = this.scheduledBy;
        return data;
    }
}

export interface IAuthorizationListViewRequest {
    category?: string;
    categoryId?: number;
    columnName?: string;
    facilityIds?: string | undefined;
    facilityIdList?: string[] | undefined;
    authStatuses?: string | undefined;
    sortColumn?: string;
    sortDir?: string;
    page?: number;
    pageSize?: number;
    dateofServiceFrom?: Date | undefined;
    dateofServiceTo?: Date | undefined;
    attendingPhysician?: string | undefined;
    authResp?: string | undefined;
    payor?: string | undefined;
    financialClass?: string | undefined;
    previousDenial?: string | undefined;
    location?: string | undefined;
    accountType?: string | undefined;
    escalated?: string | undefined;
    scheduledBy?: string | undefined;
}

export class APIResponseOfInsuranceData implements IAPIResponseOfInsuranceData {
    statusCode?: HttpStatusCode;
    isSuccess?: boolean;
    errorMessages?: string[];
    result?: InsuranceData | undefined;

    constructor(data?: IAPIResponseOfInsuranceData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusCode = _data["statusCode"];
            this.isSuccess = _data["isSuccess"];
            if (Array.isArray(_data["errorMessages"])) {
                this.errorMessages = [] as any;
                for (let item of _data["errorMessages"])
                    this.errorMessages!.push(item);
            }
            this.result = _data["result"] ? InsuranceData.fromJS(_data["result"]) : undefined as any;
        }
    }

    static fromJS(data: any): APIResponseOfInsuranceData {
        data = typeof data === 'object' ? data : {};
        let result = new APIResponseOfInsuranceData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["isSuccess"] = this.isSuccess;
        if (Array.isArray(this.errorMessages)) {
            data["errorMessages"] = [];
            for (let item of this.errorMessages)
                data["errorMessages"].push(item);
        }
        data["result"] = this.result ? this.result.toJSON() : undefined as any;
        return data;
    }
}

export interface IAPIResponseOfInsuranceData {
    statusCode?: HttpStatusCode;
    isSuccess?: boolean;
    errorMessages?: string[];
    result?: InsuranceData | undefined;
}

export class InsuranceData implements IInsuranceData {
    details?: InsuranceDetailResponse[];
    authInitiatedDate?: Date | undefined;

    constructor(data?: IInsuranceData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["details"])) {
                this.details = [] as any;
                for (let item of _data["details"])
                    this.details!.push(InsuranceDetailResponse.fromJS(item));
            }
            this.authInitiatedDate = _data["authInitiatedDate"] ? new Date(_data["authInitiatedDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): InsuranceData {
        data = typeof data === 'object' ? data : {};
        let result = new InsuranceData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.details)) {
            data["details"] = [];
            for (let item of this.details)
                data["details"].push(item ? item.toJSON() : undefined as any);
        }
        data["authInitiatedDate"] = this.authInitiatedDate ? this.authInitiatedDate.toISOString() : undefined as any;
        return data;
    }
}

export interface IInsuranceData {
    details?: InsuranceDetailResponse[];
    authInitiatedDate?: Date | undefined;
}

export class InsuranceDetailResponse implements IInsuranceDetailResponse {
    mnemonic?: string | undefined;
    description?: string | undefined;
    financialClass?: string | undefined;
    iPlan?: number | undefined;
    appaccountID?: number;
    insOrder?: number | undefined;
    address1?: string | undefined;
    address2?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    pincode?: string | undefined;
    phoneNumber?: string | undefined;
    memberID?: string | undefined;
    groupNumber?: string | undefined;
    effectiveDate?: Date | undefined;
    guarantorName?: string | undefined;
    guarantorDOB?: Date | undefined;
    guarantorRelation?: string | undefined;
    isEscalate?: boolean;
    authInitiatedDate?: Date | undefined;

    constructor(data?: IInsuranceDetailResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mnemonic = _data["mnemonic"];
            this.description = _data["description"];
            this.financialClass = _data["financialClass"];
            this.iPlan = _data["iPlan"];
            this.appaccountID = _data["appaccountID"];
            this.insOrder = _data["insOrder"];
            this.address1 = _data["address1"];
            this.address2 = _data["address2"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.pincode = _data["pincode"];
            this.phoneNumber = _data["phoneNumber"];
            this.memberID = _data["memberID"];
            this.groupNumber = _data["groupNumber"];
            this.effectiveDate = _data["effectiveDate"] ? new Date(_data["effectiveDate"].toString()) : undefined as any;
            this.guarantorName = _data["guarantorName"];
            this.guarantorDOB = _data["guarantorDOB"] ? new Date(_data["guarantorDOB"].toString()) : undefined as any;
            this.guarantorRelation = _data["guarantorRelation"];
            this.isEscalate = _data["isEscalate"];
            this.authInitiatedDate = _data["authInitiatedDate"] ? new Date(_data["authInitiatedDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): InsuranceDetailResponse {
        data = typeof data === 'object' ? data : {};
        let result = new InsuranceDetailResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mnemonic"] = this.mnemonic;
        data["description"] = this.description;
        data["financialClass"] = this.financialClass;
        data["iPlan"] = this.iPlan;
        data["appaccountID"] = this.appaccountID;
        data["insOrder"] = this.insOrder;
        data["address1"] = this.address1;
        data["address2"] = this.address2;
        data["city"] = this.city;
        data["state"] = this.state;
        data["pincode"] = this.pincode;
        data["phoneNumber"] = this.phoneNumber;
        data["memberID"] = this.memberID;
        data["groupNumber"] = this.groupNumber;
        data["effectiveDate"] = this.effectiveDate ? this.effectiveDate.toISOString() : undefined as any;
        data["guarantorName"] = this.guarantorName;
        data["guarantorDOB"] = this.guarantorDOB ? this.guarantorDOB.toISOString() : undefined as any;
        data["guarantorRelation"] = this.guarantorRelation;
        data["isEscalate"] = this.isEscalate;
        data["authInitiatedDate"] = this.authInitiatedDate ? this.authInitiatedDate.toISOString() : undefined as any;
        return data;
    }
}

export interface IInsuranceDetailResponse {
    mnemonic?: string | undefined;
    description?: string | undefined;
    financialClass?: string | undefined;
    iPlan?: number | undefined;
    appaccountID?: number;
    insOrder?: number | undefined;
    address1?: string | undefined;
    address2?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    pincode?: string | undefined;
    phoneNumber?: string | undefined;
    memberID?: string | undefined;
    groupNumber?: string | undefined;
    effectiveDate?: Date | undefined;
    guarantorName?: string | undefined;
    guarantorDOB?: Date | undefined;
    guarantorRelation?: string | undefined;
    isEscalate?: boolean;
    authInitiatedDate?: Date | undefined;
}

export class InsuranceDetailRequest implements IInsuranceDetailRequest {
    accountNumber?: string;
    coid?: number | undefined;

    constructor(data?: IInsuranceDetailRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountNumber = _data["accountNumber"];
            this.coid = _data["coid"];
        }
    }

    static fromJS(data: any): InsuranceDetailRequest {
        data = typeof data === 'object' ? data : {};
        let result = new InsuranceDetailRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountNumber"] = this.accountNumber;
        data["coid"] = this.coid;
        return data;
    }
}

export interface IInsuranceDetailRequest {
    accountNumber?: string;
    coid?: number | undefined;
}

export class AuthStatusUpdateRequest implements IAuthStatusUpdateRequest {
    accountNumber?: string | undefined;
    coid?: number;
    mnemonic?: string | undefined;
    authStatus?: string | undefined;

    constructor(data?: IAuthStatusUpdateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountNumber = _data["accountNumber"];
            this.coid = _data["coid"];
            this.mnemonic = _data["mnemonic"];
            this.authStatus = _data["authStatus"];
        }
    }

    static fromJS(data: any): AuthStatusUpdateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AuthStatusUpdateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountNumber"] = this.accountNumber;
        data["coid"] = this.coid;
        data["mnemonic"] = this.mnemonic;
        data["authStatus"] = this.authStatus;
        return data;
    }
}

export interface IAuthStatusUpdateRequest {
    accountNumber?: string | undefined;
    coid?: number;
    mnemonic?: string | undefined;
    authStatus?: string | undefined;
}

export class APIResponseOfListOfDropDownItem implements IAPIResponseOfListOfDropDownItem {
    statusCode?: HttpStatusCode;
    isSuccess?: boolean;
    errorMessages?: string[];
    result?: DropDownItem[] | undefined;

    constructor(data?: IAPIResponseOfListOfDropDownItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusCode = _data["statusCode"];
            this.isSuccess = _data["isSuccess"];
            if (Array.isArray(_data["errorMessages"])) {
                this.errorMessages = [] as any;
                for (let item of _data["errorMessages"])
                    this.errorMessages!.push(item);
            }
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result!.push(DropDownItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): APIResponseOfListOfDropDownItem {
        data = typeof data === 'object' ? data : {};
        let result = new APIResponseOfListOfDropDownItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["isSuccess"] = this.isSuccess;
        if (Array.isArray(this.errorMessages)) {
            data["errorMessages"] = [];
            for (let item of this.errorMessages)
                data["errorMessages"].push(item);
        }
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IAPIResponseOfListOfDropDownItem {
    statusCode?: HttpStatusCode;
    isSuccess?: boolean;
    errorMessages?: string[];
    result?: DropDownItem[] | undefined;
}

export class APIResponseOfInsuranceCount implements IAPIResponseOfInsuranceCount {
    statusCode?: HttpStatusCode;
    isSuccess?: boolean;
    errorMessages?: string[];
    result?: InsuranceCount | undefined;

    constructor(data?: IAPIResponseOfInsuranceCount) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusCode = _data["statusCode"];
            this.isSuccess = _data["isSuccess"];
            if (Array.isArray(_data["errorMessages"])) {
                this.errorMessages = [] as any;
                for (let item of _data["errorMessages"])
                    this.errorMessages!.push(item);
            }
            this.result = _data["result"] ? InsuranceCount.fromJS(_data["result"]) : undefined as any;
        }
    }

    static fromJS(data: any): APIResponseOfInsuranceCount {
        data = typeof data === 'object' ? data : {};
        let result = new APIResponseOfInsuranceCount();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["isSuccess"] = this.isSuccess;
        if (Array.isArray(this.errorMessages)) {
            data["errorMessages"] = [];
            for (let item of this.errorMessages)
                data["errorMessages"].push(item);
        }
        data["result"] = this.result ? this.result.toJSON() : undefined as any;
        return data;
    }
}

export interface IAPIResponseOfInsuranceCount {
    statusCode?: HttpStatusCode;
    isSuccess?: boolean;
    errorMessages?: string[];
    result?: InsuranceCount | undefined;
}

export class InsuranceCount implements IInsuranceCount {
    count?: number;

    constructor(data?: IInsuranceCount) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): InsuranceCount {
        data = typeof data === 'object' ? data : {};
        let result = new InsuranceCount();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["count"] = this.count;
        return data;
    }
}

export interface IInsuranceCount {
    count?: number;
}

export class APIResponseOfListOfCPTDTO implements IAPIResponseOfListOfCPTDTO {
    statusCode?: HttpStatusCode;
    isSuccess?: boolean;
    errorMessages?: string[];
    result?: CPTDTO[] | undefined;

    constructor(data?: IAPIResponseOfListOfCPTDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusCode = _data["statusCode"];
            this.isSuccess = _data["isSuccess"];
            if (Array.isArray(_data["errorMessages"])) {
                this.errorMessages = [] as any;
                for (let item of _data["errorMessages"])
                    this.errorMessages!.push(item);
            }
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result!.push(CPTDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): APIResponseOfListOfCPTDTO {
        data = typeof data === 'object' ? data : {};
        let result = new APIResponseOfListOfCPTDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["isSuccess"] = this.isSuccess;
        if (Array.isArray(this.errorMessages)) {
            data["errorMessages"] = [];
            for (let item of this.errorMessages)
                data["errorMessages"].push(item);
        }
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IAPIResponseOfListOfCPTDTO {
    statusCode?: HttpStatusCode;
    isSuccess?: boolean;
    errorMessages?: string[];
    result?: CPTDTO[] | undefined;
}

export class BaseCPTCode implements IBaseCPTCode {
    cptCode?: string;

    constructor(data?: IBaseCPTCode) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cptCode = _data["cptCode"];
        }
    }

    static fromJS(data: any): BaseCPTCode {
        data = typeof data === 'object' ? data : {};
        let result = new BaseCPTCode();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cptCode"] = this.cptCode;
        return data;
    }
}

export interface IBaseCPTCode {
    cptCode?: string;
}

export class CPTDTO extends BaseCPTCode implements ICPTDTO {
    cptCodeDesc?: string;
    cptCategoryCode?: string;

    constructor(data?: ICPTDTO) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.cptCodeDesc = _data["cptCodeDesc"];
            this.cptCategoryCode = _data["cptCategoryCode"];
        }
    }

    static override fromJS(data: any): CPTDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CPTDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cptCodeDesc"] = this.cptCodeDesc;
        data["cptCategoryCode"] = this.cptCategoryCode;
        super.toJSON(data);
        return data;
    }
}

export interface ICPTDTO extends IBaseCPTCode {
    cptCodeDesc?: string;
    cptCategoryCode?: string;
}

export class APIResponseOfListOfAuthInsuranceCPTDTO implements IAPIResponseOfListOfAuthInsuranceCPTDTO {
    statusCode?: HttpStatusCode;
    isSuccess?: boolean;
    errorMessages?: string[];
    result?: AuthInsuranceCPTDTO[] | undefined;

    constructor(data?: IAPIResponseOfListOfAuthInsuranceCPTDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusCode = _data["statusCode"];
            this.isSuccess = _data["isSuccess"];
            if (Array.isArray(_data["errorMessages"])) {
                this.errorMessages = [] as any;
                for (let item of _data["errorMessages"])
                    this.errorMessages!.push(item);
            }
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result!.push(AuthInsuranceCPTDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): APIResponseOfListOfAuthInsuranceCPTDTO {
        data = typeof data === 'object' ? data : {};
        let result = new APIResponseOfListOfAuthInsuranceCPTDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["isSuccess"] = this.isSuccess;
        if (Array.isArray(this.errorMessages)) {
            data["errorMessages"] = [];
            for (let item of this.errorMessages)
                data["errorMessages"].push(item);
        }
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IAPIResponseOfListOfAuthInsuranceCPTDTO {
    statusCode?: HttpStatusCode;
    isSuccess?: boolean;
    errorMessages?: string[];
    result?: AuthInsuranceCPTDTO[] | undefined;
}

export class AuthInsuranceCPTDTO extends BaseCPTCode implements IAuthInsuranceCPTDTO {
    cpT_Position?: number | undefined;
    authStatus?: string | undefined;
    cptCodeDesc?: string | undefined;
    isPrimary?: boolean;

    constructor(data?: IAuthInsuranceCPTDTO) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.cpT_Position = _data["cpT_Position"];
            this.authStatus = _data["authStatus"];
            this.cptCodeDesc = _data["cptCodeDesc"];
            this.isPrimary = _data["isPrimary"];
        }
    }

    static override fromJS(data: any): AuthInsuranceCPTDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AuthInsuranceCPTDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cpT_Position"] = this.cpT_Position;
        data["authStatus"] = this.authStatus;
        data["cptCodeDesc"] = this.cptCodeDesc;
        data["isPrimary"] = this.isPrimary;
        super.toJSON(data);
        return data;
    }
}

export interface IAuthInsuranceCPTDTO extends IBaseCPTCode {
    cpT_Position?: number | undefined;
    authStatus?: string | undefined;
    cptCodeDesc?: string | undefined;
    isPrimary?: boolean;
}

export class InsuranceCPTRequest implements IInsuranceCPTRequest {
    mnemonic?: string | undefined;
    appaccountID?: number;
    selectGrid?: string | undefined;
    sortColumn?: string | undefined;
    sortDir?: string | undefined;
    page?: number;
    pageSize?: number;

    constructor(data?: IInsuranceCPTRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mnemonic = _data["mnemonic"];
            this.appaccountID = _data["appaccountID"];
            this.selectGrid = _data["selectGrid"];
            this.sortColumn = _data["sortColumn"];
            this.sortDir = _data["sortDir"];
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
        }
    }

    static fromJS(data: any): InsuranceCPTRequest {
        data = typeof data === 'object' ? data : {};
        let result = new InsuranceCPTRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mnemonic"] = this.mnemonic;
        data["appaccountID"] = this.appaccountID;
        data["selectGrid"] = this.selectGrid;
        data["sortColumn"] = this.sortColumn;
        data["sortDir"] = this.sortDir;
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        return data;
    }
}

export interface IInsuranceCPTRequest {
    mnemonic?: string | undefined;
    appaccountID?: number;
    selectGrid?: string | undefined;
    sortColumn?: string | undefined;
    sortDir?: string | undefined;
    page?: number;
    pageSize?: number;
}

export class InsuranceCPTSaveRequest implements IInsuranceCPTSaveRequest {
    mnemonic?: string | undefined;
    appaccountID?: number;
    cptCode?: string[];

    constructor(data?: IInsuranceCPTSaveRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mnemonic = _data["mnemonic"];
            this.appaccountID = _data["appaccountID"];
            if (Array.isArray(_data["cptCode"])) {
                this.cptCode = [] as any;
                for (let item of _data["cptCode"])
                    this.cptCode!.push(item);
            }
        }
    }

    static fromJS(data: any): InsuranceCPTSaveRequest {
        data = typeof data === 'object' ? data : {};
        let result = new InsuranceCPTSaveRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mnemonic"] = this.mnemonic;
        data["appaccountID"] = this.appaccountID;
        if (Array.isArray(this.cptCode)) {
            data["cptCode"] = [];
            for (let item of this.cptCode)
                data["cptCode"].push(item);
        }
        return data;
    }
}

export interface IInsuranceCPTSaveRequest {
    mnemonic?: string | undefined;
    appaccountID?: number;
    cptCode?: string[];
}

export class InsuranceCPTPrimarySetRequest implements IInsuranceCPTPrimarySetRequest {
    mnemonic?: string | undefined;
    appaccountID?: number;
    cptCode?: string;
    includeAllIplan?: boolean;

    constructor(data?: IInsuranceCPTPrimarySetRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mnemonic = _data["mnemonic"];
            this.appaccountID = _data["appaccountID"];
            this.cptCode = _data["cptCode"];
            this.includeAllIplan = _data["includeAllIplan"];
        }
    }

    static fromJS(data: any): InsuranceCPTPrimarySetRequest {
        data = typeof data === 'object' ? data : {};
        let result = new InsuranceCPTPrimarySetRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mnemonic"] = this.mnemonic;
        data["appaccountID"] = this.appaccountID;
        data["cptCode"] = this.cptCode;
        data["includeAllIplan"] = this.includeAllIplan;
        return data;
    }
}

export interface IInsuranceCPTPrimarySetRequest {
    mnemonic?: string | undefined;
    appaccountID?: number;
    cptCode?: string;
    includeAllIplan?: boolean;
}

export class InsuranceMarkAsCompleteRequest implements IInsuranceMarkAsCompleteRequest {
    cptCode?: string[];
    mnemonic?: string | undefined;
    appaccountID?: number;
    authCompletedReasonID?: number;

    constructor(data?: IInsuranceMarkAsCompleteRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["cptCode"])) {
                this.cptCode = [] as any;
                for (let item of _data["cptCode"])
                    this.cptCode!.push(item);
            }
            this.mnemonic = _data["mnemonic"];
            this.appaccountID = _data["appaccountID"];
            this.authCompletedReasonID = _data["authCompletedReasonID"];
        }
    }

    static fromJS(data: any): InsuranceMarkAsCompleteRequest {
        data = typeof data === 'object' ? data : {};
        let result = new InsuranceMarkAsCompleteRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.cptCode)) {
            data["cptCode"] = [];
            for (let item of this.cptCode)
                data["cptCode"].push(item);
        }
        data["mnemonic"] = this.mnemonic;
        data["appaccountID"] = this.appaccountID;
        data["authCompletedReasonID"] = this.authCompletedReasonID;
        return data;
    }
}

export interface IInsuranceMarkAsCompleteRequest {
    cptCode?: string[];
    mnemonic?: string | undefined;
    appaccountID?: number;
    authCompletedReasonID?: number;
}

export class APIResponseOfAuthInsuranceCPTResponse implements IAPIResponseOfAuthInsuranceCPTResponse {
    statusCode?: HttpStatusCode;
    isSuccess?: boolean;
    errorMessages?: string[];
    result?: AuthInsuranceCPTResponse | undefined;

    constructor(data?: IAPIResponseOfAuthInsuranceCPTResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusCode = _data["statusCode"];
            this.isSuccess = _data["isSuccess"];
            if (Array.isArray(_data["errorMessages"])) {
                this.errorMessages = [] as any;
                for (let item of _data["errorMessages"])
                    this.errorMessages!.push(item);
            }
            this.result = _data["result"] ? AuthInsuranceCPTResponse.fromJS(_data["result"]) : undefined as any;
        }
    }

    static fromJS(data: any): APIResponseOfAuthInsuranceCPTResponse {
        data = typeof data === 'object' ? data : {};
        let result = new APIResponseOfAuthInsuranceCPTResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["isSuccess"] = this.isSuccess;
        if (Array.isArray(this.errorMessages)) {
            data["errorMessages"] = [];
            for (let item of this.errorMessages)
                data["errorMessages"].push(item);
        }
        data["result"] = this.result ? this.result.toJSON() : undefined as any;
        return data;
    }
}

export interface IAPIResponseOfAuthInsuranceCPTResponse {
    statusCode?: HttpStatusCode;
    isSuccess?: boolean;
    errorMessages?: string[];
    result?: AuthInsuranceCPTResponse | undefined;
}

export class AuthInsuranceCPTResponse implements IAuthInsuranceCPTResponse {
    cptSummary?: CPTStatusSummary[];
    cptPending?: AuthInsuranceCPTDetailsDTO[];
    cptHistory?: AuthInsuranceCPTDetailsDTO[];

    constructor(data?: IAuthInsuranceCPTResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["cptSummary"])) {
                this.cptSummary = [] as any;
                for (let item of _data["cptSummary"])
                    this.cptSummary!.push(CPTStatusSummary.fromJS(item));
            }
            if (Array.isArray(_data["cptPending"])) {
                this.cptPending = [] as any;
                for (let item of _data["cptPending"])
                    this.cptPending!.push(AuthInsuranceCPTDetailsDTO.fromJS(item));
            }
            if (Array.isArray(_data["cptHistory"])) {
                this.cptHistory = [] as any;
                for (let item of _data["cptHistory"])
                    this.cptHistory!.push(AuthInsuranceCPTDetailsDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AuthInsuranceCPTResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AuthInsuranceCPTResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.cptSummary)) {
            data["cptSummary"] = [];
            for (let item of this.cptSummary)
                data["cptSummary"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.cptPending)) {
            data["cptPending"] = [];
            for (let item of this.cptPending)
                data["cptPending"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.cptHistory)) {
            data["cptHistory"] = [];
            for (let item of this.cptHistory)
                data["cptHistory"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IAuthInsuranceCPTResponse {
    cptSummary?: CPTStatusSummary[];
    cptPending?: AuthInsuranceCPTDetailsDTO[];
    cptHistory?: AuthInsuranceCPTDetailsDTO[];
}

export class CPTStatusSummary implements ICPTStatusSummary {
    columnName?: string;
    cptList?: AuthInsuranceCPTStatusSummaryDTO[];

    constructor(data?: ICPTStatusSummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.columnName = _data["columnName"];
            if (Array.isArray(_data["cptList"])) {
                this.cptList = [] as any;
                for (let item of _data["cptList"])
                    this.cptList!.push(AuthInsuranceCPTStatusSummaryDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CPTStatusSummary {
        data = typeof data === 'object' ? data : {};
        let result = new CPTStatusSummary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["columnName"] = this.columnName;
        if (Array.isArray(this.cptList)) {
            data["cptList"] = [];
            for (let item of this.cptList)
                data["cptList"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ICPTStatusSummary {
    columnName?: string;
    cptList?: AuthInsuranceCPTStatusSummaryDTO[];
}

export class AuthInsuranceCPTStatusSummaryDTO implements IAuthInsuranceCPTStatusSummaryDTO {
    cptCode?: string;
    authStatus?: string | undefined;
    isPrimary?: boolean;

    constructor(data?: IAuthInsuranceCPTStatusSummaryDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cptCode = _data["cptCode"];
            this.authStatus = _data["authStatus"];
            this.isPrimary = _data["isPrimary"];
        }
    }

    static fromJS(data: any): AuthInsuranceCPTStatusSummaryDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AuthInsuranceCPTStatusSummaryDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cptCode"] = this.cptCode;
        data["authStatus"] = this.authStatus;
        data["isPrimary"] = this.isPrimary;
        return data;
    }
}

export interface IAuthInsuranceCPTStatusSummaryDTO {
    cptCode?: string;
    authStatus?: string | undefined;
    isPrimary?: boolean;
}

export class AuthInsuranceCPTDetailsDTO implements IAuthInsuranceCPTDetailsDTO {
    cptCode?: string;
    authStatus?: string | undefined;
    authNumber?: string | undefined;
    authType?: string | undefined;
    authByUser?: string | undefined;
    completeDate?: Date | undefined;
    authDate?: Date | undefined;
    authStartEndDate?: string | undefined;
    totRowCount?: number | undefined;

    constructor(data?: IAuthInsuranceCPTDetailsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cptCode = _data["cptCode"];
            this.authStatus = _data["authStatus"];
            this.authNumber = _data["authNumber"];
            this.authType = _data["authType"];
            this.authByUser = _data["authByUser"];
            this.completeDate = _data["completeDate"] ? new Date(_data["completeDate"].toString()) : undefined as any;
            this.authDate = _data["authDate"] ? new Date(_data["authDate"].toString()) : undefined as any;
            this.authStartEndDate = _data["authStartEndDate"];
            this.totRowCount = _data["totRowCount"];
        }
    }

    static fromJS(data: any): AuthInsuranceCPTDetailsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AuthInsuranceCPTDetailsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cptCode"] = this.cptCode;
        data["authStatus"] = this.authStatus;
        data["authNumber"] = this.authNumber;
        data["authType"] = this.authType;
        data["authByUser"] = this.authByUser;
        data["completeDate"] = this.completeDate ? this.completeDate.toISOString() : undefined as any;
        data["authDate"] = this.authDate ? this.authDate.toISOString() : undefined as any;
        data["authStartEndDate"] = this.authStartEndDate;
        data["totRowCount"] = this.totRowCount;
        return data;
    }
}

export interface IAuthInsuranceCPTDetailsDTO {
    cptCode?: string;
    authStatus?: string | undefined;
    authNumber?: string | undefined;
    authType?: string | undefined;
    authByUser?: string | undefined;
    completeDate?: Date | undefined;
    authDate?: Date | undefined;
    authStartEndDate?: string | undefined;
    totRowCount?: number | undefined;
}

export class InsuranceAddAuthorizationRequest implements IInsuranceAddAuthorizationRequest {
    appaccountID?: number;
    mnemonic?: string;
    authStatus?: string;
    resultID?: string | undefined;
    reshedule?: string | undefined;
    authNumber?: string | undefined;
    authDate?: Date | undefined;
    authType?: string | undefined;
    authMethodCode?: string | undefined;
    phoneNumber?: string | undefined;
    authPhoneType?: string | undefined;
    authStartDate?: Date | undefined;
    authEndDate?: Date | undefined;
    numberofVisits?: string | undefined;
    referralNumber?: string | undefined;
    authRequired?: string | undefined;
    cptList?: CPTParameterEntry[];

    constructor(data?: IInsuranceAddAuthorizationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.appaccountID = _data["appaccountID"];
            this.mnemonic = _data["mnemonic"];
            this.authStatus = _data["authStatus"];
            this.resultID = _data["resultID"];
            this.reshedule = _data["reshedule"];
            this.authNumber = _data["authNumber"];
            this.authDate = _data["authDate"] ? new Date(_data["authDate"].toString()) : undefined as any;
            this.authType = _data["authType"];
            this.authMethodCode = _data["authMethodCode"];
            this.phoneNumber = _data["phoneNumber"];
            this.authPhoneType = _data["authPhoneType"];
            this.authStartDate = _data["authStartDate"] ? new Date(_data["authStartDate"].toString()) : undefined as any;
            this.authEndDate = _data["authEndDate"] ? new Date(_data["authEndDate"].toString()) : undefined as any;
            this.numberofVisits = _data["numberofVisits"];
            this.referralNumber = _data["referralNumber"];
            this.authRequired = _data["authRequired"];
            if (Array.isArray(_data["cptList"])) {
                this.cptList = [] as any;
                for (let item of _data["cptList"])
                    this.cptList!.push(CPTParameterEntry.fromJS(item));
            }
        }
    }

    static fromJS(data: any): InsuranceAddAuthorizationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new InsuranceAddAuthorizationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["appaccountID"] = this.appaccountID;
        data["mnemonic"] = this.mnemonic;
        data["authStatus"] = this.authStatus;
        data["resultID"] = this.resultID;
        data["reshedule"] = this.reshedule;
        data["authNumber"] = this.authNumber;
        data["authDate"] = this.authDate ? this.authDate.toISOString() : undefined as any;
        data["authType"] = this.authType;
        data["authMethodCode"] = this.authMethodCode;
        data["phoneNumber"] = this.phoneNumber;
        data["authPhoneType"] = this.authPhoneType;
        data["authStartDate"] = this.authStartDate ? this.authStartDate.toISOString() : undefined as any;
        data["authEndDate"] = this.authEndDate ? this.authEndDate.toISOString() : undefined as any;
        data["numberofVisits"] = this.numberofVisits;
        data["referralNumber"] = this.referralNumber;
        data["authRequired"] = this.authRequired;
        if (Array.isArray(this.cptList)) {
            data["cptList"] = [];
            for (let item of this.cptList)
                data["cptList"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IInsuranceAddAuthorizationRequest {
    appaccountID?: number;
    mnemonic?: string;
    authStatus?: string;
    resultID?: string | undefined;
    reshedule?: string | undefined;
    authNumber?: string | undefined;
    authDate?: Date | undefined;
    authType?: string | undefined;
    authMethodCode?: string | undefined;
    phoneNumber?: string | undefined;
    authPhoneType?: string | undefined;
    authStartDate?: Date | undefined;
    authEndDate?: Date | undefined;
    numberofVisits?: string | undefined;
    referralNumber?: string | undefined;
    authRequired?: string | undefined;
    cptList?: CPTParameterEntry[];
}

export class CPTParameterEntry implements ICPTParameterEntry {
    cptCode?: string;
    cptPosition?: number | undefined;

    constructor(data?: ICPTParameterEntry) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cptCode = _data["cptCode"];
            this.cptPosition = _data["cptPosition"];
        }
    }

    static fromJS(data: any): CPTParameterEntry {
        data = typeof data === 'object' ? data : {};
        let result = new CPTParameterEntry();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cptCode"] = this.cptCode;
        data["cptPosition"] = this.cptPosition;
        return data;
    }
}

export interface ICPTParameterEntry {
    cptCode?: string;
    cptPosition?: number | undefined;
}

export class APIResponseOfListOfInsuranceAuthResultResponse implements IAPIResponseOfListOfInsuranceAuthResultResponse {
    statusCode?: HttpStatusCode;
    isSuccess?: boolean;
    errorMessages?: string[];
    result?: InsuranceAuthResultResponse[] | undefined;

    constructor(data?: IAPIResponseOfListOfInsuranceAuthResultResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusCode = _data["statusCode"];
            this.isSuccess = _data["isSuccess"];
            if (Array.isArray(_data["errorMessages"])) {
                this.errorMessages = [] as any;
                for (let item of _data["errorMessages"])
                    this.errorMessages!.push(item);
            }
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result!.push(InsuranceAuthResultResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): APIResponseOfListOfInsuranceAuthResultResponse {
        data = typeof data === 'object' ? data : {};
        let result = new APIResponseOfListOfInsuranceAuthResultResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["isSuccess"] = this.isSuccess;
        if (Array.isArray(this.errorMessages)) {
            data["errorMessages"] = [];
            for (let item of this.errorMessages)
                data["errorMessages"].push(item);
        }
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IAPIResponseOfListOfInsuranceAuthResultResponse {
    statusCode?: HttpStatusCode;
    isSuccess?: boolean;
    errorMessages?: string[];
    result?: InsuranceAuthResultResponse[] | undefined;
}

export class InsuranceAuthResultResponse implements IInsuranceAuthResultResponse {
    resultValue?: string;
    resultLabel?: string;
    authStatus?: string;

    constructor(data?: IInsuranceAuthResultResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resultValue = _data["resultValue"];
            this.resultLabel = _data["resultLabel"];
            this.authStatus = _data["authStatus"];
        }
    }

    static fromJS(data: any): InsuranceAuthResultResponse {
        data = typeof data === 'object' ? data : {};
        let result = new InsuranceAuthResultResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resultValue"] = this.resultValue;
        data["resultLabel"] = this.resultLabel;
        data["authStatus"] = this.authStatus;
        return data;
    }
}

export interface IInsuranceAuthResultResponse {
    resultValue?: string;
    resultLabel?: string;
    authStatus?: string;
}

export class APIResponseOfListOfInsuranceAuthStatusDTO implements IAPIResponseOfListOfInsuranceAuthStatusDTO {
    statusCode?: HttpStatusCode;
    isSuccess?: boolean;
    errorMessages?: string[];
    result?: InsuranceAuthStatusDTO[] | undefined;

    constructor(data?: IAPIResponseOfListOfInsuranceAuthStatusDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusCode = _data["statusCode"];
            this.isSuccess = _data["isSuccess"];
            if (Array.isArray(_data["errorMessages"])) {
                this.errorMessages = [] as any;
                for (let item of _data["errorMessages"])
                    this.errorMessages!.push(item);
            }
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result!.push(InsuranceAuthStatusDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): APIResponseOfListOfInsuranceAuthStatusDTO {
        data = typeof data === 'object' ? data : {};
        let result = new APIResponseOfListOfInsuranceAuthStatusDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["isSuccess"] = this.isSuccess;
        if (Array.isArray(this.errorMessages)) {
            data["errorMessages"] = [];
            for (let item of this.errorMessages)
                data["errorMessages"].push(item);
        }
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IAPIResponseOfListOfInsuranceAuthStatusDTO {
    statusCode?: HttpStatusCode;
    isSuccess?: boolean;
    errorMessages?: string[];
    result?: InsuranceAuthStatusDTO[] | undefined;
}

export class InsuranceAuthStatusDTO implements IInsuranceAuthStatusDTO {
    authStatus?: string;
    authStatusDesc?: string | undefined;

    constructor(data?: IInsuranceAuthStatusDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.authStatus = _data["authStatus"];
            this.authStatusDesc = _data["authStatusDesc"];
        }
    }

    static fromJS(data: any): InsuranceAuthStatusDTO {
        data = typeof data === 'object' ? data : {};
        let result = new InsuranceAuthStatusDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["authStatus"] = this.authStatus;
        data["authStatusDesc"] = this.authStatusDesc;
        return data;
    }
}

export interface IInsuranceAuthStatusDTO {
    authStatus?: string;
    authStatusDesc?: string | undefined;
}

export class APIResponseOfInsuranceGetAccountAuthorizationDTO implements IAPIResponseOfInsuranceGetAccountAuthorizationDTO {
    statusCode?: HttpStatusCode;
    isSuccess?: boolean;
    errorMessages?: string[];
    result?: InsuranceGetAccountAuthorizationDTO | undefined;

    constructor(data?: IAPIResponseOfInsuranceGetAccountAuthorizationDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusCode = _data["statusCode"];
            this.isSuccess = _data["isSuccess"];
            if (Array.isArray(_data["errorMessages"])) {
                this.errorMessages = [] as any;
                for (let item of _data["errorMessages"])
                    this.errorMessages!.push(item);
            }
            this.result = _data["result"] ? InsuranceGetAccountAuthorizationDTO.fromJS(_data["result"]) : undefined as any;
        }
    }

    static fromJS(data: any): APIResponseOfInsuranceGetAccountAuthorizationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new APIResponseOfInsuranceGetAccountAuthorizationDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["isSuccess"] = this.isSuccess;
        if (Array.isArray(this.errorMessages)) {
            data["errorMessages"] = [];
            for (let item of this.errorMessages)
                data["errorMessages"].push(item);
        }
        data["result"] = this.result ? this.result.toJSON() : undefined as any;
        return data;
    }
}

export interface IAPIResponseOfInsuranceGetAccountAuthorizationDTO {
    statusCode?: HttpStatusCode;
    isSuccess?: boolean;
    errorMessages?: string[];
    result?: InsuranceGetAccountAuthorizationDTO | undefined;
}

export class InsuranceGetAccountAuthorizationDTO implements IInsuranceGetAccountAuthorizationDTO {
    authStatus?: string;
    resultID?: number | undefined;
    isReschedule?: boolean | undefined;
    authNumber?: string | undefined;
    authDate?: Date | undefined;
    authType?: string | undefined;
    authMethodCode?: string | undefined;
    authPhone?: string | undefined;
    authPhoneTypeCode?: string | undefined;
    authStartDate?: Date | undefined;
    authEndDate?: Date | undefined;
    numAuthVisits?: number | undefined;
    referralNumber?: string | undefined;
    cpT_Position?: number | undefined;

    constructor(data?: IInsuranceGetAccountAuthorizationDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.authStatus = _data["authStatus"];
            this.resultID = _data["resultID"];
            this.isReschedule = _data["isReschedule"];
            this.authNumber = _data["authNumber"];
            this.authDate = _data["authDate"] ? new Date(_data["authDate"].toString()) : undefined as any;
            this.authType = _data["authType"];
            this.authMethodCode = _data["authMethodCode"];
            this.authPhone = _data["authPhone"];
            this.authPhoneTypeCode = _data["authPhoneTypeCode"];
            this.authStartDate = _data["authStartDate"] ? new Date(_data["authStartDate"].toString()) : undefined as any;
            this.authEndDate = _data["authEndDate"] ? new Date(_data["authEndDate"].toString()) : undefined as any;
            this.numAuthVisits = _data["numAuthVisits"];
            this.referralNumber = _data["referralNumber"];
            this.cpT_Position = _data["cpT_Position"];
        }
    }

    static fromJS(data: any): InsuranceGetAccountAuthorizationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new InsuranceGetAccountAuthorizationDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["authStatus"] = this.authStatus;
        data["resultID"] = this.resultID;
        data["isReschedule"] = this.isReschedule;
        data["authNumber"] = this.authNumber;
        data["authDate"] = this.authDate ? this.authDate.toISOString() : undefined as any;
        data["authType"] = this.authType;
        data["authMethodCode"] = this.authMethodCode;
        data["authPhone"] = this.authPhone;
        data["authPhoneTypeCode"] = this.authPhoneTypeCode;
        data["authStartDate"] = this.authStartDate ? this.authStartDate.toISOString() : undefined as any;
        data["authEndDate"] = this.authEndDate ? this.authEndDate.toISOString() : undefined as any;
        data["numAuthVisits"] = this.numAuthVisits;
        data["referralNumber"] = this.referralNumber;
        data["cpT_Position"] = this.cpT_Position;
        return data;
    }
}

export interface IInsuranceGetAccountAuthorizationDTO {
    authStatus?: string;
    resultID?: number | undefined;
    isReschedule?: boolean | undefined;
    authNumber?: string | undefined;
    authDate?: Date | undefined;
    authType?: string | undefined;
    authMethodCode?: string | undefined;
    authPhone?: string | undefined;
    authPhoneTypeCode?: string | undefined;
    authStartDate?: Date | undefined;
    authEndDate?: Date | undefined;
    numAuthVisits?: number | undefined;
    referralNumber?: string | undefined;
    cpT_Position?: number | undefined;
}

export class InusranceGetAccountAuthorizationRequest implements IInusranceGetAccountAuthorizationRequest {
    mnemonic?: string;
    appaccountID?: number;
    cptCode?: string;

    constructor(data?: IInusranceGetAccountAuthorizationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mnemonic = _data["mnemonic"];
            this.appaccountID = _data["appaccountID"];
            this.cptCode = _data["cptCode"];
        }
    }

    static fromJS(data: any): InusranceGetAccountAuthorizationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new InusranceGetAccountAuthorizationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mnemonic"] = this.mnemonic;
        data["appaccountID"] = this.appaccountID;
        data["cptCode"] = this.cptCode;
        return data;
    }
}

export interface IInusranceGetAccountAuthorizationRequest {
    mnemonic?: string;
    appaccountID?: number;
    cptCode?: string;
}

export class InsuranceEscalateAccountRequest implements IInsuranceEscalateAccountRequest {
    appaccountID?: number;
    mnemonic?: string;
    isEscalate?: boolean;
    escalationReasonCode?: string;

    constructor(data?: IInsuranceEscalateAccountRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.appaccountID = _data["appaccountID"];
            this.mnemonic = _data["mnemonic"];
            this.isEscalate = _data["isEscalate"];
            this.escalationReasonCode = _data["escalationReasonCode"];
        }
    }

    static fromJS(data: any): InsuranceEscalateAccountRequest {
        data = typeof data === 'object' ? data : {};
        let result = new InsuranceEscalateAccountRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["appaccountID"] = this.appaccountID;
        data["mnemonic"] = this.mnemonic;
        data["isEscalate"] = this.isEscalate;
        data["escalationReasonCode"] = this.escalationReasonCode;
        return data;
    }
}

export interface IInsuranceEscalateAccountRequest {
    appaccountID?: number;
    mnemonic?: string;
    isEscalate?: boolean;
    escalationReasonCode?: string;
}

export class APIResponseOfListOfInsuranceAuthMatrixResponse implements IAPIResponseOfListOfInsuranceAuthMatrixResponse {
    statusCode?: HttpStatusCode;
    isSuccess?: boolean;
    errorMessages?: string[];
    result?: InsuranceAuthMatrixResponse[] | undefined;

    constructor(data?: IAPIResponseOfListOfInsuranceAuthMatrixResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusCode = _data["statusCode"];
            this.isSuccess = _data["isSuccess"];
            if (Array.isArray(_data["errorMessages"])) {
                this.errorMessages = [] as any;
                for (let item of _data["errorMessages"])
                    this.errorMessages!.push(item);
            }
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result!.push(InsuranceAuthMatrixResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): APIResponseOfListOfInsuranceAuthMatrixResponse {
        data = typeof data === 'object' ? data : {};
        let result = new APIResponseOfListOfInsuranceAuthMatrixResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["isSuccess"] = this.isSuccess;
        if (Array.isArray(this.errorMessages)) {
            data["errorMessages"] = [];
            for (let item of this.errorMessages)
                data["errorMessages"].push(item);
        }
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IAPIResponseOfListOfInsuranceAuthMatrixResponse {
    statusCode?: HttpStatusCode;
    isSuccess?: boolean;
    errorMessages?: string[];
    result?: InsuranceAuthMatrixResponse[] | undefined;
}

export class InsuranceAuthMatrixResponse implements IInsuranceAuthMatrixResponse {
    authStatus?: string;
    authStatusDesc?: string;
    accountTypeCode?: string;
    authType?: string;

    constructor(data?: IInsuranceAuthMatrixResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.authStatus = _data["authStatus"];
            this.authStatusDesc = _data["authStatusDesc"];
            this.accountTypeCode = _data["accountTypeCode"];
            this.authType = _data["authType"];
        }
    }

    static fromJS(data: any): InsuranceAuthMatrixResponse {
        data = typeof data === 'object' ? data : {};
        let result = new InsuranceAuthMatrixResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["authStatus"] = this.authStatus;
        data["authStatusDesc"] = this.authStatusDesc;
        data["accountTypeCode"] = this.accountTypeCode;
        data["authType"] = this.authType;
        return data;
    }
}

export interface IInsuranceAuthMatrixResponse {
    authStatus?: string;
    authStatusDesc?: string;
    accountTypeCode?: string;
    authType?: string;
}

export class UpdateAuthInitiatedRequest implements IUpdateAuthInitiatedRequest {
    appAccountId?: number;
    authInitiatedDate?: Date | undefined;

    constructor(data?: IUpdateAuthInitiatedRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.appAccountId = _data["appAccountId"];
            this.authInitiatedDate = _data["authInitiatedDate"] ? new Date(_data["authInitiatedDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): UpdateAuthInitiatedRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateAuthInitiatedRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["appAccountId"] = this.appAccountId;
        data["authInitiatedDate"] = this.authInitiatedDate ? this.authInitiatedDate.toISOString() : undefined as any;
        return data;
    }
}

export interface IUpdateAuthInitiatedRequest {
    appAccountId?: number;
    authInitiatedDate?: Date | undefined;
}

export class APIResponseOfPatientInstructionsResponse implements IAPIResponseOfPatientInstructionsResponse {
    statusCode?: HttpStatusCode;
    isSuccess?: boolean;
    errorMessages?: string[];
    result?: PatientInstructionsResponse | undefined;

    constructor(data?: IAPIResponseOfPatientInstructionsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusCode = _data["statusCode"];
            this.isSuccess = _data["isSuccess"];
            if (Array.isArray(_data["errorMessages"])) {
                this.errorMessages = [] as any;
                for (let item of _data["errorMessages"])
                    this.errorMessages!.push(item);
            }
            this.result = _data["result"] ? PatientInstructionsResponse.fromJS(_data["result"]) : undefined as any;
        }
    }

    static fromJS(data: any): APIResponseOfPatientInstructionsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new APIResponseOfPatientInstructionsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["isSuccess"] = this.isSuccess;
        if (Array.isArray(this.errorMessages)) {
            data["errorMessages"] = [];
            for (let item of this.errorMessages)
                data["errorMessages"].push(item);
        }
        data["result"] = this.result ? this.result.toJSON() : undefined as any;
        return data;
    }
}

export interface IAPIResponseOfPatientInstructionsResponse {
    statusCode?: HttpStatusCode;
    isSuccess?: boolean;
    errorMessages?: string[];
    result?: PatientInstructionsResponse | undefined;
}

export class PatientInstructionsResponse implements IPatientInstructionsResponse {
    patientInstructions?: string;

    constructor(data?: IPatientInstructionsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.patientInstructions = _data["patientInstructions"];
        }
    }

    static fromJS(data: any): PatientInstructionsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PatientInstructionsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["patientInstructions"] = this.patientInstructions;
        return data;
    }
}

export interface IPatientInstructionsResponse {
    patientInstructions?: string;
}

export class PatientInstructionsDTO implements IPatientInstructionsDTO {
    facilityMnemonic?: string | undefined;
    appointmentLocation?: string | undefined;
    appointmentType?: string | undefined;

    constructor(data?: IPatientInstructionsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.facilityMnemonic = _data["facilityMnemonic"];
            this.appointmentLocation = _data["appointmentLocation"];
            this.appointmentType = _data["appointmentType"];
        }
    }

    static fromJS(data: any): PatientInstructionsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PatientInstructionsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["facilityMnemonic"] = this.facilityMnemonic;
        data["appointmentLocation"] = this.appointmentLocation;
        data["appointmentType"] = this.appointmentType;
        return data;
    }
}

export interface IPatientInstructionsDTO {
    facilityMnemonic?: string | undefined;
    appointmentLocation?: string | undefined;
    appointmentType?: string | undefined;
}

export class AppAccountNoteAddRequest implements IAppAccountNoteAddRequest {
    accountNumber?: string | undefined;
    coid?: number | undefined;
    refNoteTypeId?: number | undefined;
    refNoteActionId?: number | undefined;
    note?: string | undefined;
    hcA34ID?: string | undefined;

    constructor(data?: IAppAccountNoteAddRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountNumber = _data["accountNumber"];
            this.coid = _data["coid"];
            this.refNoteTypeId = _data["refNoteTypeId"];
            this.refNoteActionId = _data["refNoteActionId"];
            this.note = _data["note"];
            this.hcA34ID = _data["hcA34ID"];
        }
    }

    static fromJS(data: any): AppAccountNoteAddRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AppAccountNoteAddRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountNumber"] = this.accountNumber;
        data["coid"] = this.coid;
        data["refNoteTypeId"] = this.refNoteTypeId;
        data["refNoteActionId"] = this.refNoteActionId;
        data["note"] = this.note;
        data["hcA34ID"] = this.hcA34ID;
        return data;
    }
}

export interface IAppAccountNoteAddRequest {
    accountNumber?: string | undefined;
    coid?: number | undefined;
    refNoteTypeId?: number | undefined;
    refNoteActionId?: number | undefined;
    note?: string | undefined;
    hcA34ID?: string | undefined;
}

export class APIResponseOfListOfNoteTypeDTO implements IAPIResponseOfListOfNoteTypeDTO {
    statusCode?: HttpStatusCode;
    isSuccess?: boolean;
    errorMessages?: string[];
    result?: NoteTypeDTO[] | undefined;

    constructor(data?: IAPIResponseOfListOfNoteTypeDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusCode = _data["statusCode"];
            this.isSuccess = _data["isSuccess"];
            if (Array.isArray(_data["errorMessages"])) {
                this.errorMessages = [] as any;
                for (let item of _data["errorMessages"])
                    this.errorMessages!.push(item);
            }
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result!.push(NoteTypeDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): APIResponseOfListOfNoteTypeDTO {
        data = typeof data === 'object' ? data : {};
        let result = new APIResponseOfListOfNoteTypeDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["isSuccess"] = this.isSuccess;
        if (Array.isArray(this.errorMessages)) {
            data["errorMessages"] = [];
            for (let item of this.errorMessages)
                data["errorMessages"].push(item);
        }
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IAPIResponseOfListOfNoteTypeDTO {
    statusCode?: HttpStatusCode;
    isSuccess?: boolean;
    errorMessages?: string[];
    result?: NoteTypeDTO[] | undefined;
}

export class NoteTypeDTO implements INoteTypeDTO {
    refNoteTypeId?: number;
    name?: string | undefined;
    description?: string | undefined;
    active?: boolean;
    createdBy?: string | undefined;
    createdDateUtc?: Date | undefined;
    modifiedBy?: string | undefined;
    modifiedDateUtc?: Date | undefined;

    constructor(data?: INoteTypeDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.refNoteTypeId = _data["refNoteTypeId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.active = _data["active"];
            this.createdBy = _data["createdBy"];
            this.createdDateUtc = _data["createdDateUtc"] ? new Date(_data["createdDateUtc"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            this.modifiedDateUtc = _data["modifiedDateUtc"] ? new Date(_data["modifiedDateUtc"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): NoteTypeDTO {
        data = typeof data === 'object' ? data : {};
        let result = new NoteTypeDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["refNoteTypeId"] = this.refNoteTypeId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["active"] = this.active;
        data["createdBy"] = this.createdBy;
        data["createdDateUtc"] = this.createdDateUtc ? this.createdDateUtc.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        data["modifiedDateUtc"] = this.modifiedDateUtc ? this.modifiedDateUtc.toISOString() : undefined as any;
        return data;
    }
}

export interface INoteTypeDTO {
    refNoteTypeId?: number;
    name?: string | undefined;
    description?: string | undefined;
    active?: boolean;
    createdBy?: string | undefined;
    createdDateUtc?: Date | undefined;
    modifiedBy?: string | undefined;
    modifiedDateUtc?: Date | undefined;
}

export class APIResponseOfListOfNoteActionDTO implements IAPIResponseOfListOfNoteActionDTO {
    statusCode?: HttpStatusCode;
    isSuccess?: boolean;
    errorMessages?: string[];
    result?: NoteActionDTO[] | undefined;

    constructor(data?: IAPIResponseOfListOfNoteActionDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusCode = _data["statusCode"];
            this.isSuccess = _data["isSuccess"];
            if (Array.isArray(_data["errorMessages"])) {
                this.errorMessages = [] as any;
                for (let item of _data["errorMessages"])
                    this.errorMessages!.push(item);
            }
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result!.push(NoteActionDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): APIResponseOfListOfNoteActionDTO {
        data = typeof data === 'object' ? data : {};
        let result = new APIResponseOfListOfNoteActionDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["isSuccess"] = this.isSuccess;
        if (Array.isArray(this.errorMessages)) {
            data["errorMessages"] = [];
            for (let item of this.errorMessages)
                data["errorMessages"].push(item);
        }
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IAPIResponseOfListOfNoteActionDTO {
    statusCode?: HttpStatusCode;
    isSuccess?: boolean;
    errorMessages?: string[];
    result?: NoteActionDTO[] | undefined;
}

export class NoteActionDTO implements INoteActionDTO {
    refNoteActionId?: number;
    refNoteTypeId?: number | undefined;
    name?: string | undefined;
    description?: string | undefined;
    active?: boolean;
    createdBy?: string | undefined;
    createdDateUtc?: Date | undefined;
    modifiedBy?: string | undefined;
    modifiedDateUtc?: Date | undefined;
    deafultMessageNote?: string | undefined;

    constructor(data?: INoteActionDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.refNoteActionId = _data["refNoteActionId"];
            this.refNoteTypeId = _data["refNoteTypeId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.active = _data["active"];
            this.createdBy = _data["createdBy"];
            this.createdDateUtc = _data["createdDateUtc"] ? new Date(_data["createdDateUtc"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            this.modifiedDateUtc = _data["modifiedDateUtc"] ? new Date(_data["modifiedDateUtc"].toString()) : undefined as any;
            this.deafultMessageNote = _data["deafultMessageNote"];
        }
    }

    static fromJS(data: any): NoteActionDTO {
        data = typeof data === 'object' ? data : {};
        let result = new NoteActionDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["refNoteActionId"] = this.refNoteActionId;
        data["refNoteTypeId"] = this.refNoteTypeId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["active"] = this.active;
        data["createdBy"] = this.createdBy;
        data["createdDateUtc"] = this.createdDateUtc ? this.createdDateUtc.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        data["modifiedDateUtc"] = this.modifiedDateUtc ? this.modifiedDateUtc.toISOString() : undefined as any;
        data["deafultMessageNote"] = this.deafultMessageNote;
        return data;
    }
}

export interface INoteActionDTO {
    refNoteActionId?: number;
    refNoteTypeId?: number | undefined;
    name?: string | undefined;
    description?: string | undefined;
    active?: boolean;
    createdBy?: string | undefined;
    createdDateUtc?: Date | undefined;
    modifiedBy?: string | undefined;
    modifiedDateUtc?: Date | undefined;
    deafultMessageNote?: string | undefined;
}

export class APIResponseOfListOfNoteDetailsResponse implements IAPIResponseOfListOfNoteDetailsResponse {
    statusCode?: HttpStatusCode;
    isSuccess?: boolean;
    errorMessages?: string[];
    result?: NoteDetailsResponse[] | undefined;

    constructor(data?: IAPIResponseOfListOfNoteDetailsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusCode = _data["statusCode"];
            this.isSuccess = _data["isSuccess"];
            if (Array.isArray(_data["errorMessages"])) {
                this.errorMessages = [] as any;
                for (let item of _data["errorMessages"])
                    this.errorMessages!.push(item);
            }
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result!.push(NoteDetailsResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): APIResponseOfListOfNoteDetailsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new APIResponseOfListOfNoteDetailsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["isSuccess"] = this.isSuccess;
        if (Array.isArray(this.errorMessages)) {
            data["errorMessages"] = [];
            for (let item of this.errorMessages)
                data["errorMessages"].push(item);
        }
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IAPIResponseOfListOfNoteDetailsResponse {
    statusCode?: HttpStatusCode;
    isSuccess?: boolean;
    errorMessages?: string[];
    result?: NoteDetailsResponse[] | undefined;
}

export class NoteDetailsResponse implements INoteDetailsResponse {
    noteType?: string | undefined;
    noteAction?: string | undefined;
    accountNotes?: string | undefined;
    noteby?: string | undefined;
    noteDateTime?: string | undefined;

    constructor(data?: INoteDetailsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.noteType = _data["noteType"];
            this.noteAction = _data["noteAction"];
            this.accountNotes = _data["accountNotes"];
            this.noteby = _data["noteby"];
            this.noteDateTime = _data["noteDateTime"];
        }
    }

    static fromJS(data: any): NoteDetailsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new NoteDetailsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["noteType"] = this.noteType;
        data["noteAction"] = this.noteAction;
        data["accountNotes"] = this.accountNotes;
        data["noteby"] = this.noteby;
        data["noteDateTime"] = this.noteDateTime;
        return data;
    }
}

export interface INoteDetailsResponse {
    noteType?: string | undefined;
    noteAction?: string | undefined;
    accountNotes?: string | undefined;
    noteby?: string | undefined;
    noteDateTime?: string | undefined;
}

export class NoteDetailsRequest implements INoteDetailsRequest {
    accountNumber?: string;
    coid?: number;
    sortColumn?: string | undefined;
    sortDir?: string | undefined;
    page?: number | undefined;
    pageSize?: number | undefined;

    constructor(data?: INoteDetailsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountNumber = _data["accountNumber"];
            this.coid = _data["coid"];
            this.sortColumn = _data["sortColumn"];
            this.sortDir = _data["sortDir"];
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
        }
    }

    static fromJS(data: any): NoteDetailsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new NoteDetailsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountNumber"] = this.accountNumber;
        data["coid"] = this.coid;
        data["sortColumn"] = this.sortColumn;
        data["sortDir"] = this.sortDir;
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        return data;
    }
}

export interface INoteDetailsRequest {
    accountNumber?: string;
    coid?: number;
    sortColumn?: string | undefined;
    sortDir?: string | undefined;
    page?: number | undefined;
    pageSize?: number | undefined;
}

export class APIResponseOfNoteDetailsCount implements IAPIResponseOfNoteDetailsCount {
    statusCode?: HttpStatusCode;
    isSuccess?: boolean;
    errorMessages?: string[];
    result?: NoteDetailsCount | undefined;

    constructor(data?: IAPIResponseOfNoteDetailsCount) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusCode = _data["statusCode"];
            this.isSuccess = _data["isSuccess"];
            if (Array.isArray(_data["errorMessages"])) {
                this.errorMessages = [] as any;
                for (let item of _data["errorMessages"])
                    this.errorMessages!.push(item);
            }
            this.result = _data["result"] ? NoteDetailsCount.fromJS(_data["result"]) : undefined as any;
        }
    }

    static fromJS(data: any): APIResponseOfNoteDetailsCount {
        data = typeof data === 'object' ? data : {};
        let result = new APIResponseOfNoteDetailsCount();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["isSuccess"] = this.isSuccess;
        if (Array.isArray(this.errorMessages)) {
            data["errorMessages"] = [];
            for (let item of this.errorMessages)
                data["errorMessages"].push(item);
        }
        data["result"] = this.result ? this.result.toJSON() : undefined as any;
        return data;
    }
}

export interface IAPIResponseOfNoteDetailsCount {
    statusCode?: HttpStatusCode;
    isSuccess?: boolean;
    errorMessages?: string[];
    result?: NoteDetailsCount | undefined;
}

export class NoteDetailsCount implements INoteDetailsCount {
    totalCount?: number;

    constructor(data?: INoteDetailsCount) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): NoteDetailsCount {
        data = typeof data === 'object' ? data : {};
        let result = new NoteDetailsCount();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface INoteDetailsCount {
    totalCount?: number;
}

export class NoteTypeRequest implements INoteTypeRequest {
    refNoteTypeId?: number | undefined;

    constructor(data?: INoteTypeRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.refNoteTypeId = _data["refNoteTypeId"];
        }
    }

    static fromJS(data: any): NoteTypeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new NoteTypeRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["refNoteTypeId"] = this.refNoteTypeId;
        return data;
    }
}

export interface INoteTypeRequest {
    refNoteTypeId?: number | undefined;
}

export class APIResponseOfListOfUserSearchDTO implements IAPIResponseOfListOfUserSearchDTO {
    statusCode?: HttpStatusCode;
    isSuccess?: boolean;
    errorMessages?: string[];
    result?: UserSearchDTO[] | undefined;

    constructor(data?: IAPIResponseOfListOfUserSearchDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusCode = _data["statusCode"];
            this.isSuccess = _data["isSuccess"];
            if (Array.isArray(_data["errorMessages"])) {
                this.errorMessages = [] as any;
                for (let item of _data["errorMessages"])
                    this.errorMessages!.push(item);
            }
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result!.push(UserSearchDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): APIResponseOfListOfUserSearchDTO {
        data = typeof data === 'object' ? data : {};
        let result = new APIResponseOfListOfUserSearchDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["isSuccess"] = this.isSuccess;
        if (Array.isArray(this.errorMessages)) {
            data["errorMessages"] = [];
            for (let item of this.errorMessages)
                data["errorMessages"].push(item);
        }
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IAPIResponseOfListOfUserSearchDTO {
    statusCode?: HttpStatusCode;
    isSuccess?: boolean;
    errorMessages?: string[];
    result?: UserSearchDTO[] | undefined;
}

export class UserSearchDTO implements IUserSearchDTO {
    appUserId?: number;
    hcA34ID?: string;
    firstName?: string;
    lastName?: string;
    displayName?: string;

    constructor(data?: IUserSearchDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.appUserId = _data["appUserId"];
            this.hcA34ID = _data["hcA34ID"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): UserSearchDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UserSearchDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["appUserId"] = this.appUserId;
        data["hcA34ID"] = this.hcA34ID;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface IUserSearchDTO {
    appUserId?: number;
    hcA34ID?: string;
    firstName?: string;
    lastName?: string;
    displayName?: string;
}

export class APIResponseOfListOfUserPermissionDTO implements IAPIResponseOfListOfUserPermissionDTO {
    statusCode?: HttpStatusCode;
    isSuccess?: boolean;
    errorMessages?: string[];
    result?: UserPermissionDTO[] | undefined;

    constructor(data?: IAPIResponseOfListOfUserPermissionDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusCode = _data["statusCode"];
            this.isSuccess = _data["isSuccess"];
            if (Array.isArray(_data["errorMessages"])) {
                this.errorMessages = [] as any;
                for (let item of _data["errorMessages"])
                    this.errorMessages!.push(item);
            }
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result!.push(UserPermissionDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): APIResponseOfListOfUserPermissionDTO {
        data = typeof data === 'object' ? data : {};
        let result = new APIResponseOfListOfUserPermissionDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["isSuccess"] = this.isSuccess;
        if (Array.isArray(this.errorMessages)) {
            data["errorMessages"] = [];
            for (let item of this.errorMessages)
                data["errorMessages"].push(item);
        }
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IAPIResponseOfListOfUserPermissionDTO {
    statusCode?: HttpStatusCode;
    isSuccess?: boolean;
    errorMessages?: string[];
    result?: UserPermissionDTO[] | undefined;
}

export class APIResponseOfListOfUserInformationDTO implements IAPIResponseOfListOfUserInformationDTO {
    statusCode?: HttpStatusCode;
    isSuccess?: boolean;
    errorMessages?: string[];
    result?: UserInformationDTO[] | undefined;

    constructor(data?: IAPIResponseOfListOfUserInformationDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusCode = _data["statusCode"];
            this.isSuccess = _data["isSuccess"];
            if (Array.isArray(_data["errorMessages"])) {
                this.errorMessages = [] as any;
                for (let item of _data["errorMessages"])
                    this.errorMessages!.push(item);
            }
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result!.push(UserInformationDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): APIResponseOfListOfUserInformationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new APIResponseOfListOfUserInformationDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["isSuccess"] = this.isSuccess;
        if (Array.isArray(this.errorMessages)) {
            data["errorMessages"] = [];
            for (let item of this.errorMessages)
                data["errorMessages"].push(item);
        }
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IAPIResponseOfListOfUserInformationDTO {
    statusCode?: HttpStatusCode;
    isSuccess?: boolean;
    errorMessages?: string[];
    result?: UserInformationDTO[] | undefined;
}

export class UserInformationDTO implements IUserInformationDTO {
    userName?: string | undefined;
    hcA34ID?: string | undefined;
    role?: string | undefined;
    workflowName?: string | undefined;
    dateAdded?: Date;
    status?: boolean;
    totalRows?: number;

    constructor(data?: IUserInformationDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userName = _data["userName"];
            this.hcA34ID = _data["hcA34ID"];
            this.role = _data["role"];
            this.workflowName = _data["workflowName"];
            this.dateAdded = _data["dateAdded"] ? new Date(_data["dateAdded"].toString()) : undefined as any;
            this.status = _data["status"];
            this.totalRows = _data["totalRows"];
        }
    }

    static fromJS(data: any): UserInformationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UserInformationDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName;
        data["hcA34ID"] = this.hcA34ID;
        data["role"] = this.role;
        data["workflowName"] = this.workflowName;
        data["dateAdded"] = this.dateAdded ? this.dateAdded.toISOString() : undefined as any;
        data["status"] = this.status;
        data["totalRows"] = this.totalRows;
        return data;
    }
}

export interface IUserInformationDTO {
    userName?: string | undefined;
    hcA34ID?: string | undefined;
    role?: string | undefined;
    workflowName?: string | undefined;
    dateAdded?: Date;
    status?: boolean;
    totalRows?: number;
}

export class UserInformationListRequest implements IUserInformationListRequest {
    status?: boolean | undefined;
    userName?: string | undefined;
    role?: string | undefined;
    workFlow?: string | undefined;
    sortColumn?: string;
    sortDir?: string;
    pageNumber?: number;
    pageSize?: number;

    constructor(data?: IUserInformationListRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.userName = _data["userName"];
            this.role = _data["role"];
            this.workFlow = _data["workFlow"];
            this.sortColumn = _data["sortColumn"];
            this.sortDir = _data["sortDir"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
        }
    }

    static fromJS(data: any): UserInformationListRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UserInformationListRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["userName"] = this.userName;
        data["role"] = this.role;
        data["workFlow"] = this.workFlow;
        data["sortColumn"] = this.sortColumn;
        data["sortDir"] = this.sortDir;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        return data;
    }
}

export interface IUserInformationListRequest {
    status?: boolean | undefined;
    userName?: string | undefined;
    role?: string | undefined;
    workFlow?: string | undefined;
    sortColumn?: string;
    sortDir?: string;
    pageNumber?: number;
    pageSize?: number;
}

export class APIResponseOfListOfAssignUserDTO implements IAPIResponseOfListOfAssignUserDTO {
    statusCode?: HttpStatusCode;
    isSuccess?: boolean;
    errorMessages?: string[];
    result?: AssignUserDTO[] | undefined;

    constructor(data?: IAPIResponseOfListOfAssignUserDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusCode = _data["statusCode"];
            this.isSuccess = _data["isSuccess"];
            if (Array.isArray(_data["errorMessages"])) {
                this.errorMessages = [] as any;
                for (let item of _data["errorMessages"])
                    this.errorMessages!.push(item);
            }
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result!.push(AssignUserDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): APIResponseOfListOfAssignUserDTO {
        data = typeof data === 'object' ? data : {};
        let result = new APIResponseOfListOfAssignUserDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["isSuccess"] = this.isSuccess;
        if (Array.isArray(this.errorMessages)) {
            data["errorMessages"] = [];
            for (let item of this.errorMessages)
                data["errorMessages"].push(item);
        }
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IAPIResponseOfListOfAssignUserDTO {
    statusCode?: HttpStatusCode;
    isSuccess?: boolean;
    errorMessages?: string[];
    result?: AssignUserDTO[] | undefined;
}

export class AssignUserDTO implements IAssignUserDTO {
    appUserId?: number;
    displayName?: string;

    constructor(data?: IAssignUserDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.appUserId = _data["appUserId"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): AssignUserDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AssignUserDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["appUserId"] = this.appUserId;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface IAssignUserDTO {
    appUserId?: number;
    displayName?: string;
}

export class APIResponseOfCommonConfiguration implements IAPIResponseOfCommonConfiguration {
    statusCode?: HttpStatusCode;
    isSuccess?: boolean;
    errorMessages?: string[];
    result?: CommonConfiguration | undefined;

    constructor(data?: IAPIResponseOfCommonConfiguration) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusCode = _data["statusCode"];
            this.isSuccess = _data["isSuccess"];
            if (Array.isArray(_data["errorMessages"])) {
                this.errorMessages = [] as any;
                for (let item of _data["errorMessages"])
                    this.errorMessages!.push(item);
            }
            this.result = _data["result"] ? CommonConfiguration.fromJS(_data["result"]) : undefined as any;
        }
    }

    static fromJS(data: any): APIResponseOfCommonConfiguration {
        data = typeof data === 'object' ? data : {};
        let result = new APIResponseOfCommonConfiguration();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["isSuccess"] = this.isSuccess;
        if (Array.isArray(this.errorMessages)) {
            data["errorMessages"] = [];
            for (let item of this.errorMessages)
                data["errorMessages"].push(item);
        }
        data["result"] = this.result ? this.result.toJSON() : undefined as any;
        return data;
    }
}

export interface IAPIResponseOfCommonConfiguration {
    statusCode?: HttpStatusCode;
    isSuccess?: boolean;
    errorMessages?: string[];
    result?: CommonConfiguration | undefined;
}

export class CommonConfiguration implements ICommonConfiguration {
    accountLockDuration?: number;
    useEntra?: boolean;
    appointmentReminderEmailEnabled?: boolean;
    appointmentReminderEmailDebug?: boolean;

    constructor(data?: ICommonConfiguration) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountLockDuration = _data["accountLockDuration"];
            this.useEntra = _data["useEntra"];
            this.appointmentReminderEmailEnabled = _data["appointmentReminderEmailEnabled"];
            this.appointmentReminderEmailDebug = _data["appointmentReminderEmailDebug"];
        }
    }

    static fromJS(data: any): CommonConfiguration {
        data = typeof data === 'object' ? data : {};
        let result = new CommonConfiguration();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountLockDuration"] = this.accountLockDuration;
        data["useEntra"] = this.useEntra;
        data["appointmentReminderEmailEnabled"] = this.appointmentReminderEmailEnabled;
        data["appointmentReminderEmailDebug"] = this.appointmentReminderEmailDebug;
        return data;
    }
}

export interface ICommonConfiguration {
    accountLockDuration?: number;
    useEntra?: boolean;
    appointmentReminderEmailEnabled?: boolean;
    appointmentReminderEmailDebug?: boolean;
}

export class APIResponseOfCCaaSsearchAccountResponse implements IAPIResponseOfCCaaSsearchAccountResponse {
    statusCode?: HttpStatusCode;
    isSuccess?: boolean;
    errorMessages?: string[];
    result?: CCaaSsearchAccountResponse | undefined;

    constructor(data?: IAPIResponseOfCCaaSsearchAccountResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusCode = _data["statusCode"];
            this.isSuccess = _data["isSuccess"];
            if (Array.isArray(_data["errorMessages"])) {
                this.errorMessages = [] as any;
                for (let item of _data["errorMessages"])
                    this.errorMessages!.push(item);
            }
            this.result = _data["result"] ? CCaaSsearchAccountResponse.fromJS(_data["result"]) : undefined as any;
        }
    }

    static fromJS(data: any): APIResponseOfCCaaSsearchAccountResponse {
        data = typeof data === 'object' ? data : {};
        let result = new APIResponseOfCCaaSsearchAccountResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["isSuccess"] = this.isSuccess;
        if (Array.isArray(this.errorMessages)) {
            data["errorMessages"] = [];
            for (let item of this.errorMessages)
                data["errorMessages"].push(item);
        }
        data["result"] = this.result ? this.result.toJSON() : undefined as any;
        return data;
    }
}

export interface IAPIResponseOfCCaaSsearchAccountResponse {
    statusCode?: HttpStatusCode;
    isSuccess?: boolean;
    errorMessages?: string[];
    result?: CCaaSsearchAccountResponse | undefined;
}

export class CCaaSsearchAccountResponse implements ICCaaSsearchAccountResponse {
    userDemographics?: CCaaSAccountSearchDTO[] | undefined;

    constructor(data?: ICCaaSsearchAccountResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["userDemographics"])) {
                this.userDemographics = [] as any;
                for (let item of _data["userDemographics"])
                    this.userDemographics!.push(CCaaSAccountSearchDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CCaaSsearchAccountResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CCaaSsearchAccountResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.userDemographics)) {
            data["userDemographics"] = [];
            for (let item of this.userDemographics)
                data["userDemographics"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ICCaaSsearchAccountResponse {
    userDemographics?: CCaaSAccountSearchDTO[] | undefined;
}

export class CCaaSAccountSearchDTO implements ICCaaSAccountSearchDTO {
    accountGUID?: string;
    accountnumber?: string;
    firstname?: string | undefined;
    lastname?: string | undefined;
    gender?: string | undefined;
    birthDate?: string | undefined;
    medicalRecordNumber?: string | undefined;
    street?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    statecode?: string | undefined;
    country?: string | undefined;
    last4SSN?: string | undefined;
    coid?: number | undefined;
    facilityName?: string | undefined;
    zip?: string | undefined;
    appointment?: Appointment[] | undefined;

    constructor(data?: ICCaaSAccountSearchDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountGUID = _data["accountGUID"];
            this.accountnumber = _data["accountnumber"];
            this.firstname = _data["firstname"];
            this.lastname = _data["lastname"];
            this.gender = _data["gender"];
            this.birthDate = _data["birthDate"];
            this.medicalRecordNumber = _data["medicalRecordNumber"];
            this.street = _data["street"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.statecode = _data["statecode"];
            this.country = _data["country"];
            this.last4SSN = _data["last4SSN"];
            this.coid = _data["coid"];
            this.facilityName = _data["facilityName"];
            this.zip = _data["zip"];
            if (Array.isArray(_data["appointment"])) {
                this.appointment = [] as any;
                for (let item of _data["appointment"])
                    this.appointment!.push(Appointment.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CCaaSAccountSearchDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CCaaSAccountSearchDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountGUID"] = this.accountGUID;
        data["accountnumber"] = this.accountnumber;
        data["firstname"] = this.firstname;
        data["lastname"] = this.lastname;
        data["gender"] = this.gender;
        data["birthDate"] = this.birthDate;
        data["medicalRecordNumber"] = this.medicalRecordNumber;
        data["street"] = this.street;
        data["city"] = this.city;
        data["state"] = this.state;
        data["statecode"] = this.statecode;
        data["country"] = this.country;
        data["last4SSN"] = this.last4SSN;
        data["coid"] = this.coid;
        data["facilityName"] = this.facilityName;
        data["zip"] = this.zip;
        if (Array.isArray(this.appointment)) {
            data["appointment"] = [];
            for (let item of this.appointment)
                data["appointment"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ICCaaSAccountSearchDTO {
    accountGUID?: string;
    accountnumber?: string;
    firstname?: string | undefined;
    lastname?: string | undefined;
    gender?: string | undefined;
    birthDate?: string | undefined;
    medicalRecordNumber?: string | undefined;
    street?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    statecode?: string | undefined;
    country?: string | undefined;
    last4SSN?: string | undefined;
    coid?: number | undefined;
    facilityName?: string | undefined;
    zip?: string | undefined;
    appointment?: Appointment[] | undefined;
}

export class Appointment implements IAppointment {
    appointmentType?: string | undefined;
    appointmentStatus?: string | undefined;
    appointmentDate?: Date | undefined;
    appointmentTime?: string | undefined;
    appointmentDescription?: string | undefined;

    constructor(data?: IAppointment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.appointmentType = _data["appointmentType"];
            this.appointmentStatus = _data["appointmentStatus"];
            this.appointmentDate = _data["appointmentDate"] ? new Date(_data["appointmentDate"].toString()) : undefined as any;
            this.appointmentTime = _data["appointmentTime"];
            this.appointmentDescription = _data["appointmentDescription"];
        }
    }

    static fromJS(data: any): Appointment {
        data = typeof data === 'object' ? data : {};
        let result = new Appointment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["appointmentType"] = this.appointmentType;
        data["appointmentStatus"] = this.appointmentStatus;
        data["appointmentDate"] = this.appointmentDate ? this.appointmentDate.toISOString() : undefined as any;
        data["appointmentTime"] = this.appointmentTime;
        data["appointmentDescription"] = this.appointmentDescription;
        return data;
    }
}

export interface IAppointment {
    appointmentType?: string | undefined;
    appointmentStatus?: string | undefined;
    appointmentDate?: Date | undefined;
    appointmentTime?: string | undefined;
    appointmentDescription?: string | undefined;
}

export class APIResponseOfCCaaSsearchAppointmentResponse implements IAPIResponseOfCCaaSsearchAppointmentResponse {
    statusCode?: HttpStatusCode;
    isSuccess?: boolean;
    errorMessages?: string[];
    result?: CCaaSsearchAppointmentResponse | undefined;

    constructor(data?: IAPIResponseOfCCaaSsearchAppointmentResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusCode = _data["statusCode"];
            this.isSuccess = _data["isSuccess"];
            if (Array.isArray(_data["errorMessages"])) {
                this.errorMessages = [] as any;
                for (let item of _data["errorMessages"])
                    this.errorMessages!.push(item);
            }
            this.result = _data["result"] ? CCaaSsearchAppointmentResponse.fromJS(_data["result"]) : undefined as any;
        }
    }

    static fromJS(data: any): APIResponseOfCCaaSsearchAppointmentResponse {
        data = typeof data === 'object' ? data : {};
        let result = new APIResponseOfCCaaSsearchAppointmentResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["isSuccess"] = this.isSuccess;
        if (Array.isArray(this.errorMessages)) {
            data["errorMessages"] = [];
            for (let item of this.errorMessages)
                data["errorMessages"].push(item);
        }
        data["result"] = this.result ? this.result.toJSON() : undefined as any;
        return data;
    }
}

export interface IAPIResponseOfCCaaSsearchAppointmentResponse {
    statusCode?: HttpStatusCode;
    isSuccess?: boolean;
    errorMessages?: string[];
    result?: CCaaSsearchAppointmentResponse | undefined;
}

export class CCaaSsearchAppointmentResponse implements ICCaaSsearchAppointmentResponse {
    searchAppointmentResponse?: CCaaSSearchAppointmentDTO[] | undefined;

    constructor(data?: ICCaaSsearchAppointmentResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["searchAppointmentResponse"])) {
                this.searchAppointmentResponse = [] as any;
                for (let item of _data["searchAppointmentResponse"])
                    this.searchAppointmentResponse!.push(CCaaSSearchAppointmentDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CCaaSsearchAppointmentResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CCaaSsearchAppointmentResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.searchAppointmentResponse)) {
            data["searchAppointmentResponse"] = [];
            for (let item of this.searchAppointmentResponse)
                data["searchAppointmentResponse"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ICCaaSsearchAppointmentResponse {
    searchAppointmentResponse?: CCaaSSearchAppointmentDTO[] | undefined;
}

export class CCaaSSearchAppointmentDTO implements ICCaaSSearchAppointmentDTO {
    appointmentType?: string | undefined;
    appointmentStatus?: string | undefined;
    appointmentDate?: Date | undefined;
    appointmentTime?: string | undefined;

    constructor(data?: ICCaaSSearchAppointmentDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.appointmentType = _data["appointmentType"];
            this.appointmentStatus = _data["appointmentStatus"];
            this.appointmentDate = _data["appointmentDate"] ? new Date(_data["appointmentDate"].toString()) : undefined as any;
            this.appointmentTime = _data["appointmentTime"];
        }
    }

    static fromJS(data: any): CCaaSSearchAppointmentDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CCaaSSearchAppointmentDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["appointmentType"] = this.appointmentType;
        data["appointmentStatus"] = this.appointmentStatus;
        data["appointmentDate"] = this.appointmentDate ? this.appointmentDate.toISOString() : undefined as any;
        data["appointmentTime"] = this.appointmentTime;
        return data;
    }
}

export interface ICCaaSSearchAppointmentDTO {
    appointmentType?: string | undefined;
    appointmentStatus?: string | undefined;
    appointmentDate?: Date | undefined;
    appointmentTime?: string | undefined;
}

export class APIResponseOfCCaaSSearchAccountDemographicsResponse implements IAPIResponseOfCCaaSSearchAccountDemographicsResponse {
    statusCode?: HttpStatusCode;
    isSuccess?: boolean;
    errorMessages?: string[];
    result?: CCaaSSearchAccountDemographicsResponse | undefined;

    constructor(data?: IAPIResponseOfCCaaSSearchAccountDemographicsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusCode = _data["statusCode"];
            this.isSuccess = _data["isSuccess"];
            if (Array.isArray(_data["errorMessages"])) {
                this.errorMessages = [] as any;
                for (let item of _data["errorMessages"])
                    this.errorMessages!.push(item);
            }
            this.result = _data["result"] ? CCaaSSearchAccountDemographicsResponse.fromJS(_data["result"]) : undefined as any;
        }
    }

    static fromJS(data: any): APIResponseOfCCaaSSearchAccountDemographicsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new APIResponseOfCCaaSSearchAccountDemographicsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["isSuccess"] = this.isSuccess;
        if (Array.isArray(this.errorMessages)) {
            data["errorMessages"] = [];
            for (let item of this.errorMessages)
                data["errorMessages"].push(item);
        }
        data["result"] = this.result ? this.result.toJSON() : undefined as any;
        return data;
    }
}

export interface IAPIResponseOfCCaaSSearchAccountDemographicsResponse {
    statusCode?: HttpStatusCode;
    isSuccess?: boolean;
    errorMessages?: string[];
    result?: CCaaSSearchAccountDemographicsResponse | undefined;
}

export class CCaaSSearchAccountDemographicsResponse implements ICCaaSSearchAccountDemographicsResponse {
    accountDemographics?: AccountDemographics[];

    constructor(data?: ICCaaSSearchAccountDemographicsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["accountDemographics"])) {
                this.accountDemographics = [] as any;
                for (let item of _data["accountDemographics"])
                    this.accountDemographics!.push(AccountDemographics.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CCaaSSearchAccountDemographicsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CCaaSSearchAccountDemographicsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.accountDemographics)) {
            data["accountDemographics"] = [];
            for (let item of this.accountDemographics)
                data["accountDemographics"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ICCaaSSearchAccountDemographicsResponse {
    accountDemographics?: AccountDemographics[];
}

export class AccountDemographics implements IAccountDemographics {
    accountGUID?: string;
    accountnumber?: string | undefined;
    firstname?: string | undefined;
    lastname?: string | undefined;
    gender?: string | undefined;
    birthDate?: string | undefined;
    medicalRecordNumber?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    statecode?: string | undefined;
    country?: string | undefined;
    last4SSN?: string | undefined;

    constructor(data?: IAccountDemographics) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountGUID = _data["accountGUID"];
            this.accountnumber = _data["accountnumber"];
            this.firstname = _data["firstname"];
            this.lastname = _data["lastname"];
            this.gender = _data["gender"];
            this.birthDate = _data["birthDate"];
            this.medicalRecordNumber = _data["medicalRecordNumber"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.statecode = _data["statecode"];
            this.country = _data["country"];
            this.last4SSN = _data["last4SSN"];
        }
    }

    static fromJS(data: any): AccountDemographics {
        data = typeof data === 'object' ? data : {};
        let result = new AccountDemographics();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountGUID"] = this.accountGUID;
        data["accountnumber"] = this.accountnumber;
        data["firstname"] = this.firstname;
        data["lastname"] = this.lastname;
        data["gender"] = this.gender;
        data["birthDate"] = this.birthDate;
        data["medicalRecordNumber"] = this.medicalRecordNumber;
        data["city"] = this.city;
        data["state"] = this.state;
        data["statecode"] = this.statecode;
        data["country"] = this.country;
        data["last4SSN"] = this.last4SSN;
        return data;
    }
}

export interface IAccountDemographics {
    accountGUID?: string;
    accountnumber?: string | undefined;
    firstname?: string | undefined;
    lastname?: string | undefined;
    gender?: string | undefined;
    birthDate?: string | undefined;
    medicalRecordNumber?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    statecode?: string | undefined;
    country?: string | undefined;
    last4SSN?: string | undefined;
}

export class CCaaSSearchAccountDemographicsRequest implements ICCaaSSearchAccountDemographicsRequest {
    phoneNumber?: string | undefined;
    dob?: string | undefined;
    last4SSN?: string | undefined;
    accountGUID?: string | undefined;
    conversationID?: string | undefined;

    constructor(data?: ICCaaSSearchAccountDemographicsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.phoneNumber = _data["phoneNumber"];
            this.dob = _data["dob"];
            this.last4SSN = _data["last4SSN"];
            this.accountGUID = _data["accountGUID"];
            this.conversationID = _data["conversationID"];
        }
    }

    static fromJS(data: any): CCaaSSearchAccountDemographicsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CCaaSSearchAccountDemographicsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["phoneNumber"] = this.phoneNumber;
        data["dob"] = this.dob;
        data["last4SSN"] = this.last4SSN;
        data["accountGUID"] = this.accountGUID;
        data["conversationID"] = this.conversationID;
        return data;
    }
}

export interface ICCaaSSearchAccountDemographicsRequest {
    phoneNumber?: string | undefined;
    dob?: string | undefined;
    last4SSN?: string | undefined;
    accountGUID?: string | undefined;
    conversationID?: string | undefined;
}

export class APIResponseOfListOfRefServiceCenterDTO implements IAPIResponseOfListOfRefServiceCenterDTO {
    statusCode?: HttpStatusCode;
    isSuccess?: boolean;
    errorMessages?: string[];
    result?: RefServiceCenterDTO[] | undefined;

    constructor(data?: IAPIResponseOfListOfRefServiceCenterDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusCode = _data["statusCode"];
            this.isSuccess = _data["isSuccess"];
            if (Array.isArray(_data["errorMessages"])) {
                this.errorMessages = [] as any;
                for (let item of _data["errorMessages"])
                    this.errorMessages!.push(item);
            }
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result!.push(RefServiceCenterDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): APIResponseOfListOfRefServiceCenterDTO {
        data = typeof data === 'object' ? data : {};
        let result = new APIResponseOfListOfRefServiceCenterDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["isSuccess"] = this.isSuccess;
        if (Array.isArray(this.errorMessages)) {
            data["errorMessages"] = [];
            for (let item of this.errorMessages)
                data["errorMessages"].push(item);
        }
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IAPIResponseOfListOfRefServiceCenterDTO {
    statusCode?: HttpStatusCode;
    isSuccess?: boolean;
    errorMessages?: string[];
    result?: RefServiceCenterDTO[] | undefined;
}

export class RefServiceCenterDTO implements IRefServiceCenterDTO {
    refServiceCenterId?: number;
    name?: string;
    description?: string | undefined;
    active?: boolean;

    constructor(data?: IRefServiceCenterDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.refServiceCenterId = _data["refServiceCenterId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.active = _data["active"];
        }
    }

    static fromJS(data: any): RefServiceCenterDTO {
        data = typeof data === 'object' ? data : {};
        let result = new RefServiceCenterDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["refServiceCenterId"] = this.refServiceCenterId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["active"] = this.active;
        return data;
    }
}

export interface IRefServiceCenterDTO {
    refServiceCenterId?: number;
    name?: string;
    description?: string | undefined;
    active?: boolean;
}

export class APIResponseOfWorkFlowDataResponse implements IAPIResponseOfWorkFlowDataResponse {
    statusCode?: HttpStatusCode;
    isSuccess?: boolean;
    errorMessages?: string[];
    result?: WorkFlowDataResponse | undefined;

    constructor(data?: IAPIResponseOfWorkFlowDataResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusCode = _data["statusCode"];
            this.isSuccess = _data["isSuccess"];
            if (Array.isArray(_data["errorMessages"])) {
                this.errorMessages = [] as any;
                for (let item of _data["errorMessages"])
                    this.errorMessages!.push(item);
            }
            this.result = _data["result"] ? WorkFlowDataResponse.fromJS(_data["result"]) : undefined as any;
        }
    }

    static fromJS(data: any): APIResponseOfWorkFlowDataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new APIResponseOfWorkFlowDataResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["isSuccess"] = this.isSuccess;
        if (Array.isArray(this.errorMessages)) {
            data["errorMessages"] = [];
            for (let item of this.errorMessages)
                data["errorMessages"].push(item);
        }
        data["result"] = this.result ? this.result.toJSON() : undefined as any;
        return data;
    }
}

export interface IAPIResponseOfWorkFlowDataResponse {
    statusCode?: HttpStatusCode;
    isSuccess?: boolean;
    errorMessages?: string[];
    result?: WorkFlowDataResponse | undefined;
}

export class WorkFlowDataResponse implements IWorkFlowDataResponse {
    workFlow?: WorkFlow;
    serviceCenterList?: ServiceCenter[];
    locationsList?: Locations[] | undefined;
    facilitiesList?: Facility2[] | undefined;
    accountTypeList?: AccountType[] | undefined;
    majorPayorList?: MajorPayor[] | undefined;
    authMethodList?: AuthMethod[] | undefined;
    financialClassList?: FinancialClasses[] | undefined;

    constructor(data?: IWorkFlowDataResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.workFlow = _data["workFlow"] ? WorkFlow.fromJS(_data["workFlow"]) : undefined as any;
            if (Array.isArray(_data["serviceCenterList"])) {
                this.serviceCenterList = [] as any;
                for (let item of _data["serviceCenterList"])
                    this.serviceCenterList!.push(ServiceCenter.fromJS(item));
            }
            if (Array.isArray(_data["locationsList"])) {
                this.locationsList = [] as any;
                for (let item of _data["locationsList"])
                    this.locationsList!.push(Locations.fromJS(item));
            }
            if (Array.isArray(_data["facilitiesList"])) {
                this.facilitiesList = [] as any;
                for (let item of _data["facilitiesList"])
                    this.facilitiesList!.push(Facility2.fromJS(item));
            }
            if (Array.isArray(_data["accountTypeList"])) {
                this.accountTypeList = [] as any;
                for (let item of _data["accountTypeList"])
                    this.accountTypeList!.push(AccountType.fromJS(item));
            }
            if (Array.isArray(_data["majorPayorList"])) {
                this.majorPayorList = [] as any;
                for (let item of _data["majorPayorList"])
                    this.majorPayorList!.push(MajorPayor.fromJS(item));
            }
            if (Array.isArray(_data["authMethodList"])) {
                this.authMethodList = [] as any;
                for (let item of _data["authMethodList"])
                    this.authMethodList!.push(AuthMethod.fromJS(item));
            }
            if (Array.isArray(_data["financialClassList"])) {
                this.financialClassList = [] as any;
                for (let item of _data["financialClassList"])
                    this.financialClassList!.push(FinancialClasses.fromJS(item));
            }
        }
    }

    static fromJS(data: any): WorkFlowDataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new WorkFlowDataResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workFlow"] = this.workFlow ? this.workFlow.toJSON() : undefined as any;
        if (Array.isArray(this.serviceCenterList)) {
            data["serviceCenterList"] = [];
            for (let item of this.serviceCenterList)
                data["serviceCenterList"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.locationsList)) {
            data["locationsList"] = [];
            for (let item of this.locationsList)
                data["locationsList"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.facilitiesList)) {
            data["facilitiesList"] = [];
            for (let item of this.facilitiesList)
                data["facilitiesList"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.accountTypeList)) {
            data["accountTypeList"] = [];
            for (let item of this.accountTypeList)
                data["accountTypeList"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.majorPayorList)) {
            data["majorPayorList"] = [];
            for (let item of this.majorPayorList)
                data["majorPayorList"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.authMethodList)) {
            data["authMethodList"] = [];
            for (let item of this.authMethodList)
                data["authMethodList"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.financialClassList)) {
            data["financialClassList"] = [];
            for (let item of this.financialClassList)
                data["financialClassList"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IWorkFlowDataResponse {
    workFlow?: WorkFlow;
    serviceCenterList?: ServiceCenter[];
    locationsList?: Locations[] | undefined;
    facilitiesList?: Facility2[] | undefined;
    accountTypeList?: AccountType[] | undefined;
    majorPayorList?: MajorPayor[] | undefined;
    authMethodList?: AuthMethod[] | undefined;
    financialClassList?: FinancialClasses[] | undefined;
}

export class WorkFlow implements IWorkFlow {
    appWorkflowId?: number;
    workflowName?: string;
    appProcessId?: number;
    escalations?: boolean | undefined;
    authRequired?: boolean | undefined;
    active?: boolean;
    bookedDate?: number | undefined;
    serviceStartDate?: number | undefined;
    serviceEndDate?: number | undefined;

    constructor(data?: IWorkFlow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.appWorkflowId = _data["appWorkflowId"];
            this.workflowName = _data["workflowName"];
            this.appProcessId = _data["appProcessId"];
            this.escalations = _data["escalations"];
            this.authRequired = _data["authRequired"];
            this.active = _data["active"];
            this.bookedDate = _data["bookedDate"];
            this.serviceStartDate = _data["serviceStartDate"];
            this.serviceEndDate = _data["serviceEndDate"];
        }
    }

    static fromJS(data: any): WorkFlow {
        data = typeof data === 'object' ? data : {};
        let result = new WorkFlow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["appWorkflowId"] = this.appWorkflowId;
        data["workflowName"] = this.workflowName;
        data["appProcessId"] = this.appProcessId;
        data["escalations"] = this.escalations;
        data["authRequired"] = this.authRequired;
        data["active"] = this.active;
        data["bookedDate"] = this.bookedDate;
        data["serviceStartDate"] = this.serviceStartDate;
        data["serviceEndDate"] = this.serviceEndDate;
        return data;
    }
}

export interface IWorkFlow {
    appWorkflowId?: number;
    workflowName?: string;
    appProcessId?: number;
    escalations?: boolean | undefined;
    authRequired?: boolean | undefined;
    active?: boolean;
    bookedDate?: number | undefined;
    serviceStartDate?: number | undefined;
    serviceEndDate?: number | undefined;
}

export class ServiceCenter implements IServiceCenter {
    refServiceCenterId?: number;

    constructor(data?: IServiceCenter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.refServiceCenterId = _data["refServiceCenterId"];
        }
    }

    static fromJS(data: any): ServiceCenter {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceCenter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["refServiceCenterId"] = this.refServiceCenterId;
        return data;
    }
}

export interface IServiceCenter {
    refServiceCenterId?: number;
}

export class Locations implements ILocations {
    locationCode?: string;

    constructor(data?: ILocations) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.locationCode = _data["locationCode"];
        }
    }

    static fromJS(data: any): Locations {
        data = typeof data === 'object' ? data : {};
        let result = new Locations();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["locationCode"] = this.locationCode;
        return data;
    }
}

export interface ILocations {
    locationCode?: string;
}

export class Facility2 implements IFacility2 {
    appFacilityID?: number;

    constructor(data?: IFacility2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.appFacilityID = _data["appFacilityID"];
        }
    }

    static fromJS(data: any): Facility2 {
        data = typeof data === 'object' ? data : {};
        let result = new Facility2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["appFacilityID"] = this.appFacilityID;
        return data;
    }
}

export interface IFacility2 {
    appFacilityID?: number;
}

export class AccountType implements IAccountType {
    accountTypecode?: string;

    constructor(data?: IAccountType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountTypecode = _data["accountTypecode"];
        }
    }

    static fromJS(data: any): AccountType {
        data = typeof data === 'object' ? data : {};
        let result = new AccountType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountTypecode"] = this.accountTypecode;
        return data;
    }
}

export interface IAccountType {
    accountTypecode?: string;
}

export class MajorPayor implements IMajorPayor {
    majorPayorId?: number;

    constructor(data?: IMajorPayor) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.majorPayorId = _data["majorPayorId"];
        }
    }

    static fromJS(data: any): MajorPayor {
        data = typeof data === 'object' ? data : {};
        let result = new MajorPayor();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["majorPayorId"] = this.majorPayorId;
        return data;
    }
}

export interface IMajorPayor {
    majorPayorId?: number;
}

export class AuthMethod implements IAuthMethod {
    authMethodCode?: string;

    constructor(data?: IAuthMethod) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.authMethodCode = _data["authMethodCode"];
        }
    }

    static fromJS(data: any): AuthMethod {
        data = typeof data === 'object' ? data : {};
        let result = new AuthMethod();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["authMethodCode"] = this.authMethodCode;
        return data;
    }
}

export interface IAuthMethod {
    authMethodCode?: string;
}

export class FinancialClasses implements IFinancialClasses {
    financialClass?: number;

    constructor(data?: IFinancialClasses) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.financialClass = _data["financialClass"];
        }
    }

    static fromJS(data: any): FinancialClasses {
        data = typeof data === 'object' ? data : {};
        let result = new FinancialClasses();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["financialClass"] = this.financialClass;
        return data;
    }
}

export interface IFinancialClasses {
    financialClass?: number;
}

export class APIResponseOfListOfRefWorkflowProcessDTO implements IAPIResponseOfListOfRefWorkflowProcessDTO {
    statusCode?: HttpStatusCode;
    isSuccess?: boolean;
    errorMessages?: string[];
    result?: RefWorkflowProcessDTO[] | undefined;

    constructor(data?: IAPIResponseOfListOfRefWorkflowProcessDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusCode = _data["statusCode"];
            this.isSuccess = _data["isSuccess"];
            if (Array.isArray(_data["errorMessages"])) {
                this.errorMessages = [] as any;
                for (let item of _data["errorMessages"])
                    this.errorMessages!.push(item);
            }
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result!.push(RefWorkflowProcessDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): APIResponseOfListOfRefWorkflowProcessDTO {
        data = typeof data === 'object' ? data : {};
        let result = new APIResponseOfListOfRefWorkflowProcessDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["isSuccess"] = this.isSuccess;
        if (Array.isArray(this.errorMessages)) {
            data["errorMessages"] = [];
            for (let item of this.errorMessages)
                data["errorMessages"].push(item);
        }
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IAPIResponseOfListOfRefWorkflowProcessDTO {
    statusCode?: HttpStatusCode;
    isSuccess?: boolean;
    errorMessages?: string[];
    result?: RefWorkflowProcessDTO[] | undefined;
}

export class RefWorkflowProcessDTO implements IRefWorkflowProcessDTO {
    appProcessId?: number;
    processName?: string;
    active?: boolean;

    constructor(data?: IRefWorkflowProcessDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.appProcessId = _data["appProcessId"];
            this.processName = _data["processName"];
            this.active = _data["active"];
        }
    }

    static fromJS(data: any): RefWorkflowProcessDTO {
        data = typeof data === 'object' ? data : {};
        let result = new RefWorkflowProcessDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["appProcessId"] = this.appProcessId;
        data["processName"] = this.processName;
        data["active"] = this.active;
        return data;
    }
}

export interface IRefWorkflowProcessDTO {
    appProcessId?: number;
    processName?: string;
    active?: boolean;
}

export class APIResponseOfListOfWorkFlowSummaryDTO implements IAPIResponseOfListOfWorkFlowSummaryDTO {
    statusCode?: HttpStatusCode;
    isSuccess?: boolean;
    errorMessages?: string[];
    result?: WorkFlowSummaryDTO[] | undefined;

    constructor(data?: IAPIResponseOfListOfWorkFlowSummaryDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusCode = _data["statusCode"];
            this.isSuccess = _data["isSuccess"];
            if (Array.isArray(_data["errorMessages"])) {
                this.errorMessages = [] as any;
                for (let item of _data["errorMessages"])
                    this.errorMessages!.push(item);
            }
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result!.push(WorkFlowSummaryDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): APIResponseOfListOfWorkFlowSummaryDTO {
        data = typeof data === 'object' ? data : {};
        let result = new APIResponseOfListOfWorkFlowSummaryDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["isSuccess"] = this.isSuccess;
        if (Array.isArray(this.errorMessages)) {
            data["errorMessages"] = [];
            for (let item of this.errorMessages)
                data["errorMessages"].push(item);
        }
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IAPIResponseOfListOfWorkFlowSummaryDTO {
    statusCode?: HttpStatusCode;
    isSuccess?: boolean;
    errorMessages?: string[];
    result?: WorkFlowSummaryDTO[] | undefined;
}

export class WorkFlowSummaryDTO implements IWorkFlowSummaryDTO {
    appWorkFlowID?: number;
    workFlowName?: string;
    processName?: string;
    numberOfAccounts?: number | undefined;
    assignedUsers?: number;
    active?: boolean;
    total_count?: number;

    constructor(data?: IWorkFlowSummaryDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.appWorkFlowID = _data["appWorkFlowID"];
            this.workFlowName = _data["workFlowName"];
            this.processName = _data["processName"];
            this.numberOfAccounts = _data["numberOfAccounts"];
            this.assignedUsers = _data["assignedUsers"];
            this.active = _data["active"];
            this.total_count = _data["total_count"];
        }
    }

    static fromJS(data: any): WorkFlowSummaryDTO {
        data = typeof data === 'object' ? data : {};
        let result = new WorkFlowSummaryDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["appWorkFlowID"] = this.appWorkFlowID;
        data["workFlowName"] = this.workFlowName;
        data["processName"] = this.processName;
        data["numberOfAccounts"] = this.numberOfAccounts;
        data["assignedUsers"] = this.assignedUsers;
        data["active"] = this.active;
        data["total_count"] = this.total_count;
        return data;
    }
}

export interface IWorkFlowSummaryDTO {
    appWorkFlowID?: number;
    workFlowName?: string;
    processName?: string;
    numberOfAccounts?: number | undefined;
    assignedUsers?: number;
    active?: boolean;
    total_count?: number;
}

export class WorkFlowDetailsRequest implements IWorkFlowDetailsRequest {
    processId?: number | undefined;
    users?: string[] | undefined;
    status?: boolean | undefined;
    sortColumn?: string;
    sortDir?: string;
    page?: number;
    pageSize?: number;
    refreshNumbercounts?: boolean;

    constructor(data?: IWorkFlowDetailsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.processId = _data["processId"];
            if (Array.isArray(_data["users"])) {
                this.users = [] as any;
                for (let item of _data["users"])
                    this.users!.push(item);
            }
            this.status = _data["status"];
            this.sortColumn = _data["sortColumn"];
            this.sortDir = _data["sortDir"];
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
            this.refreshNumbercounts = _data["refreshNumbercounts"];
        }
    }

    static fromJS(data: any): WorkFlowDetailsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new WorkFlowDetailsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["processId"] = this.processId;
        if (Array.isArray(this.users)) {
            data["users"] = [];
            for (let item of this.users)
                data["users"].push(item);
        }
        data["status"] = this.status;
        data["sortColumn"] = this.sortColumn;
        data["sortDir"] = this.sortDir;
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        data["refreshNumbercounts"] = this.refreshNumbercounts;
        return data;
    }
}

export interface IWorkFlowDetailsRequest {
    processId?: number | undefined;
    users?: string[] | undefined;
    status?: boolean | undefined;
    sortColumn?: string;
    sortDir?: string;
    page?: number;
    pageSize?: number;
    refreshNumbercounts?: boolean;
}

export class WorkFlowDataRequest implements IWorkFlowDataRequest {
    appWorkflowId?: number | undefined;
    workflowName?: string;
    appProcessId?: number;
    serviceCenterList?: ServiceCenter[];
    escalations?: boolean | undefined;
    authRequired?: boolean | undefined;
    active?: boolean;
    bookedDate?: number | undefined;
    serviceStartDate?: number | undefined;
    serviceEndDate?: number | undefined;
    hcA34ID?: string;
    locationsList?: Locations[] | undefined;
    facilitiesList?: Facility2[] | undefined;
    accountTypeList?: AccountType[] | undefined;
    majorPayorList?: MajorPayor[] | undefined;
    authMethodList?: AuthMethod[] | undefined;
    financialClassList?: FinancialClasses[] | undefined;

    constructor(data?: IWorkFlowDataRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.appWorkflowId = _data["appWorkflowId"];
            this.workflowName = _data["workflowName"];
            this.appProcessId = _data["appProcessId"];
            if (Array.isArray(_data["serviceCenterList"])) {
                this.serviceCenterList = [] as any;
                for (let item of _data["serviceCenterList"])
                    this.serviceCenterList!.push(ServiceCenter.fromJS(item));
            }
            this.escalations = _data["escalations"];
            this.authRequired = _data["authRequired"];
            this.active = _data["active"];
            this.bookedDate = _data["bookedDate"];
            this.serviceStartDate = _data["serviceStartDate"];
            this.serviceEndDate = _data["serviceEndDate"];
            this.hcA34ID = _data["hcA34ID"];
            if (Array.isArray(_data["locationsList"])) {
                this.locationsList = [] as any;
                for (let item of _data["locationsList"])
                    this.locationsList!.push(Locations.fromJS(item));
            }
            if (Array.isArray(_data["facilitiesList"])) {
                this.facilitiesList = [] as any;
                for (let item of _data["facilitiesList"])
                    this.facilitiesList!.push(Facility2.fromJS(item));
            }
            if (Array.isArray(_data["accountTypeList"])) {
                this.accountTypeList = [] as any;
                for (let item of _data["accountTypeList"])
                    this.accountTypeList!.push(AccountType.fromJS(item));
            }
            if (Array.isArray(_data["majorPayorList"])) {
                this.majorPayorList = [] as any;
                for (let item of _data["majorPayorList"])
                    this.majorPayorList!.push(MajorPayor.fromJS(item));
            }
            if (Array.isArray(_data["authMethodList"])) {
                this.authMethodList = [] as any;
                for (let item of _data["authMethodList"])
                    this.authMethodList!.push(AuthMethod.fromJS(item));
            }
            if (Array.isArray(_data["financialClassList"])) {
                this.financialClassList = [] as any;
                for (let item of _data["financialClassList"])
                    this.financialClassList!.push(FinancialClasses.fromJS(item));
            }
        }
    }

    static fromJS(data: any): WorkFlowDataRequest {
        data = typeof data === 'object' ? data : {};
        let result = new WorkFlowDataRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["appWorkflowId"] = this.appWorkflowId;
        data["workflowName"] = this.workflowName;
        data["appProcessId"] = this.appProcessId;
        if (Array.isArray(this.serviceCenterList)) {
            data["serviceCenterList"] = [];
            for (let item of this.serviceCenterList)
                data["serviceCenterList"].push(item ? item.toJSON() : undefined as any);
        }
        data["escalations"] = this.escalations;
        data["authRequired"] = this.authRequired;
        data["active"] = this.active;
        data["bookedDate"] = this.bookedDate;
        data["serviceStartDate"] = this.serviceStartDate;
        data["serviceEndDate"] = this.serviceEndDate;
        data["hcA34ID"] = this.hcA34ID;
        if (Array.isArray(this.locationsList)) {
            data["locationsList"] = [];
            for (let item of this.locationsList)
                data["locationsList"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.facilitiesList)) {
            data["facilitiesList"] = [];
            for (let item of this.facilitiesList)
                data["facilitiesList"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.accountTypeList)) {
            data["accountTypeList"] = [];
            for (let item of this.accountTypeList)
                data["accountTypeList"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.majorPayorList)) {
            data["majorPayorList"] = [];
            for (let item of this.majorPayorList)
                data["majorPayorList"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.authMethodList)) {
            data["authMethodList"] = [];
            for (let item of this.authMethodList)
                data["authMethodList"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.financialClassList)) {
            data["financialClassList"] = [];
            for (let item of this.financialClassList)
                data["financialClassList"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IWorkFlowDataRequest {
    appWorkflowId?: number | undefined;
    workflowName?: string;
    appProcessId?: number;
    serviceCenterList?: ServiceCenter[];
    escalations?: boolean | undefined;
    authRequired?: boolean | undefined;
    active?: boolean;
    bookedDate?: number | undefined;
    serviceStartDate?: number | undefined;
    serviceEndDate?: number | undefined;
    hcA34ID?: string;
    locationsList?: Locations[] | undefined;
    facilitiesList?: Facility2[] | undefined;
    accountTypeList?: AccountType[] | undefined;
    majorPayorList?: MajorPayor[] | undefined;
    authMethodList?: AuthMethod[] | undefined;
    financialClassList?: FinancialClasses[] | undefined;
}

export class AssignedUserRequest implements IAssignedUserRequest {
    appWorkflowId?: number;
    hcA34ID?: string;
    assignedUsers?: AssignedUsers[];

    constructor(data?: IAssignedUserRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.appWorkflowId = _data["appWorkflowId"];
            this.hcA34ID = _data["hcA34ID"];
            if (Array.isArray(_data["assignedUsers"])) {
                this.assignedUsers = [] as any;
                for (let item of _data["assignedUsers"])
                    this.assignedUsers!.push(AssignedUsers.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AssignedUserRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AssignedUserRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["appWorkflowId"] = this.appWorkflowId;
        data["hcA34ID"] = this.hcA34ID;
        if (Array.isArray(this.assignedUsers)) {
            data["assignedUsers"] = [];
            for (let item of this.assignedUsers)
                data["assignedUsers"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IAssignedUserRequest {
    appWorkflowId?: number;
    hcA34ID?: string;
    assignedUsers?: AssignedUsers[];
}

export class AssignedUsers implements IAssignedUsers {
    appUserId?: number;

    constructor(data?: IAssignedUsers) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.appUserId = _data["appUserId"];
        }
    }

    static fromJS(data: any): AssignedUsers {
        data = typeof data === 'object' ? data : {};
        let result = new AssignedUsers();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["appUserId"] = this.appUserId;
        return data;
    }
}

export interface IAssignedUsers {
    appUserId?: number;
}

export class APIResponseOfListOfAlertListDTO implements IAPIResponseOfListOfAlertListDTO {
    statusCode?: HttpStatusCode;
    isSuccess?: boolean;
    errorMessages?: string[];
    result?: AlertListDTO[] | undefined;

    constructor(data?: IAPIResponseOfListOfAlertListDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusCode = _data["statusCode"];
            this.isSuccess = _data["isSuccess"];
            if (Array.isArray(_data["errorMessages"])) {
                this.errorMessages = [] as any;
                for (let item of _data["errorMessages"])
                    this.errorMessages!.push(item);
            }
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result!.push(AlertListDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): APIResponseOfListOfAlertListDTO {
        data = typeof data === 'object' ? data : {};
        let result = new APIResponseOfListOfAlertListDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["isSuccess"] = this.isSuccess;
        if (Array.isArray(this.errorMessages)) {
            data["errorMessages"] = [];
            for (let item of this.errorMessages)
                data["errorMessages"].push(item);
        }
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IAPIResponseOfListOfAlertListDTO {
    statusCode?: HttpStatusCode;
    isSuccess?: boolean;
    errorMessages?: string[];
    result?: AlertListDTO[] | undefined;
}

export class AlertListDTO implements IAlertListDTO {
    alertId?: number;
    alertText?: string | undefined;
    status?: boolean;
    alertType?: string | undefined;
    createdBy?: string | undefined;
    modifiedBy?: string | undefined;
    createdDate?: Date | undefined;
    modifiedDate?: Date | undefined;
    inactiveDate?: Date | undefined;
    accountNumber?: string | undefined;
    accountId?: number | undefined;
    refAlertID?: number | undefined;
    alertTextInfo?: string | undefined;
    totalRows?: number | undefined;
    mrn?: string | undefined;
    ageOfAccount?: number | undefined;

    constructor(data?: IAlertListDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.alertId = _data["alertId"];
            this.alertText = _data["alertText"];
            this.status = _data["status"];
            this.alertType = _data["alertType"];
            this.createdBy = _data["createdBy"];
            this.modifiedBy = _data["modifiedBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined as any;
            this.modifiedDate = _data["modifiedDate"] ? new Date(_data["modifiedDate"].toString()) : undefined as any;
            this.inactiveDate = _data["inactiveDate"] ? new Date(_data["inactiveDate"].toString()) : undefined as any;
            this.accountNumber = _data["accountNumber"];
            this.accountId = _data["accountId"];
            this.refAlertID = _data["refAlertID"];
            this.alertTextInfo = _data["alertTextInfo"];
            this.totalRows = _data["totalRows"];
            this.mrn = _data["mrn"];
            this.ageOfAccount = _data["ageOfAccount"];
        }
    }

    static fromJS(data: any): AlertListDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AlertListDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["alertId"] = this.alertId;
        data["alertText"] = this.alertText;
        data["status"] = this.status;
        data["alertType"] = this.alertType;
        data["createdBy"] = this.createdBy;
        data["modifiedBy"] = this.modifiedBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined as any;
        data["modifiedDate"] = this.modifiedDate ? this.modifiedDate.toISOString() : undefined as any;
        data["inactiveDate"] = this.inactiveDate ? this.inactiveDate.toISOString() : undefined as any;
        data["accountNumber"] = this.accountNumber;
        data["accountId"] = this.accountId;
        data["refAlertID"] = this.refAlertID;
        data["alertTextInfo"] = this.alertTextInfo;
        data["totalRows"] = this.totalRows;
        data["mrn"] = this.mrn;
        data["ageOfAccount"] = this.ageOfAccount;
        return data;
    }
}

export interface IAlertListDTO {
    alertId?: number;
    alertText?: string | undefined;
    status?: boolean;
    alertType?: string | undefined;
    createdBy?: string | undefined;
    modifiedBy?: string | undefined;
    createdDate?: Date | undefined;
    modifiedDate?: Date | undefined;
    inactiveDate?: Date | undefined;
    accountNumber?: string | undefined;
    accountId?: number | undefined;
    refAlertID?: number | undefined;
    alertTextInfo?: string | undefined;
    totalRows?: number | undefined;
    mrn?: string | undefined;
    ageOfAccount?: number | undefined;
}

export class AlertListRequest implements IAlertListRequest {
    status?: boolean | undefined;
    alertType?: string | undefined;
    postedUsers?: string | undefined;
    datePosted?: Date | undefined;
    dateInactive?: Date | undefined;
    accountNumber?: string | undefined;
    mrn?: string | undefined;
    apptURN?: string | undefined;
    appFacilityId?: string | undefined;
    sortColumn?: string;
    sortDir?: string;
    pageNumber?: number;
    pageSize?: number;

    constructor(data?: IAlertListRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.alertType = _data["alertType"];
            this.postedUsers = _data["postedUsers"];
            this.datePosted = _data["datePosted"] ? new Date(_data["datePosted"].toString()) : undefined as any;
            this.dateInactive = _data["dateInactive"] ? new Date(_data["dateInactive"].toString()) : undefined as any;
            this.accountNumber = _data["accountNumber"];
            this.mrn = _data["mrn"];
            this.apptURN = _data["apptURN"];
            this.appFacilityId = _data["appFacilityId"];
            this.sortColumn = _data["sortColumn"];
            this.sortDir = _data["sortDir"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
        }
    }

    static fromJS(data: any): AlertListRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AlertListRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["alertType"] = this.alertType;
        data["postedUsers"] = this.postedUsers;
        data["datePosted"] = this.datePosted ? this.datePosted.toISOString() : undefined as any;
        data["dateInactive"] = this.dateInactive ? this.dateInactive.toISOString() : undefined as any;
        data["accountNumber"] = this.accountNumber;
        data["mrn"] = this.mrn;
        data["apptURN"] = this.apptURN;
        data["appFacilityId"] = this.appFacilityId;
        data["sortColumn"] = this.sortColumn;
        data["sortDir"] = this.sortDir;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        return data;
    }
}

export interface IAlertListRequest {
    status?: boolean | undefined;
    alertType?: string | undefined;
    postedUsers?: string | undefined;
    datePosted?: Date | undefined;
    dateInactive?: Date | undefined;
    accountNumber?: string | undefined;
    mrn?: string | undefined;
    apptURN?: string | undefined;
    appFacilityId?: string | undefined;
    sortColumn?: string;
    sortDir?: string;
    pageNumber?: number;
    pageSize?: number;
}

export class APIResponseOfAlertDetailDTO implements IAPIResponseOfAlertDetailDTO {
    statusCode?: HttpStatusCode;
    isSuccess?: boolean;
    errorMessages?: string[];
    result?: AlertDetailDTO | undefined;

    constructor(data?: IAPIResponseOfAlertDetailDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusCode = _data["statusCode"];
            this.isSuccess = _data["isSuccess"];
            if (Array.isArray(_data["errorMessages"])) {
                this.errorMessages = [] as any;
                for (let item of _data["errorMessages"])
                    this.errorMessages!.push(item);
            }
            this.result = _data["result"] ? AlertDetailDTO.fromJS(_data["result"]) : undefined as any;
        }
    }

    static fromJS(data: any): APIResponseOfAlertDetailDTO {
        data = typeof data === 'object' ? data : {};
        let result = new APIResponseOfAlertDetailDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["isSuccess"] = this.isSuccess;
        if (Array.isArray(this.errorMessages)) {
            data["errorMessages"] = [];
            for (let item of this.errorMessages)
                data["errorMessages"].push(item);
        }
        data["result"] = this.result ? this.result.toJSON() : undefined as any;
        return data;
    }
}

export interface IAPIResponseOfAlertDetailDTO {
    statusCode?: HttpStatusCode;
    isSuccess?: boolean;
    errorMessages?: string[];
    result?: AlertDetailDTO | undefined;
}

export class AlertDetailDTO implements IAlertDetailDTO {
    alertId?: number;
    alertTextInfo?: string | undefined;
    status?: boolean;
    alertType?: string | undefined;
    createdBy?: string | undefined;
    modifiedBy?: string | undefined;
    createdDate?: Date | undefined;
    modifiedDate?: Date | undefined;
    inactiveDate?: Date | undefined;
    accountNumber?: string | undefined;
    accountId?: number | undefined;
    refAlertID?: number | undefined;
    alertText?: string | undefined;

    constructor(data?: IAlertDetailDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.alertId = _data["alertId"];
            this.alertTextInfo = _data["alertTextInfo"];
            this.status = _data["status"];
            this.alertType = _data["alertType"];
            this.createdBy = _data["createdBy"];
            this.modifiedBy = _data["modifiedBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined as any;
            this.modifiedDate = _data["modifiedDate"] ? new Date(_data["modifiedDate"].toString()) : undefined as any;
            this.inactiveDate = _data["inactiveDate"] ? new Date(_data["inactiveDate"].toString()) : undefined as any;
            this.accountNumber = _data["accountNumber"];
            this.accountId = _data["accountId"];
            this.refAlertID = _data["refAlertID"];
            this.alertText = _data["alertText"];
        }
    }

    static fromJS(data: any): AlertDetailDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AlertDetailDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["alertId"] = this.alertId;
        data["alertTextInfo"] = this.alertTextInfo;
        data["status"] = this.status;
        data["alertType"] = this.alertType;
        data["createdBy"] = this.createdBy;
        data["modifiedBy"] = this.modifiedBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined as any;
        data["modifiedDate"] = this.modifiedDate ? this.modifiedDate.toISOString() : undefined as any;
        data["inactiveDate"] = this.inactiveDate ? this.inactiveDate.toISOString() : undefined as any;
        data["accountNumber"] = this.accountNumber;
        data["accountId"] = this.accountId;
        data["refAlertID"] = this.refAlertID;
        data["alertText"] = this.alertText;
        return data;
    }
}

export interface IAlertDetailDTO {
    alertId?: number;
    alertTextInfo?: string | undefined;
    status?: boolean;
    alertType?: string | undefined;
    createdBy?: string | undefined;
    modifiedBy?: string | undefined;
    createdDate?: Date | undefined;
    modifiedDate?: Date | undefined;
    inactiveDate?: Date | undefined;
    accountNumber?: string | undefined;
    accountId?: number | undefined;
    refAlertID?: number | undefined;
    alertText?: string | undefined;
}

export class ActiveSystemAlertRequest implements IActiveSystemAlertRequest {
    pageNumber?: number;
    pageSize?: number;

    constructor(data?: IActiveSystemAlertRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
        }
    }

    static fromJS(data: any): ActiveSystemAlertRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ActiveSystemAlertRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        return data;
    }
}

export interface IActiveSystemAlertRequest {
    pageNumber?: number;
    pageSize?: number;
}

export class CreateAlertRequest implements ICreateAlertRequest {
    alertType?: string | undefined;
    alertText?: string | undefined;
    appAccountId?: number;
    status?: boolean;
    refAlertID?: number | undefined;

    constructor(data?: ICreateAlertRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.alertType = _data["alertType"];
            this.alertText = _data["alertText"];
            this.appAccountId = _data["appAccountId"];
            this.status = _data["status"];
            this.refAlertID = _data["refAlertID"];
        }
    }

    static fromJS(data: any): CreateAlertRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateAlertRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["alertType"] = this.alertType;
        data["alertText"] = this.alertText;
        data["appAccountId"] = this.appAccountId;
        data["status"] = this.status;
        data["refAlertID"] = this.refAlertID;
        return data;
    }
}

export interface ICreateAlertRequest {
    alertType?: string | undefined;
    alertText?: string | undefined;
    appAccountId?: number;
    status?: boolean;
    refAlertID?: number | undefined;
}

export class UpdateAlertRequest implements IUpdateAlertRequest {
    alertId?: number;
    alertText?: string | undefined;
    refAlertID?: number | undefined;

    constructor(data?: IUpdateAlertRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.alertId = _data["alertId"];
            this.alertText = _data["alertText"];
            this.refAlertID = _data["refAlertID"];
        }
    }

    static fromJS(data: any): UpdateAlertRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateAlertRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["alertId"] = this.alertId;
        data["alertText"] = this.alertText;
        data["refAlertID"] = this.refAlertID;
        return data;
    }
}

export interface IUpdateAlertRequest {
    alertId?: number;
    alertText?: string | undefined;
    refAlertID?: number | undefined;
}

export class APIResponseOfListOfRefAppAlerts implements IAPIResponseOfListOfRefAppAlerts {
    statusCode?: HttpStatusCode;
    isSuccess?: boolean;
    errorMessages?: string[];
    result?: RefAppAlerts[] | undefined;

    constructor(data?: IAPIResponseOfListOfRefAppAlerts) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusCode = _data["statusCode"];
            this.isSuccess = _data["isSuccess"];
            if (Array.isArray(_data["errorMessages"])) {
                this.errorMessages = [] as any;
                for (let item of _data["errorMessages"])
                    this.errorMessages!.push(item);
            }
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result!.push(RefAppAlerts.fromJS(item));
            }
        }
    }

    static fromJS(data: any): APIResponseOfListOfRefAppAlerts {
        data = typeof data === 'object' ? data : {};
        let result = new APIResponseOfListOfRefAppAlerts();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["isSuccess"] = this.isSuccess;
        if (Array.isArray(this.errorMessages)) {
            data["errorMessages"] = [];
            for (let item of this.errorMessages)
                data["errorMessages"].push(item);
        }
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IAPIResponseOfListOfRefAppAlerts {
    statusCode?: HttpStatusCode;
    isSuccess?: boolean;
    errorMessages?: string[];
    result?: RefAppAlerts[] | undefined;
}

export class RefAppAlerts implements IRefAppAlerts {
    refAlertID?: number;
    alertText?: string;
    createDateUtc?: Date;
    createdBy?: string;
    modifiedDateUtc?: Date | undefined;
    modifiedBy?: string | undefined;
    active?: boolean;

    constructor(data?: IRefAppAlerts) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.refAlertID = _data["refAlertID"];
            this.alertText = _data["alertText"];
            this.createDateUtc = _data["createDateUtc"] ? new Date(_data["createDateUtc"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modifiedDateUtc = _data["modifiedDateUtc"] ? new Date(_data["modifiedDateUtc"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            this.active = _data["active"];
        }
    }

    static fromJS(data: any): RefAppAlerts {
        data = typeof data === 'object' ? data : {};
        let result = new RefAppAlerts();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["refAlertID"] = this.refAlertID;
        data["alertText"] = this.alertText;
        data["createDateUtc"] = this.createDateUtc ? this.createDateUtc.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modifiedDateUtc"] = this.modifiedDateUtc ? this.modifiedDateUtc.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        data["active"] = this.active;
        return data;
    }
}

export interface IRefAppAlerts {
    refAlertID?: number;
    alertText?: string;
    createDateUtc?: Date;
    createdBy?: string;
    modifiedDateUtc?: Date | undefined;
    modifiedBy?: string | undefined;
    active?: boolean;
}

export class APIResponseOfListOfPreRegSummaryResponse implements IAPIResponseOfListOfPreRegSummaryResponse {
    statusCode?: HttpStatusCode;
    isSuccess?: boolean;
    errorMessages?: string[];
    result?: PreRegSummaryResponse[] | undefined;

    constructor(data?: IAPIResponseOfListOfPreRegSummaryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusCode = _data["statusCode"];
            this.isSuccess = _data["isSuccess"];
            if (Array.isArray(_data["errorMessages"])) {
                this.errorMessages = [] as any;
                for (let item of _data["errorMessages"])
                    this.errorMessages!.push(item);
            }
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result!.push(PreRegSummaryResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): APIResponseOfListOfPreRegSummaryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new APIResponseOfListOfPreRegSummaryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["isSuccess"] = this.isSuccess;
        if (Array.isArray(this.errorMessages)) {
            data["errorMessages"] = [];
            for (let item of this.errorMessages)
                data["errorMessages"].push(item);
        }
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IAPIResponseOfListOfPreRegSummaryResponse {
    statusCode?: HttpStatusCode;
    isSuccess?: boolean;
    errorMessages?: string[];
    result?: PreRegSummaryResponse[] | undefined;
}

export class PreRegSummaryResponse implements IPreRegSummaryResponse {
    sscs?: SSC2[] | undefined;
    lastRefreshedTime?: string | undefined;

    constructor(data?: IPreRegSummaryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["sscs"])) {
                this.sscs = [] as any;
                for (let item of _data["sscs"])
                    this.sscs!.push(SSC2.fromJS(item));
            }
            this.lastRefreshedTime = _data["lastRefreshedTime"];
        }
    }

    static fromJS(data: any): PreRegSummaryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PreRegSummaryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.sscs)) {
            data["sscs"] = [];
            for (let item of this.sscs)
                data["sscs"].push(item ? item.toJSON() : undefined as any);
        }
        data["lastRefreshedTime"] = this.lastRefreshedTime;
        return data;
    }
}

export interface IPreRegSummaryResponse {
    sscs?: SSC2[] | undefined;
    lastRefreshedTime?: string | undefined;
}

export class PreRegSummaryBase implements IPreRegSummaryBase {
    type?: string | undefined;
    name?: string | undefined;
    sscId?: number | undefined;
    divisionId?: number | undefined;
    facilityId?: number | undefined;
    t1?: number | undefined;
    t2?: number | undefined;
    t3?: number | undefined;
    t4?: number | undefined;
    t5?: number | undefined;
    t6?: number | undefined;
    t7?: number | undefined;
    accountsContactedToday?: number | undefined;
    accountsNotContactedToday?: number | undefined;
    total?: number | undefined;
    puAutomation?: number | undefined;

    constructor(data?: IPreRegSummaryBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.name = _data["name"];
            this.sscId = _data["sscId"];
            this.divisionId = _data["divisionId"];
            this.facilityId = _data["facilityId"];
            this.t1 = _data["t1"];
            this.t2 = _data["t2"];
            this.t3 = _data["t3"];
            this.t4 = _data["t4"];
            this.t5 = _data["t5"];
            this.t6 = _data["t6"];
            this.t7 = _data["t7"];
            this.accountsContactedToday = _data["accountsContactedToday"];
            this.accountsNotContactedToday = _data["accountsNotContactedToday"];
            this.total = _data["total"];
            this.puAutomation = _data["puAutomation"];
        }
    }

    static fromJS(data: any): PreRegSummaryBase {
        data = typeof data === 'object' ? data : {};
        let result = new PreRegSummaryBase();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["name"] = this.name;
        data["sscId"] = this.sscId;
        data["divisionId"] = this.divisionId;
        data["facilityId"] = this.facilityId;
        data["t1"] = this.t1;
        data["t2"] = this.t2;
        data["t3"] = this.t3;
        data["t4"] = this.t4;
        data["t5"] = this.t5;
        data["t6"] = this.t6;
        data["t7"] = this.t7;
        data["accountsContactedToday"] = this.accountsContactedToday;
        data["accountsNotContactedToday"] = this.accountsNotContactedToday;
        data["total"] = this.total;
        data["puAutomation"] = this.puAutomation;
        return data;
    }
}

export interface IPreRegSummaryBase {
    type?: string | undefined;
    name?: string | undefined;
    sscId?: number | undefined;
    divisionId?: number | undefined;
    facilityId?: number | undefined;
    t1?: number | undefined;
    t2?: number | undefined;
    t3?: number | undefined;
    t4?: number | undefined;
    t5?: number | undefined;
    t6?: number | undefined;
    t7?: number | undefined;
    accountsContactedToday?: number | undefined;
    accountsNotContactedToday?: number | undefined;
    total?: number | undefined;
    puAutomation?: number | undefined;
}

export class SSC2 extends PreRegSummaryBase implements ISSC2 {
    divisions?: Division2[] | undefined;

    constructor(data?: ISSC2) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["divisions"])) {
                this.divisions = [] as any;
                for (let item of _data["divisions"])
                    this.divisions!.push(Division2.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): SSC2 {
        data = typeof data === 'object' ? data : {};
        let result = new SSC2();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.divisions)) {
            data["divisions"] = [];
            for (let item of this.divisions)
                data["divisions"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface ISSC2 extends IPreRegSummaryBase {
    divisions?: Division2[] | undefined;
}

export class Division2 extends PreRegSummaryBase implements IDivision2 {
    facilities?: Facility3[] | undefined;

    constructor(data?: IDivision2) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["facilities"])) {
                this.facilities = [] as any;
                for (let item of _data["facilities"])
                    this.facilities!.push(Facility3.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): Division2 {
        data = typeof data === 'object' ? data : {};
        let result = new Division2();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.facilities)) {
            data["facilities"] = [];
            for (let item of this.facilities)
                data["facilities"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IDivision2 extends IPreRegSummaryBase {
    facilities?: Facility3[] | undefined;
}

export class Facility3 extends PreRegSummaryBase implements IFacility3 {

    constructor(data?: IFacility3) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): Facility3 {
        data = typeof data === 'object' ? data : {};
        let result = new Facility3();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IFacility3 extends IPreRegSummaryBase {
}

export class PreRegSummaryRequest implements IPreRegSummaryRequest {
    campaignType?: number | undefined;

    constructor(data?: IPreRegSummaryRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.campaignType = _data["campaignType"];
        }
    }

    static fromJS(data: any): PreRegSummaryRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PreRegSummaryRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["campaignType"] = this.campaignType;
        return data;
    }
}

export interface IPreRegSummaryRequest {
    campaignType?: number | undefined;
}

export class APIResponseOfCernerAgentFiltersDTO implements IAPIResponseOfCernerAgentFiltersDTO {
    statusCode?: HttpStatusCode;
    isSuccess?: boolean;
    errorMessages?: string[];
    result?: CernerAgentFiltersDTO | undefined;

    constructor(data?: IAPIResponseOfCernerAgentFiltersDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusCode = _data["statusCode"];
            this.isSuccess = _data["isSuccess"];
            if (Array.isArray(_data["errorMessages"])) {
                this.errorMessages = [] as any;
                for (let item of _data["errorMessages"])
                    this.errorMessages!.push(item);
            }
            this.result = _data["result"] ? CernerAgentFiltersDTO.fromJS(_data["result"]) : undefined as any;
        }
    }

    static fromJS(data: any): APIResponseOfCernerAgentFiltersDTO {
        data = typeof data === 'object' ? data : {};
        let result = new APIResponseOfCernerAgentFiltersDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["isSuccess"] = this.isSuccess;
        if (Array.isArray(this.errorMessages)) {
            data["errorMessages"] = [];
            for (let item of this.errorMessages)
                data["errorMessages"].push(item);
        }
        data["result"] = this.result ? this.result.toJSON() : undefined as any;
        return data;
    }
}

export interface IAPIResponseOfCernerAgentFiltersDTO {
    statusCode?: HttpStatusCode;
    isSuccess?: boolean;
    errorMessages?: string[];
    result?: CernerAgentFiltersDTO | undefined;
}

export class CernerAgentFiltersDTO implements ICernerAgentFiltersDTO {
    userName?: DropDownItem[];
    facilities?: DropDownItem[];
    departments?: DropDownItem[];
    sourceSystem?: DropDownItem[];

    constructor(data?: ICernerAgentFiltersDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["userName"])) {
                this.userName = [] as any;
                for (let item of _data["userName"])
                    this.userName!.push(DropDownItem.fromJS(item));
            }
            if (Array.isArray(_data["facilities"])) {
                this.facilities = [] as any;
                for (let item of _data["facilities"])
                    this.facilities!.push(DropDownItem.fromJS(item));
            }
            if (Array.isArray(_data["departments"])) {
                this.departments = [] as any;
                for (let item of _data["departments"])
                    this.departments!.push(DropDownItem.fromJS(item));
            }
            if (Array.isArray(_data["sourceSystem"])) {
                this.sourceSystem = [] as any;
                for (let item of _data["sourceSystem"])
                    this.sourceSystem!.push(DropDownItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CernerAgentFiltersDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CernerAgentFiltersDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.userName)) {
            data["userName"] = [];
            for (let item of this.userName)
                data["userName"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.facilities)) {
            data["facilities"] = [];
            for (let item of this.facilities)
                data["facilities"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.departments)) {
            data["departments"] = [];
            for (let item of this.departments)
                data["departments"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.sourceSystem)) {
            data["sourceSystem"] = [];
            for (let item of this.sourceSystem)
                data["sourceSystem"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ICernerAgentFiltersDTO {
    userName?: DropDownItem[];
    facilities?: DropDownItem[];
    departments?: DropDownItem[];
    sourceSystem?: DropDownItem[];
}

export class APIResponseOfListOfCernerAgentInformationDTO implements IAPIResponseOfListOfCernerAgentInformationDTO {
    statusCode?: HttpStatusCode;
    isSuccess?: boolean;
    errorMessages?: string[];
    result?: CernerAgentInformationDTO[] | undefined;

    constructor(data?: IAPIResponseOfListOfCernerAgentInformationDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusCode = _data["statusCode"];
            this.isSuccess = _data["isSuccess"];
            if (Array.isArray(_data["errorMessages"])) {
                this.errorMessages = [] as any;
                for (let item of _data["errorMessages"])
                    this.errorMessages!.push(item);
            }
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result!.push(CernerAgentInformationDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): APIResponseOfListOfCernerAgentInformationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new APIResponseOfListOfCernerAgentInformationDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["isSuccess"] = this.isSuccess;
        if (Array.isArray(this.errorMessages)) {
            data["errorMessages"] = [];
            for (let item of this.errorMessages)
                data["errorMessages"].push(item);
        }
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IAPIResponseOfListOfCernerAgentInformationDTO {
    statusCode?: HttpStatusCode;
    isSuccess?: boolean;
    errorMessages?: string[];
    result?: CernerAgentInformationDTO[] | undefined;
}

export class CernerAgentInformationDTO implements ICernerAgentInformationDTO {
    appSchedulingUserId?: number | undefined;
    name?: string | undefined;
    agent34ID?: string | undefined;
    facility?: string | undefined;
    department?: string | undefined;
    sourceSystem?: string | undefined;
    lastModifiedBy?: string | undefined;
    lastModifiedDate?: Date | undefined;
    status?: boolean | undefined;
    rowsCount?: number;

    constructor(data?: ICernerAgentInformationDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.appSchedulingUserId = _data["appSchedulingUserId"];
            this.name = _data["name"];
            this.agent34ID = _data["agent34ID"];
            this.facility = _data["facility"];
            this.department = _data["department"];
            this.sourceSystem = _data["sourceSystem"];
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined as any;
            this.status = _data["status"];
            this.rowsCount = _data["rowsCount"];
        }
    }

    static fromJS(data: any): CernerAgentInformationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CernerAgentInformationDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["appSchedulingUserId"] = this.appSchedulingUserId;
        data["name"] = this.name;
        data["agent34ID"] = this.agent34ID;
        data["facility"] = this.facility;
        data["department"] = this.department;
        data["sourceSystem"] = this.sourceSystem;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined as any;
        data["status"] = this.status;
        data["rowsCount"] = this.rowsCount;
        return data;
    }
}

export interface ICernerAgentInformationDTO {
    appSchedulingUserId?: number | undefined;
    name?: string | undefined;
    agent34ID?: string | undefined;
    facility?: string | undefined;
    department?: string | undefined;
    sourceSystem?: string | undefined;
    lastModifiedBy?: string | undefined;
    lastModifiedDate?: Date | undefined;
    status?: boolean | undefined;
    rowsCount?: number;
}

export class CernerAgentInformationListRequest implements ICernerAgentInformationListRequest {
    status?: string | undefined;
    agent34ID?: string | undefined;
    facilityIds?: string | undefined;
    departmentIds?: string | undefined;
    refSourceId?: number | undefined;
    pageCount?: number;
    pageNumber?: number;
    sortDir?: string;
    sortColumn?: string;

    constructor(data?: ICernerAgentInformationListRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.agent34ID = _data["agent34ID"];
            this.facilityIds = _data["facilityIds"];
            this.departmentIds = _data["departmentIds"];
            this.refSourceId = _data["refSourceId"];
            this.pageCount = _data["pageCount"];
            this.pageNumber = _data["pageNumber"];
            this.sortDir = _data["sortDir"];
            this.sortColumn = _data["sortColumn"];
        }
    }

    static fromJS(data: any): CernerAgentInformationListRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CernerAgentInformationListRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["agent34ID"] = this.agent34ID;
        data["facilityIds"] = this.facilityIds;
        data["departmentIds"] = this.departmentIds;
        data["refSourceId"] = this.refSourceId;
        data["pageCount"] = this.pageCount;
        data["pageNumber"] = this.pageNumber;
        data["sortDir"] = this.sortDir;
        data["sortColumn"] = this.sortColumn;
        return data;
    }
}

export interface ICernerAgentInformationListRequest {
    status?: string | undefined;
    agent34ID?: string | undefined;
    facilityIds?: string | undefined;
    departmentIds?: string | undefined;
    refSourceId?: number | undefined;
    pageCount?: number;
    pageNumber?: number;
    sortDir?: string;
    sortColumn?: string;
}

export class CernerAddUserDTO implements ICernerAddUserDTO {
    firstName?: string;
    lastName?: string;
    agent34ID?: string;
    facilityIds?: string;
    refSchedulingDepartmentId?: number;
    refSourceId?: number;

    constructor(data?: ICernerAddUserDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.agent34ID = _data["agent34ID"];
            this.facilityIds = _data["facilityIds"];
            this.refSchedulingDepartmentId = _data["refSchedulingDepartmentId"];
            this.refSourceId = _data["refSourceId"];
        }
    }

    static fromJS(data: any): CernerAddUserDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CernerAddUserDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["agent34ID"] = this.agent34ID;
        data["facilityIds"] = this.facilityIds;
        data["refSchedulingDepartmentId"] = this.refSchedulingDepartmentId;
        data["refSourceId"] = this.refSourceId;
        return data;
    }
}

export interface ICernerAddUserDTO {
    firstName?: string;
    lastName?: string;
    agent34ID?: string;
    facilityIds?: string;
    refSchedulingDepartmentId?: number;
    refSourceId?: number;
}

export class CernerUpdateUserDTO implements ICernerUpdateUserDTO {
    agent34ID?: string;
    active?: boolean | undefined;

    constructor(data?: ICernerUpdateUserDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.agent34ID = _data["agent34ID"];
            this.active = _data["active"];
        }
    }

    static fromJS(data: any): CernerUpdateUserDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CernerUpdateUserDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["agent34ID"] = this.agent34ID;
        data["active"] = this.active;
        return data;
    }
}

export interface ICernerUpdateUserDTO {
    agent34ID?: string;
    active?: boolean | undefined;
}

export class APIResponseOfListOfWorkQueueSummaryResponse implements IAPIResponseOfListOfWorkQueueSummaryResponse {
    statusCode?: HttpStatusCode;
    isSuccess?: boolean;
    errorMessages?: string[];
    result?: WorkQueueSummaryResponse[] | undefined;

    constructor(data?: IAPIResponseOfListOfWorkQueueSummaryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusCode = _data["statusCode"];
            this.isSuccess = _data["isSuccess"];
            if (Array.isArray(_data["errorMessages"])) {
                this.errorMessages = [] as any;
                for (let item of _data["errorMessages"])
                    this.errorMessages!.push(item);
            }
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result!.push(WorkQueueSummaryResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): APIResponseOfListOfWorkQueueSummaryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new APIResponseOfListOfWorkQueueSummaryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["isSuccess"] = this.isSuccess;
        if (Array.isArray(this.errorMessages)) {
            data["errorMessages"] = [];
            for (let item of this.errorMessages)
                data["errorMessages"].push(item);
        }
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IAPIResponseOfListOfWorkQueueSummaryResponse {
    statusCode?: HttpStatusCode;
    isSuccess?: boolean;
    errorMessages?: string[];
    result?: WorkQueueSummaryResponse[] | undefined;
}

export class WorkQueueSummaryResponse implements IWorkQueueSummaryResponse {
    queueName?: string;
    total?: number;
    refWorkQueueProcMappingId?: number;

    constructor(data?: IWorkQueueSummaryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.queueName = _data["queueName"];
            this.total = _data["total"];
            this.refWorkQueueProcMappingId = _data["refWorkQueueProcMappingId"];
        }
    }

    static fromJS(data: any): WorkQueueSummaryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new WorkQueueSummaryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["queueName"] = this.queueName;
        data["total"] = this.total;
        data["refWorkQueueProcMappingId"] = this.refWorkQueueProcMappingId;
        return data;
    }
}

export interface IWorkQueueSummaryResponse {
    queueName?: string;
    total?: number;
    refWorkQueueProcMappingId?: number;
}

export class WorkQueueSummaryRequest implements IWorkQueueSummaryRequest {
    facilityIds?: string;
    facilityIdList?: string[];
    fromDate?: Date | undefined;
    toDate?: Date | undefined;

    constructor(data?: IWorkQueueSummaryRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.facilityIds = _data["facilityIds"];
            if (Array.isArray(_data["facilityIdList"])) {
                this.facilityIdList = [] as any;
                for (let item of _data["facilityIdList"])
                    this.facilityIdList!.push(item);
            }
            this.fromDate = _data["fromDate"] ? new Date(_data["fromDate"].toString()) : undefined as any;
            this.toDate = _data["toDate"] ? new Date(_data["toDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): WorkQueueSummaryRequest {
        data = typeof data === 'object' ? data : {};
        let result = new WorkQueueSummaryRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["facilityIds"] = this.facilityIds;
        if (Array.isArray(this.facilityIdList)) {
            data["facilityIdList"] = [];
            for (let item of this.facilityIdList)
                data["facilityIdList"].push(item);
        }
        data["fromDate"] = this.fromDate ? this.fromDate.toISOString() : undefined as any;
        data["toDate"] = this.toDate ? this.toDate.toISOString() : undefined as any;
        return data;
    }
}

export interface IWorkQueueSummaryRequest {
    facilityIds?: string;
    facilityIdList?: string[];
    fromDate?: Date | undefined;
    toDate?: Date | undefined;
}

export class APIResponseOfListOfWorkQueueDetail implements IAPIResponseOfListOfWorkQueueDetail {
    statusCode?: HttpStatusCode;
    isSuccess?: boolean;
    errorMessages?: string[];
    result?: WorkQueueDetail[] | undefined;

    constructor(data?: IAPIResponseOfListOfWorkQueueDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusCode = _data["statusCode"];
            this.isSuccess = _data["isSuccess"];
            if (Array.isArray(_data["errorMessages"])) {
                this.errorMessages = [] as any;
                for (let item of _data["errorMessages"])
                    this.errorMessages!.push(item);
            }
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result!.push(WorkQueueDetail.fromJS(item));
            }
        }
    }

    static fromJS(data: any): APIResponseOfListOfWorkQueueDetail {
        data = typeof data === 'object' ? data : {};
        let result = new APIResponseOfListOfWorkQueueDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["isSuccess"] = this.isSuccess;
        if (Array.isArray(this.errorMessages)) {
            data["errorMessages"] = [];
            for (let item of this.errorMessages)
                data["errorMessages"].push(item);
        }
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IAPIResponseOfListOfWorkQueueDetail {
    statusCode?: HttpStatusCode;
    isSuccess?: boolean;
    errorMessages?: string[];
    result?: WorkQueueDetail[] | undefined;
}

export class WorkQueueDetail implements IWorkQueueDetail {
    accountNumber?: string | undefined;
    facilityName?: string | undefined;
    apptURN?: string | undefined;
    coid?: number | undefined;
    status?: string;
    modifiedBy?: string | undefined;
    assignedTo?: string | undefined;
    importDate?: Date | undefined;
    modifiedDateUtc?: Date | undefined;
    rowsCount?: number | undefined;

    constructor(data?: IWorkQueueDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountNumber = _data["accountNumber"];
            this.facilityName = _data["facilityName"];
            this.apptURN = _data["apptURN"];
            this.coid = _data["coid"];
            this.status = _data["status"];
            this.modifiedBy = _data["modifiedBy"];
            this.assignedTo = _data["assignedTo"];
            this.importDate = _data["importDate"] ? new Date(_data["importDate"].toString()) : undefined as any;
            this.modifiedDateUtc = _data["modifiedDateUtc"] ? new Date(_data["modifiedDateUtc"].toString()) : undefined as any;
            this.rowsCount = _data["rowsCount"];
        }
    }

    static fromJS(data: any): WorkQueueDetail {
        data = typeof data === 'object' ? data : {};
        let result = new WorkQueueDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountNumber"] = this.accountNumber;
        data["facilityName"] = this.facilityName;
        data["apptURN"] = this.apptURN;
        data["coid"] = this.coid;
        data["status"] = this.status;
        data["modifiedBy"] = this.modifiedBy;
        data["assignedTo"] = this.assignedTo;
        data["importDate"] = this.importDate ? this.importDate.toISOString() : undefined as any;
        data["modifiedDateUtc"] = this.modifiedDateUtc ? this.modifiedDateUtc.toISOString() : undefined as any;
        data["rowsCount"] = this.rowsCount;
        return data;
    }
}

export interface IWorkQueueDetail {
    accountNumber?: string | undefined;
    facilityName?: string | undefined;
    apptURN?: string | undefined;
    coid?: number | undefined;
    status?: string;
    modifiedBy?: string | undefined;
    assignedTo?: string | undefined;
    importDate?: Date | undefined;
    modifiedDateUtc?: Date | undefined;
    rowsCount?: number | undefined;
}

export class WorkQueueDetailRequest implements IWorkQueueDetailRequest {
    facilityIds?: string;
    facilityIdList?: string[];
    queueName?: string;
    hasFilterOnImportDate?: boolean;
    fromImportDate?: Date | undefined;
    toImportDate?: Date | undefined;
    sortColumn?: string;
    sortDir?: string;
    page?: number;
    pageSize?: number;

    constructor(data?: IWorkQueueDetailRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.facilityIds = _data["facilityIds"];
            if (Array.isArray(_data["facilityIdList"])) {
                this.facilityIdList = [] as any;
                for (let item of _data["facilityIdList"])
                    this.facilityIdList!.push(item);
            }
            this.queueName = _data["queueName"];
            this.hasFilterOnImportDate = _data["hasFilterOnImportDate"];
            this.fromImportDate = _data["fromImportDate"] ? new Date(_data["fromImportDate"].toString()) : undefined as any;
            this.toImportDate = _data["toImportDate"] ? new Date(_data["toImportDate"].toString()) : undefined as any;
            this.sortColumn = _data["sortColumn"];
            this.sortDir = _data["sortDir"];
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
        }
    }

    static fromJS(data: any): WorkQueueDetailRequest {
        data = typeof data === 'object' ? data : {};
        let result = new WorkQueueDetailRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["facilityIds"] = this.facilityIds;
        if (Array.isArray(this.facilityIdList)) {
            data["facilityIdList"] = [];
            for (let item of this.facilityIdList)
                data["facilityIdList"].push(item);
        }
        data["queueName"] = this.queueName;
        data["hasFilterOnImportDate"] = this.hasFilterOnImportDate;
        data["fromImportDate"] = this.fromImportDate ? this.fromImportDate.toISOString() : undefined as any;
        data["toImportDate"] = this.toImportDate ? this.toImportDate.toISOString() : undefined as any;
        data["sortColumn"] = this.sortColumn;
        data["sortDir"] = this.sortDir;
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        return data;
    }
}

export interface IWorkQueueDetailRequest {
    facilityIds?: string;
    facilityIdList?: string[];
    queueName?: string;
    hasFilterOnImportDate?: boolean;
    fromImportDate?: Date | undefined;
    toImportDate?: Date | undefined;
    sortColumn?: string;
    sortDir?: string;
    page?: number;
    pageSize?: number;
}

export class APIResponseOfListOfWorkQueueStatusCountDetailsResponse implements IAPIResponseOfListOfWorkQueueStatusCountDetailsResponse {
    statusCode?: HttpStatusCode;
    isSuccess?: boolean;
    errorMessages?: string[];
    result?: WorkQueueStatusCountDetailsResponse[] | undefined;

    constructor(data?: IAPIResponseOfListOfWorkQueueStatusCountDetailsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusCode = _data["statusCode"];
            this.isSuccess = _data["isSuccess"];
            if (Array.isArray(_data["errorMessages"])) {
                this.errorMessages = [] as any;
                for (let item of _data["errorMessages"])
                    this.errorMessages!.push(item);
            }
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result!.push(WorkQueueStatusCountDetailsResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): APIResponseOfListOfWorkQueueStatusCountDetailsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new APIResponseOfListOfWorkQueueStatusCountDetailsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["isSuccess"] = this.isSuccess;
        if (Array.isArray(this.errorMessages)) {
            data["errorMessages"] = [];
            for (let item of this.errorMessages)
                data["errorMessages"].push(item);
        }
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IAPIResponseOfListOfWorkQueueStatusCountDetailsResponse {
    statusCode?: HttpStatusCode;
    isSuccess?: boolean;
    errorMessages?: string[];
    result?: WorkQueueStatusCountDetailsResponse[] | undefined;
}

export class WorkQueueStatusCountDetailsResponse implements IWorkQueueStatusCountDetailsResponse {
    divisions?: Division3[] | undefined;

    constructor(data?: IWorkQueueStatusCountDetailsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["divisions"])) {
                this.divisions = [] as any;
                for (let item of _data["divisions"])
                    this.divisions!.push(Division3.fromJS(item));
            }
        }
    }

    static fromJS(data: any): WorkQueueStatusCountDetailsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new WorkQueueStatusCountDetailsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.divisions)) {
            data["divisions"] = [];
            for (let item of this.divisions)
                data["divisions"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IWorkQueueStatusCountDetailsResponse {
    divisions?: Division3[] | undefined;
}

export class WorkQueueStatusBase implements IWorkQueueStatusBase {
    type?: string | undefined;
    name?: string | undefined;
    divisionId?: number | undefined;
    marketId?: number | undefined;
    inProgress?: number | undefined;
    notStarted?: number | undefined;
    completed?: number | undefined;

    constructor(data?: IWorkQueueStatusBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.name = _data["name"];
            this.divisionId = _data["divisionId"];
            this.marketId = _data["marketId"];
            this.inProgress = _data["inProgress"];
            this.notStarted = _data["notStarted"];
            this.completed = _data["completed"];
        }
    }

    static fromJS(data: any): WorkQueueStatusBase {
        data = typeof data === 'object' ? data : {};
        let result = new WorkQueueStatusBase();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["name"] = this.name;
        data["divisionId"] = this.divisionId;
        data["marketId"] = this.marketId;
        data["inProgress"] = this.inProgress;
        data["notStarted"] = this.notStarted;
        data["completed"] = this.completed;
        return data;
    }
}

export interface IWorkQueueStatusBase {
    type?: string | undefined;
    name?: string | undefined;
    divisionId?: number | undefined;
    marketId?: number | undefined;
    inProgress?: number | undefined;
    notStarted?: number | undefined;
    completed?: number | undefined;
}

export class Division3 extends WorkQueueStatusBase implements IDivision3 {
    markets?: Market[] | undefined;

    constructor(data?: IDivision3) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["markets"])) {
                this.markets = [] as any;
                for (let item of _data["markets"])
                    this.markets!.push(Market.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): Division3 {
        data = typeof data === 'object' ? data : {};
        let result = new Division3();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.markets)) {
            data["markets"] = [];
            for (let item of this.markets)
                data["markets"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IDivision3 extends IWorkQueueStatusBase {
    markets?: Market[] | undefined;
}

export class Market extends WorkQueueStatusBase implements IMarket {
    facilities?: Facility4[] | undefined;

    constructor(data?: IMarket) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["facilities"])) {
                this.facilities = [] as any;
                for (let item of _data["facilities"])
                    this.facilities!.push(Facility4.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): Market {
        data = typeof data === 'object' ? data : {};
        let result = new Market();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.facilities)) {
            data["facilities"] = [];
            for (let item of this.facilities)
                data["facilities"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IMarket extends IWorkQueueStatusBase {
    facilities?: Facility4[] | undefined;
}

export class Facility4 extends WorkQueueStatusBase implements IFacility4 {

    constructor(data?: IFacility4) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): Facility4 {
        data = typeof data === 'object' ? data : {};
        let result = new Facility4();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IFacility4 extends IWorkQueueStatusBase {
}

export class WorkQueueStatusCountDetailsRequest implements IWorkQueueStatusCountDetailsRequest {
    id?: number | undefined;
    facilityIds?: string | undefined;
    facilityIdList?: string[];

    constructor(data?: IWorkQueueStatusCountDetailsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.facilityIds = _data["facilityIds"];
            if (Array.isArray(_data["facilityIdList"])) {
                this.facilityIdList = [] as any;
                for (let item of _data["facilityIdList"])
                    this.facilityIdList!.push(item);
            }
        }
    }

    static fromJS(data: any): WorkQueueStatusCountDetailsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new WorkQueueStatusCountDetailsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["facilityIds"] = this.facilityIds;
        if (Array.isArray(this.facilityIdList)) {
            data["facilityIdList"] = [];
            for (let item of this.facilityIdList)
                data["facilityIdList"].push(item);
        }
        return data;
    }
}

export interface IWorkQueueStatusCountDetailsRequest {
    id?: number | undefined;
    facilityIds?: string | undefined;
    facilityIdList?: string[];
}

export class APIResponseOfListOfTEFQueueSummaryResponse implements IAPIResponseOfListOfTEFQueueSummaryResponse {
    statusCode?: HttpStatusCode;
    isSuccess?: boolean;
    errorMessages?: string[];
    result?: TEFQueueSummaryResponse[] | undefined;

    constructor(data?: IAPIResponseOfListOfTEFQueueSummaryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusCode = _data["statusCode"];
            this.isSuccess = _data["isSuccess"];
            if (Array.isArray(_data["errorMessages"])) {
                this.errorMessages = [] as any;
                for (let item of _data["errorMessages"])
                    this.errorMessages!.push(item);
            }
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result!.push(TEFQueueSummaryResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): APIResponseOfListOfTEFQueueSummaryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new APIResponseOfListOfTEFQueueSummaryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["isSuccess"] = this.isSuccess;
        if (Array.isArray(this.errorMessages)) {
            data["errorMessages"] = [];
            for (let item of this.errorMessages)
                data["errorMessages"].push(item);
        }
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IAPIResponseOfListOfTEFQueueSummaryResponse {
    statusCode?: HttpStatusCode;
    isSuccess?: boolean;
    errorMessages?: string[];
    result?: TEFQueueSummaryResponse[] | undefined;
}

export class TEFQueueSummaryResponse implements ITEFQueueSummaryResponse {
    sscs?: TEFQueueSSC[] | undefined;

    constructor(data?: ITEFQueueSummaryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["sscs"])) {
                this.sscs = [] as any;
                for (let item of _data["sscs"])
                    this.sscs!.push(TEFQueueSSC.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TEFQueueSummaryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TEFQueueSummaryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.sscs)) {
            data["sscs"] = [];
            for (let item of this.sscs)
                data["sscs"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ITEFQueueSummaryResponse {
    sscs?: TEFQueueSSC[] | undefined;
}

export class TEFQueueSummaryBase implements ITEFQueueSummaryBase {
    type?: string | undefined;
    name?: string | undefined;
    sscId?: number | undefined;
    divisionId?: number | undefined;
    facilityId?: number | undefined;
    notStarted?: number | undefined;
    inProgress?: number | undefined;
    complete?: number | undefined;
    highPriority?: number | undefined;

    constructor(data?: ITEFQueueSummaryBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.name = _data["name"];
            this.sscId = _data["sscId"];
            this.divisionId = _data["divisionId"];
            this.facilityId = _data["facilityId"];
            this.notStarted = _data["notStarted"];
            this.inProgress = _data["inProgress"];
            this.complete = _data["complete"];
            this.highPriority = _data["highPriority"];
        }
    }

    static fromJS(data: any): TEFQueueSummaryBase {
        data = typeof data === 'object' ? data : {};
        let result = new TEFQueueSummaryBase();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["name"] = this.name;
        data["sscId"] = this.sscId;
        data["divisionId"] = this.divisionId;
        data["facilityId"] = this.facilityId;
        data["notStarted"] = this.notStarted;
        data["inProgress"] = this.inProgress;
        data["complete"] = this.complete;
        data["highPriority"] = this.highPriority;
        return data;
    }
}

export interface ITEFQueueSummaryBase {
    type?: string | undefined;
    name?: string | undefined;
    sscId?: number | undefined;
    divisionId?: number | undefined;
    facilityId?: number | undefined;
    notStarted?: number | undefined;
    inProgress?: number | undefined;
    complete?: number | undefined;
    highPriority?: number | undefined;
}

export class TEFQueueSSC extends TEFQueueSummaryBase implements ITEFQueueSSC {
    divisions?: TEFQueueDivision[] | undefined;

    constructor(data?: ITEFQueueSSC) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["divisions"])) {
                this.divisions = [] as any;
                for (let item of _data["divisions"])
                    this.divisions!.push(TEFQueueDivision.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): TEFQueueSSC {
        data = typeof data === 'object' ? data : {};
        let result = new TEFQueueSSC();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.divisions)) {
            data["divisions"] = [];
            for (let item of this.divisions)
                data["divisions"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface ITEFQueueSSC extends ITEFQueueSummaryBase {
    divisions?: TEFQueueDivision[] | undefined;
}

export class TEFQueueDivision extends TEFQueueSummaryBase implements ITEFQueueDivision {
    facilities?: TEFQueueFacility[] | undefined;

    constructor(data?: ITEFQueueDivision) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["facilities"])) {
                this.facilities = [] as any;
                for (let item of _data["facilities"])
                    this.facilities!.push(TEFQueueFacility.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): TEFQueueDivision {
        data = typeof data === 'object' ? data : {};
        let result = new TEFQueueDivision();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.facilities)) {
            data["facilities"] = [];
            for (let item of this.facilities)
                data["facilities"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface ITEFQueueDivision extends ITEFQueueSummaryBase {
    facilities?: TEFQueueFacility[] | undefined;
}

export class TEFQueueFacility extends TEFQueueSummaryBase implements ITEFQueueFacility {

    constructor(data?: ITEFQueueFacility) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): TEFQueueFacility {
        data = typeof data === 'object' ? data : {};
        let result = new TEFQueueFacility();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface ITEFQueueFacility extends ITEFQueueSummaryBase {
}

export class TEFQueueSummaryRequest implements ITEFQueueSummaryRequest {
    facilityIds?: string | undefined;
    facilityIdList?: string[] | undefined;
    queueStatuses?: string | undefined;
    fromDate?: Date | undefined;
    toDate?: Date | undefined;

    constructor(data?: ITEFQueueSummaryRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.facilityIds = _data["facilityIds"];
            if (Array.isArray(_data["facilityIdList"])) {
                this.facilityIdList = [] as any;
                for (let item of _data["facilityIdList"])
                    this.facilityIdList!.push(item);
            }
            this.queueStatuses = _data["queueStatuses"];
            this.fromDate = _data["fromDate"] ? new Date(_data["fromDate"].toString()) : undefined as any;
            this.toDate = _data["toDate"] ? new Date(_data["toDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): TEFQueueSummaryRequest {
        data = typeof data === 'object' ? data : {};
        let result = new TEFQueueSummaryRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["facilityIds"] = this.facilityIds;
        if (Array.isArray(this.facilityIdList)) {
            data["facilityIdList"] = [];
            for (let item of this.facilityIdList)
                data["facilityIdList"].push(item);
        }
        data["queueStatuses"] = this.queueStatuses;
        data["fromDate"] = this.fromDate ? this.fromDate.toISOString() : undefined as any;
        data["toDate"] = this.toDate ? this.toDate.toISOString() : undefined as any;
        return data;
    }
}

export interface ITEFQueueSummaryRequest {
    facilityIds?: string | undefined;
    facilityIdList?: string[] | undefined;
    queueStatuses?: string | undefined;
    fromDate?: Date | undefined;
    toDate?: Date | undefined;
}

export class APIResponseOfListOfTEFQueueListViewDetailDTO implements IAPIResponseOfListOfTEFQueueListViewDetailDTO {
    statusCode?: HttpStatusCode;
    isSuccess?: boolean;
    errorMessages?: string[];
    result?: TEFQueueListViewDetailDTO[] | undefined;

    constructor(data?: IAPIResponseOfListOfTEFQueueListViewDetailDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusCode = _data["statusCode"];
            this.isSuccess = _data["isSuccess"];
            if (Array.isArray(_data["errorMessages"])) {
                this.errorMessages = [] as any;
                for (let item of _data["errorMessages"])
                    this.errorMessages!.push(item);
            }
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result!.push(TEFQueueListViewDetailDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): APIResponseOfListOfTEFQueueListViewDetailDTO {
        data = typeof data === 'object' ? data : {};
        let result = new APIResponseOfListOfTEFQueueListViewDetailDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["isSuccess"] = this.isSuccess;
        if (Array.isArray(this.errorMessages)) {
            data["errorMessages"] = [];
            for (let item of this.errorMessages)
                data["errorMessages"].push(item);
        }
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IAPIResponseOfListOfTEFQueueListViewDetailDTO {
    statusCode?: HttpStatusCode;
    isSuccess?: boolean;
    errorMessages?: string[];
    result?: TEFQueueListViewDetailDTO[] | undefined;
}

export class TEFQueueListViewDetailDTO implements ITEFQueueListViewDetailDTO {
    accountNumber?: string | undefined;
    facilityName?: string | undefined;
    emrSystem?: string | undefined;
    coid?: number | undefined;
    status?: string;
    modifiedBy?: string | undefined;
    lockedBy?: string | undefined;
    importDate?: Date | undefined;
    modifiedDateUtc?: Date | undefined;
    rowsCount?: number | undefined;
    mnemonic?: string | undefined;
    patient?: string | undefined;
    meditechMarket?: string | undefined;
    interactionCount?: number | undefined;
    outcome?: string | undefined;
    apptAge?: number | undefined;

    constructor(data?: ITEFQueueListViewDetailDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountNumber = _data["accountNumber"];
            this.facilityName = _data["facilityName"];
            this.emrSystem = _data["emrSystem"];
            this.coid = _data["coid"];
            this.status = _data["status"];
            this.modifiedBy = _data["modifiedBy"];
            this.lockedBy = _data["lockedBy"];
            this.importDate = _data["importDate"] ? new Date(_data["importDate"].toString()) : undefined as any;
            this.modifiedDateUtc = _data["modifiedDateUtc"] ? new Date(_data["modifiedDateUtc"].toString()) : undefined as any;
            this.rowsCount = _data["rowsCount"];
            this.mnemonic = _data["mnemonic"];
            this.patient = _data["patient"];
            this.meditechMarket = _data["meditechMarket"];
            this.interactionCount = _data["interactionCount"];
            this.outcome = _data["outcome"];
            this.apptAge = _data["apptAge"];
        }
    }

    static fromJS(data: any): TEFQueueListViewDetailDTO {
        data = typeof data === 'object' ? data : {};
        let result = new TEFQueueListViewDetailDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountNumber"] = this.accountNumber;
        data["facilityName"] = this.facilityName;
        data["emrSystem"] = this.emrSystem;
        data["coid"] = this.coid;
        data["status"] = this.status;
        data["modifiedBy"] = this.modifiedBy;
        data["lockedBy"] = this.lockedBy;
        data["importDate"] = this.importDate ? this.importDate.toISOString() : undefined as any;
        data["modifiedDateUtc"] = this.modifiedDateUtc ? this.modifiedDateUtc.toISOString() : undefined as any;
        data["rowsCount"] = this.rowsCount;
        data["mnemonic"] = this.mnemonic;
        data["patient"] = this.patient;
        data["meditechMarket"] = this.meditechMarket;
        data["interactionCount"] = this.interactionCount;
        data["outcome"] = this.outcome;
        data["apptAge"] = this.apptAge;
        return data;
    }
}

export interface ITEFQueueListViewDetailDTO {
    accountNumber?: string | undefined;
    facilityName?: string | undefined;
    emrSystem?: string | undefined;
    coid?: number | undefined;
    status?: string;
    modifiedBy?: string | undefined;
    lockedBy?: string | undefined;
    importDate?: Date | undefined;
    modifiedDateUtc?: Date | undefined;
    rowsCount?: number | undefined;
    mnemonic?: string | undefined;
    patient?: string | undefined;
    meditechMarket?: string | undefined;
    interactionCount?: number | undefined;
    outcome?: string | undefined;
    apptAge?: number | undefined;
}

export class TEFQueueListViewRequest implements ITEFQueueListViewRequest {
    queueStatuses?: string;
    facilityIds?: string;
    facilityIdList?: string[];
    queueName?: string;
    sortColumn?: string;
    emrSystems?: string;
    emrSystemList?: string[];
    sortDir?: string;
    page?: number;
    pageSize?: number;
    genesysInteractionOutcomes?: string;
    isHighPriority?: boolean;
    fromDate?: Date | undefined;
    toDate?: Date | undefined;

    constructor(data?: ITEFQueueListViewRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.queueStatuses = _data["queueStatuses"];
            this.facilityIds = _data["facilityIds"];
            if (Array.isArray(_data["facilityIdList"])) {
                this.facilityIdList = [] as any;
                for (let item of _data["facilityIdList"])
                    this.facilityIdList!.push(item);
            }
            this.queueName = _data["queueName"];
            this.sortColumn = _data["sortColumn"];
            this.emrSystems = _data["emrSystems"];
            if (Array.isArray(_data["emrSystemList"])) {
                this.emrSystemList = [] as any;
                for (let item of _data["emrSystemList"])
                    this.emrSystemList!.push(item);
            }
            this.sortDir = _data["sortDir"];
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
            this.genesysInteractionOutcomes = _data["genesysInteractionOutcomes"];
            this.isHighPriority = _data["isHighPriority"];
            this.fromDate = _data["fromDate"] ? new Date(_data["fromDate"].toString()) : undefined as any;
            this.toDate = _data["toDate"] ? new Date(_data["toDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): TEFQueueListViewRequest {
        data = typeof data === 'object' ? data : {};
        let result = new TEFQueueListViewRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["queueStatuses"] = this.queueStatuses;
        data["facilityIds"] = this.facilityIds;
        if (Array.isArray(this.facilityIdList)) {
            data["facilityIdList"] = [];
            for (let item of this.facilityIdList)
                data["facilityIdList"].push(item);
        }
        data["queueName"] = this.queueName;
        data["sortColumn"] = this.sortColumn;
        data["emrSystems"] = this.emrSystems;
        if (Array.isArray(this.emrSystemList)) {
            data["emrSystemList"] = [];
            for (let item of this.emrSystemList)
                data["emrSystemList"].push(item);
        }
        data["sortDir"] = this.sortDir;
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        data["genesysInteractionOutcomes"] = this.genesysInteractionOutcomes;
        data["isHighPriority"] = this.isHighPriority;
        data["fromDate"] = this.fromDate ? this.fromDate.toISOString() : undefined as any;
        data["toDate"] = this.toDate ? this.toDate.toISOString() : undefined as any;
        return data;
    }
}

export interface ITEFQueueListViewRequest {
    queueStatuses?: string;
    facilityIds?: string;
    facilityIdList?: string[];
    queueName?: string;
    sortColumn?: string;
    emrSystems?: string;
    emrSystemList?: string[];
    sortDir?: string;
    page?: number;
    pageSize?: number;
    genesysInteractionOutcomes?: string;
    isHighPriority?: boolean;
    fromDate?: Date | undefined;
    toDate?: Date | undefined;
}

export class APIResponseOfPreRegFiltersDTO implements IAPIResponseOfPreRegFiltersDTO {
    statusCode?: HttpStatusCode;
    isSuccess?: boolean;
    errorMessages?: string[];
    result?: PreRegFiltersDTO | undefined;

    constructor(data?: IAPIResponseOfPreRegFiltersDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusCode = _data["statusCode"];
            this.isSuccess = _data["isSuccess"];
            if (Array.isArray(_data["errorMessages"])) {
                this.errorMessages = [] as any;
                for (let item of _data["errorMessages"])
                    this.errorMessages!.push(item);
            }
            this.result = _data["result"] ? PreRegFiltersDTO.fromJS(_data["result"]) : undefined as any;
        }
    }

    static fromJS(data: any): APIResponseOfPreRegFiltersDTO {
        data = typeof data === 'object' ? data : {};
        let result = new APIResponseOfPreRegFiltersDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["isSuccess"] = this.isSuccess;
        if (Array.isArray(this.errorMessages)) {
            data["errorMessages"] = [];
            for (let item of this.errorMessages)
                data["errorMessages"].push(item);
        }
        data["result"] = this.result ? this.result.toJSON() : undefined as any;
        return data;
    }
}

export interface IAPIResponseOfPreRegFiltersDTO {
    statusCode?: HttpStatusCode;
    isSuccess?: boolean;
    errorMessages?: string[];
    result?: PreRegFiltersDTO | undefined;
}

export class PreRegFiltersDTO implements IPreRegFiltersDTO {
    facilities?: PreRegFacilityRoot[];
    accountStatuses?: DropDownItem[];
    outcomes?: DropDownItem[];
    campaigns?: DropDownItem[];
    preRegSites?: DropDownItem[];

    constructor(data?: IPreRegFiltersDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["facilities"])) {
                this.facilities = [] as any;
                for (let item of _data["facilities"])
                    this.facilities!.push(PreRegFacilityRoot.fromJS(item));
            }
            if (Array.isArray(_data["accountStatuses"])) {
                this.accountStatuses = [] as any;
                for (let item of _data["accountStatuses"])
                    this.accountStatuses!.push(DropDownItem.fromJS(item));
            }
            if (Array.isArray(_data["outcomes"])) {
                this.outcomes = [] as any;
                for (let item of _data["outcomes"])
                    this.outcomes!.push(DropDownItem.fromJS(item));
            }
            if (Array.isArray(_data["campaigns"])) {
                this.campaigns = [] as any;
                for (let item of _data["campaigns"])
                    this.campaigns!.push(DropDownItem.fromJS(item));
            }
            if (Array.isArray(_data["preRegSites"])) {
                this.preRegSites = [] as any;
                for (let item of _data["preRegSites"])
                    this.preRegSites!.push(DropDownItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PreRegFiltersDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PreRegFiltersDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.facilities)) {
            data["facilities"] = [];
            for (let item of this.facilities)
                data["facilities"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.accountStatuses)) {
            data["accountStatuses"] = [];
            for (let item of this.accountStatuses)
                data["accountStatuses"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.outcomes)) {
            data["outcomes"] = [];
            for (let item of this.outcomes)
                data["outcomes"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.campaigns)) {
            data["campaigns"] = [];
            for (let item of this.campaigns)
                data["campaigns"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.preRegSites)) {
            data["preRegSites"] = [];
            for (let item of this.preRegSites)
                data["preRegSites"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPreRegFiltersDTO {
    facilities?: PreRegFacilityRoot[];
    accountStatuses?: DropDownItem[];
    outcomes?: DropDownItem[];
    campaigns?: DropDownItem[];
    preRegSites?: DropDownItem[];
}

export class PreRegFacilityRoot implements IPreRegFacilityRoot {
    value?: string;
    label?: string;
    children?: Child2[];

    constructor(data?: IPreRegFacilityRoot) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.label = _data["label"];
            if (Array.isArray(_data["children"])) {
                this.children = [] as any;
                for (let item of _data["children"])
                    this.children!.push(Child2.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PreRegFacilityRoot {
        data = typeof data === 'object' ? data : {};
        let result = new PreRegFacilityRoot();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["label"] = this.label;
        if (Array.isArray(this.children)) {
            data["children"] = [];
            for (let item of this.children)
                data["children"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPreRegFacilityRoot {
    value?: string;
    label?: string;
    children?: Child2[];
}

export class Child2 implements IChild2 {
    value?: string;
    label?: string;

    constructor(data?: IChild2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.label = _data["label"];
        }
    }

    static fromJS(data: any): Child2 {
        data = typeof data === 'object' ? data : {};
        let result = new Child2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["label"] = this.label;
        return data;
    }
}

export interface IChild2 {
    value?: string;
    label?: string;
}

export class APIResponseOfPuAutomationFiltersDTO implements IAPIResponseOfPuAutomationFiltersDTO {
    statusCode?: HttpStatusCode;
    isSuccess?: boolean;
    errorMessages?: string[];
    result?: PuAutomationFiltersDTO | undefined;

    constructor(data?: IAPIResponseOfPuAutomationFiltersDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusCode = _data["statusCode"];
            this.isSuccess = _data["isSuccess"];
            if (Array.isArray(_data["errorMessages"])) {
                this.errorMessages = [] as any;
                for (let item of _data["errorMessages"])
                    this.errorMessages!.push(item);
            }
            this.result = _data["result"] ? PuAutomationFiltersDTO.fromJS(_data["result"]) : undefined as any;
        }
    }

    static fromJS(data: any): APIResponseOfPuAutomationFiltersDTO {
        data = typeof data === 'object' ? data : {};
        let result = new APIResponseOfPuAutomationFiltersDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["isSuccess"] = this.isSuccess;
        if (Array.isArray(this.errorMessages)) {
            data["errorMessages"] = [];
            for (let item of this.errorMessages)
                data["errorMessages"].push(item);
        }
        data["result"] = this.result ? this.result.toJSON() : undefined as any;
        return data;
    }
}

export interface IAPIResponseOfPuAutomationFiltersDTO {
    statusCode?: HttpStatusCode;
    isSuccess?: boolean;
    errorMessages?: string[];
    result?: PuAutomationFiltersDTO | undefined;
}

export class PuAutomationFiltersDTO implements IPuAutomationFiltersDTO {
    facilities?: PreRegFacilityRoot[];
    status?: DropDownItem[];
    campaign?: DropDownItem[];
    preRegSites?: DropDownItem[];
    puAmountDue?: PUAmountDueDTO[];

    constructor(data?: IPuAutomationFiltersDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["facilities"])) {
                this.facilities = [] as any;
                for (let item of _data["facilities"])
                    this.facilities!.push(PreRegFacilityRoot.fromJS(item));
            }
            if (Array.isArray(_data["status"])) {
                this.status = [] as any;
                for (let item of _data["status"])
                    this.status!.push(DropDownItem.fromJS(item));
            }
            if (Array.isArray(_data["campaign"])) {
                this.campaign = [] as any;
                for (let item of _data["campaign"])
                    this.campaign!.push(DropDownItem.fromJS(item));
            }
            if (Array.isArray(_data["preRegSites"])) {
                this.preRegSites = [] as any;
                for (let item of _data["preRegSites"])
                    this.preRegSites!.push(DropDownItem.fromJS(item));
            }
            if (Array.isArray(_data["puAmountDue"])) {
                this.puAmountDue = [] as any;
                for (let item of _data["puAmountDue"])
                    this.puAmountDue!.push(PUAmountDueDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PuAutomationFiltersDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PuAutomationFiltersDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.facilities)) {
            data["facilities"] = [];
            for (let item of this.facilities)
                data["facilities"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.status)) {
            data["status"] = [];
            for (let item of this.status)
                data["status"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.campaign)) {
            data["campaign"] = [];
            for (let item of this.campaign)
                data["campaign"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.preRegSites)) {
            data["preRegSites"] = [];
            for (let item of this.preRegSites)
                data["preRegSites"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.puAmountDue)) {
            data["puAmountDue"] = [];
            for (let item of this.puAmountDue)
                data["puAmountDue"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPuAutomationFiltersDTO {
    facilities?: PreRegFacilityRoot[];
    status?: DropDownItem[];
    campaign?: DropDownItem[];
    preRegSites?: DropDownItem[];
    puAmountDue?: PUAmountDueDTO[];
}

export class PUAmountDueDTO implements IPUAmountDueDTO {
    displayValue?: string;
    filterValue?: string;
    orderNumber?: number;

    constructor(data?: IPUAmountDueDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.displayValue = _data["displayValue"];
            this.filterValue = _data["filterValue"];
            this.orderNumber = _data["orderNumber"];
        }
    }

    static fromJS(data: any): PUAmountDueDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PUAmountDueDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["displayValue"] = this.displayValue;
        data["filterValue"] = this.filterValue;
        data["orderNumber"] = this.orderNumber;
        return data;
    }
}

export interface IPUAmountDueDTO {
    displayValue?: string;
    filterValue?: string;
    orderNumber?: number;
}

export class APIResponseOfListOfPreRegQueueListViewDetailDTO implements IAPIResponseOfListOfPreRegQueueListViewDetailDTO {
    statusCode?: HttpStatusCode;
    isSuccess?: boolean;
    errorMessages?: string[];
    result?: PreRegQueueListViewDetailDTO[] | undefined;

    constructor(data?: IAPIResponseOfListOfPreRegQueueListViewDetailDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusCode = _data["statusCode"];
            this.isSuccess = _data["isSuccess"];
            if (Array.isArray(_data["errorMessages"])) {
                this.errorMessages = [] as any;
                for (let item of _data["errorMessages"])
                    this.errorMessages!.push(item);
            }
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result!.push(PreRegQueueListViewDetailDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): APIResponseOfListOfPreRegQueueListViewDetailDTO {
        data = typeof data === 'object' ? data : {};
        let result = new APIResponseOfListOfPreRegQueueListViewDetailDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["isSuccess"] = this.isSuccess;
        if (Array.isArray(this.errorMessages)) {
            data["errorMessages"] = [];
            for (let item of this.errorMessages)
                data["errorMessages"].push(item);
        }
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IAPIResponseOfListOfPreRegQueueListViewDetailDTO {
    statusCode?: HttpStatusCode;
    isSuccess?: boolean;
    errorMessages?: string[];
    result?: PreRegQueueListViewDetailDTO[] | undefined;
}

export class PreRegQueueListViewDetailDTO implements IPreRegQueueListViewDetailDTO {
    patient?: string | undefined;
    outcome?: string | undefined;
    accountNumber?: string | undefined;
    campaign?: string | undefined;
    dateofservice?: Date | undefined;
    accountStatus?: string;
    interactionCount?: number | undefined;
    interactionDate?: Date | undefined;
    refPreRegSiteCode?: string | undefined;
    preRegSiteDate?: Date | undefined;
    estimatedPatientDueAmount?: string | undefined;
    receivedAmount?: string | undefined;
    rowsCount?: number;
    coid?: number;
    lockedBy?: string | undefined;

    constructor(data?: IPreRegQueueListViewDetailDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.patient = _data["patient"];
            this.outcome = _data["outcome"];
            this.accountNumber = _data["accountNumber"];
            this.campaign = _data["campaign"];
            this.dateofservice = _data["dateofservice"] ? new Date(_data["dateofservice"].toString()) : undefined as any;
            this.accountStatus = _data["accountStatus"];
            this.interactionCount = _data["interactionCount"];
            this.interactionDate = _data["interactionDate"] ? new Date(_data["interactionDate"].toString()) : undefined as any;
            this.refPreRegSiteCode = _data["refPreRegSiteCode"];
            this.preRegSiteDate = _data["preRegSiteDate"] ? new Date(_data["preRegSiteDate"].toString()) : undefined as any;
            this.estimatedPatientDueAmount = _data["estimatedPatientDueAmount"];
            this.receivedAmount = _data["receivedAmount"];
            this.rowsCount = _data["rowsCount"];
            this.coid = _data["coid"];
            this.lockedBy = _data["lockedBy"];
        }
    }

    static fromJS(data: any): PreRegQueueListViewDetailDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PreRegQueueListViewDetailDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["patient"] = this.patient;
        data["outcome"] = this.outcome;
        data["accountNumber"] = this.accountNumber;
        data["campaign"] = this.campaign;
        data["dateofservice"] = this.dateofservice ? this.dateofservice.toISOString() : undefined as any;
        data["accountStatus"] = this.accountStatus;
        data["interactionCount"] = this.interactionCount;
        data["interactionDate"] = this.interactionDate ? this.interactionDate.toISOString() : undefined as any;
        data["refPreRegSiteCode"] = this.refPreRegSiteCode;
        data["preRegSiteDate"] = this.preRegSiteDate ? this.preRegSiteDate.toISOString() : undefined as any;
        data["estimatedPatientDueAmount"] = this.estimatedPatientDueAmount;
        data["receivedAmount"] = this.receivedAmount;
        data["rowsCount"] = this.rowsCount;
        data["coid"] = this.coid;
        data["lockedBy"] = this.lockedBy;
        return data;
    }
}

export interface IPreRegQueueListViewDetailDTO {
    patient?: string | undefined;
    outcome?: string | undefined;
    accountNumber?: string | undefined;
    campaign?: string | undefined;
    dateofservice?: Date | undefined;
    accountStatus?: string;
    interactionCount?: number | undefined;
    interactionDate?: Date | undefined;
    refPreRegSiteCode?: string | undefined;
    preRegSiteDate?: Date | undefined;
    estimatedPatientDueAmount?: string | undefined;
    receivedAmount?: string | undefined;
    rowsCount?: number;
    coid?: number;
    lockedBy?: string | undefined;
}

export class PreRegQueueListViewRequest implements IPreRegQueueListViewRequest {
    queueStatuses?: string | undefined;
    facilityIds?: string;
    facilityIdList?: string[];
    sortColumn?: string | undefined;
    sortDir?: string | undefined;
    page?: number;
    pageSize?: number;
    genesysInteractionOutcomes?: string | undefined;
    campaign?: string | undefined;
    preRegSite?: string | undefined;
    interactionStartDate?: Date | undefined;
    interactionEndDate?: Date | undefined;

    constructor(data?: IPreRegQueueListViewRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.queueStatuses = _data["queueStatuses"];
            this.facilityIds = _data["facilityIds"];
            if (Array.isArray(_data["facilityIdList"])) {
                this.facilityIdList = [] as any;
                for (let item of _data["facilityIdList"])
                    this.facilityIdList!.push(item);
            }
            this.sortColumn = _data["sortColumn"];
            this.sortDir = _data["sortDir"];
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
            this.genesysInteractionOutcomes = _data["genesysInteractionOutcomes"];
            this.campaign = _data["campaign"];
            this.preRegSite = _data["preRegSite"];
            this.interactionStartDate = _data["interactionStartDate"] ? new Date(_data["interactionStartDate"].toString()) : undefined as any;
            this.interactionEndDate = _data["interactionEndDate"] ? new Date(_data["interactionEndDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): PreRegQueueListViewRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PreRegQueueListViewRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["queueStatuses"] = this.queueStatuses;
        data["facilityIds"] = this.facilityIds;
        if (Array.isArray(this.facilityIdList)) {
            data["facilityIdList"] = [];
            for (let item of this.facilityIdList)
                data["facilityIdList"].push(item);
        }
        data["sortColumn"] = this.sortColumn;
        data["sortDir"] = this.sortDir;
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        data["genesysInteractionOutcomes"] = this.genesysInteractionOutcomes;
        data["campaign"] = this.campaign;
        data["preRegSite"] = this.preRegSite;
        data["interactionStartDate"] = this.interactionStartDate ? this.interactionStartDate.toISOString() : undefined as any;
        data["interactionEndDate"] = this.interactionEndDate ? this.interactionEndDate.toISOString() : undefined as any;
        return data;
    }
}

export interface IPreRegQueueListViewRequest {
    queueStatuses?: string | undefined;
    facilityIds?: string;
    facilityIdList?: string[];
    sortColumn?: string | undefined;
    sortDir?: string | undefined;
    page?: number;
    pageSize?: number;
    genesysInteractionOutcomes?: string | undefined;
    campaign?: string | undefined;
    preRegSite?: string | undefined;
    interactionStartDate?: Date | undefined;
    interactionEndDate?: Date | undefined;
}

export class APIResponseOfPreRegListViewResponseDTO implements IAPIResponseOfPreRegListViewResponseDTO {
    statusCode?: HttpStatusCode;
    isSuccess?: boolean;
    errorMessages?: string[];
    result?: PreRegListViewResponseDTO | undefined;

    constructor(data?: IAPIResponseOfPreRegListViewResponseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusCode = _data["statusCode"];
            this.isSuccess = _data["isSuccess"];
            if (Array.isArray(_data["errorMessages"])) {
                this.errorMessages = [] as any;
                for (let item of _data["errorMessages"])
                    this.errorMessages!.push(item);
            }
            this.result = _data["result"] ? PreRegListViewResponseDTO.fromJS(_data["result"]) : undefined as any;
        }
    }

    static fromJS(data: any): APIResponseOfPreRegListViewResponseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new APIResponseOfPreRegListViewResponseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["isSuccess"] = this.isSuccess;
        if (Array.isArray(this.errorMessages)) {
            data["errorMessages"] = [];
            for (let item of this.errorMessages)
                data["errorMessages"].push(item);
        }
        data["result"] = this.result ? this.result.toJSON() : undefined as any;
        return data;
    }
}

export interface IAPIResponseOfPreRegListViewResponseDTO {
    statusCode?: HttpStatusCode;
    isSuccess?: boolean;
    errorMessages?: string[];
    result?: PreRegListViewResponseDTO | undefined;
}

export class PreRegListViewResponseDTO implements IPreRegListViewResponseDTO {
    preRegListViewDetails?: PreRegListViewDetailDTO[] | undefined;
    puAutomationListViewDetails?: PuAutomationListViewDetailDTO[] | undefined;

    constructor(data?: IPreRegListViewResponseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["preRegListViewDetails"])) {
                this.preRegListViewDetails = [] as any;
                for (let item of _data["preRegListViewDetails"])
                    this.preRegListViewDetails!.push(PreRegListViewDetailDTO.fromJS(item));
            }
            if (Array.isArray(_data["puAutomationListViewDetails"])) {
                this.puAutomationListViewDetails = [] as any;
                for (let item of _data["puAutomationListViewDetails"])
                    this.puAutomationListViewDetails!.push(PuAutomationListViewDetailDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PreRegListViewResponseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PreRegListViewResponseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.preRegListViewDetails)) {
            data["preRegListViewDetails"] = [];
            for (let item of this.preRegListViewDetails)
                data["preRegListViewDetails"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.puAutomationListViewDetails)) {
            data["puAutomationListViewDetails"] = [];
            for (let item of this.puAutomationListViewDetails)
                data["puAutomationListViewDetails"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPreRegListViewResponseDTO {
    preRegListViewDetails?: PreRegListViewDetailDTO[] | undefined;
    puAutomationListViewDetails?: PuAutomationListViewDetailDTO[] | undefined;
}

export class PreRegListViewDetailDTO implements IPreRegListViewDetailDTO {
    patient?: string | undefined;
    outcome?: string | undefined;
    accountNumber?: string | undefined;
    campaign?: string | undefined;
    dateofservice?: Date | undefined;
    accountStatus?: string;
    interactionCount?: number | undefined;
    interactionDate?: Date | undefined;
    refPreRegSiteCode?: string | undefined;
    preRegSiteDate?: Date | undefined;
    estimatedPatientDueAmount?: string | undefined;
    receivedAmount?: string | undefined;
    rowsCount?: number;
    coid?: number;
    financialClass?: string | undefined;
    lockedBy?: string | undefined;
    cellPhone?: string | undefined;
    homePhone?: string | undefined;
    email?: string | undefined;

    constructor(data?: IPreRegListViewDetailDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.patient = _data["patient"];
            this.outcome = _data["outcome"];
            this.accountNumber = _data["accountNumber"];
            this.campaign = _data["campaign"];
            this.dateofservice = _data["dateofservice"] ? new Date(_data["dateofservice"].toString()) : undefined as any;
            this.accountStatus = _data["accountStatus"];
            this.interactionCount = _data["interactionCount"];
            this.interactionDate = _data["interactionDate"] ? new Date(_data["interactionDate"].toString()) : undefined as any;
            this.refPreRegSiteCode = _data["refPreRegSiteCode"];
            this.preRegSiteDate = _data["preRegSiteDate"] ? new Date(_data["preRegSiteDate"].toString()) : undefined as any;
            this.estimatedPatientDueAmount = _data["estimatedPatientDueAmount"];
            this.receivedAmount = _data["receivedAmount"];
            this.rowsCount = _data["rowsCount"];
            this.coid = _data["coid"];
            this.financialClass = _data["financialClass"];
            this.lockedBy = _data["lockedBy"];
            this.cellPhone = _data["cellPhone"];
            this.homePhone = _data["homePhone"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): PreRegListViewDetailDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PreRegListViewDetailDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["patient"] = this.patient;
        data["outcome"] = this.outcome;
        data["accountNumber"] = this.accountNumber;
        data["campaign"] = this.campaign;
        data["dateofservice"] = this.dateofservice ? this.dateofservice.toISOString() : undefined as any;
        data["accountStatus"] = this.accountStatus;
        data["interactionCount"] = this.interactionCount;
        data["interactionDate"] = this.interactionDate ? this.interactionDate.toISOString() : undefined as any;
        data["refPreRegSiteCode"] = this.refPreRegSiteCode;
        data["preRegSiteDate"] = this.preRegSiteDate ? this.preRegSiteDate.toISOString() : undefined as any;
        data["estimatedPatientDueAmount"] = this.estimatedPatientDueAmount;
        data["receivedAmount"] = this.receivedAmount;
        data["rowsCount"] = this.rowsCount;
        data["coid"] = this.coid;
        data["financialClass"] = this.financialClass;
        data["lockedBy"] = this.lockedBy;
        data["cellPhone"] = this.cellPhone;
        data["homePhone"] = this.homePhone;
        data["email"] = this.email;
        return data;
    }
}

export interface IPreRegListViewDetailDTO {
    patient?: string | undefined;
    outcome?: string | undefined;
    accountNumber?: string | undefined;
    campaign?: string | undefined;
    dateofservice?: Date | undefined;
    accountStatus?: string;
    interactionCount?: number | undefined;
    interactionDate?: Date | undefined;
    refPreRegSiteCode?: string | undefined;
    preRegSiteDate?: Date | undefined;
    estimatedPatientDueAmount?: string | undefined;
    receivedAmount?: string | undefined;
    rowsCount?: number;
    coid?: number;
    financialClass?: string | undefined;
    lockedBy?: string | undefined;
    cellPhone?: string | undefined;
    homePhone?: string | undefined;
    email?: string | undefined;
}

export class PuAutomationListViewDetailDTO implements IPuAutomationListViewDetailDTO {
    patient!: string;
    accountNumber!: string;
    coid!: number;
    unit!: number;
    primaryEmail!: string | undefined;
    status!: string;
    campaign!: string;
    divisionName!: string;
    source!: string;
    scheduledDateTime!: Date;
    preRegSite!: string;
    fhirUpdateLastModified!: Date | undefined;
    estimatedDueAmount!: string;
    wrapupCode!: string;
    rowsCount!: number;

    constructor(data?: IPuAutomationListViewDetailDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.patient = _data["patient"];
            this.accountNumber = _data["accountNumber"];
            this.coid = _data["coid"];
            this.unit = _data["unit"];
            this.primaryEmail = _data["primaryEmail"];
            this.status = _data["status"];
            this.campaign = _data["campaign"];
            this.divisionName = _data["divisionName"];
            this.source = _data["source"];
            this.scheduledDateTime = _data["scheduledDateTime"] ? new Date(_data["scheduledDateTime"].toString()) : undefined as any;
            this.preRegSite = _data["preRegSite"];
            this.fhirUpdateLastModified = _data["fhirUpdateLastModified"] ? new Date(_data["fhirUpdateLastModified"].toString()) : undefined as any;
            this.estimatedDueAmount = _data["estimatedDueAmount"];
            this.wrapupCode = _data["wrapupCode"];
            this.rowsCount = _data["rowsCount"];
        }
    }

    static fromJS(data: any): PuAutomationListViewDetailDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PuAutomationListViewDetailDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["patient"] = this.patient;
        data["accountNumber"] = this.accountNumber;
        data["coid"] = this.coid;
        data["unit"] = this.unit;
        data["primaryEmail"] = this.primaryEmail;
        data["status"] = this.status;
        data["campaign"] = this.campaign;
        data["divisionName"] = this.divisionName;
        data["source"] = this.source;
        data["scheduledDateTime"] = this.scheduledDateTime ? this.scheduledDateTime.toISOString() : undefined as any;
        data["preRegSite"] = this.preRegSite;
        data["fhirUpdateLastModified"] = this.fhirUpdateLastModified ? this.fhirUpdateLastModified.toISOString() : undefined as any;
        data["estimatedDueAmount"] = this.estimatedDueAmount;
        data["wrapupCode"] = this.wrapupCode;
        data["rowsCount"] = this.rowsCount;
        return data;
    }
}

export interface IPuAutomationListViewDetailDTO {
    patient: string;
    accountNumber: string;
    coid: number;
    unit: number;
    primaryEmail: string | undefined;
    status: string;
    campaign: string;
    divisionName: string;
    source: string;
    scheduledDateTime: Date;
    preRegSite: string;
    fhirUpdateLastModified: Date | undefined;
    estimatedDueAmount: string;
    wrapupCode: string;
    rowsCount: number;
}

export class PreRegListViewRequest implements IPreRegListViewRequest {
    columnName?: string;
    facilityIds?: string;
    facilityIdList?: string[];
    sortColumn?: string | undefined;
    sortDir?: string | undefined;
    page?: number;
    pageSize?: number;
    genesysInteractionOutcomes?: string | undefined;
    campaign?: string | undefined;
    preRegSite?: string | undefined;
    queueStatuses?: string | undefined;
    puAmountDue?: string | undefined;

    constructor(data?: IPreRegListViewRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.columnName = _data["columnName"];
            this.facilityIds = _data["facilityIds"];
            if (Array.isArray(_data["facilityIdList"])) {
                this.facilityIdList = [] as any;
                for (let item of _data["facilityIdList"])
                    this.facilityIdList!.push(item);
            }
            this.sortColumn = _data["sortColumn"];
            this.sortDir = _data["sortDir"];
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
            this.genesysInteractionOutcomes = _data["genesysInteractionOutcomes"];
            this.campaign = _data["campaign"];
            this.preRegSite = _data["preRegSite"];
            this.queueStatuses = _data["queueStatuses"];
            this.puAmountDue = _data["puAmountDue"];
        }
    }

    static fromJS(data: any): PreRegListViewRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PreRegListViewRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["columnName"] = this.columnName;
        data["facilityIds"] = this.facilityIds;
        if (Array.isArray(this.facilityIdList)) {
            data["facilityIdList"] = [];
            for (let item of this.facilityIdList)
                data["facilityIdList"].push(item);
        }
        data["sortColumn"] = this.sortColumn;
        data["sortDir"] = this.sortDir;
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        data["genesysInteractionOutcomes"] = this.genesysInteractionOutcomes;
        data["campaign"] = this.campaign;
        data["preRegSite"] = this.preRegSite;
        data["queueStatuses"] = this.queueStatuses;
        data["puAmountDue"] = this.puAmountDue;
        return data;
    }
}

export interface IPreRegListViewRequest {
    columnName?: string;
    facilityIds?: string;
    facilityIdList?: string[];
    sortColumn?: string | undefined;
    sortDir?: string | undefined;
    page?: number;
    pageSize?: number;
    genesysInteractionOutcomes?: string | undefined;
    campaign?: string | undefined;
    preRegSite?: string | undefined;
    queueStatuses?: string | undefined;
    puAmountDue?: string | undefined;
}

export class APIResponseOfListOfEptacAuthQueueListViewDetailDTO implements IAPIResponseOfListOfEptacAuthQueueListViewDetailDTO {
    statusCode?: HttpStatusCode;
    isSuccess?: boolean;
    errorMessages?: string[];
    result?: EptacAuthQueueListViewDetailDTO[] | undefined;

    constructor(data?: IAPIResponseOfListOfEptacAuthQueueListViewDetailDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusCode = _data["statusCode"];
            this.isSuccess = _data["isSuccess"];
            if (Array.isArray(_data["errorMessages"])) {
                this.errorMessages = [] as any;
                for (let item of _data["errorMessages"])
                    this.errorMessages!.push(item);
            }
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result!.push(EptacAuthQueueListViewDetailDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): APIResponseOfListOfEptacAuthQueueListViewDetailDTO {
        data = typeof data === 'object' ? data : {};
        let result = new APIResponseOfListOfEptacAuthQueueListViewDetailDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["isSuccess"] = this.isSuccess;
        if (Array.isArray(this.errorMessages)) {
            data["errorMessages"] = [];
            for (let item of this.errorMessages)
                data["errorMessages"].push(item);
        }
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IAPIResponseOfListOfEptacAuthQueueListViewDetailDTO {
    statusCode?: HttpStatusCode;
    isSuccess?: boolean;
    errorMessages?: string[];
    result?: EptacAuthQueueListViewDetailDTO[] | undefined;
}

export class EptacAuthQueueListViewDetailDTO implements IEptacAuthQueueListViewDetailDTO {
    patient?: string | undefined;
    accountNumber?: string | undefined;
    facilityName?: string | undefined;
    coid?: number | undefined;
    meditechMarket?: string | undefined;
    emrSystem?: string | undefined;
    status?: string;
    interactionCount?: number | undefined;
    lockedBy?: string | undefined;
    modifiedBy?: string | undefined;
    modifiedDateUtc?: Date | undefined;
    createdBy?: string | undefined;
    createdDateUtc?: Date | undefined;
    rowsCount?: number | undefined;
    escalationReason?: string | undefined;
    authStat?: string | undefined;

    constructor(data?: IEptacAuthQueueListViewDetailDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.patient = _data["patient"];
            this.accountNumber = _data["accountNumber"];
            this.facilityName = _data["facilityName"];
            this.coid = _data["coid"];
            this.meditechMarket = _data["meditechMarket"];
            this.emrSystem = _data["emrSystem"];
            this.status = _data["status"];
            this.interactionCount = _data["interactionCount"];
            this.lockedBy = _data["lockedBy"];
            this.modifiedBy = _data["modifiedBy"];
            this.modifiedDateUtc = _data["modifiedDateUtc"] ? new Date(_data["modifiedDateUtc"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.createdDateUtc = _data["createdDateUtc"] ? new Date(_data["createdDateUtc"].toString()) : undefined as any;
            this.rowsCount = _data["rowsCount"];
            this.escalationReason = _data["escalationReason"];
            this.authStat = _data["authStat"];
        }
    }

    static fromJS(data: any): EptacAuthQueueListViewDetailDTO {
        data = typeof data === 'object' ? data : {};
        let result = new EptacAuthQueueListViewDetailDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["patient"] = this.patient;
        data["accountNumber"] = this.accountNumber;
        data["facilityName"] = this.facilityName;
        data["coid"] = this.coid;
        data["meditechMarket"] = this.meditechMarket;
        data["emrSystem"] = this.emrSystem;
        data["status"] = this.status;
        data["interactionCount"] = this.interactionCount;
        data["lockedBy"] = this.lockedBy;
        data["modifiedBy"] = this.modifiedBy;
        data["modifiedDateUtc"] = this.modifiedDateUtc ? this.modifiedDateUtc.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["createdDateUtc"] = this.createdDateUtc ? this.createdDateUtc.toISOString() : undefined as any;
        data["rowsCount"] = this.rowsCount;
        data["escalationReason"] = this.escalationReason;
        data["authStat"] = this.authStat;
        return data;
    }
}

export interface IEptacAuthQueueListViewDetailDTO {
    patient?: string | undefined;
    accountNumber?: string | undefined;
    facilityName?: string | undefined;
    coid?: number | undefined;
    meditechMarket?: string | undefined;
    emrSystem?: string | undefined;
    status?: string;
    interactionCount?: number | undefined;
    lockedBy?: string | undefined;
    modifiedBy?: string | undefined;
    modifiedDateUtc?: Date | undefined;
    createdBy?: string | undefined;
    createdDateUtc?: Date | undefined;
    rowsCount?: number | undefined;
    escalationReason?: string | undefined;
    authStat?: string | undefined;
}

export class EptacAuthQueueListViewRequest implements IEptacAuthQueueListViewRequest {
    authStat?: string | undefined;
    facilityIds?: string;
    facilityIdList?: string[];
    emrSystems?: string;
    emrSystemList?: string[];
    sortColumn?: string | undefined;
    sortDir?: string | undefined;
    page?: number;
    pageSize?: number;
    queueStatuses?: string | undefined;

    constructor(data?: IEptacAuthQueueListViewRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.authStat = _data["authStat"];
            this.facilityIds = _data["facilityIds"];
            if (Array.isArray(_data["facilityIdList"])) {
                this.facilityIdList = [] as any;
                for (let item of _data["facilityIdList"])
                    this.facilityIdList!.push(item);
            }
            this.emrSystems = _data["emrSystems"];
            if (Array.isArray(_data["emrSystemList"])) {
                this.emrSystemList = [] as any;
                for (let item of _data["emrSystemList"])
                    this.emrSystemList!.push(item);
            }
            this.sortColumn = _data["sortColumn"];
            this.sortDir = _data["sortDir"];
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
            this.queueStatuses = _data["queueStatuses"];
        }
    }

    static fromJS(data: any): EptacAuthQueueListViewRequest {
        data = typeof data === 'object' ? data : {};
        let result = new EptacAuthQueueListViewRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["authStat"] = this.authStat;
        data["facilityIds"] = this.facilityIds;
        if (Array.isArray(this.facilityIdList)) {
            data["facilityIdList"] = [];
            for (let item of this.facilityIdList)
                data["facilityIdList"].push(item);
        }
        data["emrSystems"] = this.emrSystems;
        if (Array.isArray(this.emrSystemList)) {
            data["emrSystemList"] = [];
            for (let item of this.emrSystemList)
                data["emrSystemList"].push(item);
        }
        data["sortColumn"] = this.sortColumn;
        data["sortDir"] = this.sortDir;
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        data["queueStatuses"] = this.queueStatuses;
        return data;
    }
}

export interface IEptacAuthQueueListViewRequest {
    authStat?: string | undefined;
    facilityIds?: string;
    facilityIdList?: string[];
    emrSystems?: string;
    emrSystemList?: string[];
    sortColumn?: string | undefined;
    sortDir?: string | undefined;
    page?: number;
    pageSize?: number;
    queueStatuses?: string | undefined;
}

export class APIResponseOfListOfSpecialDropDown implements IAPIResponseOfListOfSpecialDropDown {
    statusCode?: HttpStatusCode;
    isSuccess?: boolean;
    errorMessages?: string[];
    result?: SpecialDropDown[] | undefined;

    constructor(data?: IAPIResponseOfListOfSpecialDropDown) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusCode = _data["statusCode"];
            this.isSuccess = _data["isSuccess"];
            if (Array.isArray(_data["errorMessages"])) {
                this.errorMessages = [] as any;
                for (let item of _data["errorMessages"])
                    this.errorMessages!.push(item);
            }
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result!.push(SpecialDropDown.fromJS(item));
            }
        }
    }

    static fromJS(data: any): APIResponseOfListOfSpecialDropDown {
        data = typeof data === 'object' ? data : {};
        let result = new APIResponseOfListOfSpecialDropDown();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["isSuccess"] = this.isSuccess;
        if (Array.isArray(this.errorMessages)) {
            data["errorMessages"] = [];
            for (let item of this.errorMessages)
                data["errorMessages"].push(item);
        }
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IAPIResponseOfListOfSpecialDropDown {
    statusCode?: HttpStatusCode;
    isSuccess?: boolean;
    errorMessages?: string[];
    result?: SpecialDropDown[] | undefined;
}

export class SpecialDropDown implements ISpecialDropDown {
    id?: number;
    label?: string;
    value?: string;

    constructor(data?: ISpecialDropDown) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.label = _data["label"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): SpecialDropDown {
        data = typeof data === 'object' ? data : {};
        let result = new SpecialDropDown();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["label"] = this.label;
        data["value"] = this.value;
        return data;
    }
}

export interface ISpecialDropDown {
    id?: number;
    label?: string;
    value?: string;
}

export class APIResponseOfExhaustedworkqueueFiltersDTO implements IAPIResponseOfExhaustedworkqueueFiltersDTO {
    statusCode?: HttpStatusCode;
    isSuccess?: boolean;
    errorMessages?: string[];
    result?: ExhaustedworkqueueFiltersDTO | undefined;

    constructor(data?: IAPIResponseOfExhaustedworkqueueFiltersDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusCode = _data["statusCode"];
            this.isSuccess = _data["isSuccess"];
            if (Array.isArray(_data["errorMessages"])) {
                this.errorMessages = [] as any;
                for (let item of _data["errorMessages"])
                    this.errorMessages!.push(item);
            }
            this.result = _data["result"] ? ExhaustedworkqueueFiltersDTO.fromJS(_data["result"]) : undefined as any;
        }
    }

    static fromJS(data: any): APIResponseOfExhaustedworkqueueFiltersDTO {
        data = typeof data === 'object' ? data : {};
        let result = new APIResponseOfExhaustedworkqueueFiltersDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["isSuccess"] = this.isSuccess;
        if (Array.isArray(this.errorMessages)) {
            data["errorMessages"] = [];
            for (let item of this.errorMessages)
                data["errorMessages"].push(item);
        }
        data["result"] = this.result ? this.result.toJSON() : undefined as any;
        return data;
    }
}

export interface IAPIResponseOfExhaustedworkqueueFiltersDTO {
    statusCode?: HttpStatusCode;
    isSuccess?: boolean;
    errorMessages?: string[];
    result?: ExhaustedworkqueueFiltersDTO | undefined;
}

export class ExhaustedworkqueueFiltersDTO implements IExhaustedworkqueueFiltersDTO {
    facilities?: PreRegFacilityRoot[];
    exhaustedEffortDate?: ExhaustedEffortDateList[];
    accountStatuses?: DropDownItem[];
    successfulContactAttempts?: SuccessInteractionCountList[];

    constructor(data?: IExhaustedworkqueueFiltersDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["facilities"])) {
                this.facilities = [] as any;
                for (let item of _data["facilities"])
                    this.facilities!.push(PreRegFacilityRoot.fromJS(item));
            }
            if (Array.isArray(_data["exhaustedEffortDate"])) {
                this.exhaustedEffortDate = [] as any;
                for (let item of _data["exhaustedEffortDate"])
                    this.exhaustedEffortDate!.push(ExhaustedEffortDateList.fromJS(item));
            }
            if (Array.isArray(_data["accountStatuses"])) {
                this.accountStatuses = [] as any;
                for (let item of _data["accountStatuses"])
                    this.accountStatuses!.push(DropDownItem.fromJS(item));
            }
            if (Array.isArray(_data["successfulContactAttempts"])) {
                this.successfulContactAttempts = [] as any;
                for (let item of _data["successfulContactAttempts"])
                    this.successfulContactAttempts!.push(SuccessInteractionCountList.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ExhaustedworkqueueFiltersDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ExhaustedworkqueueFiltersDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.facilities)) {
            data["facilities"] = [];
            for (let item of this.facilities)
                data["facilities"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.exhaustedEffortDate)) {
            data["exhaustedEffortDate"] = [];
            for (let item of this.exhaustedEffortDate)
                data["exhaustedEffortDate"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.accountStatuses)) {
            data["accountStatuses"] = [];
            for (let item of this.accountStatuses)
                data["accountStatuses"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.successfulContactAttempts)) {
            data["successfulContactAttempts"] = [];
            for (let item of this.successfulContactAttempts)
                data["successfulContactAttempts"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IExhaustedworkqueueFiltersDTO {
    facilities?: PreRegFacilityRoot[];
    exhaustedEffortDate?: ExhaustedEffortDateList[];
    accountStatuses?: DropDownItem[];
    successfulContactAttempts?: SuccessInteractionCountList[];
}

export class ExhaustedEffortDateList implements IExhaustedEffortDateList {
    exhaustedEffortDate?: Date | undefined;

    constructor(data?: IExhaustedEffortDateList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.exhaustedEffortDate = _data["exhaustedEffortDate"] ? new Date(_data["exhaustedEffortDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): ExhaustedEffortDateList {
        data = typeof data === 'object' ? data : {};
        let result = new ExhaustedEffortDateList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["exhaustedEffortDate"] = this.exhaustedEffortDate ? this.exhaustedEffortDate.toISOString() : undefined as any;
        return data;
    }
}

export interface IExhaustedEffortDateList {
    exhaustedEffortDate?: Date | undefined;
}

export class SuccessInteractionCountList implements ISuccessInteractionCountList {
    successfulContactAttempts?: number | undefined;

    constructor(data?: ISuccessInteractionCountList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.successfulContactAttempts = _data["successfulContactAttempts"];
        }
    }

    static fromJS(data: any): SuccessInteractionCountList {
        data = typeof data === 'object' ? data : {};
        let result = new SuccessInteractionCountList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["successfulContactAttempts"] = this.successfulContactAttempts;
        return data;
    }
}

export interface ISuccessInteractionCountList {
    successfulContactAttempts?: number | undefined;
}

export class APIResponseOfListOfExhaustedQueueListViewDetailDTO implements IAPIResponseOfListOfExhaustedQueueListViewDetailDTO {
    statusCode?: HttpStatusCode;
    isSuccess?: boolean;
    errorMessages?: string[];
    result?: ExhaustedQueueListViewDetailDTO[] | undefined;

    constructor(data?: IAPIResponseOfListOfExhaustedQueueListViewDetailDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusCode = _data["statusCode"];
            this.isSuccess = _data["isSuccess"];
            if (Array.isArray(_data["errorMessages"])) {
                this.errorMessages = [] as any;
                for (let item of _data["errorMessages"])
                    this.errorMessages!.push(item);
            }
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result!.push(ExhaustedQueueListViewDetailDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): APIResponseOfListOfExhaustedQueueListViewDetailDTO {
        data = typeof data === 'object' ? data : {};
        let result = new APIResponseOfListOfExhaustedQueueListViewDetailDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["isSuccess"] = this.isSuccess;
        if (Array.isArray(this.errorMessages)) {
            data["errorMessages"] = [];
            for (let item of this.errorMessages)
                data["errorMessages"].push(item);
        }
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IAPIResponseOfListOfExhaustedQueueListViewDetailDTO {
    statusCode?: HttpStatusCode;
    isSuccess?: boolean;
    errorMessages?: string[];
    result?: ExhaustedQueueListViewDetailDTO[] | undefined;
}

export class ExhaustedQueueListViewDetailDTO implements IExhaustedQueueListViewDetailDTO {
    facilityName?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    accountNumber?: string | undefined;
    appointmentType?: string | undefined;
    appointmentDescription?: string | undefined;
    homePhone?: string | undefined;
    cellPhone?: string | undefined;
    email?: string | undefined;
    contactAttempts?: number | undefined;
    successfulContactAttempts?: number | undefined;
    followUpCode?: string | undefined;
    followUpDate?: Date | undefined;
    lastSuccessfullContactedDate?: string | undefined;
    lastOutcome?: string | undefined;
    lastOutcomeError?: string | undefined;
    ageInDays?: number | undefined;
    appointmentCreationDate?: Date | undefined;
    smsContactDate?: string | undefined;
    emailContactDate?: string | undefined;
    dialerContactDate?: string | undefined;
    reason?: string | undefined;
    patient?: string | undefined;
    coid?: number | undefined;
    meditechMarket?: string | undefined;
    emrSystem?: string | undefined;
    apptURN?: string | undefined;
    accountStatus?: string;
    exhaustedEffortDate?: Date | undefined;
    modifiedBy?: string | undefined;
    modifiedDateUtc?: Date | undefined;
    lockedBy?: string | undefined;
    rowsCount?: number | undefined;
    mnemonic?: string | undefined;
    previousModifiedBy?: string | undefined;
    previousModifiedDateUtc?: Date | undefined;

    constructor(data?: IExhaustedQueueListViewDetailDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.facilityName = _data["facilityName"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.accountNumber = _data["accountNumber"];
            this.appointmentType = _data["appointmentType"];
            this.appointmentDescription = _data["appointmentDescription"];
            this.homePhone = _data["homePhone"];
            this.cellPhone = _data["cellPhone"];
            this.email = _data["email"];
            this.contactAttempts = _data["contactAttempts"];
            this.successfulContactAttempts = _data["successfulContactAttempts"];
            this.followUpCode = _data["followUpCode"];
            this.followUpDate = _data["followUpDate"] ? new Date(_data["followUpDate"].toString()) : undefined as any;
            this.lastSuccessfullContactedDate = _data["lastSuccessfullContactedDate"];
            this.lastOutcome = _data["lastOutcome"];
            this.lastOutcomeError = _data["lastOutcomeError"];
            this.ageInDays = _data["ageInDays"];
            this.appointmentCreationDate = _data["appointmentCreationDate"] ? new Date(_data["appointmentCreationDate"].toString()) : undefined as any;
            this.smsContactDate = _data["smsContactDate"];
            this.emailContactDate = _data["emailContactDate"];
            this.dialerContactDate = _data["dialerContactDate"];
            this.reason = _data["reason"];
            this.patient = _data["patient"];
            this.coid = _data["coid"];
            this.meditechMarket = _data["meditechMarket"];
            this.emrSystem = _data["emrSystem"];
            this.apptURN = _data["apptURN"];
            this.accountStatus = _data["accountStatus"];
            this.exhaustedEffortDate = _data["exhaustedEffortDate"] ? new Date(_data["exhaustedEffortDate"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            this.modifiedDateUtc = _data["modifiedDateUtc"] ? new Date(_data["modifiedDateUtc"].toString()) : undefined as any;
            this.lockedBy = _data["lockedBy"];
            this.rowsCount = _data["rowsCount"];
            this.mnemonic = _data["mnemonic"];
            this.previousModifiedBy = _data["previousModifiedBy"];
            this.previousModifiedDateUtc = _data["previousModifiedDateUtc"] ? new Date(_data["previousModifiedDateUtc"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): ExhaustedQueueListViewDetailDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ExhaustedQueueListViewDetailDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["facilityName"] = this.facilityName;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["accountNumber"] = this.accountNumber;
        data["appointmentType"] = this.appointmentType;
        data["appointmentDescription"] = this.appointmentDescription;
        data["homePhone"] = this.homePhone;
        data["cellPhone"] = this.cellPhone;
        data["email"] = this.email;
        data["contactAttempts"] = this.contactAttempts;
        data["successfulContactAttempts"] = this.successfulContactAttempts;
        data["followUpCode"] = this.followUpCode;
        data["followUpDate"] = this.followUpDate ? this.followUpDate.toISOString() : undefined as any;
        data["lastSuccessfullContactedDate"] = this.lastSuccessfullContactedDate;
        data["lastOutcome"] = this.lastOutcome;
        data["lastOutcomeError"] = this.lastOutcomeError;
        data["ageInDays"] = this.ageInDays;
        data["appointmentCreationDate"] = this.appointmentCreationDate ? this.appointmentCreationDate.toISOString() : undefined as any;
        data["smsContactDate"] = this.smsContactDate;
        data["emailContactDate"] = this.emailContactDate;
        data["dialerContactDate"] = this.dialerContactDate;
        data["reason"] = this.reason;
        data["patient"] = this.patient;
        data["coid"] = this.coid;
        data["meditechMarket"] = this.meditechMarket;
        data["emrSystem"] = this.emrSystem;
        data["apptURN"] = this.apptURN;
        data["accountStatus"] = this.accountStatus;
        data["exhaustedEffortDate"] = this.exhaustedEffortDate ? formatDate(this.exhaustedEffortDate) : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        data["modifiedDateUtc"] = this.modifiedDateUtc ? this.modifiedDateUtc.toISOString() : undefined as any;
        data["lockedBy"] = this.lockedBy;
        data["rowsCount"] = this.rowsCount;
        data["mnemonic"] = this.mnemonic;
        data["previousModifiedBy"] = this.previousModifiedBy;
        data["previousModifiedDateUtc"] = this.previousModifiedDateUtc ? this.previousModifiedDateUtc.toISOString() : undefined as any;
        return data;
    }
}

export interface IExhaustedQueueListViewDetailDTO {
    facilityName?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    accountNumber?: string | undefined;
    appointmentType?: string | undefined;
    appointmentDescription?: string | undefined;
    homePhone?: string | undefined;
    cellPhone?: string | undefined;
    email?: string | undefined;
    contactAttempts?: number | undefined;
    successfulContactAttempts?: number | undefined;
    followUpCode?: string | undefined;
    followUpDate?: Date | undefined;
    lastSuccessfullContactedDate?: string | undefined;
    lastOutcome?: string | undefined;
    lastOutcomeError?: string | undefined;
    ageInDays?: number | undefined;
    appointmentCreationDate?: Date | undefined;
    smsContactDate?: string | undefined;
    emailContactDate?: string | undefined;
    dialerContactDate?: string | undefined;
    reason?: string | undefined;
    patient?: string | undefined;
    coid?: number | undefined;
    meditechMarket?: string | undefined;
    emrSystem?: string | undefined;
    apptURN?: string | undefined;
    accountStatus?: string;
    exhaustedEffortDate?: Date | undefined;
    modifiedBy?: string | undefined;
    modifiedDateUtc?: Date | undefined;
    lockedBy?: string | undefined;
    rowsCount?: number | undefined;
    mnemonic?: string | undefined;
    previousModifiedBy?: string | undefined;
    previousModifiedDateUtc?: Date | undefined;
}

export class ExhaustedQueueListViewRequest implements IExhaustedQueueListViewRequest {
    facilityIds?: string;
    facilityIdList?: string[];
    queueStatuses?: string;
    exhaustedEffortDate?: Date | undefined;
    emrSystems?: string;
    emrSystemList?: string[];
    sortColumn?: string;
    sortDir?: string;
    page?: number;
    pageSize?: number;
    fromAgeInDays?: number | undefined;
    toAgeInDays?: number | undefined;
    fromSuccessfulContactAttempts?: number | undefined;
    toSuccessfulContactAttempts?: number | undefined;
    partialAccountNumber?: string | undefined;

    constructor(data?: IExhaustedQueueListViewRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.facilityIds = _data["facilityIds"];
            if (Array.isArray(_data["facilityIdList"])) {
                this.facilityIdList = [] as any;
                for (let item of _data["facilityIdList"])
                    this.facilityIdList!.push(item);
            }
            this.queueStatuses = _data["queueStatuses"];
            this.exhaustedEffortDate = _data["exhaustedEffortDate"] ? new Date(_data["exhaustedEffortDate"].toString()) : undefined as any;
            this.emrSystems = _data["emrSystems"];
            if (Array.isArray(_data["emrSystemList"])) {
                this.emrSystemList = [] as any;
                for (let item of _data["emrSystemList"])
                    this.emrSystemList!.push(item);
            }
            this.sortColumn = _data["sortColumn"];
            this.sortDir = _data["sortDir"];
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
            this.fromAgeInDays = _data["fromAgeInDays"];
            this.toAgeInDays = _data["toAgeInDays"];
            this.fromSuccessfulContactAttempts = _data["fromSuccessfulContactAttempts"];
            this.toSuccessfulContactAttempts = _data["toSuccessfulContactAttempts"];
            this.partialAccountNumber = _data["partialAccountNumber"];
        }
    }

    static fromJS(data: any): ExhaustedQueueListViewRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ExhaustedQueueListViewRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["facilityIds"] = this.facilityIds;
        if (Array.isArray(this.facilityIdList)) {
            data["facilityIdList"] = [];
            for (let item of this.facilityIdList)
                data["facilityIdList"].push(item);
        }
        data["queueStatuses"] = this.queueStatuses;
        data["exhaustedEffortDate"] = this.exhaustedEffortDate ? formatDate(this.exhaustedEffortDate) : undefined as any;
        data["emrSystems"] = this.emrSystems;
        if (Array.isArray(this.emrSystemList)) {
            data["emrSystemList"] = [];
            for (let item of this.emrSystemList)
                data["emrSystemList"].push(item);
        }
        data["sortColumn"] = this.sortColumn;
        data["sortDir"] = this.sortDir;
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        data["fromAgeInDays"] = this.fromAgeInDays;
        data["toAgeInDays"] = this.toAgeInDays;
        data["fromSuccessfulContactAttempts"] = this.fromSuccessfulContactAttempts;
        data["toSuccessfulContactAttempts"] = this.toSuccessfulContactAttempts;
        data["partialAccountNumber"] = this.partialAccountNumber;
        return data;
    }
}

export interface IExhaustedQueueListViewRequest {
    facilityIds?: string;
    facilityIdList?: string[];
    queueStatuses?: string;
    exhaustedEffortDate?: Date | undefined;
    emrSystems?: string;
    emrSystemList?: string[];
    sortColumn?: string;
    sortDir?: string;
    page?: number;
    pageSize?: number;
    fromAgeInDays?: number | undefined;
    toAgeInDays?: number | undefined;
    fromSuccessfulContactAttempts?: number | undefined;
    toSuccessfulContactAttempts?: number | undefined;
    partialAccountNumber?: string | undefined;
}

export class APIResponseOfListOfExhaustedQueueSummaryResponse implements IAPIResponseOfListOfExhaustedQueueSummaryResponse {
    statusCode?: HttpStatusCode;
    isSuccess?: boolean;
    errorMessages?: string[];
    result?: ExhaustedQueueSummaryResponse[] | undefined;

    constructor(data?: IAPIResponseOfListOfExhaustedQueueSummaryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusCode = _data["statusCode"];
            this.isSuccess = _data["isSuccess"];
            if (Array.isArray(_data["errorMessages"])) {
                this.errorMessages = [] as any;
                for (let item of _data["errorMessages"])
                    this.errorMessages!.push(item);
            }
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result!.push(ExhaustedQueueSummaryResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): APIResponseOfListOfExhaustedQueueSummaryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new APIResponseOfListOfExhaustedQueueSummaryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["isSuccess"] = this.isSuccess;
        if (Array.isArray(this.errorMessages)) {
            data["errorMessages"] = [];
            for (let item of this.errorMessages)
                data["errorMessages"].push(item);
        }
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IAPIResponseOfListOfExhaustedQueueSummaryResponse {
    statusCode?: HttpStatusCode;
    isSuccess?: boolean;
    errorMessages?: string[];
    result?: ExhaustedQueueSummaryResponse[] | undefined;
}

export class ExhaustedQueueSummaryResponse implements IExhaustedQueueSummaryResponse {
    sscs?: ExhaustedQueueSSC[] | undefined;

    constructor(data?: IExhaustedQueueSummaryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["sscs"])) {
                this.sscs = [] as any;
                for (let item of _data["sscs"])
                    this.sscs!.push(ExhaustedQueueSSC.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ExhaustedQueueSummaryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ExhaustedQueueSummaryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.sscs)) {
            data["sscs"] = [];
            for (let item of this.sscs)
                data["sscs"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IExhaustedQueueSummaryResponse {
    sscs?: ExhaustedQueueSSC[] | undefined;
}

export class ExhaustedQueueSummaryBase implements IExhaustedQueueSummaryBase {
    type?: string | undefined;
    name?: string | undefined;
    sscId?: number | undefined;
    divisionId?: number | undefined;
    facilityId?: number | undefined;
    notStarted?: number | undefined;
    inProgress?: number | undefined;
    complete?: number | undefined;

    constructor(data?: IExhaustedQueueSummaryBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.name = _data["name"];
            this.sscId = _data["sscId"];
            this.divisionId = _data["divisionId"];
            this.facilityId = _data["facilityId"];
            this.notStarted = _data["notStarted"];
            this.inProgress = _data["inProgress"];
            this.complete = _data["complete"];
        }
    }

    static fromJS(data: any): ExhaustedQueueSummaryBase {
        data = typeof data === 'object' ? data : {};
        let result = new ExhaustedQueueSummaryBase();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["name"] = this.name;
        data["sscId"] = this.sscId;
        data["divisionId"] = this.divisionId;
        data["facilityId"] = this.facilityId;
        data["notStarted"] = this.notStarted;
        data["inProgress"] = this.inProgress;
        data["complete"] = this.complete;
        return data;
    }
}

export interface IExhaustedQueueSummaryBase {
    type?: string | undefined;
    name?: string | undefined;
    sscId?: number | undefined;
    divisionId?: number | undefined;
    facilityId?: number | undefined;
    notStarted?: number | undefined;
    inProgress?: number | undefined;
    complete?: number | undefined;
}

export class ExhaustedQueueSSC extends ExhaustedQueueSummaryBase implements IExhaustedQueueSSC {
    divisions?: ExhaustedQueueDivision[] | undefined;

    constructor(data?: IExhaustedQueueSSC) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["divisions"])) {
                this.divisions = [] as any;
                for (let item of _data["divisions"])
                    this.divisions!.push(ExhaustedQueueDivision.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): ExhaustedQueueSSC {
        data = typeof data === 'object' ? data : {};
        let result = new ExhaustedQueueSSC();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.divisions)) {
            data["divisions"] = [];
            for (let item of this.divisions)
                data["divisions"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IExhaustedQueueSSC extends IExhaustedQueueSummaryBase {
    divisions?: ExhaustedQueueDivision[] | undefined;
}

export class ExhaustedQueueDivision extends ExhaustedQueueSummaryBase implements IExhaustedQueueDivision {
    facilities?: ExhaustedQueueFacility[] | undefined;

    constructor(data?: IExhaustedQueueDivision) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["facilities"])) {
                this.facilities = [] as any;
                for (let item of _data["facilities"])
                    this.facilities!.push(ExhaustedQueueFacility.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): ExhaustedQueueDivision {
        data = typeof data === 'object' ? data : {};
        let result = new ExhaustedQueueDivision();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.facilities)) {
            data["facilities"] = [];
            for (let item of this.facilities)
                data["facilities"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IExhaustedQueueDivision extends IExhaustedQueueSummaryBase {
    facilities?: ExhaustedQueueFacility[] | undefined;
}

export class ExhaustedQueueFacility extends ExhaustedQueueSummaryBase implements IExhaustedQueueFacility {

    constructor(data?: IExhaustedQueueFacility) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ExhaustedQueueFacility {
        data = typeof data === 'object' ? data : {};
        let result = new ExhaustedQueueFacility();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IExhaustedQueueFacility extends IExhaustedQueueSummaryBase {
}

export class ExhaustedQueueSummaryRequest implements IExhaustedQueueSummaryRequest {
    facilityIds?: string | undefined;
    facilityIdList?: string[] | undefined;
    queueStatuses?: string | undefined;

    constructor(data?: IExhaustedQueueSummaryRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.facilityIds = _data["facilityIds"];
            if (Array.isArray(_data["facilityIdList"])) {
                this.facilityIdList = [] as any;
                for (let item of _data["facilityIdList"])
                    this.facilityIdList!.push(item);
            }
            this.queueStatuses = _data["queueStatuses"];
        }
    }

    static fromJS(data: any): ExhaustedQueueSummaryRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ExhaustedQueueSummaryRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["facilityIds"] = this.facilityIds;
        if (Array.isArray(this.facilityIdList)) {
            data["facilityIdList"] = [];
            for (let item of this.facilityIdList)
                data["facilityIdList"].push(item);
        }
        data["queueStatuses"] = this.queueStatuses;
        return data;
    }
}

export interface IExhaustedQueueSummaryRequest {
    facilityIds?: string | undefined;
    facilityIdList?: string[] | undefined;
    queueStatuses?: string | undefined;
}

function formatDate(d: Date) {
    return d.getFullYear() + '-' + 
        (d.getMonth() < 9 ? ('0' + (d.getMonth()+1)) : (d.getMonth()+1)) + '-' +
        (d.getDate() < 10 ? ('0' + d.getDate()) : d.getDate());
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

function isAxiosError(obj: any): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}